/**
 * Auto-generated by server/scripts/generatePrebuiltItineraries.js
 * Do not edit by hand. Regenerate: node server/scripts/generatePrebuiltItineraries.js
 */
export const PREBUILT_ITINERARIES = {
  "new-york": {
    "3": {
      "plannerCity": "East Rutherford",
      "matchDay": 2,
      "city": "East Rutherford (New York Metro Area)",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrive in NYC & Check-in",
              "description": "Arrive at Newark Liberty International Airport (EWR) or John F. Kennedy International Airport (JFK), transfer to your accommodation in Midtown Manhattan, Jersey City, or Hoboken. Settle in and prepare for sightseeing.",
              "placeName": "Midtown Manhattan",
              "mapLink": "https://www.google.com/maps/place/Midtown,+Manhattan,+New+York,+NY",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Midtown_Manhattan_skyline_from_Weehawken.jpg/1280px-Midtown_Manhattan_skyline_from_Weehawken.jpg",
              "suggested_time": "09:00"
            },
            {
              "name": "Explore Times Square",
              "description": "Immerse yourself in the vibrant energy of Times Square, famous for its dazzling billboards, street performers, and bustling atmosphere. A quintessential NYC landmark.",
              "placeName": "Times Square",
              "mapLink": "https://www.google.com/maps/place/Times+Square/@40.7579747,-73.9877317,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Times_Square_at_night-01.jpg/1920px-Times_Square_at_night-01.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Visit Rockefeller Center & St. Patrick's Cathedral",
              "description": "Walk to Rockefeller Center, admire its iconic architecture, and then visit the stunning St. Patrick's Cathedral across the street. Consider going up Top of the Rock for panoramic views.",
              "placeName": "Rockefeller Center",
              "mapLink": "https://www.google.com/maps/place/Rockefeller+Center/@40.7587401,-73.9786448,17z",
              "ticketLink": "https://www.getyourguide.com/new-york-city-l59/top-of-the-rock-observation-deck-entry-ticket-t21473/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Rockefeller_Center_Christmas_Tree_2022.jpg/1920px-Rockefeller_Center_Christmas_Tree_2022.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:30"
            },
            {
              "name": "Classic New York Pizza Lunch",
              "description": "Experience a true New York culinary tradition with a classic slice of pizza. Joe's Pizza is a highly-rated, iconic spot.",
              "placeName": "Joe's Pizza (Bleecker St)",
              "mapLink": "https://www.google.com/maps/place/Joe's+Pizza/@40.730811,-74.000305,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Joe%27s_Pizza_on_Bleecker_Street.jpg/1920px-Joe%27s_Pizza_on_Bleecker_Street.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Football Factory at Legends Bar",
              "description": "Immerse yourself in football culture at one of NYC's premier soccer bars. Enjoy drinks, pub food, and discussions about the beautiful game with fellow fans.",
              "placeName": "The Football Factory at Legends",
              "mapLink": "https://www.google.com/maps/place/The+Football+Factory+at+Legends/@40.7483863,-73.985959,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Football_Factory_at_Legends_%28cropped%29.jpg/1280px-Football_Factory_at_Legends_%28cropped%29.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Travel to MetLife Stadium & FIFA Fan Fest",
              "description": "Take NJ Transit from NY Penn Station to Secaucus Junction, then transfer to a special event train to MetLife Stadium. Arrive early to experience the pre-match atmosphere and official FIFA Fan Fest activities.",
              "placeName": "MetLife Stadium",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.8134706,-74.0747444,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/MetLife_Stadium_Interior.jpg/1920px-MetLife_Stadium_Interior.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Explore Pre-Match Festivities",
              "description": "Engage with other fans, participate in interactive games, enjoy live music, and soak in the vibrant atmosphere of the FIFA Fan Fest outside MetLife Stadium.",
              "placeName": "MetLife Stadium Complex (Fan Fest Area)",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.8134706,-74.0747444,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/FIFA_Fan_Fest_Durban_2010.jpg/1920px-FIFA_Fan_Fest_Durban_2010.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Match Day Entry & Stadium Experience",
              "description": "Enter MetLife Stadium, find your seats, and experience the excitement building up to kickoff. Grab official merchandise and stadium food.",
              "placeName": "MetLife Stadium",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.8134706,-74.0747444,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/MetLife_Stadium_during_a_game.jpg/1920px-MetLife_Stadium_during_a_game.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Attend FIFA World Cup Match",
              "description": "Witness a thrilling FIFA World Cup match live at MetLife Stadium, cheering on your favorite team amidst thousands of passionate fans.",
              "placeName": "MetLife Stadium",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.8134706,-74.0747444,17z",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/MetLife_Stadium_-_Football_Match.jpg/1920px-MetLife_Stadium_-_Football_Match.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "Post-Match Celebration & Return to NYC",
              "description": "Celebrate the match outcome with fellow fans and begin your journey back to Manhattan via NJ Transit. Consider a late dinner or drinks in NYC.",
              "placeName": "New York Penn Station",
              "mapLink": "https://www.google.com/maps/place/New+York+Penn+Station/@40.7505045,-73.9935272,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Penn_Station_LIRR_Concourse.jpg/1920px-Penn_Station_LIRR_Concourse.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Statue of Liberty & Ellis Island Ferry",
              "description": "Take a ferry from Battery Park to visit the iconic Statue of Liberty and the historic Ellis Island, symbols of freedom and immigration. Book tickets in advance.",
              "placeName": "Statue of Liberty National Monument",
              "mapLink": "https://www.google.com/maps/place/Statue+of+Liberty+National+Monument/@40.6892494,-74.0445004,17z",
              "ticketLink": "https://www.statueoflibertytickets.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Statue_of_Liberty%2C_NY.jpg/1920px-Statue_of_Liberty%2C_NY.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "One World Observatory",
              "description": "Ascend to the top of One World Trade Center for breathtaking 360-degree views of the New York City skyline, including the Statue of Liberty and Brooklyn Bridge.",
              "placeName": "One World Observatory",
              "mapLink": "https://www.google.com/maps/place/One+World+Observatory/@40.7130081,-74.0131464,17z",
              "ticketLink": "https://www.oneworldobservatory.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/One_World_Trade_Center_from_Hoboken.jpg/1920px-One_World_Trade_Center_from_Hoboken.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:30"
            },
            {
              "name": "Lunch in Financial District & 9/11 Memorial",
              "description": "Grab lunch in the Financial District, then visit the solemn 9/11 Memorial & Museum to pay respects and learn about the events of September 11, 2001.",
              "placeName": "9/11 Memorial & Museum",
              "mapLink": "https://www.google.com/maps/place/National+September+11+Memorial+%26+Museum/@40.711536,-74.0125867,17z",
              "ticketLink": "https://www.911memorial.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/9-11_Memorial_Fountain.jpg/1920px-9-11_Memorial_Fountain.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Greenwich Village",
              "description": "Enjoy a farewell dinner in the charming and historic Greenwich Village, known for its diverse culinary scene and bohemian atmosphere. Consider Carbone for a high-end Italian experience (book well in advance) or The Grey Dog for a casual, lively vibe.",
              "placeName": "Greenwich Village",
              "mapLink": "https://www.google.com/maps/place/Greenwich+Village,+New+York,+NY",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Greenwich_Village_street_scene_2016.jpg/1920px-Greenwich_Village_street_scene_2016.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "New York Style Pizza (Joe's Pizza, John's of Bleecker Street)",
        "Classic NYC Bagel & Lox (Russ & Daughters Cafe, Ess-a-Bagel)",
        "Street food from diverse neighborhoods (e.g., Halal Guys, food trucks)",
        "Cheesecake (Junior's Restaurant)",
        "Deli Sandwiches (Katz's Delicatessen)"
      ],
      "football_experiences": [
        "FIFA Fan Fest at MetLife Stadium",
        "Attending a FIFA World Cup Match at MetLife Stadium",
        "The Football Factory at Legends (NYC Sports Bar)",
        "Official FIFA Merchandise Stores (Pop-ups during World Cup)",
        "Visiting local sports bars to watch other matches"
      ],
      "travel_tips": [
        "How to Reach MetLife Stadium: On match days, the most efficient way to reach MetLife Stadium from NYC is via NJ Transit. Take a train from New York Penn Station (NYC) to Secaucus Junction (NJ), then transfer to a special event train that goes directly to MetLife Stadium. The total journey can take 45-60 minutes.",
        "Accommodation: For convenience to both NYC attractions and MetLife Stadium, consider staying in Midtown Manhattan (near Penn Station for NJ Transit), or in Jersey City/Hoboken (NJ), which offers easier access to both NJ Transit to MetLife and PATH trains to Lower and Midtown Manhattan.",
        "Public Transportation in NYC/NJ: The New York metropolitan area has an extensive public transport system. For travel within NYC, use the MTA (Metropolitan Transportation Authority) subway and bus system. For travel between NYC and New Jersey, use NJ Transit trains/buses or the PATH train. Purchase an OMNY card or use contactless payment (credit/debit card, smartphone) for MTA and PATH. For NJ Transit trains, purchase tickets via the NJ Transit Mobile App or at station vending machines.",
        "Early Arrival: On match day, plan to arrive at MetLife Stadium several hours before kickoff to allow for security checks, fan zone exploration, and potential transit delays.",
        "Book in Advance: For popular attractions like the Statue of Liberty, One World Observatory, or Broadway shows, book tickets well in advance, especially during a major event like the World Cup."
      ]
    },
    "5": {
      "plannerCity": "East Rutherford",
      "matchDay": 3,
      "city": "East Rutherford, NJ (NYC Metro Area)",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Times Square Immersion",
              "description": "Arrive at Newark Liberty International Airport (EWR) or JFK/LaGuardia, transfer to your hotel in Manhattan or nearby NJ. Begin your NYC experience with the iconic Times Square.",
              "placeName": "Times Square",
              "mapLink": "https://www.google.com/maps/place/Times+Square,+Manhattan,+NY+10036",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Times_Square_at_night_-_Jan_2006.jpg/1920px-Times_Square_at_night_-_Jan_2006.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Classic New York Breakfast",
              "description": "Enjoy a classic New York bagel and coffee to start your day.",
              "placeName": "Ess-a-Bagel (Midtown East)",
              "mapLink": "https://www.google.com/maps/place/Ess-a-Bagel/@40.756281,-73.974351,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259021876b00b:0x51582e0a2955f190!8m2!3d40.756281!4d-73.971776!16s%2Fg%2F1td0k62t?entry=ttu",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Central Park Stroll",
              "description": "Explore the iconic urban oasis, Central Park. Visit Bethesda Terrace, Strawberry Fields, or just enjoy a leisurely walk. Easily accessible from Midtown.",
              "placeName": "Central Park",
              "mapLink": "https://www.google.com/maps/place/Central+Park,+New+York,+NY/@40.7812,-73.9665,15z/data=!3m1!4b1!4m6!3m5!1s0x89c2589a018531e3:0xab206138e7cff50f!8m2!3d40.7812!4d-73.9665!16zL20vMDFfc3g?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Central_Park_from_Top_of_the_Rock_2013-09-23.jpg/1920px-Central_Park_from_Top_of_the_Rock_2013-09-23.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Broadway Show & Dinner",
              "description": "Experience a world-class Broadway show in the Theater District followed by dinner in the vibrant Hell's Kitchen neighborhood.",
              "placeName": "Shubert Alley (Broadway Theater District)",
              "mapLink": "https://www.google.com/maps/place/Shubert+Alley,+New+York,+NY+10036",
              "ticketLink": "https://www.broadway.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Broadway_theatre_district_%288338902888%29.jpg/1920px-Broadway_theatre_district_%288338902888%29.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Dinner in Hell's Kitchen",
              "description": "Enjoy diverse cuisine on Restaurant Row, known for its wide array of restaurants just west of the Theater District.",
              "placeName": "Restaurant Row (W 46th St, Hell's Kitchen)",
              "mapLink": "https://www.google.com/maps/place/Restaurant+Row/@40.759495,-73.992661,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259b360a4843b:0x5e0f0655d8d067b5!8m2!3d40.759495!4d-73.990086!16s%2Fg%2F11b6y8z20y?entry=ttu",
              "best_time": "evening",
              "suggested_time": "09:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Statue of Liberty & Ellis Island",
              "description": "Take a ferry from Battery Park to visit the iconic Statue of Liberty and learn about immigration history at Ellis Island. Book tickets in advance, as this is a popular attraction.",
              "placeName": "Battery Park (ferry departure)",
              "mapLink": "https://www.google.com/maps/place/Battery+Park,+New+York,+NY+10004",
              "ticketLink": "https://www.statueoflibertytickets.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Statue_of_Liberty_7.jpg/1920px-Statue_of_Liberty_7.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Wall Street & Financial District",
              "description": "Explore the heart of global finance, see the Charging Bull, Federal Hall, and the New York Stock Exchange. This area is a short walk from Battery Park.",
              "placeName": "Wall Street",
              "mapLink": "https://www.google.com/maps/place/Wall+St,+New+York,+NY+10005",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Wall_Street_at_Night_P1020038.jpg/1920px-Wall_Street_at_Night_P1020038.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at Stone Street",
              "description": "Grab lunch at one of the historic pubs or restaurants on Stone Street in the Financial District, a pedestrian-only alley.",
              "placeName": "Stone Street",
              "mapLink": "https://www.google.com/maps/place/Stone+St,+New+York,+NY+10004",
              "best_time": "afternoon",
              "suggested_time": "12:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Greenwich Village Exploration & Dinner",
              "description": "Wander through the charming streets of Greenwich Village, known for its bohemian history, jazz clubs, and diverse dining scene.",
              "placeName": "Greenwich Village",
              "mapLink": "https://www.google.com/maps/place/Greenwich+Village,+New+York,+NY",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Washington_Square_Park_arch.jpg/1920px-Washington_Square_Park_arch.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at Joe's Pizza",
              "description": "Enjoy a classic New York slice at the legendary Joe's Pizza, a Greenwich Village institution.",
              "placeName": "Joe's Pizza (Bleecker St)",
              "mapLink": "https://www.google.com/maps/place/Joe's+Pizza/@40.729788,-74.002016,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259929f95f463:0x1b87a4192666a010!8m2!3d40.729788!4d-73.999441!16s%2Fg%2F1tdw_036?entry=ttu",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Official FIFA Fan Fest / Fan Zone",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Fest. This will likely be located in a major NYC park or public space, or a dedicated area near MetLife Stadium, offering live music, food, and sponsor activities.",
              "placeName": "Official FIFA Fan Fest (Location TBD - likely NYC or near MetLife)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Fest+New+York+2026",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/FIFA_Fan_Fest_Rio_de_Janeiro.jpg/1920px-FIFA_Fan_Fest_Rio_de_Janeiro.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to MetLife Stadium & Pre-Match Atmosphere",
              "description": "Take the special event train from Secaucus Junction to MetLife Stadium. Arrive early to soak in the pre-match excitement, explore stadium surroundings, and grab food/drinks.",
              "placeName": "MetLife Stadium",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.812836,-74.074749,17z/data=!3m1!4b1!4m6!3m5!1s0x89c256037b52125f:0x7b587a8b4172c3d!8m2!3d40.812836!4d-74.072174!16zL20vMDM2M3Iz?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/MetLife_Stadium_during_Super_Bowl_XLVIII.jpg/1920px-MetLife_Stadium_during_Super_Bowl_XLVIII.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            },
            {
              "name": "Pre-match Meal at Stadium",
              "description": "Enjoy stadium food and drinks from the numerous concessions as you get ready for the match.",
              "placeName": "MetLife Stadium Concessions",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.812836,-74.074749,17z/data=!3m1!4b1!4m6!3m5!1s0x89c256037b52125f:0x7b587a8b4172c3d!8m2!3d40.812836!4d-74.072174!16zL2m/MDM2M3Iz?entry=ttu",
              "best_time": "afternoon",
              "suggested_time": "05:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a FIFA World Cup match live at MetLife Stadium, one of the premier venues for the tournament!",
              "placeName": "MetLife Stadium",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.812836,-74.074749,17z/data=!3m1!4b1!4m6!3m5!1s0x89c256037b52125f:0x7b587a8b4172c3d!8m2!3d40.812836!4d-74.072174!16zL2m/MDM2M3Iz?entry=ttu",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/MetLife_Stadium_Interior_2017.jpg/1920px-MetLife_Stadium_Interior_2017.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            },
            {
              "name": "Post-Match Celebration/Relaxation",
              "description": "After the match, join fellow fans at a sports bar near Penn Station or head back to your accommodation for a late dinner or drinks.",
              "placeName": "Stout NYC Penn Station",
              "mapLink": "https://www.google.com/maps/place/Stout+NYC+Penn+Station/@40.751268,-73.992601,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259ae6a45d075:0x229424c82c3c6f4f!8m2!3d40.751268!4d-73.990026!16s%2Fg%2F1tdy0y6d?entry=ttu",
              "best_time": "evening",
              "suggested_time": "10:30 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "The Metropolitan Museum of Art (The Met)",
              "description": "Spend your morning exploring one of the world's largest and finest art museums, with collections spanning 5,000 years of culture. Located on the Upper East Side, adjacent to Central Park.",
              "placeName": "The Metropolitan Museum of Art",
              "mapLink": "https://www.google.com/maps/place/The+Metropolitan+Museum+of+Art/@40.779437,-73.963244,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2589501234567:0x6f1f42220d2b785!8m2!3d40.779437!4d-73.960669!16zL20vMDQzcjQ?entry=ttu",
              "ticketLink": "https://www.metmuseum.org/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/The_Metropolitan_Museum_of_Art_at_sunset.jpg/1920px-The_Metropolitan_Museum_of_Art_at_sunset.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Fifth Avenue Shopping & Rockefeller Center",
              "description": "Stroll down Fifth Avenue, renowned for its luxury boutiques. Visit Rockefeller Center, home to Top of the Rock observation deck and NBC Studios. This area is a short subway ride from The Met.",
              "placeName": "Rockefeller Center",
              "mapLink": "https://www.google.com/maps/place/Rockefeller+Center,+New+York,+NY+10020",
              "ticketLink": "https://www.topoftherocknyc.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Rockefeller_Center_at_dusk.jpg/1920px-Rockefeller_Center_at_dusk.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Lunch at Katz's Delicatessen",
              "description": "Indulge in a legendary pastrami on rye at this historic New York deli, located on the Lower East Side. This is a deliberate longer travel for an iconic food experience.",
              "placeName": "Katz's Delicatessen",
              "mapLink": "https://www.google.com/maps/place/Katz's+Delicatessen/@40.722248,-73.987391,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25983758079a1:0x93309a47d2f9748b!8m2!3d40.722248!4d-73.984816!16s%2Fg%2F1td068_8?entry=ttu",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Koreatown",
              "description": "Experience vibrant Korean culture and cuisine. Enjoy authentic Korean BBQ or other dishes in this lively neighborhood near Midtown.",
              "placeName": "Koreatown (W 32nd St, NYC)",
              "mapLink": "https://www.google.com/maps/place/Koreatown,+New+York,+NY+10001",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Korean BBQ at Jongro BBQ",
              "description": "Savor traditional Korean BBQ in a lively setting at Jongro BBQ, a popular spot in Koreatown.",
              "placeName": "Jongro BBQ",
              "mapLink": "https://www.google.com/maps/place/Jongro+BBQ/@40.748366,-73.987741,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2598d1a1643c1:0xf016e3100650d53c!8m2!3d40.748366!4d-73.985166!16s%2Fg%2F1tdw092s?entry=ttu",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Brooklyn Bridge Walk & DUMBO",
              "description": "Walk across the iconic Brooklyn Bridge from Manhattan to Brooklyn, enjoying stunning skyline views. Explore the DUMBO neighborhood (Down Under the Manhattan Bridge Overpass), known for its cobblestone streets and waterfront.",
              "placeName": "Brooklyn Bridge Park",
              "mapLink": "https://www.google.com/maps/place/Brooklyn+Bridge+Park/@40.702008,-73.998495,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a3d02a2491b:0x89589d316fb2f32a!8m2!3d40.702008!4d-73.99592!16s%2Fg%2F11b6x_53_0?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Brooklyn_Bridge_from_Dumbo.jpg/1920px-Brooklyn_Bridge_from_Dumbo.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Pizza at Grimaldi's Pizzeria",
              "description": "Enjoy coal-fired brick-oven pizza under the Brooklyn Bridge at the famous Grimaldi's Pizzeria in DUMBO.",
              "placeName": "Grimaldi's Pizzeria (DUMBO)",
              "mapLink": "https://www.google.com/maps/place/Grimaldi's+Pizzeria/@40.702488,-73.993181,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a3d46399999:0x82a514d3a010077!8m2!3d40.702488!4d-73.990606!16s%2Fg%2F1tj57k8t?entry=ttu",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "The High Line & Chelsea Market",
              "description": "Walk along The High Line, an elevated park built on a historic freight rail line. Then, explore Chelsea Market, a popular food hall and shopping mall in the Meatpacking District.",
              "placeName": "The High Line (Gansevoort St entrance)",
              "mapLink": "https://www.google.com/maps/place/The+High+Line/@40.740034,-74.008453,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259837965a3d1:0x41f32a244b7d519d!8m2!3d40.740034!4d-74.005878!16zL2m/MDY3Z3Fm?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/The_High_Line_Park%2C_NYC.jpg/1920px-The_High_Line_Park%2C_NYC.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Chelsea Market Bites",
              "description": "Grab a snack or light meal from one of the many diverse vendors inside Chelsea Market.",
              "placeName": "Chelsea Market",
              "mapLink": "https://www.google.com/maps/place/Chelsea+Market/@40.74232,-74.00547,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259972322a36b:0x5e0f0655d8d067b5!8m2!3d40.74232!4d-74.002895!16s%2Fg%2F1tdw092s?entry=ttu",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure Prep",
              "description": "Enjoy a final New York dinner in Midtown or near your preferred airport (EWR, JFK, or LaGuardia) before heading out for your departure.",
              "placeName": "Midtown Manhattan (near transport hubs)",
              "mapLink": "https://www.google.com/maps/place/Midtown+Manhattan,+New+York,+NY",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "New York Style Pizza (Joe's Pizza, Grimaldi's Pizzeria)",
        "Bagel and Lox (Ess-a-Bagel)",
        "Pastrami on Rye (Katz's Delicatessen)",
        "Street Food (Hot Dogs, Pretzels from street vendors)",
        "Korean BBQ (Jongro BBQ)",
        "Fine Dining (Restaurant Row in Hell's Kitchen)"
      ],
      "football_experiences": [
        "Attending a FIFA World Cup Match at MetLife Stadium in East Rutherford, NJ",
        "Visiting the Official FIFA Fan Fest / Fan Zone (location TBD, likely in NYC or near MetLife)",
        "Watching other World Cup matches at sports bars in NYC (e.g., Stout NYC, Legends NYC)",
        "Exploring official FIFA merchandise stores (locations to be announced)"
      ],
      "travel_tips": [
        "**Getting to MetLife Stadium (East Rutherford, NJ):** The most efficient way from NYC is via NJ Transit. Take a train from New York Penn Station (Manhattan) to Secaucus Junction. From Secaucus Junction, transfer to a special event train directly to MetLife Stadium. This journey typically takes 30-45 minutes total from Penn Station. Plan to arrive early on match day.",
        "**Where to Stay:**\n*   **Manhattan (Midtown West, Chelsea, Hell's Kitchen):** Best for sightseeing and easy access to New York Penn Station for NJ Transit to MetLife Stadium. Offers a wide range of hotels for various budgets.\n*   **Secaucus, NJ:** Closest to MetLife Stadium, often has hotel shuttle services to the stadium. Good for budget-conscious travelers or those prioritizing stadium proximity.\n*   **Jersey City, NJ:** Offers good public transport links (PATH train to Manhattan, NJ Transit to Secaucus) and often more affordable accommodation than Manhattan, with great views of the NYC skyline.",
        "**Public Transportation in NYC/NJ:**\n*   **New York City (MTA):** The subway and bus system is extensive and runs 24/7. Purchase a MetroCard at any subway station or use OMNY (tap-to-pay with contactless credit/debit card or mobile wallet) for seamless travel on subways and buses. A 7-day unlimited pass might be cost-effective if you plan to use public transport frequently.\n*   **New Jersey (NJ Transit):** For travel within New Jersey and between New Jersey and NYC (including to MetLife Stadium), use NJ Transit trains and buses. Tickets can be purchased at vending machines in stations or via the NJ Transit Mobile App. There is no single 'pass' that covers both MTA and NJ Transit comprehensively, so plan to purchase separate tickets/passes for each system as needed.",
        "**Booking in Advance:** For popular attractions (Statue of Liberty, Broadway shows, Top of the Rock, major museums) and especially World Cup match tickets, book well in advance to secure your spot and preferred times.",
        "**Walking:** NYC is a highly walkable city. Wear comfortable shoes, as you'll be doing a lot of walking between subway stations and attractions. Be prepared for crowds, especially in tourist hotspots.",
        "**Security:** Be aware of your surroundings, especially in crowded tourist areas and on public transport. Keep valuables secure and avoid displaying large amounts of cash."
      ]
    },
    "7": {
      "plannerCity": "East Rutherford",
      "matchDay": 4,
      "city": "East Rutherford",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Newark Liberty International Airport (EWR) or John F. Kennedy International Airport (JFK), transfer to your accommodation in Manhattan or a convenient area in New Jersey (e.g., Jersey City, Hoboken).",
              "placeName": "Manhattan, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Manhattan,+New+York,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/nyc_skyline.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Times Square Exploration",
              "description": "Immerse yourself in the vibrant energy of Times Square, known for its dazzling billboards and entertainment.",
              "placeName": "Times Square, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Times+Square,+New+York,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/times_square.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Pre-Theater Dinner at Joe Allen",
              "description": "Enjoy a classic American dinner in the heart of the Theater District, a favorite among Broadway regulars.",
              "placeName": "Joe Allen, 326 W 46th St, New York, NY 10036",
              "mapLink": "https://www.google.com/maps/place/Joe+Allen/@40.759453,-73.987771,17z/data=!3m1!4b1!4m6!3m5!1s0x89c258546b5a308b:0x89e2183c5093557e!8m2!3d40.759453!4d-73.985196!16s%2Fg%2F1tdyynk2",
              "ticketLink": null,
              "imageUrl": "https://example.com/joe_allen.jpg",
              "best_time": "afternoon",
              "suggested_time": "17:00"
            }
          ],
          "evening": [
            {
              "name": "Top of the Rock Observation Deck",
              "description": "Experience breathtaking panoramic views of the Manhattan skyline, including the Empire State Building and Central Park, from the Top of the Rock.",
              "placeName": "Top of the Rock Observation Deck, 30 Rockefeller Plaza, New York, NY 10112",
              "mapLink": "https://www.google.com/maps/place/Top+of+the+Rock+Observation+Deck/@40.759089,-73.979024,17z/data=!3m1!4b1!4m6!3m5!1s0x89c258f338d39f4f:0x6f69842a5a5441d!8m2!3d40.759089!4d-73.976449!16s%2Fg%2F1th303g3",
              "ticketLink": "https://www.viator.com/tours/New-York-City/Top-of-the-Rock-Observation-Deck-Ticket/d687-6577TOP",
              "imageUrl": "https://example.com/top_of_the_rock.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Statue of Liberty & Ellis Island Ferry",
              "description": "Take a ferry from Battery Park to visit the iconic Statue of Liberty and learn about immigrant history at Ellis Island.",
              "placeName": "Battery Park, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Battery+Park/@40.703215,-74.017772,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a176881c169:0x89b036573c7343e2!8m2!3d40.703215!4d-74.015197!16s%2Fg%2F1tdm20g3",
              "ticketLink": "https://www.statueoflibertytickets.com/",
              "imageUrl": "https://example.com/statue_of_liberty.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "9/11 Memorial & Museum",
              "description": "Pay respects at the solemn 9/11 Memorial and visit the museum to understand the tragic events of September 11, 2001.",
              "placeName": "9/11 Memorial & Museum, 180 Greenwich St, New York, NY 10007",
              "mapLink": "https://www.google.com/maps/place/National+September+11+Memorial+%26+Museum/@40.711532,-74.013233,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a191f6920f3:0x1531e21764619b0!8m2!3d40.711532!4d-74.010658!16s%2Fg%2F1th3l7g3",
              "ticketLink": "https://www.911memorial.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://example.com/911_memorial.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at Katz's Delicatessen",
              "description": "Savor an iconic pastrami on rye sandwich at the legendary Katz's Delicatessen, a true New York institution.",
              "placeName": "Katz's Delicatessen, 205 E Houston St, New York, NY 10002",
              "mapLink": "https://www.google.com/maps/place/Katz's+Delicatessen/@40.72224,-73.987348,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25983794b1509:0x8dd0b2e352f2f35d!8m2!3d40.72224!4d-73.984773!16s%2Fg%2F1tdy25n5",
              "ticketLink": null,
              "imageUrl": "https://example.com/katzs_deli.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "Explore Greenwich Village & Jazz",
              "description": "Wander through the charming streets of Greenwich Village, known for its bohemian history, and catch a live jazz performance at a local club.",
              "placeName": "Greenwich Village, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Greenwich+Village,+New+York,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/greenwich_village.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Central Park Stroll",
              "description": "Enjoy a leisurely morning walk through Central Park, visiting iconic spots like Bethesda Terrace, Strawberry Fields, and The Mall.",
              "placeName": "Central Park, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Central+Park/@40.7812,-73.9665,15z/data=!3m1!4b1!4m6!3m5!1s0x89c2589a1c9a00a3:0x2283e371a0296e05!8m2!3d40.7812!4d-73.9665!16zL20vMDFrY3g",
              "ticketLink": null,
              "imageUrl": "https://example.com/central_park.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "The Metropolitan Museum of Art (The Met)",
              "description": "Spend the afternoon exploring one of the world's largest and finest art museums, located right by Central Park.",
              "placeName": "The Metropolitan Museum of Art, 1000 Fifth Avenue, New York, NY 10028",
              "mapLink": "https://www.google.com/maps/place/The+Metropolitan+Museum+of+Art/@40.779434,-73.963244,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2589544a49197:0x221815124fc8b9!8m2!3d40.779434!4d-73.960669!16zL20vMDQ5NjMy",
              "ticketLink": "https://www.metmuseum.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://example.com/the_met.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Street Food Lunch near Central Park",
              "description": "Grab a quick and delicious bite from a street vendor near Central Park, perhaps a classic New York hot dog or a Halal Guys platter.",
              "placeName": "53rd and 6th Halal Cart, W 53rd St & 6th Ave, New York, NY 10019",
              "mapLink": "https://www.google.com/maps/place/The+Halal+Guys/@40.761899,-73.979069,17z/data=!3m1!4b1!4m6!3m5!1s0x89c258f7e77a2965:0x8797f14b62892976!8m2!3d40.761899!4d-73.976494!16s%2Fg%2F1th28kg4",
              "ticketLink": null,
              "imageUrl": "https://example.com/halal_guys.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "Grand Central Terminal & Oyster Bar Dinner",
              "description": "Admire the stunning architecture of Grand Central Terminal, then enjoy fresh seafood at the iconic Grand Central Oyster Bar & Restaurant.",
              "placeName": "Grand Central Terminal, 89 E 42nd St, New York, NY 10017",
              "mapLink": "https://www.google.com/maps/place/Grand+Central+Terminal/@40.752726,-73.977227,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2590212f43a05:0x5e24b335359b32c6!8m2!3d40.752726!4d-73.974652!16zL20vMDFrY2Q",
              "ticketLink": null,
              "imageUrl": "https://example.com/grand_central.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, cultural performances, food, and interactive football activities.",
              "placeName": "FIFA Fan Festival (e.g., Central Park or Hudson Yards, NYC - specific location TBD for 2026)",
              "mapLink": "https://www.google.com/maps/place/Central+Park,+New+York,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/fifa_fan_fest.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to MetLife Stadium & Pre-Match Tailgate",
              "description": "Take NJ Transit from Penn Station (NYC) to Secaucus Junction, then transfer to a special event train to MetLife Stadium. Enjoy the vibrant pre-match atmosphere and tailgate parties outside the stadium. (Allow 1.5-2 hours travel time)",
              "placeName": "MetLife Stadium, 1 MetLife Stadium Dr, East Rutherford, NJ 07073",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.813083,-74.074719,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2f8623b18536f:0x393278553d1000b9!8m2!3d40.813083!4d-74.072144!16zL20vMDV2ajUw",
              "ticketLink": null,
              "imageUrl": "https://example.com/metlife_stadium_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at MetLife Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at MetLife Stadium. Cheer on your favorite teams and soak in the electric atmosphere.",
              "placeName": "MetLife Stadium, 1 MetLife Stadium Dr, East Rutherford, NJ 07073",
              "mapLink": "https://www.google.com/maps/place/MetLife+Stadium/@40.813083,-74.074719,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2f8623b18536f:0x393278553d1000b9!8m2!3d40.813083!4d-74.072144!16zL20vMDV2ajUw",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://example.com/fifa_match.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Walk the Brooklyn Bridge",
              "description": "Take an iconic walk across the Brooklyn Bridge, enjoying stunning views of the Manhattan skyline and the East River.",
              "placeName": "Brooklyn Bridge, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Brooklyn+Bridge/@40.706086,-73.998687,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a231804f553:0x1b721867120349b7!8m2!3d40.706086!4d-73.996112!16zL20vMDFrY2o",
              "ticketLink": null,
              "imageUrl": "https://example.com/brooklyn_bridge.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore DUMBO & Brooklyn Bridge Park",
              "description": "Discover the trendy DUMBO neighborhood, known for its cobblestone streets, art galleries, and scenic Brooklyn Bridge Park. Ride Jane's Carousel.",
              "placeName": "DUMBO, Brooklyn, NY",
              "mapLink": "https://www.google.com/maps/place/DUMBO,+Brooklyn,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/dumbo_brooklyn.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Pizza at Grimaldi's Pizzeria",
              "description": "Enjoy a classic New York-style coal-fired brick oven pizza at the famous Grimaldi's, located right under the Brooklyn Bridge.",
              "placeName": "Grimaldi's Pizzeria, 1 Front St, Brooklyn, NY 11201",
              "mapLink": "https://www.google.com/maps/place/Grimaldi's+Pizzeria/@40.702758,-73.994271,17z/data=!3m1!4b1!4m6!3m5!1s0x89c25a3d76e72b4f:0xa7d82a176881c169!8m2!3d40.702758!4d-73.991696!16s%2Fg%2F1tdyyg1k",
              "ticketLink": null,
              "imageUrl": "https://example.com/grimaldis_pizza.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Williamsburg Exploration & Dinner",
              "description": "Head to Williamsburg for its vibrant nightlife, boutique shops, and diverse culinary scene. Enjoy dinner at a local restaurant or brewery.",
              "placeName": "Williamsburg, Brooklyn, NY",
              "mapLink": "https://www.google.com/maps/place/Williamsburg,+Brooklyn,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/williamsburg.jpg",
              "best_time": "evening",
              "suggested_time": "18:30"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Chelsea Market Exploration",
              "description": "Browse the unique shops and enjoy diverse food options at Chelsea Market, a popular food hall and shopping mall.",
              "placeName": "Chelsea Market, 75 9th Ave, New York, NY 10011",
              "mapLink": "https://www.google.com/maps/place/Chelsea+Market/@40.742308,-74.004944,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259c99187ec9d:0x3977c082531f9f52!8m2!3d40.742308!4d-74.002369!16zL20vMDd2a2Zk",
              "ticketLink": null,
              "imageUrl": "https://example.com/chelsea_market.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Walk The High Line",
              "description": "Stroll along The High Line, an elevated urban park built on a historic freight rail line, offering unique perspectives of the city.",
              "placeName": "The High Line, New York, NY",
              "mapLink": "https://www.google.com/maps/place/The+High+Line/@40.748332,-74.005994,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259c636f3c5f7:0x5e24b335359b32c6!8m2!3d40.748332!4d-74.003419!16zL20vMDY3d3Yy",
              "ticketLink": null,
              "imageUrl": "https://example.com/the_high_line.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Dinner at Eataly Flatiron",
              "description": "Indulge in authentic Italian food, from pasta to pizza and artisanal products, at Eataly Flatiron, a vibrant Italian marketplace and restaurant complex.",
              "placeName": "Eataly Flatiron, 200 5th Ave, New York, NY 10010",
              "mapLink": "https://www.google.com/maps/place/Eataly+Flatiron/@40.741005,-73.990422,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259a49b6b7a5d:0x5e24b335359b32c6!8m2!3d40.741005!4d-73.987847!16s%2Fg%2F1th28kg4",
              "ticketLink": null,
              "imageUrl": "https://example.com/eataly_flatiron.jpg",
              "best_time": "afternoon",
              "suggested_time": "17:00"
            }
          ],
          "evening": [
            {
              "name": "Football Factory at Legends (Sports Bar)",
              "description": "Catch up on global football news, watch games, and enjoy a pint at the Football Factory at Legends, a popular soccer pub.",
              "placeName": "Football Factory at Legends, 6 W 33rd St, New York, NY 10001",
              "mapLink": "https://www.google.com/maps/place/The+Football+Factory+at+Legends/@40.748956,-73.987186,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259a5d15a9143:0x5e24b335359b32c6!8m2!3d40.748956!4d-73.984611!16s%2Fg%2F1th28kg4",
              "ticketLink": null,
              "imageUrl": "https://example.com/football_factory.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Bagel Brunch at Russ & Daughters Cafe",
              "description": "Enjoy a quintessential New York bagel and lox experience at the historic Russ & Daughters Cafe on the Lower East Side.",
              "placeName": "Russ & Daughters Cafe, 127 Orchard St, New York, NY 10002",
              "mapLink": "https://www.google.com/maps/place/Russ+%26+Daughters+Cafe/@40.720819,-73.988019,17z/data=!3m1!4b1!4m6!3m5!1s0x89c259837a5f6e81:0x5e24b335359b32c6!8m2!3d40.720819!4d-73.985444!16s%2Fg%2F1th28kg4",
              "ticketLink": null,
              "imageUrl": "https://example.com/russ_daughters.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Last-Minute Souvenirs & Departure Prep",
              "description": "Grab any last-minute souvenirs or gifts, then head back to your accommodation to pick up luggage and prepare for departure.",
              "placeName": "Herald Square, New York, NY",
              "mapLink": "https://www.google.com/maps/place/Herald+Square,+New+York,+NY",
              "ticketLink": null,
              "imageUrl": "https://example.com/herald_square.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Departure from NYC Area",
              "description": "Travel to Newark Liberty International Airport (EWR) or John F. Kennedy International Airport (JFK) for your onward journey.",
              "placeName": "Newark Liberty International Airport (EWR)",
              "mapLink": "https://www.google.com/maps/place/Newark+Liberty+International+Airport/@40.692503,-74.174149,17z/data=!3m1!4b1!4m6!3m5!1s0x89c252d6a59b5895:0x5e24b335359b32c6!8m2!3d40.692503!4d-74.171574!16zL20vMDV2ajUw",
              "ticketLink": null,
              "imageUrl": "https://example.com/airport.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "New York-style Pizza (Grimaldi's Pizzeria, Joe's Pizza)",
        "Bagels and Lox (Russ & Daughters Cafe, Ess-a-Bagel)",
        "Pastrami on Rye (Katz's Delicatessen)",
        "Street Food (Halal Guys, hot dogs from street vendors)",
        "Cheesecake (Junior's Restaurant)",
        "Fine Dining (Per Se, Le Bernardin - for a splurge)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (official fan zone in NYC, location TBD for 2026)",
        "Live FIFA World Cup Match at MetLife Stadium",
        "Football Factory at Legends (popular soccer pub in Manhattan)",
        "Exploring sports merchandise stores in Times Square"
      ],
      "travel_tips": [
        "**Getting to MetLife Stadium (East Rutherford, NJ):** From Manhattan, take an NJ Transit train from Penn Station (34th St & 7th Ave) to Secaucus Junction. From Secaucus Junction, transfer to a special event train that goes directly to MetLife Stadium. Allow 1.5 to 2 hours for travel on match days due to crowds. Check NJ Transit schedules in advance.",
        "**Where to Stay:** Consider staying in Manhattan (Midtown, Chelsea, Greenwich Village) for easy access to attractions, though it can be more expensive. For a potentially more affordable option with good connectivity, look at hotels in Jersey City or Hoboken, New Jersey. These areas offer PATH train access to Lower and Midtown Manhattan, and are closer to MetLife Stadium.",
        "**Public Transportation in NYC/NJ:**\n  - **New York City (MTA):** The subway and bus system is extensive. Use OMNY (tap-to-pay with your credit/debit card or smartphone) for seamless travel, or purchase a MetroCard. OMNY is generally recommended for visitors.\n  - **New Jersey Transit (NJ Transit):** Operates trains and buses throughout New Jersey, including routes to/from NYC. Purchase tickets via the NJ Transit Mobile App or at ticket machines/windows at stations.\n  - **PATH Train:** Connects Newark, Harrison, Jersey City, and Hoboken in New Jersey with Lower and Midtown Manhattan. You can use OMNY or a SmartLink card for PATH fares. It is a separate system from MTA and NJ Transit.",
        "**Getting Around NYC:** Walking is often the best way to experience neighborhoods. For longer distances, the subway is usually the fastest option. Taxis and ride-sharing services are also available but can be expensive and slow in heavy traffic.",
        "**Budgeting:** For a medium budget, plan for approximately $150-250 per person per day for food, activities, and local transportation (excluding accommodation and match tickets). Look for lunch specials and consider street food for some meals."
      ]
    }
  },
  "los-angeles": {
    "3": {
      "plannerCity": "Los Angeles",
      "matchDay": 2,
      "city": "Los Angeles",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Hollywood Walk of Fame & TCL Chinese Theatre",
              "description": "Stroll along the iconic Hollywood Walk of Fame, spot your favorite stars, and admire the historic TCL Chinese Theatre with its celebrity handprints and footprints.",
              "placeName": "Hollywood Walk of Fame",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Hollywood+Walk+of+Fame",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Hollywood_Walk_of_Fame_2020.jpg/1280px-Hollywood_Walk_of_Fame_2020.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Breakfast at The Griddle Cafe",
              "description": "Enjoy a hearty breakfast at a famous Hollywood spot known for its enormous and delicious pancakes.",
              "placeName": "The Griddle Cafe",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Griddle+Cafe",
              "imageUrl": "https://example.com/griddle_cafe.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Santa Monica Pier & Beach",
              "description": "Experience the classic California beach vibe. Ride the Ferris wheel, walk along the pier, and relax on the sandy beaches of Santa Monica.",
              "placeName": "Santa Monica Pier",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Santa+Monica+Pier",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Santa_Monica_Pier_Panorama.jpg/1280px-Santa_Monica_Pier_Panorama.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at Pono Burger Santa Monica",
              "description": "Enjoy organic, grass-fed burgers and gourmet fries near the Santa Monica beach.",
              "placeName": "Pono Burger Santa Monica",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Pono+Burger+Santa+Monica",
              "imageUrl": "https://example.com/pono_burger.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at The Misfit Restaurant + Bar",
              "description": "Savor modern American cuisine and craft cocktails in a stylish, bustling setting just steps from the Santa Monica Pier.",
              "placeName": "The Misfit Restaurant + Bar",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Misfit+Restaurant+%2B+Bar",
              "imageUrl": "https://example.com/misfit_bar.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Natural History Museum of Los Angeles County",
              "description": "Explore vast collections covering natural and cultural history, including dinosaur fossils, gem and mineral exhibits, and California's ecosystems. Located relatively close to SoFi Stadium.",
              "placeName": "Natural History Museum of Los Angeles County",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Natural+History+Museum+of+Los+Angeles+County",
              "ticketLink": "https://example.com/nhm_tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Natural_History_Museum_of_Los_Angeles_County_2016.jpg/1280px-Natural_History_Museum_of_Los_Angeles_County_2016.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Lunch at Exposition Park Rose Garden",
              "description": "Grab a quick bite from a nearby food truck or cafe and enjoy it amidst the beautiful Exposition Park Rose Garden, adjacent to the museum.",
              "placeName": "Exposition Park Rose Garden",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Exposition+Park+Rose+Garden",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Exposition_Park_Rose_Garden_2009.jpg/1280px-Exposition_Park_Rose_Garden_2009.jpg",
              "best_time": "morning",
              "suggested_time": "12:30"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match atmosphere at the official FIFA Fan Festival. Enjoy live music, food vendors, sponsor activations, and celebrate with fans from around the world. (Location to be confirmed closer to 2026, assumed near SoFi or easily accessible).",
              "placeName": "SoFi Stadium Precinct (or designated Fan Zone)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "imageUrl": "https://example.com/fifa_fan_fest.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Arrive at SoFi Stadium Early",
              "description": "Head to SoFi Stadium to soak in the vibrant match day energy, explore the stadium's concourses, grab official merchandise, and find your seats well before kick-off.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/SoFi_Stadium_on_September_13%2C_2020.jpg/1280px-SoFi_Stadium_on_September_13%2C_2020.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Witness the excitement of a FIFA World Cup match live at the state-of-the-art SoFi Stadium, one of the premier venues for the tournament.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "ticketLink": "https://example.com/fifa_match_tickets",
              "imageUrl": "https://example.com/sofi_stadium_match.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Griffith Observatory",
              "description": "Enjoy breathtaking panoramic views of the Los Angeles skyline, the Pacific Ocean, and the iconic Hollywood Sign. Explore the exhibits and planetarium shows.",
              "placeName": "Griffith Observatory",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Griffith+Observatory",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Griffith_Observatory_from_the_air.jpg/1280px-Griffith_Observatory_from_the_air.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Breakfast at The Trails Cafe",
              "description": "Enjoy a charming outdoor breakfast or coffee at this rustic cafe nestled in Griffith Park, a short distance from the observatory.",
              "placeName": "The Trails Cafe",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Trails+Cafe",
              "imageUrl": "https://example.com/trails_cafe.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "The Original Farmers Market & The Grove",
              "description": "Explore a historic open-air market with diverse food stalls, specialty grocers, and shops. Adjacent, The Grove offers high-end shopping and dining in a beautifully designed outdoor mall.",
              "placeName": "The Original Farmers Market",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Original+Farmers+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Original_Farmers_Market_Los_Angeles.jpg/1280px-Original_Farmers_Market_Los_Angeles.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at Du-par's Restaurant & Bakery",
              "description": "Savor classic American diner fare, famous pancakes, and fresh-baked pies at this iconic establishment within the Original Farmers Market.",
              "placeName": "Du-par's Restaurant & Bakery",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Du-par%27s+Restaurant+%26+Bakery",
              "imageUrl": "https://example.com/dupars_bakery.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Culver City",
              "description": "Enjoy a final Los Angeles meal in vibrant Culver City, known for its diverse culinary scene and proximity to SoFi Stadium and LAX.",
              "placeName": "Father's Office (Culver City)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Father%27s+Office+Culver+City",
              "imageUrl": "https://example.com/fathers_office.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "In-N-Out Burger (Classic California fast food, try the 'Animal Style')",
        "Taco Trucks (Authentic street tacos found throughout the city, especially in East LA and Boyle Heights)",
        "Pink's Hot Dogs (Hollywood institution since 1939, famous for its chili dogs)",
        "California Pizza Kitchen (Casual dining, known for its innovative pizzas and California cuisine)",
        "Korean BBQ (Experience interactive dining in Koreatown with grilling at your table)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Official fan zones with live broadcasts, entertainment, food, and sponsor activities)",
        "SoFi Stadium Match Day Experience (Arrive early to soak in the atmosphere, explore the stadium, and enjoy pre-match festivities)",
        "Official FIFA Merchandise Stores (Located at fan zones and the stadium for official gear)",
        "Local Sports Bars (Watch other World Cup matches with local fans; consider places in Hollywood, Santa Monica, or Downtown LA)"
      ],
      "travel_tips": [
        "How to Reach SoFi Stadium (Inglewood): SoFi Stadium is located in Inglewood, a city south-west of downtown Los Angeles. On match days, public transport and designated shuttles are the recommended way to get there.",
        "Metro K Line (Crenshaw/LAX Line): Take the K Line to Downtown Inglewood Station. From there, match day shuttles or a walk may be available to the stadium. Check official event guides closer to 2026 for shuttle details.",
        "Metro C Line (Green Line): Take the C Line to Hawthorne/Lennox Station. Match day shuttles are typically provided directly from this station to SoFi Stadium.",
        "Ride-sharing: Uber/Lyft will operate, but expect heavy traffic, road closures, and surge pricing on match days. Designated drop-off/pick-up zones will be established.",
        "Where to Stay: Consider accommodations in Inglewood (closest), Culver City (good balance of dining, transport, and proximity), El Segundo/Hawthorne (close to LAX and SoFi), or Marina del Rey/Playa Vista for a coastal vibe. Downtown LA offers many hotel options but involves a longer commute to SoFi via Metro.",
        "Public Transportation in LA: The Los Angeles Metro system includes an extensive network of Metro Rail (subway and light rail) and Metro Bus lines. This is the most cost-effective way to get around.",
        "TAP Card: A reusable, reloadable card required for all Metro services. Purchase at Metro stations or online and load with fare (single rides, day passes, 7-day passes). Tap your card at validators before boarding trains or buses.",
        "Planning Your Journey: Use Google Maps or the official Metro Trip Planner app for real-time schedules, routing, and fare information. Be aware that travel times can be significant due to LA's size and traffic."
      ]
    },
    "5": {
      "plannerCity": "Los Angeles",
      "matchDay": 3,
      "city": "Los Angeles",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive at Los Angeles International Airport (LAX), take a shuttle or ride-share to your accommodation. We recommend staying in areas like Culver City, Inglewood, or Koreatown for good access to SoFi Stadium and other attractions.",
              "placeName": "Los Angeles International Airport (LAX)",
              "mapLink": "https://www.google.com/maps/place/Los+Angeles+International+Airport/@33.9415889,-118.4085447,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b0d213b24bfd:0x1b79f928e217112d!8m2!3d33.9415889!4d-118.4085447!16zL20vMDQzYzE?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/LAX_Theme_Building.jpg/1024px-LAX_Theme_Building.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Hollywood Walk of Fame & TCL Chinese Theatre",
              "description": "Stroll along the iconic Hollywood Walk of Fame, spot your favorite stars, and admire the handprints and footprints of legends at the TCL Chinese Theatre.",
              "placeName": "Hollywood Walk of Fame",
              "mapLink": "https://www.google.com/maps/place/Hollywood+Walk+of+Fame/@34.1016839,-118.3377749,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2bf07077e77a1:0x4111306e0018a14b!8m2!3d34.1016839!4d-118.3377749!16zL20vMGQxZHo?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Hollywood_Walk_of_Fame_stars.jpg/1024px-Hollywood_Walk_of_Fame_stars.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at In-N-Out Burger",
              "description": "Experience a true California classic with a Double-Double, animal style fries, and a milkshake. This iconic fast-food chain is a must-try.",
              "placeName": "In-N-Out Burger (Hollywood Blvd)",
              "mapLink": "https://www.google.com/maps/place/In-N-Out+Burger/@34.1018861,-118.3364406,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2bf070624d77d:0x87d606191a329ef2!8m2!3d34.1018861!4d-118.3364406!16s%2Fg%2F1tdw0y46?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/In-N-Out_Burger_restaurant_in_Los_Angeles%2C_California.jpg/1024px-In-N-Out_Burger_restaurant_in_Los_Angeles%2C_California.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Santa Monica Pier & Beach",
              "description": "Enjoy the iconic Santa Monica Pier with its amusement park, arcade, and stunning ocean views. Take a walk along the beach and feel the Pacific breeze.",
              "placeName": "Santa Monica Pier",
              "mapLink": "https://www.google.com/maps/place/Santa+Monica+Pier/@34.0088921,-118.4988772,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2a4d9526715f5:0x5e5272a297e59c2!8m2!3d34.0088921!4d-118.4988772!16zL20vMDFjZjN3?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Santa_Monica_Pier_-_August_2018.jpg/1024px-Santa_Monica_Pier_-_August_2018.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Venice Beach Boardwalk",
              "description": "Walk, bike, or people-watch at the eclectic Venice Beach Boardwalk, famous for its street performers, Muscle Beach, and vibrant art scene.",
              "placeName": "Venice Beach Boardwalk",
              "mapLink": "https://www.google.com/maps/place/Venice+Beach+Boardwalk/@33.9928509,-118.4740713,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2a45053f3607f:0x3418579435b80e72!8m2!3d33.9928509!4d-118.4740713!16zL20vMGY1MjQ?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Venice_Beach_Boardwalk_in_2022.jpg/1024px-Venice_Beach_Boardwalk_in_2022.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Griffith Observatory & Hollywood Sign View",
              "description": "Travel to Griffith Observatory (note: this is a longer journey from Venice Beach, allow 1-1.5 hours depending on traffic) for breathtaking panoramic views of the city, the Hollywood Sign, and the Pacific Ocean, especially beautiful at sunset. Explore the exhibits inside.",
              "placeName": "Griffith Observatory",
              "mapLink": "https://www.google.com/maps/place/Griffith+Observatory/@34.1185521,-118.3003738,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2c10744040409:0x879133b3a27072a3!8m2!3d34.1185521!4d-118.3003738!16zL20vMGQxYzc?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Griffith_Observatory_from_the_southwest_2.jpg/1024px-Griffith_Observatory_from_the_southwest_2.jpg",
              "best_time": "evening",
              "suggested_time": "17:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival / Fan Zone",
              "description": "Immerse yourself in the pre-match excitement at an official FIFA Fan Festival or Fan Zone (locations typically announced closer to the event, often in central areas like Exposition Park or Downtown LA). Enjoy live music, food, games, and merchandise.",
              "placeName": "FIFA Fan Festival (Anticipated location: Exposition Park or Downtown LA)",
              "mapLink": "https://www.google.com/maps/place/Exposition+Park/@34.0152427,-118.2882207,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2c7f407b78f4b:0x5e263e3d489f6608!8m2!3d34.0152427!4d-118.2882207!16zL20vMGI5d2Y?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/FIFA_Fan_Fest_Rio_de_Janeiro_2014.jpg/1024px-FIFA_Fan_Fest_Rio_de_Janeiro_2014.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to SoFi Stadium & Pre-Match Atmosphere",
              "description": "Head to SoFi Stadium in Inglewood. Utilize designated FIFA shuttle services from Metro stations or Park & Ride lots. Arrive early to soak in the vibrant atmosphere, explore the stadium grounds, and visit team fan shops.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/place/SoFi+Stadium/@33.9534914,-118.3392437,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b74054a1796d:0x22131015f69c0d75!8m2!3d33.9534914!4d-118.3392437!16zL20vMGZ5d2h3?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/SoFi_Stadium_Opening_Night.jpg/1024px-SoFi_Stadium_Opening_Night.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at SoFi Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the state-of-the-art SoFi Stadium, home to the Los Angeles Rams and Chargers. Enjoy the game, the crowd, and the unforgettable energy of global football.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/place/SoFi+Stadium/@33.9534914,-118.3392437,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b74054a1796d:0x22131015f69c0d75!8m2!3d33.9534914!4d-118.3392437!16zL20vMGZ5d2h3?entry=ttu",
              "ticketLink": "https://www.fifa.com/tickets/world-cup-2026",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/SoFi_Stadium_on_March_12%2C_2022.jpg/1024px-SoFi_Stadium_on_March_12%2C_2022.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "The Getty Center",
              "description": "Visit The Getty Center, a stunning architectural marvel with impressive art collections, beautiful gardens, and panoramic views of Los Angeles. Allow ample time for exploration.",
              "placeName": "The Getty Center",
              "mapLink": "https://www.google.com/maps/place/The+Getty+Center/@34.0772274,-118.4741641,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2bc9571932973:0x1b7026df128795c6!8m2!3d34.0772274!4d-118.4741641!16zL20vMGQxY3c?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/The_Getty_Center_2007.jpg/1024px-The_Getty_Center_2007.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Grand Central Market & Angel's Flight",
              "description": "Head downtown to Grand Central Market, a historic food hall with diverse culinary options. Enjoy lunch from a variety of vendors, then take a ride on the iconic Angel's Flight funicular.",
              "placeName": "Grand Central Market",
              "mapLink": "https://www.google.com/maps/place/Grand+Central+Market/@34.0507304,-118.2514125,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2c647b0e1e695:0x5e5272a297e59c2!8m2!3d34.0507304!4d-118.2514125!16zL20vMDd2bXg?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Grand_Central_Market%2C_Los_Angeles_%28cropped%29.jpg/1024px-Grand_Central_Market%2C_Los_Angeles_%28cropped%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Little Tokyo",
              "description": "Explore the historic Little Tokyo district and enjoy an authentic Japanese dinner. Try a ramen spot like Daikokuya or a sushi restaurant.",
              "placeName": "Little Tokyo",
              "mapLink": "https://www.google.com/maps/place/Little+Tokyo/@34.0480397,-118.240751,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2c64b73b22e1b:0x5e5272a297e59c2!8m2!3d34.0480397!4d-118.240751!16zL20vMDRfMmc?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Little_Tokyo_in_Los_Angeles.jpg/1024px-Little_Tokyo_in_Los_Angeles.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Petersen Automotive Museum",
              "description": "Visit the Petersen Automotive Museum on Museum Row, known for its stunning architecture and impressive collection of classic, custom, and futuristic vehicles. Perfect for car enthusiasts.",
              "placeName": "Petersen Automotive Museum",
              "mapLink": "https://www.google.com/maps/place/Petersen+Automotive+Museum/@34.0621434,-118.3582103,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b9213192451f:0x5e5272a297e59c2!8m2!3d34.0621434!4d-118.3582103!16zL20vMGc4a3Q?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Petersen_Automotive_Museum_cropped.jpg/1024px-Petersen_Automotive_Museum_cropped.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Last-minute Souvenir Shopping / Lunch",
              "description": "Enjoy a final Los Angeles meal or pick up some last-minute souvenirs. Consider a casual lunch at a popular spot like Pink's Hot Dogs (Hollywood) or a gourmet food truck.",
              "placeName": "The Grove / Farmers Market",
              "mapLink": "https://www.google.com/maps/place/The+Original+Farmers+Market/@34.072049,-118.3580556,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b92205562723:0x5e5272a297e59c2!8m2!3d34.072049!4d-118.3580556!16zL20vMGI3bXo?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/The_Grove%2C_Los_Angeles.jpg/1024px-The_Grove%2C_Los_Angeles.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Departure from LAX",
              "description": "Head to Los Angeles International Airport (LAX) for your departure, taking with you unforgettable memories of the FIFA World Cup and Los Angeles.",
              "placeName": "Los Angeles International Airport (LAX)",
              "mapLink": "https://www.google.com/maps/place/Los+Angeles+International+Airport/@33.9415889,-118.4085447,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2b0d213b24bfd:0x1b79f928e217112d!8m2!3d33.9415889!4d-118.4085447!16zL20vMDQzYzE?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/LAX_Theme_Building.jpg/1024px-LAX_Theme_Building.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "In-N-Out Burger (Classic California fast food)",
        "Tacos (from street vendors or a local taqueria like Leo's Tacos Truck)",
        "Ramen (Little Tokyo - e.g., Daikokuya)",
        "California Pizza Kitchen (Original BBQ Chicken Pizza)",
        "Kogi BBQ Truck (Korean BBQ Tacos)"
      ],
      "football_experiences": [
        "FIFA Fan Festival / Fan Zone (anticipated locations: Exposition Park, Downtown LA)",
        "Live FIFA World Cup Match at SoFi Stadium, Inglewood",
        "Visiting a local sports bar (e.g., The Greyhound Bar & Grill, Lucky Baldwin's Pub) to catch other matches",
        "Exploring the pre-match atmosphere around SoFi Stadium on match day"
      ],
      "travel_tips": [
        "**Public Transportation:** Los Angeles has an extensive Metro Rail and Metro Bus system. Purchase a reloadable **TAP card** ($2) from vending machines at Metro stations or Metro Customer Service Centers, then load it with fare (e.g., a 1-Day Pass for $3.50 or stored value). Use the Metro Trip Planner for routes and schedules.",
        "**Getting to SoFi Stadium:** SoFi Stadium is located in Inglewood and does not have a direct Metro Rail station. For FIFA World Cup matches, special event shuttles will likely operate from nearby Metro Rail stations (e.g., Downtown Inglewood Station on the K Line, or Hawthorne/Lennox Station on the C Line) or designated Park & Ride lots. Check official FIFA and LA Metro announcements closer to the event for specific match day transportation plans.",
        "**Where to Stay:** Consider accommodations in areas like **Culver City**, **Inglewood**, **Koreatown**, or **Downtown Los Angeles**. These areas offer a good balance of accessibility to SoFi Stadium (via short ride-shares or future Metro connections/shuttles) and major tourist attractions. West Hollywood and Hollywood are also popular but further from SoFi.",
        "**Traffic:** Los Angeles is notorious for traffic. Always factor in extra travel time, especially during peak hours (7-10 AM and 3-7 PM on weekdays). Use real-time navigation apps.",
        "**Walking/Footwear:** Many attractions require walking. Wear comfortable shoes.",
        "**Sun Protection:** Los Angeles is sunny. Bring sunscreen, a hat, and sunglasses, and stay hydrated."
      ]
    },
    "7": {
      "plannerCity": "Los Angeles",
      "matchDay": 4,
      "city": "Los Angeles",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Griffith Observatory",
              "description": "Enjoy panoramic views of the Los Angeles basin, Hollywood Sign, and Pacific Ocean. Explore the exhibits on space and science.",
              "placeName": "Griffith Observatory",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Griffith+Observatory",
              "ticketLink": "https://griffithobservatory.org/visit/admission/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Griffith_Observatory_from_the_air.jpg/1920px-Griffith_Observatory_from_the_air.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Hollywood Walk of Fame & TCL Chinese Theatre",
              "description": "Stroll along the iconic Hollywood Walk of Fame, discover celebrity stars, and see the handprints and footprints at the historic TCL Chinese Theatre.",
              "placeName": "Hollywood Walk of Fame",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Hollywood+Walk+of+Fame",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Hollywood_Walk_of_Fame_stars_2010.jpg/1920px-Hollywood_Walk_of_Fame_stars_2010.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at In-N-Out Burger",
              "description": "Experience a classic California fast-food joint. Order your burger 'Animal Style' for a local favorite.",
              "placeName": "In-N-Out Burger (Hollywood)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=In-N-Out+Burger+7009+Sunset+Blvd%2C+Los+Angeles%2C+CA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/In-N-Out_Burger_at_Fisherman%27s_Wharf%2C_San_Francisco.jpg/1920px-In-N-Out_Burger_at_Fisherman%27s_Wharf%2C_San_Francisco.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Hollywood & Sunset Strip Exploration",
              "description": "Enjoy dinner at a restaurant on the Sunset Strip, then soak in the vibrant nightlife and iconic music venues.",
              "placeName": "The Rainbow Bar & Grill",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Rainbow+Bar+and+Grill",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Rainbow_Bar_%26_Grill_on_Sunset_Strip.jpg/1920px-Rainbow_Bar_%26_Grill_on_Sunset_Strip.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Santa Monica Pier & Beach",
              "description": "Visit the iconic Santa Monica Pier, enjoy the Pacific Park amusement rides, and relax on the beautiful beach.",
              "placeName": "Santa Monica Pier",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Santa+Monica+Pier",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Santa_Monica_Pier_at_Sunset.jpg/1920px-Santa_Monica_Pier_at_Sunset.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Venice Beach Boardwalk",
              "description": "Stroll or bike along the lively Venice Beach Boardwalk, famous for its street performers, Muscle Beach, and eclectic shops.",
              "placeName": "Venice Beach Boardwalk",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Venice+Beach+Boardwalk",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Venice_Beach_Boardwalk_%281%29.jpg/1920px-Venice_Beach_Boardwalk_%281%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at The Lobster",
              "description": "Enjoy fresh seafood with stunning ocean views right at the entrance to Santa Monica Pier.",
              "placeName": "The Lobster",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Lobster+Santa+Monica",
              "imageUrl": "https://res.cloudinary.com/traveltripper/image/upload/v1580252199/oxq8372s5g2y3v6l8z3u.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Santa Monica",
              "description": "Explore the dining scene in Santa Monica, perhaps at a restaurant on 3rd Street Promenade or near the beach.",
              "placeName": "Élephante Beach House",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Elephante+Beach+House+Santa+Monica",
              "imageUrl": "https://www.elephante.com/wp-content/uploads/2023/07/Elephante-Beach-House-Santa-Monica.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Grand Central Market & Angels Flight Railway",
              "description": "Explore the historic Grand Central Market, a vibrant food hall with diverse vendors. Take a ride on the iconic Angels Flight funicular.",
              "placeName": "Grand Central Market",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Grand+Central+Market+Los+Angeles",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Grand_Central_Market_at_night.jpg/1920px-Grand_Central_Market_at_night.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Breakfast/Brunch at Eggslut (Grand Central Market)",
              "description": "Indulge in a gourmet egg sandwich at this popular stall within Grand Central Market.",
              "placeName": "Eggslut (Grand Central Market)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Eggslut+Grand+Central+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Eggslut_Fairfax_on_Brioche.jpg/1280px-Eggslut_Fairfax_on_Brioche.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "The Broad Museum",
              "description": "Visit this contemporary art museum, home to a vast collection of post-war and contemporary art. Free general admission (reservations recommended).",
              "placeName": "The Broad",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Broad+Museum",
              "ticketLink": "https://ticketing.thebroad.org/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/The_Broad_Museum_Los_Angeles_California.jpg/1920px-The_Broad_Museum_Los_Angeles_California.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Downtown LA",
              "description": "Explore the diverse dining options in Downtown LA, from casual eateries to upscale restaurants.",
              "placeName": "Bavel",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Bavel+Los+Angeles",
              "imageUrl": "https://www.baveldtla.com/wp-content/uploads/2021/04/Bavel_Dining_Room_1.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Los Angeles",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch matches on giant screens.",
              "placeName": "Grand Park (Likely Fan Fest Location)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Grand+Park+Los+Angeles",
              "imageUrl": "https://www.lacounty.gov/wp-content/uploads/2019/07/grand-park-dtla.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to SoFi Stadium & Pre-Match Tailgate",
              "description": "Make your way to SoFi Stadium in Inglewood. Join fellow fans for pre-match festivities, food trucks, and the electric atmosphere around the stadium.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/SoFi_Stadium_2020.jpg/1920px-SoFi_Stadium_2020.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            },
            {
              "name": "Lunch/Snacks at SoFi Stadium Area",
              "description": "Grab a bite from food vendors or local spots around SoFi Stadium before entering for the match.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at SoFi Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the state-of-the-art SoFi Stadium, home to the biggest sporting events.",
              "placeName": "SoFi Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=SoFi+Stadium",
              "ticketLink": "https://www.fifa.com/worldcup/2026/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/SoFi_Stadium_interior_during_Super_Bowl_LVI.jpg/1920px-SoFi_Stadium_interior_during_Super_Bowl_LVI.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "The Getty Center",
              "description": "Explore a world-renowned art museum with stunning architecture, gardens, and panoramic views of Los Angeles. Take the tram up to the center.",
              "placeName": "The Getty Center",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Getty+Center",
              "ticketLink": "https://www.getty.edu/visit/plan/tickets.html",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Getty_Center_West_Building.jpg/1920px-Getty_Center_West_Building.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Rodeo Drive & Beverly Hills",
              "description": "Experience the glamour of Beverly Hills with a stroll along Rodeo Drive, famous for its luxury boutiques and celebrity sightings.",
              "placeName": "Rodeo Drive",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Rodeo+Drive+Beverly+Hills",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Rodeo_Drive_2011.jpg/1920px-Rodeo_Drive_2011.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            },
            {
              "name": "Sweet Treat at Sprinkles Cupcakes",
              "description": "Grab a delicious cupcake from the original Sprinkles bakery in Beverly Hills, a local favorite.",
              "placeName": "Sprinkles Cupcakes (Beverly Hills)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Sprinkles+Cupcakes+Beverly+Hills",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Sprinkles_Cupcakes_NYC.jpg/1280px-Sprinkles_Cupcakes_NYC.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in West Hollywood",
              "description": "Enjoy dinner in the vibrant West Hollywood neighborhood, known for its trendy restaurants and lively atmosphere.",
              "placeName": "Catch LA",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Catch+LA",
              "imageUrl": "https://www.catchrestaurants.com/wp-content/uploads/2021/04/Catch-LA-Rooftop-Dining.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Hollywood Sign Viewpoint Hike",
              "description": "Hike to a popular viewpoint for stunning photos of the iconic Hollywood Sign and panoramic city views from Griffith Park.",
              "placeName": "Canyon Lake Drive (Hollywood Sign View)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Canyon+Lake+Drive+Hollywood+Sign+View",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Hollywood_Sign_from_Griffith_Observatory.jpg/1920px-Hollywood_Sign_from_Griffith_Observatory.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Runyon Canyon Park Hike",
              "description": "Enjoy a popular urban hike offering fantastic views of the city, the Hollywood Sign, and celebrity spotting opportunities.",
              "placeName": "Runyon Canyon Park",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Runyon+Canyon+Park",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Runyon_Canyon_Park_view.jpg/1920px-Runyon_Canyon_Park_view.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Lunch at Pink's Hot Dogs",
              "description": "Experience a legendary Los Angeles hot dog stand, famous for its variety of creative hot dogs and long lines.",
              "placeName": "Pink's Hot Dogs",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Pinks+Hot+Dogs+Los+Angeles",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Pinks_Hot_Dogs_%284093952737%29.jpg/1920px-Pinks_Hot_Dogs_%284093952737%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:00"
            }
          ],
          "evening": [
            {
              "name": "Universal CityWalk Hollywood",
              "description": "Spend your evening exploring Universal CityWalk, a vibrant entertainment complex with shops, restaurants, and movie theaters.",
              "placeName": "Universal CityWalk Hollywood",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Universal+CityWalk+Hollywood",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Universal_CityWalk_at_night.jpg/1920px-Universal_CityWalk_at_night.jpg",
              "best_time": "evening",
              "suggested_time": "18:30"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Explore Koreatown",
              "description": "Discover the vibrant culture of Koreatown, known for its unique shops, spas, and 24-hour businesses.",
              "placeName": "Koreatown, Los Angeles",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Koreatown+Los+Angeles",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Koreatown_Los_Angeles_sign.jpg/1920px-Koreatown_Los_Angeles_sign.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Korean BBQ Lunch",
              "description": "Enjoy an authentic Korean BBQ experience, a staple of LA's diverse culinary scene.",
              "placeName": "Kang Ho Dong Baekjeong (Koreatown)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Kang+Ho+Dong+Baekjeong+Koreatown",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Korean_BBQ_at_Kang_Ho-dong_Baekjeong_in_Los_Angeles.jpg/1920px-Korean_BBQ_at_Kang_Ho-dong_Baekjeong_in_Los_Angeles.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Departure from LAX",
              "description": "Head to Los Angeles International Airport (LAX) for your departure, reflecting on your World Cup and LA adventure.",
              "placeName": "Los Angeles International Airport (LAX)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Los+Angeles+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Los_Angeles_International_Airport_at_night.jpg/1920px-Los_Angeles_International_Airport_at_night.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "In-N-Out Burger (classic California fast food)",
        "Tacos from a street vendor or taqueria (e.g., Leo's Tacos Truck)",
        "Korean BBQ in Koreatown (e.g., Kang Ho Dong Baekjeong)",
        "Gourmet egg sandwiches at Eggslut (Grand Central Market)",
        "Seafood in Santa Monica (e.g., The Lobster)",
        "Pink's Hot Dogs (LA institution)"
      ],
      "football_experiences": [
        "FIFA Fan Festival Los Angeles (Grand Park or other designated area)",
        "Pre-match tailgate and atmosphere around SoFi Stadium",
        "FIFA World Cup Match at SoFi Stadium, Inglewood",
        "Visiting sports bars in Hollywood or West Hollywood to watch other matches"
      ],
      "travel_tips": [
        "**Getting to SoFi Stadium:** SoFi Stadium is located in Inglewood. On match days, the best way to reach it is via the Metro Rail C Line (formerly Green Line) to the Hawthorne/Lennox Station, then connect to a dedicated stadium shuttle service (likely provided by Metro or the event organizers). Alternatively, the K Line (Crenshaw/LAX Line) to Downtown Inglewood Station may also have shuttle connections. Check official FIFA and LA Metro announcements closer to the event for specific routes and schedules.",
        "**Public Transportation in Los Angeles:** The primary public transport system is Metro, which includes a comprehensive network of Metro Rail (subway and light rail) and Metro Bus lines. Purchase a reusable **TAP card** at any Metro Rail station vending machine or major bus stops. Load it with stored value or a 1-Day/7-Day Pass. Use the Metro Trip Planner or apps like Google Maps for route planning.",
        "**Accommodation Recommendations:** Consider staying in areas with good Metro access, such as Downtown LA (DTLA), Hollywood, Koreatown, or Culver City. These areas offer a range of hotels for medium budgets and provide relatively easy access to SoFi Stadium and major attractions. For a more upscale experience, Beverly Hills or Santa Monica are options, but may require longer travel times to SoFi.",
        "**Traffic:** Los Angeles is notorious for traffic. Always factor in extra travel time, especially during peak hours or when traveling to/from events like the World Cup. Public transport is highly recommended to avoid parking hassles and traffic delays.",
        "**Walking/Cycling:** While LA is spread out, certain neighborhoods (e.g., Santa Monica, Venice, Hollywood, DTLA) are very walkable or bike-friendly. Consider renting bikes in beach areas."
      ]
    }
  },
  "dallas": {
    "3": {
      "plannerCity": "Arlington",
      "matchDay": 2,
      "city": "Arlington",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Globe Life Field Tour (Home of Texas Rangers)",
              "description": "Explore the state-of-the-art baseball stadium, just steps from AT&T Stadium. A great way to start immersing in the local sports culture.",
              "placeName": "Globe Life Field",
              "mapLink": "https://www.google.com/maps/place/Globe+Life+Field/@32.747514,-97.082729,17z/",
              "ticketLink": "https://www.mlb.com/rangers/ballpark/tours",
              "imageUrl": "https://www.mlb.com/rangers/ballpark/information/imagery/globe-life-field-exterior-night-1920x1080.jpg",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Hurtado Barbecue",
              "description": "Savor authentic Texas barbecue known for its unique blend of Central Texas and Mexican influences.",
              "placeName": "Hurtado Barbecue",
              "mapLink": "https://www.google.com/maps/place/Hurtado+Barbecue/@32.748366,-97.108253,17z/",
              "imageUrl": "https://hurtadobbq.com/wp-content/uploads/2020/09/hurtado-bbq-arlington-home-min.jpg",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Explore the AT&T Stadium Grounds & Art Collection",
              "description": "Get a sneak peek of the iconic AT&T Stadium exterior and explore its impressive contemporary art collection (self-guided viewing of public areas).",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747761,-97.094595,17z/",
              "imageUrl": "https://static.attstadium.com/assets/img/att-stadium-exterior-1.jpg",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Entertainment at Texas Live!",
              "description": "Enjoy a vibrant entertainment complex featuring multiple restaurants, bars, and a large outdoor plaza, right next to the stadiums.",
              "placeName": "Texas Live!",
              "mapLink": "https://www.google.com/maps/place/Texas+Live!/@32.747746,-97.085791,17z/",
              "imageUrl": "https://www.texas-live.com/images/default-source/default-album/texas-live-exterior-2.jpg?sfvrsn=a4675e24_2",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match atmosphere at the official FIFA Fan Festival, with live music, food, merchandise, and interactive football activities. (Location assumed near stadium complex).",
              "placeName": "FIFA Fan Festival (Assumed location near AT&T Stadium)",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747761,-97.094595,17z/",
              "imageUrl": "https://digitalhub.fifa.com/transform/4b170c47-3b2d-450f-a725-70335e326639/FIFA-World-Cup-Qatar-2022-Fan-Festival-Al-Bidda-Park-Doha",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Meal & Atmosphere",
              "description": "Grab a meal at one of the many eateries within the Fan Festival or surrounding Texas Live! complex, soaking in the growing excitement.",
              "placeName": "Texas Live! / FIFA Fan Festival",
              "mapLink": "https://www.google.com/maps/place/Texas+Live!/@32.747746,-97.085791,17z/",
              "imageUrl": "https://www.texas-live.com/images/default-source/default-album/texas-live-dining.jpg?sfvrsn=a4675e24_2",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Head to AT&T Stadium Gates",
              "description": "Make your way to AT&T Stadium, explore the concourses, find your seats, and experience the pre-match build-up inside the venue.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747761,-97.094595,17z/",
              "imageUrl": "https://static.attstadium.com/assets/img/att-stadium-interior-1.jpg",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match!",
              "description": "Witness the thrill of a live FIFA World Cup match at the magnificent AT&T Stadium.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747761,-97.094595,17z/",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/70274246-8152-44f2-95f3-c5b7661df6d3/FIFA-World-Cup-Qatar-2022-Match-Action",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Post-Match Celebration/Dinner",
              "description": "Celebrate or commiserate with fellow fans. Options available at Texas Live! or head to a local Arlington spot for a late dinner.",
              "placeName": "Texas Live! or local Arlington restaurant",
              "mapLink": "https://www.google.com/maps/place/Texas+Live!/@32.747746,-97.085791,17z/",
              "imageUrl": "https://www.texas-live.com/images/default-source/default-album/texas-live-crowd.jpg?sfvrsn=a4675e24_2",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "The Sixth Floor Museum at Dealey Plaza",
              "description": "Visit the historic site depicting the assassination and legacy of President John F. Kennedy. A profound historical landmark.",
              "placeName": "The Sixth Floor Museum at Dealey Plaza",
              "mapLink": "https://www.google.com/maps/place/The+Sixth+Floor+Museum+at+Dealey+Plaza/@32.779532,-96.809315,17z/",
              "ticketLink": "https://www.jfk.org/visit/plan-your-visit/tickets/",
              "imageUrl": "https://www.jfk.org/wp-content/uploads/2019/07/The-Sixth-Floor-Museum-at-Dealey-Plaza-Exterior.jpg",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Breakfast/Brunch at Ellen's",
              "description": "Enjoy a hearty breakfast or brunch at a popular spot in downtown Dallas, known for its Southern comfort food.",
              "placeName": "Ellen's",
              "mapLink": "https://www.google.com/maps/place/Ellen's/@32.784405,-96.801646,17z/",
              "imageUrl": "https://static.wixstatic.com/media/078a6d_1b8c0e6f8b6d4e5f9e8a7c2e0b8c0e6f~mv2.jpg/v1/fill/w_640,h_480,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/078a6d_1b8c0e6f8b6d4e5f9e8a7c2e0b8c0e6f~mv2.jpg",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Dallas Arts District",
              "description": "Wander through the largest contiguous urban arts district in the nation, home to world-class museums and performance venues.",
              "placeName": "Dallas Arts District",
              "mapLink": "https://www.google.com/maps/place/Dallas+Arts+District/@32.788466,-96.797967,16z/",
              "imageUrl": "https://www.dallasartsdistrict.org/wp-content/uploads/2021/08/Dallas-Arts-District-Museums.jpg",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Deep Ellum Exploration & Coffee",
              "description": "Discover the historic Deep Ellum entertainment district, known for its vibrant street art, live music, and unique shops. Grab a coffee or snack.",
              "placeName": "Deep Ellum",
              "mapLink": "https://www.google.com/maps/place/Deep+Ellum/@32.783637,-96.786524,16z/",
              "imageUrl": "https://assets.simpleviewinc.com/simpleview/image/upload/c_fill,h_800,q_75,w_1200/v1/clients/dallas/Deep_Ellum_Street_Art_d3f3f262-d278-433b-8515-56019a57100b.jpg",
              "suggested_time": "04:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at Pecan Lodge",
              "description": "Indulge in some of Dallas's most famous, award-winning barbecue for your final Texas meal. Be prepared for a potential wait!",
              "placeName": "Pecan Lodge",
              "mapLink": "https://www.google.com/maps/place/Pecan+Lodge/@32.784405,-96.788414,17z/",
              "imageUrl": "https://pecanlodge.com/wp-content/uploads/2020/07/PecanLodge-exterior-1024x683.jpg",
              "suggested_time": "06:30 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Texas BBQ (Hurtado Barbecue, Pecan Lodge)",
        "Tex-Mex (e.g., El Fenix, Mia's Tex-Mex)",
        "Southern Comfort Food (Ellen's)"
      ],
      "football_experiences": [
        "FIFA Fan Festival",
        "AT&T Stadium Match Day Experience",
        "Exploring AT&T Stadium (Art Collection/Exterior)",
        "Texas Live! atmosphere"
      ],
      "travel_tips": [
        "How to reach the stadium (AT&T Stadium, Arlington): AT&T Stadium is not directly served by light rail. On match days, dedicated shuttles are typically provided from designated parking lots around Arlington and potentially from DART (Dallas Area Rapid Transit) light rail stations in Dallas (e.g., CentrePort/DFW Airport Station or downtown Dallas stations). For general travel, ride-sharing services (Uber/Lyft) are the most convenient option to/from the stadium. Pre-booking ride-shares for busy event days is recommended.",
        "Where to stay: For proximity to AT&T Stadium, consider hotels in Arlington's Entertainment District. Irving (especially Las Colinas) offers good options with easier access to DFW Airport and a reasonable drive to Arlington. Downtown Dallas or Fort Worth offer more urban experiences but will involve longer commutes (30-45 minutes drive, or longer via public transport).",
        "Public Transportation in Dallas-Fort Worth: The DART (Dallas Area Rapid Transit) system serves Dallas and surrounding cities with light rail, commuter rail (Trinity Railway Express - TRE), and buses. Trinity Metro serves Fort Worth. Arlington has the Arlington On-Demand service (Via), which is a ride-share public transit system within the city. For DART, purchase tickets via the GoPass app or at station kiosks. For TRE, tickets can be purchased at stations. Arlington On-Demand requires booking through the Via app. A regional pass might be available for the World Cup, otherwise, single-ride or day passes are common. For travel between Dallas and Fort Worth, the Trinity Railway Express (TRE) commuter rail is an option."
      ]
    },
    "5": {
      "plannerCity": "Arlington",
      "matchDay": 3,
      "city": "Arlington",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore Dealey Plaza and The Sixth Floor Museum",
              "description": "Visit the historic site of President John F. Kennedy's assassination and learn about his legacy and the events of November 22, 1963, at the museum located in the former Texas School Book Depository.",
              "placeName": "The Sixth Floor Museum at Dealey Plaza",
              "mapLink": "https://www.google.com/maps/place/The+Sixth+Floor+Museum+at+Dealey+Plaza",
              "ticketLink": "https://www.jfk.org/visit/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/The_Sixth_Floor_Museum_at_Dealey_Plaza_2019.jpg/1280px-The_Sixth_Floor_Museum_at_Dealey_Plaza_2019.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Pecan Lodge",
              "description": "Savor authentic Texas barbecue at one of Dallas' most acclaimed smokehouses. Known for its brisket, ribs, and homemade sides.",
              "placeName": "Pecan Lodge",
              "mapLink": "https://www.google.com/maps/place/Pecan+Lodge",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Pecan_Lodge_2016.jpg/1280px-Pecan_Lodge_2016.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30 PM"
            },
            {
              "name": "Dallas Arts District Exploration",
              "description": "Wander through the largest contiguous urban arts district in the nation. Visit the Dallas Museum of Art (free general admission) or the Nasher Sculpture Center.",
              "placeName": "Dallas Arts District",
              "mapLink": "https://www.google.com/maps/place/Dallas+Arts+District",
              "ticketLink": "https://nashersculpturecenter.org/visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Dallas_Arts_District_at_night.jpg/1280px-Dallas_Arts_District_at_night.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Mi Cocina and Stroll Klyde Warren Park",
              "description": "Enjoy upscale Tex-Mex cuisine at Mi Cocina, then take an evening stroll or enjoy a free event at Klyde Warren Park, a vibrant urban park built over a freeway.",
              "placeName": "Mi Cocina - Klyde Warren Park",
              "mapLink": "https://www.google.com/maps/place/Mi+Cocina",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Klyde_Warren_Park_Dallas.jpg/1280px-Klyde_Warren_Park_Dallas.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Dallas World Aquarium",
              "description": "Discover exotic animals and marine life in a rainforest setting. A unique experience combining an aquarium and zoo.",
              "placeName": "Dallas World Aquarium",
              "mapLink": "https://www.google.com/maps/place/The+Dallas+World+Aquarium",
              "ticketLink": "https://dwazoo.com/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Dallas_World_Aquarium_02.jpg/1280px-Dallas_World_Aquarium_02.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at El Fenix",
              "description": "Experience classic Tex-Mex at one of Dallas' oldest and most beloved Mexican restaurants, serving traditional dishes since 1918.",
              "placeName": "El Fenix Mexican Restaurant - Downtown",
              "mapLink": "https://www.google.com/maps/place/El+Fenix+Mexican+Restaurant",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/ElFenix.jpg/1280px-ElFenix.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Reunion Tower Geo-Deck",
              "description": "Ascend to the top of Reunion Tower for 360-degree panoramic views of the Dallas skyline from the GeO-Deck observation level.",
              "placeName": "Reunion Tower",
              "mapLink": "https://www.google.com/maps/place/Reunion+Tower",
              "ticketLink": "https://reuniontower.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Reunion_Tower_Dallas_TX_2016.jpg/1280px-Reunion_Tower_Dallas_TX_2016.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dallas Soccer Bar Experience",
              "description": "Immerse yourself in local football culture by visiting a popular soccer-friendly bar in Dallas. Enjoy drinks and discussions with fellow fans.",
              "placeName": "The Londoner Pub",
              "mapLink": "https://www.google.com/maps/place/The+Londoner+Pub",
              "imageUrl": "https://londonerpub.com/wp-content/uploads/2019/07/Londoner-Pub-Dallas.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival (Arlington)",
              "description": "Kick off match day at the official FIFA Fan Festival. Enjoy live music, entertainment, food, interactive football games, and a vibrant atmosphere with fans from around the world.",
              "placeName": "FIFA Fan Festival Location (TBD, likely near AT&T Stadium or Globe Life Field)",
              "mapLink": "https://www.google.com/maps/search/Globe+Life+Field+Arlington+TX",
              "imageUrl": "https://digitalhub.fifa.com/transform/2e1964f5-207d-41a4-9788-b8054c76d004/FIFA-Fan-Festival?io=transform:fill,width:1920&quality=75",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Lunch at Texas Live!",
              "description": "Continue the pre-match excitement at Texas Live!, an entertainment complex adjacent to Globe Life Field. Grab lunch at one of its many restaurants or bars, soak in the fan energy, and then head towards AT&T Stadium.",
              "placeName": "Texas Live!",
              "mapLink": "https://www.google.com/maps/place/Texas+Live!",
              "imageUrl": "https://www.texas-live.com/sites/default/files/styles/16_9_large/public/2021-02/Texas-Live_Exterior_Night_1.jpg?h=81282285&itok=8yK-3k5m",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Arrive at AT&T Stadium & Explore",
              "description": "Arrive early at AT&T Stadium to navigate security, find your seats, and explore the impressive architecture and fan amenities of this world-class venue.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/AT%26T_Stadium_Exterior_2016.jpg/1280px-AT%26T_Stadium_Exterior_2016.jpg",
              "best_time": "afternoon",
              "suggested_time": "04:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a FIFA World Cup match live at AT&T Stadium! Witness world-class football in an electrifying atmosphere.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/34407380-60b3-4632-ab00-84451000f607/Dallas-stadium-exterior?io=transform:fill,width:1920&quality=75",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Fort Worth Stockyards National Historic District",
              "description": "Step back in time to the Old West. Witness the twice-daily cattle drive, explore the historic corrals, and browse western shops.",
              "placeName": "Fort Worth Stockyards National Historic District",
              "mapLink": "https://www.google.com/maps/place/Fort+Worth+Stockyards+National+Historic+District",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Fort_Worth_Stockyards_Main_Street.jpg/1280px-Fort_Worth_Stockyards_Main_Street.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Joe T. Garcia's Mexican Restaurant",
              "description": "Dine at a Fort Worth institution known for its sprawling patio, strong margaritas, and family-style Tex-Mex fare.",
              "placeName": "Joe T. Garcia's Mexican Restaurant",
              "mapLink": "https://www.google.com/maps/place/Joe+T.+Garcia%27s+Mexican+Restaurant",
              "imageUrl": "https://joetgarcias.com/wp-content/uploads/2019/04/Joe-T-Garcias-Patio.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Kimbell Art Museum",
              "description": "Visit one of the world's most impressive small museums, housing a collection of European, Asian, and Precolumbian art in an iconic Louis Kahn-designed building.",
              "placeName": "Kimbell Art Museum",
              "mapLink": "https://www.google.com/maps/place/Kimbell+Art+Museum",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Kimbell_Art_Museum_Facade.jpg/1280px-Kimbell_Art_Museum_Facade.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Entertainment at Sundance Square",
              "description": "Explore the vibrant entertainment district of Sundance Square in downtown Fort Worth. Enjoy dinner at a restaurant like Reata Restaurant for upscale Texan cuisine, followed by live music or a show.",
              "placeName": "Sundance Square",
              "mapLink": "https://www.google.com/maps/place/Sundance+Square",
              "imageUrl": "https://www.sundancesquare.com/wp-content/uploads/2021/08/sundance-square-fort-worth-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Shopping at Grand Prairie Premium Outlets",
              "description": "Enjoy a morning of retail therapy at Grand Prairie Premium Outlets, offering a wide range of designer and brand-name stores at discounted prices, conveniently located between Dallas and Fort Worth.",
              "placeName": "Grand Prairie Premium Outlets",
              "mapLink": "https://www.google.com/maps/place/Grand+Prairie+Premium+Outlets",
              "imageUrl": "https://assets.simon.com/tenant-media/58017/GrandPrairie-Hero.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Babe's Chicken Dinner House (Arlington)",
              "description": "Indulge in classic Southern comfort food with family-style fried chicken, mashed potatoes, and more at this local favorite.",
              "placeName": "Babe's Chicken Dinner House - Arlington",
              "mapLink": "https://www.google.com/maps/place/Babe%27s+Chicken+Dinner+House",
              "imageUrl": "https://www.babeschicken.com/wp-content/uploads/2019/08/babes-arlington-exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "International Bowling Museum & Hall of Fame",
              "description": "Explore the history and culture of bowling through interactive exhibits and memorabilia. A fun and unique stop in Arlington.",
              "placeName": "International Bowling Museum & Hall of Fame",
              "mapLink": "https://www.google.com/maps/place/International+Bowling+Museum+%26+Hall+of+Fame",
              "ticketLink": "https://bowlingmuseum.com/visit/hours-and-admission/",
              "imageUrl": "https://www.bowlingmuseum.com/wp-content/uploads/2022/07/Hall-of-Fame-Entrance-1024x768.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at The Capital Grille",
              "description": "Enjoy a sophisticated farewell dinner at The Capital Grille, known for its dry-aged steaks, fresh seafood, and extensive wine list.",
              "placeName": "The Capital Grille - Dallas",
              "mapLink": "https://www.google.com/maps/place/The+Capital+Grille",
              "imageUrl": "https://media.thecapitalgrille.com/images/site/ext/homepage/CG_Exterior_Hero.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Pecan Lodge (Dallas) - Texas BBQ",
        "El Fenix (Dallas) - Classic Tex-Mex",
        "Mi Cocina (Dallas) - Upscale Tex-Mex",
        "Joe T. Garcia's (Fort Worth) - Family-style Tex-Mex with a beautiful patio",
        "Reata Restaurant (Fort Worth) - Upscale Southwestern/Texan cuisine",
        "Babe's Chicken Dinner House (Arlington) - Southern Fried Chicken & Comfort Food",
        "Terry Black's BBQ (Dallas) - Another excellent BBQ option",
        "Cane Rosso (Dallas) - Authentic Neapolitan-style pizza"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Arlington) - Official fan zone with entertainment and food.",
        "AT&T Stadium Tour - Experience the stadium's locker rooms, field, and club areas (can be done on non-match days).",
        "Match Day at AT&T Stadium - Live game experience.",
        "Texas Live! (Arlington) - Entertainment complex with sports bars and restaurants near the stadium.",
        "Local Soccer Bars (e.g., The Londoner Pub in Dallas) - Immerse in local football fan culture."
      ],
      "travel_tips": [
        "**Getting to Arlington and AT&T Stadium:** Arlington does not have a direct light rail or commuter rail connection. The primary public transport for the DFW metroplex is DART (Dallas Area Rapid Transit) which serves Dallas and surrounding cities, and Trinity Metro which serves Fort Worth. For AT&T Stadium (Arlington), you will typically need to use a combination of DART/Trinity Metro and ride-sharing/taxi.",
        "**From Dallas to AT&T Stadium:** Take a DART Green or Orange Line train to the Downtown Irving/Heritage Crossing Station or CentrePort/DFW Airport Station. From there, use a ride-sharing service (Uber/Lyft) or taxi for the remaining 15-20 minute drive to the stadium. FIFA may arrange dedicated shuttles from specific DART stations during the World Cup, so check official event guides closer to the date.",
        "**From Fort Worth to AT&T Stadium:** Take the Trinity Railway Express (TRE) from Fort Worth Central Station to CentrePort/DFW Airport Station, then use a ride-sharing service or taxi for the final leg.",
        "**Public Transportation within Dallas/Fort Worth:**",
        "  - **Dallas Area Rapid Transit (DART):** Offers light rail, commuter rail (TRE), and bus services throughout Dallas and many surrounding suburbs. The GoPass app or a GoPass Tap Card is recommended for easy fare payment.",
        "  - **Trinity Metro (Fort Worth):** Provides bus services within Fort Worth and TEXRail commuter rail connecting Fort Worth to DFW Airport. A local pass or exact cash fare is needed.",
        "  - **Trinity Railway Express (TRE):** Connects downtown Dallas (Union Station) and downtown Fort Worth (ITC) with several stops in between, including CentrePort/DFW Airport.",
        "  - **Ride-sharing:** Uber and Lyft are widely available and often necessary for reaching destinations not directly served by public transit, especially in Arlington.",
        "**Where to Stay:** Consider staying in downtown Dallas, Uptown Dallas, or the Las Colinas area of Irving. These areas offer good hotel selections, are generally well-connected by DART (for Dallas options), and provide relatively convenient access to Arlington via ride-sharing or shuttles. Staying in Arlington itself (near the Entertainment District) offers proximity to the stadium but might be more expensive during the World Cup and less connected to broader DFW public transport for non-match days.",
        "**Booking:** Book accommodations, match tickets, and popular museum tickets well in advance due to high demand during the World Cup.",
        "**Weather:** June/July in Texas is hot and humid. Dress in light clothing, stay hydrated, and plan indoor activities during the hottest parts of the day."
      ]
    },
    "7": {
      "plannerCity": "Arlington",
      "matchDay": 4,
      "city": "Arlington",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Dallas/Fort Worth International Airport (DFW), travel to your accommodation in Arlington or a nearby DART-accessible area, and check in. Settle in and prepare for your World Cup adventure.",
              "placeName": "DFW International Airport",
              "mapLink": "https://www.google.com/maps/place/DFW+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/DFW_Terminal_D_exterior.jpg/1280px-DFW_Terminal_D_exterior.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Arlington Entertainment District Exploration",
              "description": "Explore the vibrant area around AT&T Stadium. Visit Globe Life Field, home of the Texas Rangers, and soak in the atmosphere of Texas Live!, an entertainment complex with restaurants and bars.",
              "placeName": "Texas Live!",
              "mapLink": "https://www.google.com/maps/place/Texas+Live!/@32.748386,-97.087799,17z/data=!3m1!4b1!4m6!3m5!1s0x864e83c79a1f7375:0x5e02206771d9d95f!8m2!3d32.748386!4d-97.085224!16s%2Fg%2F11g6d6w38d",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Texas_Live%21_at_Globe_Life_Park_in_Arlington_%28cropped%29.jpg/1280px-Texas_Live%21_at_Globe_Life_Park_in_Arlington_%28cropped%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Hurtado Barbecue",
              "description": "Enjoy authentic Texas BBQ at Hurtado Barbecue, known for its unique blend of Tex-Mex and traditional Central Texas BBQ flavors.",
              "placeName": "Hurtado Barbecue",
              "mapLink": "https://www.google.com/maps/place/Hurtado+Barbecue/@32.604902,-97.108422,17z/data=!3m1!4b1!4m6!3m5!1s0x864e622b3b85f67b:0x5c41496a77d1cf6a!8m2!3d32.604902!4d-97.105847!16s%2Fg%2F11f06x3b_3",
              "imageUrl": "https://hurtadobbq.com/wp-content/uploads/2023/06/IMG_9999.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Fort Worth Stockyards National Historic District (Longer Excursion)",
              "description": "Travel to Fort Worth for a step back into the Old West. Witness the cattle drive, explore the historic buildings, and visit the many Western-themed shops.",
              "placeName": "Fort Worth Stockyards National Historic District",
              "mapLink": "https://www.google.com/maps/place/Fort+Worth+Stockyards+National+Historic+District/@32.791522,-97.348633,17z/data=!3m1!4b1!4m6!3m5!1s0x864e727e025406d3:0x15354966d5b002c0!8m2!3d32.791522!4d-97.346058!16s%2Fg%2F11b6q756y1",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Fort_Worth_Stockyards_National_Historic_District.jpg/1280px-Fort_Worth_Stockyards_National_Historic_District.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Sundance Square Exploration",
              "description": "Continue your Fort Worth exploration in Sundance Square, a lively downtown district with shops, restaurants, and entertainment venues. Enjoy the architecture and vibrant atmosphere.",
              "placeName": "Sundance Square",
              "mapLink": "https://www.google.com/maps/place/Sundance+Square/@32.753896,-97.332025,17z/data=!3m1!4b1!4m6!3m5!1s0x864e715015e1975b:0x22137691d17d5e6e!8m2!3d32.753896!4d-97.32945!16s%2Fg%2F1tdy3f4h",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Sundance_Square_Fort_Worth_Texas.jpg/1280px-Sundance_Square_Fort_Worth_Texas.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Reata Restaurant",
              "description": "Dine at Reata Restaurant, a Fort Worth institution known for its upscale Texan cuisine and rooftop patio with city views.",
              "placeName": "Reata Restaurant",
              "mapLink": "https://www.google.com/maps/place/Reata+Restaurant/@32.753457,-97.330541,17z/data=!3m1!4b1!4m6!3m5!1s0x864e7153a559239d:0x3913009590848130!8m2!3d32.753457!4d-97.327966!16s%2Fg%2F1tf7w4y5",
              "imageUrl": "https://www.reata.net/wp-content/uploads/2019/11/reata_rooftop-1024x682.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "The Sixth Floor Museum at Dealey Plaza (Longer Excursion)",
              "description": "Travel to Dallas and visit The Sixth Floor Museum at Dealey Plaza, which chronicles the assassination and legacy of President John F. Kennedy.",
              "placeName": "The Sixth Floor Museum at Dealey Plaza",
              "mapLink": "https://www.google.com/maps/place/The+Sixth+Floor+Museum+at+Dealey+Plaza/@32.779532,-96.80938,17z/data=!3m1!4b1!4m6!3m5!1s0x864e991585805565:0x2719d3635a92a54e!8m2!3d32.779532!4d-96.806805!16s%2Fg%2F1tdy596x",
              "ticketLink": "https://www.jfk.org/visit/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/The_Sixth_Floor_Museum_at_Dealey_Plaza.jpg/1280px-The_Sixth_Floor_Museum_at_Dealey_Plaza.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Dallas Arts District & Klyde Warren Park",
              "description": "Explore the Dallas Arts District, home to museums like the Dallas Museum of Art and Nasher Sculpture Center. Afterward, relax at Klyde Warren Park, an urban oasis built over a freeway, often featuring food trucks and free activities.",
              "placeName": "Klyde Warren Park",
              "mapLink": "https://www.google.com/maps/place/Klyde+Warren+Park/@32.788574,-96.801666,17z/data=!3m1!4b1!4m6!3m5!1s0x864e991530739c6b:0x52467d5ce390f77e!8m2!3d32.788574!4d-96.799091!16s%2Fg%2F11b65v7f6x",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Klyde_Warren_Park_view_from_the_Dallas_Museum_of_Art.jpg/1280px-Klyde_Warren_Park_view_from_the_Dallas_Museum_of_Art.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Entertainment in Deep Ellum",
              "description": "Experience the vibrant nightlife and diverse dining scene of Deep Ellum. Choose from numerous restaurants, bars, and live music venues. Consider dinner at Pecan Lodge for award-winning BBQ.",
              "placeName": "Pecan Lodge",
              "mapLink": "https://www.google.com/maps/place/Pecan+Lodge/@32.784659,-96.786523,17z/data=!3m1!4b1!4m6!3m5!1s0x864e992163b2f567:0x892900b46765d7ae!8m2!3d32.784659!4d-96.783948!16s%2Fg%2F1tf7w4y5",
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/2J2eL7W_yFfH7oQY9B924A/o.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Fest Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Fest. Enjoy live music, food vendors, interactive games, and watch other matches on giant screens.",
              "placeName": "FIFA Fan Fest (Location TBD by FIFA in Dallas/Arlington area)",
              "mapLink": "https://www.google.com/maps/place/Dallas,+TX",
              "imageUrl": "https://digitalhub.fifa.com/transform/5450415a-930f-4886-905b-b9d997622819/FIFA-Fan-Festival-Sydney-2023-Credit-FIFA-Getty-Images-1",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities and Stadium Arrival",
              "description": "Head to AT&T Stadium early to experience the pre-match buzz. Explore the stadium perimeter, grab some official merchandise, and enjoy the vibrant atmosphere with fellow fans.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747796,-97.094528,17z/data=!3m1!4b1!4m6!3m5!1s0x864e83c0780281b3:0x39a06180373c683!8m2!3d32.747796!4d-97.091953!16s%2Fg%2F11b6q79275",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/AT%26T_Stadium_-_Arlington%2C_Texas.jpg/1280px-AT%26T_Stadium_-_Arlington%2C_Texas.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match!",
              "description": "Cheer on your favorite team as you witness a thrilling FIFA World Cup match live at AT&T Stadium. Soak in the global spectacle and unforgettable moments.",
              "placeName": "AT&T Stadium",
              "mapLink": "https://www.google.com/maps/place/AT%26T+Stadium/@32.747796,-97.094528,17z/data=!3m1!4b1!4m6!3m5!1s0x864e83c0780281b3:0x39a06180373c683!8m2!3d32.747796!4d-97.091953!16s%2Fg%2F11b6q79275",
              "ticketLink": "https://www.fifa.com/tournaments/mens/worldcup/2026/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/94a46a78-2d83-4a6c-949e-10825b746813/ATT-Stadium-Dallas-2",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Reunion Tower GeO-Deck (Longer Excursion)",
              "description": "Visit Reunion Tower in Dallas for panoramic 360-degree views of the Dallas skyline. The GeO-Deck offers indoor and outdoor observation decks with interactive exhibits.",
              "placeName": "Reunion Tower",
              "mapLink": "https://www.google.com/maps/place/Reunion+Tower/@32.775825,-96.810565,17z/data=!3m1!4b1!4m6!3m5!1s0x864e99157582f3c3:0x15354966d5b03517!8m2!3d32.775825!4d-96.80799!16s%2Fg%2F1tdy2j94",
              "ticketLink": "https://www.reuniontower.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Reunion_Tower_and_Hyatt_Regency_Dallas_at_night.jpg/1280px-Reunion_Tower_and_Hyatt_Regency_Dallas_at_night.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Dallas World Aquarium",
              "description": "Explore the Dallas World Aquarium, an educational and immersive experience featuring marine life, exotic birds, and mammals in recreated natural habitats.",
              "placeName": "Dallas World Aquarium",
              "mapLink": "https://www.google.com/maps/place/Dallas+World+Aquarium/@32.781845,-96.809322,17z/data=!3m1!4b1!4m6!3m5!1s0x864e9914948a8019:0x15354966d5b01859!8m2!3d32.781845!4d-96.806747!16s%2Fg%2F1tdy494h",
              "ticketLink": "https://www.dwazoo.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Dallas_World_Aquarium_01.jpg/1280px-Dallas_World_Aquarium_01.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Uptown Dallas",
              "description": "Enjoy dinner in Uptown Dallas, a trendy neighborhood known for its upscale dining, lively bars, and pedestrian-friendly streets. Consider Meso Maya for delicious Mexican cuisine.",
              "placeName": "Meso Maya Comida y Copas (Uptown)",
              "mapLink": "https://www.google.com/maps/place/Meso+Maya+Comida+y+Copas/@32.793798,-96.804822,17z/data=!3m1!4b1!4m6!3m5!1s0x864e9911961e6261:0x2281895a9437d806!8m2!3d32.793798!4d-96.802247!16s%2Fg%2F1tdy2j94",
              "imageUrl": "https://mesomaya.com/wp-content/uploads/2021/03/Meso-Maya-Uptown-Dallas-Exterior.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Arlington Museum of Art",
              "description": "Visit the Arlington Museum of Art, featuring rotating exhibitions of contemporary art, often with a focus on local and regional artists.",
              "placeName": "Arlington Museum of Art",
              "mapLink": "https://www.google.com/maps/place/Arlington+Museum+of+Art/@32.73587,-97.108605,17z/data=!3m1!4b1!4m6!3m5!1s0x864e83c676d1e9f1:0x41e860161476f52!8m2!3d32.73587!4d-97.10603!16s%2Fg%2F1tdy2j94",
              "imageUrl": "https://arlingtonmuseum.org/wp-content/uploads/2023/10/A-Woman-of-Influence-931x1024.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Shopping at The Parks Mall at Arlington",
              "description": "Enjoy some retail therapy and souvenir shopping at The Parks Mall at Arlington, a large indoor shopping center with a variety of stores and dining options.",
              "placeName": "The Parks Mall at Arlington",
              "mapLink": "https://www.google.com/maps/place/The+Parks+Mall+at+Arlington/@32.684157,-97.126442,17z/data=!3m1!4b1!4m6!3m5!1s0x864e7c7a523a07a1:0x15354966d5b06733!8m2!3d32.684157!4d-97.123867!16s%2Fg%2F1tdy2j94",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/The_Parks_Mall_at_Arlington.jpg/1280px-The_Parks_Mall_at_Arlington.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at The Cheesecake Factory",
              "description": "Enjoy a final dinner in Arlington at The Cheesecake Factory, offering a vast menu with something for everyone, perfect for a group.",
              "placeName": "The Cheesecake Factory (The Parks Mall)",
              "mapLink": "https://www.google.com/maps/place/The+Cheesecake+Factory/@32.684157,-97.126442,17z/data=!4m6!3m5!1s0x864e7c7a523a07a1:0x15354966d5b06733!8m2!3d32.684157!4d-97.123867!16s%2Fg%2F1tdy2j94",
              "imageUrl": "https://www.thecheesecakefactory.com/assets/images/header_logo.png",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Departure",
              "description": "Enjoy a final Texas breakfast, pack up, and head to DFW International Airport for your departure.",
              "placeName": "DFW International Airport",
              "mapLink": "https://www.google.com/maps/place/DFW+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/DFW_Terminal_D_exterior.jpg/1280px-DFW_Terminal_D_exterior.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Texas BBQ: Pecan Lodge (Dallas), Terry Black's BBQ (Dallas), Hurtado Barbecue (Arlington)",
        "Tex-Mex: Joe T. Garcia's (Fort Worth), Meso Maya (Dallas), Mi Cocina (Dallas)",
        "Steak: Pappas Bros. Steakhouse (Dallas), Bob's Steak & Chop House (Dallas)",
        "Southern Comfort Food: Ellen's (Dallas), AllGood Cafe (Deep Ellum)"
      ],
      "football_experiences": [
        "FIFA Fan Fest: Official fan zones with live music, food, games, and match screenings.",
        "AT&T Stadium Tour: Post-match, consider a stadium tour to see behind-the-scenes.",
        "Sports Bars: Catch other matches at local sports bars like Pluckers Wing Bar or Texas Live!.",
        "Local Soccer Clubs: Check for local club matches (e.g., FC Dallas) if schedule permits, for a grassroots experience."
      ],
      "travel_tips": [
        "How to reach the stadium (AT&T Stadium, Arlington): Arlington has limited traditional public transport. For World Cup matches, expect dedicated shuttle services from designated parking lots and possibly from DART (Dallas Area Rapid Transit) light rail stations in Dallas or Trinity Metro (Fort Worth) stations. Ride-sharing services (Uber/Lyft) will be available but may experience surge pricing and heavy traffic on match days. Plan to arrive early.",
        "Where to stay: Consider staying in Arlington near the Entertainment District for proximity to the stadium, though public transport options are limited to ride-shares or the 'Arlington On-Demand' service (Via). Alternatively, stay in downtown Dallas or Fort Worth, which offer better access to DART (Dallas) or Trinity Metro (Fort Worth) public transport. From these areas, you would rely on special event shuttles or ride-shares to reach AT&T Stadium. Aim for hotels within 60 minutes travel time (by car/ride-share) of the stadium on non-match days.",
        "Public Transportation in DFW: The Dallas-Fort Worth metroplex has two main public transit systems: DART (Dallas Area Rapid Transit) serving Dallas and surrounding suburbs, and Trinity Metro serving Fort Worth. Arlington itself is not directly served by DART light rail or Trinity Metro commuter rail. For DART, purchase a GoPass app or GoPass Tap card for easy travel on buses and light rail. For Trinity Metro, also use their GoPass app or paper tickets. For travel between Dallas and Fort Worth, you can use the Trinity Railway Express (TRE) commuter rail. Within Arlington, 'Arlington On-Demand' (Via) offers ride-share style public transit. For stadium access on match days, dedicated event shuttles are the most likely and recommended option."
      ]
    }
  },
  "atlanta": {
    "3": {
      "plannerCity": "Atlanta",
      "matchDay": 2,
      "city": "Atlanta",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive in Atlanta, check into your accommodation, and prepare for a day of exploration.",
              "placeName": "Downtown Atlanta",
              "mapLink": "https://www.google.com/maps/place/Downtown+Atlanta",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Atlanta_skyline_from_Jackson_Street_Bridge.jpg/1920px-Atlanta_skyline_from_Jackson_Street_Bridge.jpg",
              "suggested_time": "09:00"
            },
            {
              "name": "Explore Centennial Olympic Park",
              "description": "Begin your Atlanta adventure at the iconic Centennial Olympic Park, built for the 1996 Summer Olympics. Enjoy the Fountain of Rings show.",
              "placeName": "Centennial Olympic Park",
              "mapLink": "https://www.google.com/maps/place/Centennial+Olympic+Park",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Centennial_Olympic_Park_01.jpg/1920px-Centennial_Olympic_Park_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Georgia Aquarium",
              "description": "Visit one of the largest aquariums in the world, home to thousands of animals, including whale sharks and beluga whales.",
              "placeName": "Georgia Aquarium",
              "mapLink": "https://www.google.com/maps/place/Georgia+Aquarium",
              "ticketLink": "https://www.georgiaaquarium.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Georgia_Aquarium_Entrance.jpg/1920px-Georgia_Aquarium_Entrance.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "World of Coca-Cola",
              "description": "Discover the history of the world's most famous beverage, sample different Coca-Cola products from around the globe, and see the vault where the secret formula is kept.",
              "placeName": "World of Coca-Cola",
              "mapLink": "https://www.google.com/maps/place/World+of+Coca-Cola",
              "ticketLink": "https://www.worldofcoca-cola.com/plan-your-visit/buy-tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/World_of_Coca-Cola_entrance.jpg/1920px-World_of_Coca-Cola_entrance.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Paschal's Restaurant",
              "description": "Enjoy a historic soul food experience at Paschal's, a legendary Atlanta restaurant known for its fried chicken and rich history in the Civil Rights Movement.",
              "placeName": "Paschal's Restaurant",
              "mapLink": "https://www.google.com/maps/place/Paschal's+Restaurant",
              "ticketLink": null,
              "imageUrl": "https://paschalsrestaurant.com/wp-content/uploads/2021/04/Paschals-Restaurant-1-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Official FIFA Fan Festival",
              "description": "Immerse yourself in the World Cup atmosphere at the Official FIFA Fan Festival. Enjoy live music, food, games, and watch other matches on giant screens. (Proposed location: Centennial Olympic Park area)",
              "placeName": "Official FIFA Fan Festival Atlanta (Proposed Location: Centennial Olympic Park)",
              "mapLink": "https://www.google.com/maps/place/Centennial+Olympic+Park",
              "ticketLink": null,
              "imageUrl": "https://digitalhub.fifa.com/transform/5f1f9a0c-6685-4074-b594-8178e2259160/Doha-Fan-Festival-Hero-Desktop",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Walk to Mercedes-Benz Stadium",
              "description": "Soak in the vibrant pre-match atmosphere around Mercedes-Benz Stadium. Enjoy street vendors, fan interactions, and the excitement building up to the game.",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/place/Mercedes-Benz+Stadium",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Mercedes-Benz_Stadium_Exterior.jpg/1920px-Mercedes-Benz_Stadium_Exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Mercedes-Benz Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the state-of-the-art Mercedes-Benz Stadium, home to Atlanta United FC and the NFL's Atlanta Falcons.",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/place/Mercedes-Benz+Stadium",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Inside_Mercedes-Benz_Stadium.jpg/1920px-Inside_Mercedes-Benz_Stadium.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Martin Luther King Jr. National Historical Park",
              "description": "Visit the birthplace, church, and final resting place of Dr. Martin Luther King Jr. Explore the exhibits at the visitor center and the International Civil Rights Walk of Fame.",
              "placeName": "Martin Luther King Jr. National Historical Park",
              "mapLink": "https://www.google.com/maps/place/Martin+Luther+King+Jr.+National+Historical+Park",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Ebenezer_Baptist_Church_MLK_Jr_National_Historical_Park.jpg/1920px-Ebenezer_Baptist_Church_MLK_Jr_National_Historical_Park.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Atlanta BeltLine Eastside Trail & Krog Street Market",
              "description": "Walk or bike a section of the Atlanta BeltLine Eastside Trail, an urban greenspace and trail network. Enjoy lunch and explore unique shops at Krog Street Market, a popular food hall.",
              "placeName": "Krog Street Market",
              "mapLink": "https://www.google.com/maps/place/Krog+Street+Market",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Krog_Street_Market_interior.jpg/1920px-Krog_Street_Market_interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at Mary Mac's Tea Room",
              "description": "Savor authentic Southern comfort food at Mary Mac's Tea Room, an Atlanta institution serving classic dishes since 1945.",
              "placeName": "Mary Mac's Tea Room",
              "mapLink": "https://www.google.com/maps/place/Mary+Mac's+Tea+Room",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Mary_Mac%27s_Tea_Room_in_Atlanta.jpg/1920px-Mary_Mac%27s_Tea_Room_in_Atlanta.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Paschal's Restaurant: For historic soul food, especially their famous fried chicken.",
        "Mary Mac's Tea Room: An Atlanta institution for classic Southern comfort food like fried green tomatoes and peach cobbler.",
        "Krog Street Market: A vibrant food hall offering diverse culinary options from local vendors.",
        "The Varsity: An iconic Atlanta drive-in restaurant serving chili dogs, burgers, and onion rings since 1928."
      ],
      "football_experiences": [
        "Official FIFA Fan Festival: Engage in pre-match excitement, live music, and screenings.",
        "Attending a FIFA World Cup Match at Mercedes-Benz Stadium: The ultimate match-day experience.",
        "Exploring the fan atmosphere around Mercedes-Benz Stadium: Join fellow fans in the vibrant build-up to the game."
      ],
      "travel_tips": [
        "How to reach Mercedes-Benz Stadium: The stadium is conveniently located in downtown Atlanta and is directly served by MARTA (Metropolitan Atlanta Rapid Transit Authority). Take the Blue or Green line to the Dome/GWCC/Philips Arena/Mercedes-Benz Stadium station. This is the most recommended and efficient way to reach the stadium on match days.",
        "Where to stay: For easy access to the stadium and many attractions, consider hotels in Downtown or Midtown Atlanta. These areas offer a wide range of accommodation options and are well-connected by MARTA, typically within a 30-minute ride to the stadium. The Old Fourth Ward also provides good options with excellent access to the BeltLine and historical sites.",
        "Public Transportation in Atlanta: Atlanta's public transit system is MARTA, which includes both heavy rail (trains) and bus services. To use MARTA, purchase a 'Breeze Card' at any MARTA station. You can load funds or passes onto this reusable card for tap-and-go access. It's the best way to navigate the city, especially during major events like the World Cup."
      ]
    },
    "5": {
      "plannerCity": "Atlanta",
      "matchDay": 3,
      "city": "Atlanta",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Atlanta, check into your hotel (recommended areas: Downtown, Midtown, Old Fourth Ward for convenient MARTA access).",
              "placeName": "Downtown Atlanta",
              "mapLink": "https://www.google.com/maps/search/Downtown+Atlanta",
              "imageUrl": "https://example.com/image/DowntownAtlanta",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Explore Centennial Olympic Park",
              "description": "Start your Atlanta adventure at the heart of the 1996 Olympic Games. Enjoy the Fountain of Rings and stroll through the park.",
              "placeName": "Centennial Olympic Park",
              "mapLink": "https://www.google.com/maps/search/Centennial+Olympic+Park",
              "imageUrl": "https://example.com/image/CentennialOlympicPark",
              "best_time": "morning",
              "suggested_time": "10:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Georgia Aquarium",
              "description": "Discover one of the world's largest aquariums, home to thousands of animals, including whale sharks and beluga whales.",
              "placeName": "Georgia Aquarium",
              "mapLink": "https://www.google.com/maps/search/Georgia+Aquarium",
              "ticketLink": "https://www.georgiaaquarium.org/tickets/",
              "imageUrl": "https://example.com/image/GeorgiaAquarium",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "World of Coca-Cola",
              "description": "Immerse yourself in the history of the world's most famous beverage, sample different Coca-Cola products from around the globe.",
              "placeName": "World of Coca-Cola",
              "mapLink": "https://www.google.com/maps/search/World+of+Coca-Cola",
              "ticketLink": "https://www.worldofcoca-cola.com/plan-your-visit/buy-tickets/",
              "imageUrl": "https://example.com/image/WorldofCocaCola",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Pitty Pat's Porch",
              "description": "Enjoy classic Southern cuisine in a charming, historic setting, reminiscent of 'Gone With the Wind' era.",
              "placeName": "Pitty Pat's Porch",
              "mapLink": "https://www.google.com/maps/search/Pitty+Pat's+Porch",
              "imageUrl": "https://example.com/image/PittyPatsPorch",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Martin Luther King Jr. National Historical Park",
              "description": "Visit the birthplace, church (Ebenezer Baptist Church), and final resting place of Dr. Martin Luther King Jr., and explore his legacy.",
              "placeName": "Martin Luther King Jr. National Historical Park",
              "mapLink": "https://www.google.com/maps/search/Martin+Luther+King+Jr.+National+Historical+Park",
              "imageUrl": "https://example.com/image/MLKPark",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "National Center for Civil and Human Rights",
              "description": "Explore the American Civil Rights Movement and the global human rights struggle through powerful exhibits.",
              "placeName": "National Center for Civil and Human Rights",
              "mapLink": "https://www.google.com/maps/search/National+Center+for+Civil+and+Human+Rights",
              "ticketLink": "https://www.civilandhumanrights.org/visit/tickets/",
              "imageUrl": "https://example.com/image/CivilandHumanRights",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at Paschal's Restaurant",
              "description": "Dine at a historic soul food restaurant, a beloved Atlanta institution known for its fried chicken and Southern hospitality.",
              "placeName": "Paschal's Restaurant",
              "mapLink": "https://www.google.com/maps/search/Paschal's+Restaurant",
              "imageUrl": "https://example.com/image/PaschalsRestaurant",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Ponce City Market Exploration & Dinner",
              "description": "Experience this vibrant, historic building transformed into a bustling food hall, retail space, and community hub. Enjoy diverse dinner options.",
              "placeName": "Ponce City Market",
              "mapLink": "https://www.google.com/maps/search/Ponce+City+Market",
              "imageUrl": "https://example.com/image/PonceCityMarket",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch parties.",
              "placeName": "FIFA Fan Festival (Location TBD, likely near Mercedes-Benz Stadium)",
              "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium",
              "imageUrl": "https://example.com/image/FIFANFanFestival",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Arrival at Mercedes-Benz Stadium",
              "description": "Soak in the excitement around the stadium, grab a snack, and head into Mercedes-Benz Stadium for the World Cup match.",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium",
              "imageUrl": "https://example.com/image/MercedesBenzStadium",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Mercedes-Benz Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at one of the world's most modern stadiums.",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium",
              "ticketLink": "https://www.fifa.com/tickets/",
              "imageUrl": "https://example.com/image/WorldCupMatch",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Post-Match Dinner at The Varsity",
              "description": "Celebrate (or commiserate) with an iconic Atlanta fast-food experience known for its chili dogs, burgers, and onion rings. 'What'll ya have?'",
              "placeName": "The Varsity",
              "mapLink": "https://www.google.com/maps/search/The+Varsity",
              "imageUrl": "https://example.com/image/TheVarsity",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Explore Piedmont Park",
              "description": "Enjoy Atlanta's premier urban park, offering walking trails, green spaces, and stunning views of the Midtown skyline.",
              "placeName": "Piedmont Park",
              "mapLink": "https://www.google.com/maps/search/Piedmont+Park",
              "imageUrl": "https://example.com/image/PiedmontPark",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "High Museum of Art",
              "description": "Visit the leading art museum in the Southeast, featuring extensive collections of American, European, African, and decorative arts.",
              "placeName": "High Museum of Art",
              "mapLink": "https://www.google.com/maps/search/High+Museum+of+Art",
              "ticketLink": "https://high.org/visit/tickets/",
              "imageUrl": "https://example.com/image/HighMuseumofArt",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch in Midtown",
              "description": "Enjoy a casual lunch in Atlanta's vibrant Midtown district, known for its diverse culinary scene.",
              "placeName": "Midtown Atlanta",
              "mapLink": "https://www.google.com/maps/search/Midtown+Atlanta",
              "imageUrl": "https://example.com/image/MidtownAtlanta",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Krog Street Market",
              "description": "Another fantastic food hall experience, Krog Street Market offers a variety of local eateries and artisanal shops.",
              "placeName": "Krog Street Market",
              "mapLink": "https://www.google.com/maps/search/Krog+Street+Market",
              "imageUrl": "https://example.com/image/KrogStreetMarket",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "College Football Hall of Fame",
              "description": "Dive into the history and heroes of college football, an interactive experience for sports enthusiasts, located downtown near the stadium.",
              "placeName": "College Football Hall of Fame",
              "mapLink": "https://www.google.com/maps/search/College+Football+Hall+of+Fame",
              "ticketLink": "https://cfbhall.com/tickets/",
              "imageUrl": "https://example.com/image/CollegeFootballHallofFame",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Breakfast at Thumbs Up Diner",
              "description": "Savor a classic American breakfast or brunch at this beloved local diner, known for its hearty portions and retro vibe.",
              "placeName": "Thumbs Up Diner",
              "mapLink": "https://www.google.com/maps/search/Thumbs+Up+Diner",
              "imageUrl": "https://example.com/image/ThumbsUpDiner",
              "best_time": "morning",
              "suggested_time": "08:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Last-minute Souvenir Shopping & Departure",
              "description": "Grab any last-minute souvenirs or gifts before heading to the airport for your departure.",
              "placeName": "Hartsfield-Jackson Atlanta International Airport (ATL)",
              "mapLink": "https://www.google.com/maps/search/Hartsfield-Jackson+Atlanta+International+Airport",
              "imageUrl": "https://example.com/image/AtlantaAirport",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        {
          "name": "The Varsity",
          "description": "An iconic Atlanta drive-in and fast-food institution, famous for its chili dogs, burgers, and frosted oranges.",
          "placeName": "The Varsity",
          "mapLink": "https://www.google.com/maps/search/The+Varsity"
        },
        {
          "name": "Mary Mac's Tea Room",
          "description": "Serving traditional Southern comfort food since 1945, known for fried chicken, collard greens, and sweet tea.",
          "placeName": "Mary Mac's Tea Room",
          "mapLink": "https://www.google.com/maps/search/Mary+Mac's+Tea+Room"
        },
        {
          "name": "Fox Bros Bar-B-Q",
          "description": "A local favorite for authentic Texas-style barbecue with a Southern twist.",
          "placeName": "Fox Bros Bar-B-Q",
          "mapLink": "https://www.google.com/maps/search/Fox+Bros+Bar-B-Q"
        },
        {
          "name": "Krog Street Market / Ponce City Market",
          "description": "Two vibrant food halls offering a diverse array of local eateries, artisanal goods, and dining experiences.",
          "placeName": "Krog Street Market",
          "mapLink": "https://www.google.com/maps/search/Krog+Street+Market"
        },
        {
          "name": "Paschal's Restaurant",
          "description": "A historic Atlanta restaurant serving classic soul food, including legendary fried chicken, and a hub during the Civil Rights Movement.",
          "placeName": "Paschal's Restaurant",
          "mapLink": "https://www.google.com/maps/search/Paschal's+Restaurant"
        }
      ],
      "football_experiences": [
        {
          "name": "FIFA World Cup Match at Mercedes-Benz Stadium",
          "description": "Witness the excitement of a live FIFA World Cup game in Atlanta's state-of-the-art stadium.",
          "placeName": "Mercedes-Benz Stadium",
          "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium"
        },
        {
          "name": "FIFA Fan Festival",
          "description": "Join fellow fans at the official fan zone for live screenings, entertainment, food, and World Cup festivities.",
          "placeName": "FIFA Fan Festival (Location TBD, likely near Mercedes-Benz Stadium)",
          "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium"
        },
        {
          "name": "College Football Hall of Fame",
          "description": "Explore the history and legends of American college football through interactive exhibits and a 45-yard indoor football field.",
          "placeName": "College Football Hall of Fame",
          "mapLink": "https://www.google.com/maps/search/College+Football+Hall+of+Fame"
        }
      ],
      "travel_tips": [
        {
          "name": "Getting to Mercedes-Benz Stadium",
          "description": "The Mercedes-Benz Stadium is easily accessible via MARTA (Metropolitan Atlanta Rapid Transit Authority). The closest stations are GWCC/CNN Center Station (East-West Line) and Vine City Station (East-West Line). Both are within a short walking distance to the stadium. Consider taking MARTA on match day to avoid traffic and parking.",
          "placeName": "Mercedes-Benz Stadium",
          "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium"
        },
        {
          "name": "Where to Stay",
          "description": "Recommended areas for accommodation include Downtown, Midtown, and Old Fourth Ward. These neighborhoods offer a range of hotels, good access to MARTA, and are within 30-60 minutes of the stadium and major attractions. Staying near a MARTA station is highly advisable for easy navigation.",
          "placeName": "Atlanta",
          "mapLink": "https://www.google.com/maps/search/Atlanta"
        },
        {
          "name": "Public Transportation in Atlanta",
          "description": "MARTA is Atlanta's primary public transportation system, including both rail and bus services. The rail system connects key areas like Downtown, Midtown, Buckhead, and Hartsfield-Jackson Atlanta International Airport (ATL). To use MARTA, purchase a Breeze Card ($2 per card) at any MARTA station, then load it with funds for single rides ($2.50) or multi-day passes. The Breeze Card is rechargeable and can be used on both buses and trains.",
          "placeName": "MARTA",
          "mapLink": "https://www.google.com/maps/search/MARTA+Atlanta"
        }
      ]
    },
    "7": {
      "plannerCity": "Atlanta",
      "matchDay": 4,
      "city": "Atlanta",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival in Atlanta & Hotel Check-in",
              "description": "Arrive at Hartsfield-Jackson Atlanta International Airport (ATL), take MARTA to your accommodation, and check in. Settle in before starting your World Cup adventure.",
              "placeName": "Hartsfield-Jackson Atlanta International Airport (ATL)",
              "mapLink": "https://www.google.com/maps/search/Hartsfield-Jackson+Atlanta+International+Airport+(ATL)",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Atlanta_airport_domestic_terminal.jpg/1024px-Atlanta_airport_domestic_terminal.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Centennial Olympic Park",
              "description": "Visit the iconic park built for the 1996 Summer Olympics, a green oasis in the heart of downtown Atlanta. Enjoy the Fountain of Rings show.",
              "placeName": "Centennial Olympic Park",
              "mapLink": "https://www.google.com/maps/search/Centennial+Olympic+Park",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Centennial_Olympic_Park_01.jpg/1024px-Centennial_Olympic_Park_01.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "World of Coca-Cola",
              "description": "Explore the history of the world's most famous beverage, see the vault where the secret formula is kept, and taste over 100 different Coca-Cola products from around the globe.",
              "placeName": "World of Coca-Cola",
              "mapLink": "https://www.google.com/maps/search/World+of+Coca-Cola",
              "ticketLink": "https://www.worldofcoca-cola.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/World_of_Coca-Cola_Museum_in_Atlanta.jpg/1024px-World_of_Coca-Cola_Museum_in_Atlanta.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner at The Busy Bee Cafe",
              "description": "Savor authentic Southern comfort food at this historic Atlanta institution, known for its fried chicken and soul food dishes. (Approx. 10-15 min walk from Centennial Park area)",
              "placeName": "The Busy Bee Cafe",
              "mapLink": "https://www.google.com/maps/search/The+Busy+Bee+Cafe",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Busy_Bee_Cafe_%28Atlanta%29.jpg/1024px-Busy_Bee_Cafe_%28Atlanta%29.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Georgia Aquarium",
              "description": "Immerse yourself in one of the world's largest aquariums, home to thousands of marine animals, including whale sharks and manta rays. (Adjacent to Centennial Olympic Park)",
              "placeName": "Georgia Aquarium",
              "mapLink": "https://www.google.com/maps/search/Georgia+Aquarium",
              "ticketLink": "https://www.georgiaaquarium.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Georgia_Aquarium_2.jpg/1024px-Georgia_Aquarium_2.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "National Center for Civil and Human Rights",
              "description": "Explore the American Civil Rights Movement and the global human rights struggle through powerful exhibits and interactive displays. (Adjacent to Centennial Olympic Park)",
              "placeName": "National Center for Civil and Human Rights",
              "mapLink": "https://www.google.com/maps/search/National+Center+for+Civil+and+Human+Rights",
              "ticketLink": "https://www.civilandhumanrights.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/National_Center_for_Civil_and_Human_Rights_exterior.jpg/1024px-National_Center_for_Civil_and_Human_Rights_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Exploration at Ponce City Market",
              "description": "Enjoy a diverse culinary experience at this historic building turned bustling food hall and retail space. Walk along the Atlanta BeltLine Eastside Trail afterwards. (Approx. 15-20 min MARTA ride/rideshare from Downtown)",
              "placeName": "Ponce City Market",
              "mapLink": "https://www.google.com/maps/search/Ponce+City+Market",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Ponce_City_Market_Atlanta_2016.jpg/1024px-Ponce_City_Market_Atlanta_2016.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Martin Luther King, Jr. National Historical Park",
              "description": "Visit the birthplace, childhood home, Ebenezer Baptist Church, and final resting place of Dr. Martin Luther King, Jr. Learn about his life and legacy. (Short MARTA ride to King Memorial Station)",
              "placeName": "Martin Luther King, Jr. National Historical Park",
              "mapLink": "https://www.google.com/maps/search/Martin+Luther+King,+Jr.+National+Historical+Park",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/MLK_National_Historical_Park_Visitor_Center.jpg/1024px-MLK_National_Historical_Park_Visitor_Center.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "High Museum of Art",
              "description": "Explore Atlanta's premier art museum, featuring extensive collections of European, American, decorative, and African art, as well as photography and modern works. (MARTA to Arts Center Station in Midtown)",
              "placeName": "High Museum of Art",
              "mapLink": "https://www.google.com/maps/search/High+Museum+of+Art",
              "ticketLink": "https://high.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/High_Museum_of_Art_-_Atlanta%2C_GA_-_USA.jpg/1024px-High_Museum_of_Art_-_Atlanta%2C_GA_-_USA.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at South City Kitchen Midtown",
              "description": "Enjoy upscale Southern cuisine with a contemporary twist in a vibrant Midtown setting, known for its fried green tomatoes and shrimp and grits. (Walking distance from High Museum)",
              "placeName": "South City Kitchen Midtown",
              "mapLink": "https://www.google.com/maps/search/South+City+Kitchen+Midtown",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/South_City_Kitchen_Midtown.jpg/1024px-South_City_Kitchen_Midtown.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, official merchandise, and interactive football activities. (Likely located in or near Centennial Olympic Park, check official schedules).",
              "placeName": "FIFA Fan Festival (Atlanta)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Atlanta",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/FIFA_Fan_Festival_Doha.jpg/1024px-FIFA_Fan_Festival_Doha.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Head to Mercedes-Benz Stadium",
              "description": "Soak in the pre-match excitement around the stadium area. Grab a snack or drink at a nearby establishment before heading into Mercedes-Benz Stadium. (Walk from Fan Festival or short MARTA ride).",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Mercedes-Benz_Stadium_at_night.jpg/1024px-Mercedes-Benz_Stadium_at_night.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Mercedes-Benz Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the state-of-the-art Mercedes-Benz Stadium. Enjoy the game, the crowd, and the unforgettable atmosphere.",
              "placeName": "Mercedes-Benz Stadium",
              "mapLink": "https://www.google.com/maps/search/Mercedes-Benz+Stadium",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Atlanta_United_FC_vs_Portland_Timbers_-_Mercedes-Benz_Stadium_-_March_18%2C_2018.jpg/1024px-Atlanta_United_FC_vs_Portland_Timbers_-_Mercedes-Benz_Stadium_-_March_18%2C_2018.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Piedmont Park",
              "description": "Enjoy a leisurely morning stroll, rent a bike, or relax in Atlanta's largest urban park, offering stunning skyline views. (MARTA to Midtown or Arts Center Station)",
              "placeName": "Piedmont Park",
              "mapLink": "https://www.google.com/maps/search/Piedmont+Park",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Piedmont_Park_Lake.jpg/1024px-Piedmont_Park_Lake.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Atlanta Botanical Garden",
              "description": "Discover a diverse collection of plant life, including a beautiful orchid display, a large children's garden, and an impressive canopy walk. (Adjacent to Piedmont Park)",
              "placeName": "Atlanta Botanical Garden",
              "mapLink": "https://www.google.com/maps/search/Atlanta+Botanical+Garden",
              "ticketLink": "https://atlantabg.org/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Atlanta_Botanical_Garden_Canopy_Walk.jpg/1024px-Atlanta_Botanical_Garden_Canopy_Walk.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Miller Union",
              "description": "Experience farm-to-table Southern cuisine at this acclaimed restaurant, known for its fresh, seasonal ingredients and elegant atmosphere. (Approx. 15-20 min rideshare/MARTA from Midtown)",
              "placeName": "Miller Union",
              "mapLink": "https://www.google.com/maps/search/Miller+Union",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Miller_Union_Atlanta.jpg/1024px-Miller_Union_Atlanta.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Oakland Cemetery",
              "description": "Explore Atlanta's oldest public park and the final resting place of many notable Atlantans, including Margaret Mitchell and Bobby Jones. A beautiful and historic green space. (MARTA to King Memorial Station)",
              "placeName": "Oakland Cemetery",
              "mapLink": "https://www.google.com/maps/search/Oakland+Cemetery",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Oakland_Cemetery_Atlanta.jpg/1024px-Oakland_Cemetery_Atlanta.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Atlanta BeltLine Eastside Trail & Inman Park",
              "description": "Walk or bike a section of the Atlanta BeltLine Eastside Trail, exploring public art and connecting to vibrant neighborhoods like Inman Park, known for its Victorian homes and boutiques. (Accessible from Oakland Cemetery or Inman Park/Reynoldstown MARTA stations)",
              "placeName": "Atlanta BeltLine Eastside Trail",
              "mapLink": "https://www.google.com/maps/search/Atlanta+BeltLine+Eastside+Trail",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Atlanta_BeltLine_Eastside_Trail_view.jpg/1024px-Atlanta_BeltLine_Eastside_Trail_view.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Krog Street Market",
              "description": "Indulge in a variety of culinary delights at Krog Street Market, a popular food hall housed in a historic warehouse, located directly on the BeltLine. (Short walk from Inman Park)",
              "placeName": "Krog Street Market",
              "mapLink": "https://www.google.com/maps/search/Krog+Street+Market",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Krog_Street_Market_Atlanta.jpg/1024px-Krog_Street_Market_Atlanta.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Shopping at Atlantic Station",
              "description": "Enjoy some last-minute souvenir shopping or explore the open-air retail and entertainment district before heading to the airport. (Accessible via MARTA to Arts Center Station, then free shuttle)",
              "placeName": "Atlantic Station",
              "mapLink": "https://www.google.com/maps/search/Atlantic+Station",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Atlantic_Station_Atlanta_2017.jpg/1024px-Atlantic_Station_Atlanta_2017.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at The Varsity",
              "description": "Grab an iconic Atlanta lunch at The Varsity, the world's largest drive-in restaurant, famous for its chili dogs, onion rings, and 'What'll ya have?' catchphrase. (MARTA to North Ave Station)",
              "placeName": "The Varsity",
              "mapLink": "https://www.google.com/maps/search/The+Varsity",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/The_Varsity_Atlanta_GA.jpg/1024px-The_Varsity_Atlanta_GA.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Departure from Atlanta",
              "description": "Head back to Hartsfield-Jackson Atlanta International Airport (ATL) via MARTA for your departure.",
              "placeName": "Hartsfield-Jackson Atlanta International Airport (ATL)",
              "mapLink": "https://www.google.com/maps/search/Hartsfield-Jackson+Atlanta+International+Airport+(ATL)",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Atlanta_airport_domestic_terminal_atrium.jpg/1024px-Atlanta_airport_domestic_terminal_atrium.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "The Busy Bee Cafe (Authentic Southern Soul Food)",
        "Ponce City Market (Diverse Food Hall with many options like Minero and H&F Burger)",
        "South City Kitchen Midtown (Upscale Southern Cuisine)",
        "Miller Union (Farm-to-Table Southern)",
        "Krog Street Market (Trendy Food Hall with various eateries like Gu's Kitchen and Superica)",
        "The Varsity (Iconic Atlanta Fast Food)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Official fan zone with live entertainment and activities)",
        "Pre-match festivities and atmosphere around Mercedes-Benz Stadium",
        "Attending a FIFA World Cup Match at Mercedes-Benz Stadium"
      ],
      "travel_tips": [
        "**Stadium Access (Mercedes-Benz Stadium):** Mercedes-Benz Stadium is conveniently located in downtown Atlanta and is directly accessible via MARTA. The closest MARTA stations are Dome/GWCC/Philips Arena/CNN Center Station (Blue/Green Lines) and Vine City Station (Blue/Green Lines). Both are a short walk (5-10 minutes) to the stadium gates. MARTA will likely run extended hours on match days.",
        "**Accommodation:** For easy access to the stadium and popular attractions, consider staying in Downtown, Midtown, or Buckhead. These areas offer a wide range of hotels and are well-connected by MARTA. Downtown and Midtown are particularly ideal for stadium access and sightseeing. Neighborhoods along the MARTA lines, even if slightly further out, can also be good options for budget-conscious travelers.",
        "**Public Transportation (MARTA):** The Metropolitan Atlanta Rapid Transit Authority (MARTA) operates Atlanta's public transportation system, including heavy rail (trains) and bus services. It is the most efficient and recommended way to navigate the city, especially during major events. Purchase a Breeze Card (a reusable, rechargeable fare card) at any MARTA station or online. You can load single rides, daily passes, or weekly passes onto the card. Fares are typically $2.50 per ride, with daily and weekly passes offering better value for frequent use. Download the 'MARTA On The Go' app for real-time train and bus information."
      ]
    }
  },
  "seattle": {
    "3": {
      "plannerCity": "Seattle",
      "matchDay": 2,
      "city": "Seattle",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Pike Place Market Exploration & Breakfast",
              "description": "Start your day at Seattle's iconic public market. Explore the stalls, watch the fishmongers throw fish, and soak in the vibrant atmosphere. Grab breakfast from local vendors.",
              "placeName": "Pike Place Market",
              "mapLink": "https://www.google.com/maps/place/Pike+Place+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Pike_Place_Market_entrance_sign_2017.jpg/1280px-Pike_Place_Market_entrance_sign_2017.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Coffee & Pastries at Pike Place",
              "description": "Enjoy a coffee at the original Starbucks location and a delicious pastry from Piroshky Piroshky.",
              "placeName": "Piroshky Piroshky",
              "mapLink": "https://www.google.com/maps/place/Piroshky+Piroshky",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Piroshky_Piroshky%2C_Seattle.jpg/1280px-Piroshky_Piroshky%2C_Seattle.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Space Needle Visit",
              "description": "Take in panoramic views of Seattle, Puget Sound, and the Olympic and Cascade Mountains from the observation deck of the Space Needle.",
              "placeName": "Space Needle",
              "mapLink": "https://www.google.com/maps/place/Space+Needle",
              "ticketLink": "https://www.spaceneedle.com/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Space_Needle_2011-07-04.jpg/1280px-Space_Needle_2011-07-04.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Chihuly Garden and Glass",
              "description": "Immerse yourself in the stunning glass artwork of Dale Chihuly, located right next to the Space Needle.",
              "placeName": "Chihuly Garden and Glass",
              "mapLink": "https://www.google.com/maps/place/Chihuly+Garden+and+Glass",
              "ticketLink": "https://www.chihulygardenandglass.com/visit/plan-your-visit",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Chihuly_Garden_and_Glass_-_Glasshouse_-_July_2022_-_01.jpg/1280px-Chihuly_Garden_and_Glass_-_Glasshouse_-_July_2022_-_01.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Belltown",
              "description": "Enjoy a delicious dinner in the vibrant Belltown neighborhood, known for its diverse culinary scene.",
              "placeName": "Belltown (Restaurant Recommendation: Navy Strength)",
              "mapLink": "https://www.google.com/maps/place/Navy+Strength",
              "imageUrl": "https://media.cntraveler.com/photos/59235e5898516d337f7112c3/master/w_1920%2Cc_limit/Navy%2520Strength-2.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            },
            {
              "name": "Evening Stroll & Waterfront Views",
              "description": "Take a leisurely walk along the Seattle Waterfront, enjoying the evening lights and views of Puget Sound.",
              "placeName": "Seattle Waterfront",
              "mapLink": "https://www.google.com/maps/place/Seattle+Waterfront",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Seattle_Waterfront_at_night.jpg/1280px-Seattle_Waterfront_at_night.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Festival. Enjoy live music, food, games, and interact with fellow fans. (Location TBD, historically often near waterfront or large public park).",
              "placeName": "FIFA Fan Festival (assumed location: Waterfront Park)",
              "mapLink": "https://www.google.com/maps/place/Waterfront+Park",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg/1280px-FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Lunch near Lumen Field",
              "description": "Head towards Lumen Field and soak in the vibrant match-day atmosphere. Grab a casual lunch at a sports bar or eatery in Pioneer Square or SoDo.",
              "placeName": "Pioneer Square (Restaurant Recommendation: Flatstick Pub)",
              "mapLink": "https://www.google.com/maps/place/Flatstick+Pub+-+Pioneer+Square",
              "imageUrl": "https://res.cloudinary.com/traveltripper/image/upload/v1574895085/v3_dev/f1yq0g93j921b7k9x0z0.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Enter Lumen Field for Match",
              "description": "Arrive early at Lumen Field to find your seats, explore the stadium, and prepare for kick-off. Enjoy the World Cup match!",
              "placeName": "Lumen Field",
              "mapLink": "https://www.google.com/maps/place/Lumen+Field",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Lumen_Field_night_game.jpg/1280px-Lumen_Field_night_game.jpg",
              "best_time": "afternoon",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "Post-Match Celebration & Dinner",
              "description": "Celebrate (or commiserate!) after the match with dinner and drinks in the historic Pioneer Square neighborhood, just steps from Lumen Field.",
              "placeName": "Pioneer Square (Restaurant Recommendation: The London Plane)",
              "mapLink": "https://www.google.com/maps/place/The+London+Plane",
              "imageUrl": "https://images.squarespace-cdn.com/content/v1/52e50570e4b0c793ff82626e/1487198733220-4G181X0492E38V89921U/image-asset.jpeg",
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Museum of Pop Culture (MoPOP)",
              "description": "Explore interactive exhibits dedicated to music, science fiction, and pop culture, housed in an iconic Frank Gehry-designed building.",
              "placeName": "Museum of Pop Culture (MoPOP)",
              "mapLink": "https://www.google.com/maps/place/Museum+of+Pop+Culture",
              "ticketLink": "https://www.mopop.org/visit/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/EMP_Museum_from_east.jpg/1280px-EMP_Museum_from_east.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Ferry to Bainbridge Island",
              "description": "Take a scenic 35-minute ferry ride across Puget Sound to Bainbridge Island. Enjoy stunning views of the Seattle skyline, Mount Rainier, and the Olympic Mountains. Explore the charming town of Winslow.",
              "placeName": "Washington State Ferries - Seattle Terminal (Colman Dock)",
              "mapLink": "https://www.google.com/maps/place/Colman+Dock+-+Seattle+Ferry+Terminal",
              "ticketLink": "https://wsdot.wa.gov/travel/washington-state-ferries/fares",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Seattle_skyline_from_Bainbridge_ferry.jpg/1280px-Seattle_skyline_from_Bainbridge_ferry.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Explore Winslow & Lunch on Bainbridge Island",
              "description": "Wander through the shops and galleries of Winslow, the main town on Bainbridge Island. Enjoy a fresh seafood lunch.",
              "placeName": "Winslow, Bainbridge Island (Restaurant Recommendation: Doc's Marina Grill)",
              "mapLink": "https://www.google.com/maps/place/Doc%27s+Marina+Grill",
              "imageUrl": "https://www.docsmarinagrill.com/wp-content/uploads/2019/04/Docs-Marina-Grill-Bainbridge-Island-Exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Capitol Hill",
              "description": "Return to Seattle and enjoy a farewell dinner in the lively Capitol Hill neighborhood, known for its diverse dining options and nightlife.",
              "placeName": "Capitol Hill (Restaurant Recommendation: Oddfellows Cafe + Bar)",
              "mapLink": "https://www.google.com/maps/place/Oddfellows+Cafe+%2B+Bar",
              "imageUrl": "https://images.squarespace-cdn.com/content/v1/5e73995642a8b9487c654483/1585250462002-3C0P03429Q38J420K08C/Oddfellows-Cafe-and-Bar.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Piroshky Piroshky (Pike Place Market): Russian pastries.",
        "Beecher's Handmade Cheese (Pike Place Market): Famous mac & cheese, artisan cheese.",
        "Pike Place Chowder (Pike Place Market): Award-winning clam chowder.",
        "Ivar's Acres of Clams (Waterfront): Classic Pacific Northwest seafood, fish and chips.",
        "Dick's Drive-In (Various locations): Seattle's iconic fast-food burgers and fries.",
        "Taylor Shellfish Oyster Bar (Capitol Hill/Pioneer Square): Fresh, local oysters and seafood."
      ],
      "football_experiences": [
        "FIFA Fan Festival (Official fan zone with live music, food, and big screens).",
        "Lumen Field Match Day Experience (Attending a FIFA World Cup match).",
        "Pioneer Square Sports Bars (Catching other matches and soaking in the football atmosphere).",
        "Sounders FC Team Store (Official merchandise of Seattle's MLS team, located at Lumen Field)."
      ],
      "travel_tips": [
        {
          "category": "Getting to Lumen Field",
          "details": "Lumen Field (800 Occidental Ave S, Seattle, WA 98134) is easily accessible via public transportation. The most direct route is using the Link Light Rail. Take the 1 Line to the Stadium Station, which is located directly across the street from the stadium. This is the recommended and most efficient way on match days. King County Metro buses also serve the area."
        },
        {
          "category": "Where to Stay",
          "details": "For convenient access to Lumen Field and major attractions, consider staying in downtown Seattle, Pioneer Square, Belltown, or Capitol Hill. These neighborhoods offer a range of hotels and are well-connected by public transit, keeping you within a 30-60 minute commute to the stadium."
        },
        {
          "category": "Public Transportation in Seattle",
          "details": "Seattle's public transport system is managed by King County Metro (buses) and Sound Transit (Link Light Rail, Sounder commuter rail, Streetcar). The Link Light Rail is excellent for connecting downtown, Capitol Hill, the University District, and Sea-Tac Airport. Buses cover a wider network. Purchase an ORCA card (One Regional Card for All) for seamless travel across Link Light Rail, King County Metro buses, Seattle Streetcar, and Washington State Ferries (passenger fare only). You can load funds onto the card at Link Light Rail stations, select retailers, or online. Cash payment is also accepted on buses and for single-ride Light Rail tickets, but the ORCA card is more convenient and often offers better value."
        }
      ]
    },
    "5": {
      "plannerCity": "Seattle",
      "matchDay": 3,
      "city": "Seattle",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Pike Place Market Exploration",
              "description": "Immerse yourself in the bustling atmosphere of Seattle's iconic public market. Watch fishmongers throw fish, explore artisan stalls, and discover fresh local produce.",
              "placeName": "Pike Place Market",
              "mapLink": "https://www.google.com/maps/place/Pike+Place+Market",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a2/Pike_Place_Market_entrance.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Breakfast at Piroshky Piroshky",
              "description": "Enjoy traditional Russian baked goods, a local favorite, right within Pike Place Market.",
              "placeName": "Piroshky Piroshky",
              "mapLink": "https://www.google.com/maps/place/Piroshky+Piroshky",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Piroshky_Piroshky%2C_Seattle_Pike_Place_Market_01.jpg/1280px-Piroshky_Piroshky%2C_Seattle_Pike_Place_Market_01.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Seattle Waterfront & Aquarium",
              "description": "Stroll along the revitalized waterfront, enjoy views of Puget Sound, and visit the Seattle Aquarium to see marine life.",
              "placeName": "Seattle Aquarium",
              "mapLink": "https://www.google.com/maps/place/Seattle+Aquarium",
              "ticketLink": "https://www.viator.com/tours/Seattle/Seattle-Aquarium-Admission-Ticket/d704-3620SEAQ",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Seattle_Aquarium_from_above.jpg/1280px-Seattle_Aquarium_from_above.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Seattle Great Wheel Ride",
              "description": "Experience panoramic views of the city skyline, Puget Sound, and the Olympic Mountains from the Ferris wheel.",
              "placeName": "Seattle Great Wheel",
              "mapLink": "https://www.google.com/maps/place/Seattle+Great+Wheel",
              "ticketLink": "https://www.viator.com/tours/Seattle/Seattle-Great-Wheel-Admission-Ticket/d704-5100P1",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Seattle_Great_Wheel_-_2015-08-01.jpg/1280px-Seattle_Great_Wheel_-_2015-08-01.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner at The Pink Door",
              "description": "Enjoy delicious Italian-American cuisine and cabaret entertainment in this hidden gem near Pike Place Market. Reservations highly recommended.",
              "placeName": "The Pink Door",
              "mapLink": "https://www.google.com/maps/place/The+Pink+Door",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0f/55/9b/a0/photo1jpg.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Space Needle",
              "description": "Ascend to the observation deck of Seattle's most iconic landmark for breathtaking 360-degree views of the city, mountains, and water.",
              "placeName": "Space Needle",
              "mapLink": "https://www.google.com/maps/place/Space+Needle",
              "ticketLink": "https://www.viator.com/tours/Seattle/Space-Needle-Observation-Deck-Ticket/d704-5100P2",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Space_Needle_Seattle_2011.jpg/1280px-Space_Needle_Seattle_2011.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Chihuly Garden and Glass",
              "description": "Explore the vibrant and intricate glass art of Dale Chihuly in a stunning indoor and outdoor exhibition, located at Seattle Center next to the Space Needle.",
              "placeName": "Chihuly Garden and Glass",
              "mapLink": "https://www.google.com/maps/place/Chihuly+Garden+and+Glass",
              "ticketLink": "https://www.viator.com/tours/Seattle/Chihuly-Garden-and-Glass-Admission-Ticket/d704-3620CHIHULY",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Chihuly_Garden_and_Glass_02.jpg/1280px-Chihuly_Garden_and_Glass_02.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Museum of Pop Culture (MoPOP)",
              "description": "Dive into the world of music, science fiction, and pop culture at this unique museum, also located at Seattle Center.",
              "placeName": "Museum of Pop Culture",
              "mapLink": "https://www.google.com/maps/place/Museum+of+Pop+Culture",
              "ticketLink": "https://www.viator.com/tours/Seattle/Museum-of-Pop-Culture-MoPOP-Admission-Ticket/d704-3620MOP",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/MoPOP_Museum_in_Seattle.jpg/1280px-MoPOP_Museum_in_Seattle.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Capitol Hill",
              "description": "Explore the diverse culinary scene of Capitol Hill. Enjoy a meal at Oddfellows Cafe + Bar, known for its cozy ambiance and delicious food, then explore the vibrant neighborhood.",
              "placeName": "Oddfellows Cafe + Bar",
              "mapLink": "https://www.google.com/maps/place/Oddfellows+Cafe+%2B+Bar",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/07/04/e5/28/oddfellows-cafe-bar.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival & Pre-Match Atmosphere",
              "description": "Immerse yourself in the FIFA Fan Festival, likely located in Occidental Square and/or Lumen Field North Plaza. Enjoy live entertainment, food, and fan activities.",
              "placeName": "Occidental Square",
              "mapLink": "https://www.google.com/maps/place/Occidental+Square",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Occidental_Square_Park_in_Seattle.jpg/1280px-Occidental_Square_Park_in_Seattle.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Brunch at Biscuit Bitch",
              "description": "Fuel up for match day with a hearty and unique biscuit sandwich from this popular local spot in Pioneer Square, a short walk from the fan zone.",
              "placeName": "Biscuit Bitch - Pioneer Square",
              "mapLink": "https://www.google.com/maps/place/Biscuit+Bitch+-+Pioneer+Square",
              "ticketLink": null,
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/68p-pI-iM_G8n8Qn-jD4fQ/o.jpg",
              "best_time": "morning",
              "suggested_time": "11:30"
            }
          ],
          "afternoon": [
            {
              "name": "Match Day Pre-Game Festivities",
              "description": "Continue soaking in the match day excitement around Lumen Field. Grab a drink at a nearby sports bar or simply enjoy the vibrant atmosphere with fellow fans.",
              "placeName": "Lumen Field",
              "mapLink": "https://www.google.com/maps/place/Lumen+Field",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Lumen_Field_Panorama.jpg/1280px-Lumen_Field_Panorama.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Lumen Field",
              "description": "Experience the thrill of a live FIFA World Cup match at Lumen Field in Seattle. Cheer for your favorite team!",
              "placeName": "Lumen Field",
              "mapLink": "https://www.google.com/maps/place/Lumen+Field",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Lumen_Field_during_a_Seattle_Seahawks_game.jpg/1280px-Lumen_Field_during_a_Seattle_Seahawks_game.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            },
            {
              "name": "Post-Match Dinner & Celebration",
              "description": "Celebrate or commiserate after the match with dinner and drinks at F.X. McRory's Steak Chop and Oyster House, a classic Seattle sports bar and restaurant near the stadium.",
              "placeName": "F.X. McRory's Steak Chop and Oyster House",
              "mapLink": "https://www.google.com/maps/place/F.X.+McRory's+Steak+Chop+and+Oyster+House",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/03/40/63/01/f-x-mcrory-s.jpg",
              "best_time": "evening",
              "suggested_time": "22:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Bainbridge Island Ferry Ride",
              "description": "Enjoy a scenic 35-minute ferry ride across Puget Sound to Bainbridge Island. Take in panoramic views of the Seattle skyline, Mount Rainier, and the Olympic Mountains.",
              "placeName": "Colman Dock (Seattle Ferry Terminal)",
              "mapLink": "https://www.google.com/maps/place/Colman+Dock",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Seattle_Ferry_Terminal_and_Ferry_Boat.jpg/1280px-Seattle_Ferry_Terminal_and_Ferry_Boat.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Explore Downtown Winslow, Bainbridge Island",
              "description": "Wander through the charming town of Winslow, just a short walk from the ferry terminal. Explore local shops, art galleries, and enjoy the relaxed island atmosphere.",
              "placeName": "Winslow, Bainbridge Island",
              "mapLink": "https://www.google.com/maps/place/Winslow,+Bainbridge+Island,+WA",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Downtown_Winslow%2C_Bainbridge_Island%2C_WA.jpg/1280px-Downtown_Winslow%2C_Bainbridge_Island%2C_WA.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Return Ferry to Seattle & Ballard Locks",
              "description": "Take the ferry back to Seattle. Afterwards, head to the Hiram M. Chittenden Locks (Ballard Locks) to watch boats pass between Puget Sound and Lake Union/Lake Washington, and see the fish ladder.",
              "placeName": "Hiram M. Chittenden Locks",
              "mapLink": "https://www.google.com/maps/place/Hiram+M.+Chittenden+Locks",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Hiram_M._Chittenden_Locks_-_Seattle%2C_WA.jpg/1280px-Hiram_M._Chittenden_Locks_-_Seattle%2C_WA.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Fremont Troll & Dinner in Fremont",
              "description": "Visit the quirky Fremont Troll sculpture beneath the Aurora Bridge. Afterwards, enjoy dinner in the eclectic Fremont neighborhood. Try Revel for creative Korean-inspired cuisine.",
              "placeName": "Fremont Troll",
              "mapLink": "https://www.google.com/maps/place/Fremont+Troll",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Fremont_Troll_Seattle.jpg/1280px-Fremont_Troll_Seattle.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            },
            {
              "name": "Dinner at Revel",
              "description": "Savor innovative Korean fusion dishes at Revel, a highly-rated restaurant in the heart of Fremont.",
              "placeName": "Revel",
              "mapLink": "https://www.google.com/maps/place/Revel",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/09/a3/9b/6e/revel.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Bill Speidel's Underground Tour",
              "description": "Explore Seattle's hidden history beneath the streets of Pioneer Square on this entertaining and informative walking tour.",
              "placeName": "Bill Speidel's Underground Tour",
              "mapLink": "https://www.google.com/maps/place/Bill+Speidel's+Underground+Tour",
              "ticketLink": "https://www.viator.com/tours/Seattle/Seattle-Underground-Walking-Tour/d704-5100P3",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Seattle_Underground_Tour_01.jpg/1280px-Seattle_Underground_Tour_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Original Starbucks & Souvenir Shopping",
              "description": "Visit the first Starbucks store at Pike Place Market for a photo opportunity and a coffee. Spend time browsing for last-minute souvenirs in the market or nearby shops.",
              "placeName": "The Original Starbucks",
              "mapLink": "https://www.google.com/maps/place/The+Original+Starbucks",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/First_Starbucks_store.jpg/1280px-First_Starbucks_store.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Farewell Seafood Dinner at Taylor Shellfish Farms",
              "description": "Enjoy a final taste of Seattle's renowned seafood with fresh oysters and other delights at Taylor Shellfish Farms, known for its sustainable and delicious offerings.",
              "placeName": "Taylor Shellfish Farms (Capitol Hill)",
              "mapLink": "https://www.google.com/maps/place/Taylor+Shellfish+Farms+Melrose+Market",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0b/2a/39/53/taylor-shellfish-farms.jpg",
              "best_time": "evening",
              "suggested_time": "18:30"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Piroshky Piroshky (Russian baked goods)",
        "Beecher's Handmade Cheese (mac and cheese, cheese curds)",
        "Pike Place Chowder (clam chowder)",
        "Ivar's Acres of Clams (fish and chips, seafood)",
        "Taylor Shellfish Farms (fresh oysters, seafood)",
        "Dick's Drive-In (classic burgers, fries)",
        "Coffee from local roasters (e.g., Victrola, Caffe Vita)",
        "Asian cuisine in the International District"
      ],
      "football_experiences": [
        "FIFA Fan Festival at Occidental Square / Lumen Field North Plaza",
        "FIFA World Cup Match at Lumen Field",
        "Pre-match atmosphere and tailgating around Lumen Field",
        "Visiting local sports bars (e.g., F.X. McRory's, The George & Dragon Pub)"
      ],
      "travel_tips": [
        "**Stadium Access (Lumen Field):** Lumen Field is conveniently located in the SoDo neighborhood. The easiest way to reach it is via the Link Light Rail. Use the 'Stadium Station' stop, which is directly adjacent to the stadium. Several King County Metro bus routes also serve the area.",
        "**Where to Stay:** For easy access to Lumen Field and major attractions, consider staying in downtown Seattle, Pioneer Square, Belltown, or Capitol Hill. These neighborhoods offer a range of accommodation options and are well-connected by public transit. SoDo also has some hotel options and is closest to the stadium.",
        "**Public Transportation:** Seattle's public transportation system is efficient for navigating the city. The main systems are: \n  - **Link Light Rail:** Connects SeaTac Airport to downtown, Capitol Hill, and Northgate. It's ideal for airport transfers and reaching Lumen Field.\n  - **King County Metro Buses:** An extensive network covering the entire city and surrounding areas.\n  - **Seattle Streetcar:** Connects downtown with South Lake Union and Capitol Hill/First Hill.\n  - **Seattle Monorail:** Connects downtown (Westlake Center) to Seattle Center (Space Needle, MoPOP).\n  **Recommended Pass:** Purchase an **ORCA card** (One Regional Card for All) for seamless travel across Link Light Rail, King County Metro buses, Seattle Streetcar, and Washington State Ferries. You can load money onto it or buy multi-day passes. ORCA cards are available at Link Light Rail stations, select retailers, and online. Google Maps is excellent for planning public transport routes.",
        "**Walking:** Seattle is a walkable city, especially downtown, but be prepared for hills. Wear comfortable shoes.",
        "**Weather:** Seattle weather in June/July is generally pleasant, with mild temperatures and less rain, but it's always wise to pack layers and a light rain jacket just in case."
      ]
    },
    "7": {
      "plannerCity": "Seattle",
      "matchDay": 4,
      "city": "Seattle",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Seattle-Tacoma International Airport (SEA), take the Link Light Rail to your accommodation in downtown Seattle, Belltown, or Capitol Hill, and check in. Settle in and prepare for your Seattle adventure.",
              "placeName": "Downtown Seattle",
              "mapLink": "https://www.google.com/maps/search/Downtown+Seattle",
              "ticketLink": "",
              "imageUrl": "https://example.com/seattle_downtown_arrival.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Pike Place Market",
              "description": "Immerse yourself in the vibrant atmosphere of Seattle's historic market. Watch fishmongers throw fish, browse local crafts, and enjoy street performers. Visit the original Starbucks across the street.",
              "placeName": "Pike Place Market",
              "mapLink": "https://www.google.com/maps/search/Pike+Place+Market",
              "ticketLink": "",
              "imageUrl": "https://example.com/pike_place_market.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Taste Local Delicacies",
              "description": "Enjoy a delicious pastry from Piroshky Piroshky and sample artisanal cheese at Beecher's Handmade Cheese, both iconic market staples.",
              "placeName": "Piroshky Piroshky at Pike Place Market",
              "mapLink": "https://www.google.com/maps/search/Piroshky+Piroshky+Pike+Place+Market",
              "ticketLink": "",
              "imageUrl": "https://example.com/piroshky_piroshky.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Seattle Great Wheel Ride",
              "description": "Enjoy panoramic views of the city skyline, Puget Sound, and the Olympic Mountains from atop the Seattle Great Wheel on Pier 57.",
              "placeName": "Seattle Great Wheel",
              "mapLink": "https://www.google.com/maps/search/Seattle+Great+Wheel",
              "ticketLink": "https://www.viator.com/Seattle-Great-Wheel-tickets",
              "imageUrl": "https://example.com/great_wheel.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner in Belltown",
              "description": "Savor a modern American meal in the lively Belltown neighborhood, known for its diverse culinary scene and vibrant nightlife.",
              "placeName": "Local 360",
              "mapLink": "https://www.google.com/maps/search/Local+360+Seattle",
              "ticketLink": "",
              "imageUrl": "https://example.com/local360.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Space Needle & Chihuly Garden and Glass",
              "description": "Visit Seattle's most iconic landmark for breathtaking 360-degree views. Afterwards, explore the stunning glass art installations at Chihuly Garden and Glass, located adjacent to the Space Needle.",
              "placeName": "Space Needle",
              "mapLink": "https://www.google.com/maps/search/Space+Needle",
              "ticketLink": "https://www.spaceneedle.com/tickets",
              "imageUrl": "https://example.com/space_needle.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Museum of Pop Culture (MoPOP)",
              "description": "Dive into the world of music, sci-fi, and pop culture at MoPOP, an interactive museum with fascinating exhibits.",
              "placeName": "Museum of Pop Culture (MoPOP)",
              "mapLink": "https://www.google.com/maps/search/Museum+of+Pop+Culture",
              "ticketLink": "https://mopop.org/visit/tickets/",
              "imageUrl": "https://example.com/mopop.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Queen Anne",
              "description": "Enjoy a delightful dinner in the charming Queen Anne neighborhood, known for its beautiful Victorian homes and upscale restaurants.",
              "placeName": "Toulouse Petit Kitchen & Lounge",
              "mapLink": "https://www.google.com/maps/search/Toulouse+Petit+Kitchen+%26+Lounge",
              "ticketLink": "",
              "imageUrl": "https://example.com/toulouse_petit.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            },
            {
              "name": "Sunset Views at Kerry Park",
              "description": "Capture postcard-perfect views of the Seattle skyline, including the Space Needle and Mount Rainier (on a clear day), during sunset from Kerry Park.",
              "placeName": "Kerry Park",
              "mapLink": "https://www.google.com/maps/search/Kerry+Park",
              "ticketLink": "",
              "imageUrl": "https://example.com/kerry_park_sunset.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Seattle Aquarium",
              "description": "Explore the diverse marine life of the Pacific Northwest and beyond at the Seattle Aquarium, located on Pier 59.",
              "placeName": "Seattle Aquarium",
              "mapLink": "https://www.google.com/maps/search/Seattle+Aquarium",
              "ticketLink": "https://www.seattleaquarium.org/tickets",
              "imageUrl": "https://example.com/seattle_aquarium.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Waterfront Stroll",
              "description": "Enjoy a leisurely walk along Seattle's revitalized waterfront, taking in the views of Puget Sound and its active ferry traffic.",
              "placeName": "Seattle Waterfront",
              "mapLink": "https://www.google.com/maps/search/Seattle+Waterfront",
              "ticketLink": "",
              "imageUrl": "https://example.com/seattle_waterfront.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pioneer Square & Underground Tour",
              "description": "Discover Seattle's hidden history on Bill Speidel's Underground Tour, exploring subterranean passages and learning about the city's early days. Afterwards, explore the historic Pioneer Square neighborhood.",
              "placeName": "Pioneer Square",
              "mapLink": "https://www.google.com/maps/search/Pioneer+Square+Seattle",
              "ticketLink": "https://www.undergroundtour.com/tickets/",
              "imageUrl": "https://example.com/underground_tour.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Ivar's Acres of Clams",
              "description": "Indulge in classic Pacific Northwest seafood at the iconic Ivar's Acres of Clams, a Seattle institution on Pier 54.",
              "placeName": "Ivar's Acres of Clams",
              "mapLink": "https://www.google.com/maps/search/Ivar's+Acres+of+Clams",
              "ticketLink": "",
              "imageUrl": "https://example.com/ivars.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            },
            {
              "name": "Pioneer Square Pub Crawl",
              "description": "Experience the historic charm of Pioneer Square's pubs and bars. Many establishments offer a great atmosphere for football fans.",
              "placeName": "Pioneer Square",
              "mapLink": "https://www.google.com/maps/search/Pioneer+Square+Pubs",
              "ticketLink": "",
              "imageUrl": "https://example.com/pioneer_square_pub.jpg",
              "best_time": "evening",
              "suggested_time": "08:30 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch matches on giant screens. (Location TBD, often near Seattle Center or waterfront).",
              "placeName": "FIFA Fan Festival Seattle (Anticipated Location: Seattle Center)",
              "mapLink": "https://www.google.com/maps/search/Seattle+Center",
              "ticketLink": "",
              "imageUrl": "https://example.com/fan_festival.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Lumen Field Walk",
              "description": "Head towards Lumen Field, soaking in the pre-match excitement. Enjoy the fan march, grab a quick bite or drink at a nearby sports bar or food truck.",
              "placeName": "Lumen Field",
              "mapLink": "https://www.google.com/maps/search/Lumen+Field",
              "ticketLink": "",
              "imageUrl": "https://example.com/lumen_field_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            },
            {
              "name": "Dinner at Elysian Fields",
              "description": "Enjoy a pre-match meal and craft beer at Elysian Fields, a popular brewery and restaurant located just steps from Lumen Field, known for its lively atmosphere on game days.",
              "placeName": "Elysian Fields",
              "mapLink": "https://www.google.com/maps/search/Elysian+Fields+Seattle",
              "ticketLink": "",
              "imageUrl": "https://example.com/elysian_fields.jpg",
              "best_time": "afternoon",
              "suggested_time": "05:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Lumen Field",
              "description": "Experience the thrill of a live FIFA World Cup match at Lumen Field, cheering on your favorite team in an electrifying atmosphere.",
              "placeName": "Lumen Field",
              "mapLink": "https://www.google.com/maps/search/Lumen+Field",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://example.com/lumen_field_match.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Ferry to Bainbridge Island",
              "description": "Embark on a scenic 35-minute ferry ride across Puget Sound to Bainbridge Island. Enjoy stunning views of the Seattle skyline and surrounding mountains.",
              "placeName": "Seattle Ferry Terminal (Pier 52)",
              "mapLink": "https://www.google.com/maps/search/Seattle+Ferry+Terminal+Pier+52",
              "ticketLink": "https://wsdot.wa.gov/travel/washington-state-ferries",
              "imageUrl": "https://example.com/bainbridge_ferry.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Winslow (Bainbridge Island)",
              "description": "Wander through the charming town of Winslow, exploring local boutiques, art galleries, and waterfront parks. Enjoy lunch at a local cafe.",
              "placeName": "Winslow, Bainbridge Island",
              "mapLink": "https://www.google.com/maps/search/Winslow+Bainbridge+Island",
              "ticketLink": "",
              "imageUrl": "https://example.com/winslow_bainbridge.jpg",
              "best_time": "afternoon",
              "suggested_time": "11:00 AM"
            },
            {
              "name": "Lunch at Streamliner Diner",
              "description": "Enjoy a classic American diner experience with fresh, local ingredients at Streamliner Diner in Winslow.",
              "placeName": "Streamliner Diner",
              "mapLink": "https://www.google.com/maps/search/Streamliner+Diner+Bainbridge+Island",
              "ticketLink": "",
              "imageUrl": "https://example.com/streamliner_diner.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Return to Seattle & Dinner in Capitol Hill",
              "description": "Take the ferry back to Seattle and enjoy dinner in the lively and diverse Capitol Hill neighborhood, known for its eclectic dining scene.",
              "placeName": "Oddfellows Cafe + Bar",
              "mapLink": "https://www.google.com/maps/search/Oddfellows+Cafe+%2B+Bar+Seattle",
              "ticketLink": "",
              "imageUrl": "https://example.com/oddfellows_cafe.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "University of Washington Campus",
              "description": "Explore the beautiful University of Washington campus, famous for its stunning architecture, particularly the Suzzallo Library and the Quad's cherry blossoms (seasonal). Walk along 'The Ave' for student life.",
              "placeName": "University of Washington",
              "mapLink": "https://www.google.com/maps/search/University+of+Washington",
              "ticketLink": "",
              "imageUrl": "https://example.com/uw_campus.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Gas Works Park",
              "description": "Visit Gas Works Park, a unique urban park built on the site of a former gasification plant. Enjoy panoramic views of the Seattle skyline, Lake Union, and the Space Needle.",
              "placeName": "Gas Works Park",
              "mapLink": "https://www.google.com/maps/search/Gas+Works+Park",
              "ticketLink": "",
              "imageUrl": "https://example.com/gas_works_park.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Fremont Troll & Dinner",
              "description": "Discover the quirky Fremont Troll sculpture lurking under the Aurora Bridge. Afterwards, enjoy dinner in the eclectic Fremont neighborhood, known as the 'Center of the Universe'.",
              "placeName": "Fremont Troll",
              "mapLink": "https://www.google.com/maps/search/Fremont+Troll",
              "ticketLink": "",
              "imageUrl": "https://example.com/fremont_troll.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at Paseo Caribbean Food",
              "description": "Savor the renowned Caribbean sandwiches at Paseo Caribbean Food, a local favorite in Fremont known for its vibrant flavors.",
              "placeName": "Paseo Caribbean Food (Fremont)",
              "mapLink": "https://www.google.com/maps/search/Paseo+Caribbean+Food+Fremont",
              "ticketLink": "",
              "imageUrl": "https://example.com/paseo.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Farewell Breakfast at Portage Bay Cafe",
              "description": "Enjoy a delicious, organic breakfast with a famous 'topping bar' at Portage Bay Cafe, a popular Seattle brunch spot.",
              "placeName": "Portage Bay Cafe (South Lake Union)",
              "mapLink": "https://www.google.com/maps/search/Portage+Bay+Cafe+South+Lake+Union",
              "ticketLink": "",
              "imageUrl": "https://example.com/portage_bay_cafe.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Souvenir Shopping / Last-Minute Sightseeing",
              "description": "Spend your last morning picking up souvenirs or revisiting a favorite spot before heading to the airport.",
              "placeName": "Seattle Downtown",
              "mapLink": "https://www.google.com/maps/search/Seattle+Downtown",
              "ticketLink": "",
              "imageUrl": "https://example.com/seattle_souvenirs.jpg",
              "best_time": "morning",
              "suggested_time": "10:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Seattle-Tacoma International Airport (SEA)",
              "description": "Take the Link Light Rail from downtown Seattle directly to Sea-Tac Airport for your departure.",
              "placeName": "Seattle-Tacoma International Airport (SEA)",
              "mapLink": "https://www.google.com/maps/search/Seattle-Tacoma+International+Airport",
              "ticketLink": "",
              "imageUrl": "https://example.com/sea_airport.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Piroshky Piroshky (Pike Place Market) - Russian pastries",
        "Beecher's Handmade Cheese (Pike Place Market) - Artisanal cheese, grilled cheese sandwiches",
        "Ivar's Acres of Clams (Waterfront) - Classic fish and chips, seafood",
        "Dick's Drive-In (Various locations) - Classic Seattle burgers and fries",
        "Paseo Caribbean Food (Fremont) - Famous Caribbean sandwiches",
        "Portage Bay Cafe (Multiple locations) - Organic breakfast and brunch with a topping bar",
        "Local 360 (Belltown) - Farm-to-table American cuisine"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Day 4): Immerse yourself in the World Cup atmosphere with live music, food, and giant screens.",
        "Lumen Field Match Day (Day 4): Attend a live FIFA World Cup match at Seattle's premier stadium.",
        "Pre-Match Atmosphere around Lumen Field (Day 4): Join the fan marches and enjoy the buzz around the stadium.",
        "Pioneer Square Pubs (Day 3 evening): Experience Seattle's pub culture, often lively with sports discussions."
      ],
      "travel_tips": [
        "Stadium Access (Lumen Field): Lumen Field is conveniently located just south of downtown Seattle. The easiest way to reach it is via the Link Light Rail. Take the 1 Line to Stadium Station, which is directly adjacent to the stadium. King County Metro buses also serve the area.",
        "Where to Stay: Consider staying in areas like Downtown Seattle, Pioneer Square, Belltown, Capitol Hill, or South Lake Union. These neighborhoods offer excellent public transportation access to Lumen Field (within a 60-minute commute) and other major attractions, along with a wide range of dining and entertainment options.",
        "Public Transportation: Seattle's public transportation system is robust and recommended for navigating the city. The Link Light Rail (1 Line) connects Seattle-Tacoma International Airport (SEA) to downtown, Capitol Hill, and the University District. King County Metro operates an extensive bus network throughout the city and surrounding areas. For ferries, Washington State Ferries serves various islands and peninsulas, including Bainbridge Island from Pier 52.",
        "Payment for Transit: The ORCA card is highly recommended for seamless travel across Link Light Rail, Metro buses, and Washington State Ferries (passenger fare only). You can purchase and load an ORCA card at Link Light Rail stations, transit customer service centers, or online. Single-ride tickets are also available at Link Light Rail stations and on buses (exact cash fare required for buses if not using ORCA)."
      ]
    }
  },
  "san-francisco": {
    "3": {
      "plannerCity": "Santa Clara",
      "matchDay": 2,
      "city": "Santa Clara",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Intel Museum",
              "description": "Explore the history of silicon and computing in the heart of Silicon Valley.",
              "placeName": "Intel Museum",
              "mapLink": "https://www.google.com/maps/place/Intel+Museum",
              "ticketLink": "https://www.intel.com/content/www/us/en/company/intel-museum.html",
              "imageUrl": "https://example.com/intel_museum.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Breakfast at Bill's Cafe (Willow Glen)",
              "description": "Enjoy a hearty breakfast or brunch at a local favorite, famous for its pancakes and omelets.",
              "placeName": "Bill's Cafe (Willow Glen)",
              "mapLink": "https://www.google.com/maps/place/Bill's+Cafe+Willow+Glen",
              "imageUrl": "https://example.com/bills_cafe.jpg",
              "best_time": "morning",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "The Tech Interactive",
              "description": "Engage with hands-on science and technology exhibits in downtown San Jose.",
              "placeName": "The Tech Interactive",
              "mapLink": "https://www.google.com/maps/place/The+Tech+Interactive",
              "ticketLink": "https://www.thetech.org/visit",
              "imageUrl": "https://example.com/the_tech_interactive.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at San Pedro Square Market",
              "description": "Experience a vibrant marketplace with a variety of food vendors offering diverse culinary options.",
              "placeName": "San Pedro Square Market",
              "mapLink": "https://www.google.com/maps/place/San+Pedro+Square+Market",
              "imageUrl": "https://example.com/san_pedro_square_market.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Explore Santana Row",
              "description": "Stroll through Santana Row, an upscale outdoor shopping, dining, and entertainment district.",
              "placeName": "Santana Row",
              "mapLink": "https://www.google.com/maps/place/Santana+Row",
              "imageUrl": "https://example.com/santana_row.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at Original Joe's of San Jose",
              "description": "Savor classic Italian-American cuisine at a historic San Jose institution.",
              "placeName": "Original Joe's of San Jose",
              "mapLink": "https://www.google.com/maps/place/Original+Joe's+of+San+Jose",
              "imageUrl": "https://example.com/original_joes.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival (Discovery Meadow Park)",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Festival, featuring live music, food, and fan activities.",
              "placeName": "Discovery Meadow Park, San Jose",
              "mapLink": "https://www.google.com/maps/place/Discovery+Meadow+Park",
              "imageUrl": "https://example.com/fifa_fan_festival.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-match Atmosphere at Levi's Stadium",
              "description": "Arrive early to soak in the electric atmosphere, explore stadium surroundings, and visit official merchandise stores.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium",
              "imageUrl": "https://example.com/levis_stadium_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            },
            {
              "name": "Early Dinner/Late Lunch at Bourbon Pub",
              "description": "Enjoy a meal and drinks at this upscale pub located adjacent to Levi's Stadium, perfect for pre-match dining.",
              "placeName": "Bourbon Pub",
              "mapLink": "https://www.google.com/maps/place/Bourbon+Pub",
              "imageUrl": "https://example.com/bourbon_pub.jpg",
              "best_time": "afternoon",
              "suggested_time": "05:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Levi's Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the iconic Levi's Stadium.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://example.com/fifa_match_stadium.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Golden Gate Bridge Welcome Center & Vista Point",
              "description": "Travel to San Francisco to witness the breathtaking views of the iconic Golden Gate Bridge.",
              "placeName": "Golden Gate Bridge Welcome Center",
              "mapLink": "https://www.google.com/maps/place/Golden+Gate+Bridge+Welcome+Center",
              "imageUrl": "https://example.com/golden_gate_bridge.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Breakfast at Ferry Building Marketplace (SF)",
              "description": "Enjoy a meal from a diverse selection of artisan food vendors at San Francisco's historic Ferry Building.",
              "placeName": "Ferry Building Marketplace",
              "mapLink": "https://www.google.com/maps/place/Ferry+Building+Marketplace",
              "imageUrl": "https://example.com/ferry_building.jpg",
              "best_time": "morning",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Fisherman's Wharf & Pier 39",
              "description": "Explore the bustling waterfront, see the famous sea lions, and enjoy the lively street performers.",
              "placeName": "Fisherman's Wharf",
              "mapLink": "https://www.google.com/maps/place/Fisherman's+Wharf",
              "imageUrl": "https://example.com/fishermans_wharf.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at Boudin Bakery & Cafe (Fisherman's Wharf)",
              "description": "Savor classic clam chowder served in a sourdough bread bowl, a quintessential San Francisco experience.",
              "placeName": "Boudin Bakery & Cafe (Fisherman's Wharf)",
              "mapLink": "https://www.google.com/maps/place/Boudin+Bakery+%26+Cafe",
              "imageUrl": "https://example.com/boudin_bakery.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at The Farmers Union",
              "description": "Enjoy American comfort food and a selection of craft beers in downtown San Jose before your departure.",
              "placeName": "The Farmers Union",
              "mapLink": "https://www.google.com/maps/place/The+Farmers+Union",
              "imageUrl": "https://example.com/farmers_union.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Bill's Cafe (Willow Glen) for breakfast/brunch",
        "San Pedro Square Market for diverse lunch options",
        "Original Joe's of San Jose for classic Italian-American dinner",
        "Boudin Bakery & Cafe (Fisherman's Wharf) for clam chowder in a sourdough bowl",
        "The Farmers Union for American comfort food and craft beers"
      ],
      "football_experiences": [
        "FIFA Fan Festival at Discovery Meadow Park (San Jose)",
        "Pre-match atmosphere and activities at Levi's Stadium",
        "Attending a FIFA World Cup Match at Levi's Stadium"
      ],
      "travel_tips": [
        "How to reach Levi's Stadium: The most convenient way is via VTA Light Rail (Orange Line) to the Great America Station, which is directly adjacent to the stadium. Special event services will likely be in operation on match days. VTA buses also serve the area.",
        "Where to stay: Consider accommodations in Santa Clara, San Jose, or Sunnyvale. These cities offer good access to Levi's Stadium via VTA Light Rail. Palo Alto or Mountain View are also viable options, accessible via Caltrain with a VTA connection. Look for hotels near VTA Light Rail stops for easy transit.",
        "Public Transportation for Santa Clara/San Jose and the Bay Area: The primary transit system in Santa Clara County is VTA (Valley Transportation Authority), operating buses and light rail. For regional travel, especially to San Francisco, use Caltrain (commuter rail from San Jose to San Francisco) and BART (Bay Area Rapid Transit, which connects to Caltrain at Millbrae and serves San Francisco and wider Bay Area). The recommended fare card for seamless travel across all these systems (VTA, Caltrain, BART, Muni in SF, etc.) is the Clipper Card. Purchase a Clipper Card and load value or multi-day passes onto it for convenience."
      ]
    },
    "5": {
      "plannerCity": "Santa Clara",
      "matchDay": 3,
      "city": "Santa Clara",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Check-in",
              "description": "Arrive in Santa Clara, check into your accommodation, and prepare for your World Cup adventure.",
              "placeName": "Santa Clara",
              "mapLink": "https://www.google.com/maps/place/Santa+Clara,+CA",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Santa_Clara_City_Hall.jpg/800px-Santa_Clara_City_Hall.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Mission Santa Clara de Asís",
              "description": "Visit the historic eighth Spanish mission in California, located on the beautiful Santa Clara University campus.",
              "placeName": "Mission Santa Clara de Asís",
              "mapLink": "https://www.google.com/maps/place/Mission+Santa+Clara+de+As%C3%ADs/@37.349603,-121.939228,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcb041a729e2f:0x6b148d56b006871c!8m2!3d37.349603!4d-121.9366531!16s%2Fg%2F1tdy4q9k?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Mission_Santa_Clara_de_Asis.jpg/1280px-Mission_Santa_Clara_de_Asis.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "The Tech Interactive",
              "description": "Explore hands-on exhibits focused on science and technology in downtown San Jose. Great for all ages.",
              "placeName": "The Tech Interactive",
              "mapLink": "https://www.google.com/maps/place/The+Tech+Interactive/@37.330873,-121.892404,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcd35e4d2572b:0x51c5e7b233a5796b!8m2!3d37.330873!4d-121.8898291!16s%2Fg%2F1tdz0v_k?entry=ttu",
              "ticketLink": "https://www.thetech.org/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/The_Tech_Museum_of_Innovation.jpg/1280px-The_Tech_Museum_of_Innovation.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at Bill's Cafe (San Jose)",
              "description": "Enjoy a classic American diner experience known for its breakfast and lunch dishes.",
              "placeName": "Bill's Cafe (Willow Glen)",
              "mapLink": "https://www.google.com/maps/place/Bill's+Cafe+Willow+Glen/@37.305085,-121.905627,17z/data=!3m1!4b1!4m6!3m5!1s0x808e330a84d41e7f:0x93361e604724a87a!8m2!3d37.305085!4d-121.9030521!16s%2Fg%2F1td9z_v7?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://billscafe.com/wp-content/uploads/2019/07/Bills-Cafe-Interior-1024x683.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Santana Row",
              "description": "Dine at one of the upscale restaurants at Santana Row, an outdoor shopping and dining district. Consider 'Left Bank Brasserie' for French cuisine or 'Fogo de Chão Brazilian Steakhouse' for a unique experience.",
              "placeName": "Santana Row",
              "mapLink": "https://www.google.com/maps/place/Santana+Row/@37.320492,-121.954201,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb564a515f401:0x391307b629007f9c!8m2!3d37.320492!4d-121.9516261!16s%2Fg%2F1td8n00x?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.santanarow.com/sites/default/files/styles/slideshow_xl/public/2021-06/SantanaRow-Hero_1.jpg?itok=fU3L90Vd",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Golden Gate Bridge & Presidio",
              "description": "Take public transit (Caltrain + Muni) to San Francisco to see the iconic Golden Gate Bridge. Walk or bike across, and explore the Presidio National Park. This is an intentional longer excursion from Santa Clara.",
              "placeName": "Golden Gate Bridge",
              "mapLink": "https://www.google.com/maps/place/Golden+Gate+Bridge/@37.819929,-122.478255,17z/data=!3m1!4b1!4m6!3m5!1s0x808586de69d7c8a7:0x510927.99479323c!8m2!3d37.819929!4d-122.478255!16s%2Fg%2F12239m8b?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Golden_Gate_Bridge_HDR_2.jpg/1280px-Golden_Gate_Bridge_HDR_2.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Fisherman's Wharf & Pier 39",
              "description": "Visit the lively Fisherman's Wharf, see the sea lions at Pier 39, and soak in the bustling atmosphere.",
              "placeName": "Fisherman's Wharf",
              "mapLink": "https://www.google.com/maps/place/Fisherman's+Wharf/@37.808092,-122.417726,17z/data=!3m1!4b1!4m6!3m5!1s0x808580f4f9f7d4b9:0x416d3f234327041a!8m2!3d37.808092!4d-122.4151511!16s%2Fg%2F11b6q7_221?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Fisherman%27s_Wharf%2C_San_Francisco_-_April_2016.jpg/1280px-Fisherman%27s_Wharf%2C_San_Francisco_-_April_2016.jpg",
              "best_time": "morning",
              "suggested_time": "11:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Boudin Bakery",
              "description": "Enjoy San Francisco's famous sourdough bread bowl clam chowder at the iconic Boudin Bakery.",
              "placeName": "Boudin Bakery & Cafe (Fisherman's Wharf)",
              "mapLink": "https://www.google.com/maps/place/Boudin+Bakery+%26+Cafe/@37.808514,-122.417387,17z/data=!3m1!4b1!4m6!3m5!1s0x808580f339f4270f:0x228e938949826317!8m2!3d37.808514!4d-122.4148121!16s%2Fg%2F1tf7w4y5?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Boudin_Sourdough_Bakery_and_Cafe_at_Fisherman%27s_Wharf.jpg/1280px-Boudin_Sourdough_Bakery_and_Cafe_at_Fisherman%27s_Wharf.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Lombard Street & Coit Tower",
              "description": "Walk down the 'most crooked street in the world', Lombard Street, and then head to Coit Tower for panoramic views of the city (optional: Alcatraz if tickets were booked months in advance).",
              "placeName": "Lombard Street",
              "mapLink": "https://www.google.com/maps/place/Lombard+Street/@37.802128,-122.419069,17z/data=!3m1!4b1!4m6!3m5!1s0x808580e03a951d3b:0x8797e87a206b0266!8m2!3d37.802128!4d-122.4164941!16s%2Fg%2F1tf75v6f?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Lombard_Street_in_San_Francisco.jpg/1280px-Lombard_Street_in_San_Francisco.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Chinatown",
              "description": "Experience the vibrant culture and delicious food of San Francisco's Chinatown. Consider 'House of Nanking' for a lively atmosphere or 'Great Eastern Restaurant' for dim sum.",
              "placeName": "San Francisco Chinatown",
              "mapLink": "https://www.google.com/maps/place/Chinatown,+San+Francisco,+CA/@37.794101,-122.408226,17z/data=!3m1!4b1!4m6!3m5!1s0x8085806c9a3b2b4f:0xa193b0a70183350!8m2!3d37.794101!4d-122.4056511!16s%2Fg%2F1tdw767x?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Chinatown_Gate_San_Francisco.jpg/1280px-Chinatown_Gate_San_Francisco.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Fest / FIFA Fan Festival",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Fest. Enjoy live music, food, sponsor activities, and watch other matches on giant screens. The main Fan Fest will likely be in San Jose or near Levi's Stadium.",
              "placeName": "Levi's Stadium Fan Zone (or designated city fan fest location)",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium/@37.403213,-121.970258,17z/data=!3m1!4b1!4m6!3m5!1s0x808fc99a5e840d23:0x117462a673d36674!8m2!3d37.403213!4d-121.9676831!16s%2Fg%2F11b6q7_5w3?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://digitalhub.fifa.com/transform/4b17921a-e90c-4c6e-827d-944433d73507/FIFA-Fan-Festival-Doha?io=transform:fill,width:1920,height:1080",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Pre-Match Lunch & Tailgate Atmosphere",
              "description": "Grab a casual lunch near the stadium or participate in the vibrant tailgating scene around Levi's Stadium. Many informal food vendors and local establishments will be buzzing.",
              "placeName": "Restaurants near Levi's Stadium / Great America Parkway",
              "mapLink": "https://www.google.com/maps/search/restaurants+near+Levi's+Stadium/@37.403213,-121.970258,15z/data=!3m1!4b1?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.mercurynews.com/wp-content/uploads/2016/08/20150914__mn-tailgate-0915-01.jpg?w=810",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "afternoon": [
            {
              "name": "Head to Levi's Stadium for Match Day",
              "description": "Make your way to Levi's Stadium early to soak in the pre-match excitement, find your seats, and enjoy the official ceremonies. Use VTA Light Rail for convenient access.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium/@37.403213,-121.970258,17z/data=!3m1!4b1!4m6!3m5!1s0x808fc99a5e840d23:0x117462a673d36674!8m2!3d37.403213!4d-121.9676831!16s%2Fg%2F11b6q7_5w3?entry=ttu",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Levi%27s_Stadium_in_Santa_Clara%2C_California.jpg/1280px-Levi%27s_Stadium_in_Santa_Clara%2C_California.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a live FIFA World Cup match at Levi's Stadium. Cheer for your team and enjoy world-class football.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium/@37.403213,-121.970258,17z/data=!3m1!4b1!4m6!3m5!1s0x808fc99a5e840d23:0x117462a673d36674!8m2!3d37.403213!4d-121.9676831!16s%2Fg%2F11b6q7_5w3?entry=ttu",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/54ac0e5d-c694-436f-b258-953e5e347071/FIFA-World-Cup-Qatar-2022-Argentina-v-France-Final?io=transform:fill,width:1920,height:1080",
              "best_time": "evening",
              "suggested_time": "17:00"
            },
            {
              "name": "Post-Match Dinner at a Sports Bar",
              "description": "Celebrate or commiserate after the match with dinner and drinks at a local sports bar. 'The Counter' (San Jose) or 'Taplands Taproom & Bottle Shop' (Santa Clara) are good options for a casual atmosphere and good food.",
              "placeName": "The Counter (San Jose)",
              "mapLink": "https://www.google.com/maps/place/The+Counter+Custom+Burgers/@37.320297,-121.951554,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb5649987829d:0x317a3a9926b01511!8m2!3d37.320297!4d-121.9489791!16s%2Fg%2F1td8n04z?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0b/49/a1/38/the-counter.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Stanford University Campus & Hoover Tower",
              "description": "Explore the beautiful campus of Stanford University in Palo Alto. Visit the iconic Hoover Tower for panoramic views and the Rodin Sculpture Garden.",
              "placeName": "Stanford University",
              "mapLink": "https://www.google.com/maps/place/Stanford+University/@37.427475,-122.170425,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb25875267591:0x4d4906f35b43343d!8m2!3d37.427475!4d-122.1678501!16s%2Fg%2F1tdy4q9k?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Hoover_Tower_at_Stanford_University.jpg/1280px-Hoover_Tower_at_Stanford_University.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Cantor Arts Center",
              "description": "Visit Stanford's Cantor Arts Center, home to an impressive collection of art, including the largest collection of Rodin bronzes outside of Paris. Admission is free.",
              "placeName": "Cantor Arts Center at Stanford University",
              "mapLink": "https://www.google.com/maps/place/Cantor+Arts+Center/@37.422736,-122.169123,17z/data=!3m1!4b1!4m6!3m5!1s0x808fbb23512b9a7f:0x341e3d360098f98a!8m2!3d37.422736!4d-122.1665481!16s%2Fg%2F1tdz0v_k?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Cantor_Arts_Center.jpg/1280px-Cantor_Arts_Center.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Lunch in Downtown Palo Alto",
              "description": "Enjoy lunch in the charming downtown area of Palo Alto. 'Oren's Hummus' is a popular spot for Middle Eastern cuisine, or 'Palo Alto Creamery' for classic American comfort food.",
              "placeName": "Downtown Palo Alto",
              "mapLink": "https://www.google.com/maps/place/Palo+Alto,+CA/@37.441883,-122.143019,15z/data=!3m1!4b1!4m6!3m5!1s0x808fbb280735870f:0x808593a8d9a435a2!8m2!3d37.441883!4d-122.143019!16s%2Fg%2F1td72517?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.paloaltoonline.com/news/photos/2019/april/2/downtown-palo-alto-web.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:00"
            }
          ],
          "evening": [
            {
              "name": "Explore University Avenue & Dinner",
              "description": "Stroll along University Avenue in Palo Alto, known for its shops and diverse dining options. Enjoy dinner at 'Evvia Estiatorio' for upscale Greek or 'Pizzeria Delfina' for delicious pizza.",
              "placeName": "University Avenue, Palo Alto",
              "mapLink": "https://www.google.com/maps/place/University+Ave,+Palo+Alto,+CA/@37.443593,-122.162744,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb217f763a8a3:0x1b2d0752e5572242!8m2!3d37.443593!4d-122.1601691!16s%2Fg%2F1tdw767x?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.cityofpaloalto.org/files/assets/public/v/1/departments/planning-and-development/planning/images/university-ave.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Winchester Mystery House",
              "description": "Visit the bizarre and fascinating Winchester Mystery House in San Jose, a sprawling mansion known for its architectural oddities and ghost stories.",
              "placeName": "Winchester Mystery House",
              "mapLink": "https://www.google.com/maps/place/Winchester+Mystery+House/@37.320392,-121.954737,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb564d6e973e7:0x228e938949826317!8m2!3d37.320392!4d-121.9521621!16s%2Fg%2F1tf7w4y5?entry=ttu",
              "ticketLink": "https://winchestermysteryhouse.com/buy-tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Winchester_Mystery_House_exterior.jpg/1280px-Winchester_Mystery_House_exterior.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Brunch at Proto's Pizzeria & Pasta",
              "description": "Enjoy a casual brunch or early lunch at Proto's Pizzeria & Pasta, known for its fresh ingredients and cozy atmosphere in Santa Clara.",
              "placeName": "Proto's Pizzeria & Pasta (Santa Clara)",
              "mapLink": "https://www.google.com/maps/place/Proto's+Pizzeria+%26+Pasta/@37.351296,-121.966961,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcb0d1e57c83f:0x2e0c1f55a6d51096!8m2!3d37.351296!4d-121.9643861!16s%2Fg%2F11b6q7_221?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.protosrestaurant.com/wp-content/uploads/2019/07/protos_restaurant_interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "afternoon": [
            {
              "name": "Last-minute Souvenir Shopping",
              "description": "Do some last-minute souvenir shopping at Westfield Valley Fair mall or other local shops before heading to the airport.",
              "placeName": "Westfield Valley Fair",
              "mapLink": "https://www.google.com/maps/place/Westfield+Valley+Fair/@37.323565,-121.947239,17z/data=!3m1!4b1!4m6!3m5!1s0x808fb56353982e5b:0x8797e87a206b0266!8m2!3d37.323565!4d-121.9446641!16s%2Fg%2F1tf75v6f?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Westfield_Valley_Fair_entrance.jpg/1280px-Westfield_Valley_Fair_entrance.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Departure",
              "description": "Head to San Jose International Airport (SJC) or San Francisco International Airport (SFO) for your departure.",
              "placeName": "San Jose International Airport (SJC)",
              "mapLink": "https://www.google.com/maps/place/San+Jose+Mineta+International+Airport+(SJC)/@37.36399,-121.928929,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcb2c7e09095f:0x6c9d0d8f0f0c0f0e!8m2!3d37.36399!4d-121.9263541!16s%2Fg%2F1tdy4q9k?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/San_Jose_International_Airport_Terminal_A.jpg/1280px-San_Jose_International_Airport_Terminal_A.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Boudin Bakery's Sourdough Bread Bowl Clam Chowder (San Francisco)",
        "Mission-style Burrito (e.g., from La Taqueria in San Francisco, though not explicitly in itinerary, it's an iconic Bay Area food)",
        "Dim Sum in San Francisco Chinatown",
        "Classic American Breakfast/Brunch at Bill's Cafe (San Jose)",
        "Upscale dining at Santana Row (San Jose)",
        "Mediterranean cuisine at Oren's Hummus (Palo Alto)"
      ],
      "football_experiences": [
        "FIFA Fan Fest / FIFA Fan Festival (Santa Clara/San Jose)",
        "Live FIFA World Cup Match at Levi's Stadium",
        "Tailgating atmosphere around Levi's Stadium on match day",
        "Visiting sports bars in San Jose or Santa Clara for post-match celebrations."
      ],
      "travel_tips": [
        "How to reach Levi's Stadium: The most efficient way is via VTA Light Rail. The Lick Mill and Great America stations are directly adjacent to the stadium. VTA also operates bus services. Special event shuttles may also be available from key transit hubs. Plan to arrive early on match day.",
        "Where to stay: Consider hotels in Santa Clara (closest to stadium, but potentially pricier), San Jose (larger city, good VTA connections, more options), or Sunnyvale/Mountain View (good balance of proximity and options). Book well in advance due to high demand during the World Cup.",
        "Public Transportation in the Bay Area: The Bay Area has a comprehensive public transport network. Purchase a 'Clipper Card' upon arrival. This reloadable card works across most major transit systems, including:",
        "- VTA (Valley Transportation Authority): Operates light rail and buses in Santa Clara and San Jose. Essential for getting to Levi's Stadium.",
        "- Caltrain: Commuter rail connecting San Jose, Palo Alto, and San Francisco. Useful for the San Francisco day trip (connects to Muni).",
        "- BART (Bay Area Rapid Transit): Connects San Francisco, Oakland, and extends to Berryessa/North San Jose (via Milpitas station, which connects to VTA). Useful for airport transfers (SFO/OAK) and longer Bay Area trips.",
        "- Muni (San Francisco Municipal Railway): San Francisco's local transit, including buses, streetcars, and cable cars. Use for getting around San Francisco.",
        "Fares: Fares vary by distance and system. The Clipper Card simplifies payment across all systems. You can load cash value or regional passes onto it.",
        "Traffic: Bay Area traffic can be heavy, especially during peak hours. Relying on public transport is highly recommended, particularly on match days.",
        "Weather: June/July in the Bay Area is typically mild and sunny, but San Francisco can be notably cooler and foggier, especially in the mornings and evenings. Bring layers for comfort."
      ]
    },
    "7": {
      "plannerCity": "Santa Clara",
      "matchDay": 4,
      "city": "Santa Clara",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at San Jose Mineta International Airport (SJC) or San Francisco International Airport (SFO) and transfer to your accommodation in Santa Clara or San Jose. Take time to settle in.",
              "placeName": "San Jose Mineta International Airport (SJC)",
              "mapLink": "https://www.google.com/maps/place/San+Jose+Mineta+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/San_Jose_International_Airport_Terminal_B.jpg/1280px-San_Jose_International_Airport_Terminal_B.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Mission Santa Clara de Asís & Santa Clara University",
              "description": "Visit the eighth of the 21 California Missions, located on the beautiful Santa Clara University campus. Explore the historic mission church and the university grounds.",
              "placeName": "Mission Santa Clara de Asís",
              "mapLink": "https://www.google.com/maps/place/Mission+Santa+Clara+de+As%C3%ADs",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Mission_Santa_Clara_de_Asis.jpg/1280px-Mission_Santa_Clara_de_Asis.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Birk's Restaurant",
              "description": "Enjoy a classic American steakhouse experience known for its high-quality cuts and elegant atmosphere, conveniently located in Santa Clara.",
              "placeName": "Birk's Restaurant",
              "mapLink": "https://www.google.com/maps/place/Birk's+Restaurant",
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/2J2Mv6pE356E0bVd4qgO6g/o.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Discover the Intel Museum",
              "description": "Explore the history of computing and the making of microprocessors at this fascinating museum located at Intel's headquarters.",
              "placeName": "Intel Museum",
              "mapLink": "https://www.google.com/maps/place/Intel+Museum",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Intel_Museum_entrance.JPG/1280px-Intel_Museum_entrance.JPG",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore the Winchester Mystery House",
              "description": "Tour the sprawling, eccentric mansion of Sarah Winchester, known for its bizarre architecture, secret passages, and paranormal legends.",
              "placeName": "Winchester Mystery House",
              "mapLink": "https://www.google.com/maps/place/Winchester+Mystery+House",
              "ticketLink": "https://www.winchestermysteryhouse.com/buy-tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Winchester_Mystery_House_exterior.jpg/1280px-Winchester_Mystery_House_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Stroll at Santana Row",
              "description": "Enjoy dinner at one of the many upscale restaurants like Left Bank Brasserie and explore the vibrant shopping and entertainment district.",
              "placeName": "Santana Row",
              "mapLink": "https://www.google.com/maps/place/Santana+Row",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/SantanaRow.jpg/1280px-SantanaRow.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Levi's Stadium Tour",
              "description": "Get a behind-the-scenes look at the home of the San Francisco 49ers and a 2026 FIFA World Cup venue, including locker rooms, press box, and the field.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium",
              "ticketLink": "https://www.levisstadium.com/tours/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Levi%27s_Stadium_panorama.jpg/1280px-Levi%27s_Stadium_panorama.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Engage at The Tech Interactive",
              "description": "A family-friendly science and technology center in downtown San Jose, offering hands-on exhibits focused on innovation and Silicon Valley's impact.",
              "placeName": "The Tech Interactive",
              "mapLink": "https://www.google.com/maps/place/The+Tech+Interactive",
              "ticketLink": "https://www.thetech.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/The_Tech_Museum_of_Innovation_building.jpg/1280px-The_Tech_Museum_of_Innovation_building.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA Fan Festival Kick-off or Sports Bar Atmosphere",
              "description": "If the FIFA Fan Festival is open for early activities, head there. Otherwise, soak in the pre-match excitement at a local sports bar like Britannia Arms Pub in San Jose.",
              "placeName": "Britannia Arms Pub (San Jose)",
              "mapLink": "https://www.google.com/maps/place/Britannia+Arms+Pub",
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/2J2Mv6pE356E0bVd4qgO6g/o.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Santa Clara",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and merchandise, connecting with fans from around the world.",
              "placeName": "FIFA Fan Festival Santa Clara (Exact Location TBD)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Santa+Clara",
              "imageUrl": "https://fifafanfestival.com/assets/images/home/hero-bg-desktop.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Excitement & Walk to Levi's Stadium",
              "description": "Continue enjoying the fan zone activities, grab some street food, and join the lively march of fans heading towards Levi's Stadium for the match.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Levi%27s_Stadium_on_game_day.jpg/1280px-Levi%27s_Stadium_on_game_day.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Levi's Stadium!",
              "description": "Experience the thrill of a live FIFA World Cup match at Levi's Stadium. After the match, celebrate or commiserate with fellow fans.",
              "placeName": "Levi's Stadium",
              "mapLink": "https://www.google.com/maps/place/Levi's+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Levi%27s_Stadium_during_Super_Bowl_50.jpg/1280px-Levi%27s_Stadium_during_Super_Bowl_50.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Stroll through San Jose Municipal Rose Garden",
              "description": "Enjoy a peaceful morning walk through this stunning 5.5-acre garden featuring over 3,500 rose bushes and 180 varieties, a perfect spot for relaxation.",
              "placeName": "San Jose Municipal Rose Garden",
              "mapLink": "https://www.google.com/maps/place/San+Jose+Municipal+Rose+Garden",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/San_Jose_Municipal_Rose_Garden_01.jpg/1280px-San_Jose_Municipal_Rose_Garden_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Shopping and Lunch at Westfield Valley Fair",
              "description": "Indulge in some retail therapy at one of Northern California's largest shopping malls. Enjoy lunch at Din Tai Fung for acclaimed Taiwanese dumplings.",
              "placeName": "Westfield Valley Fair",
              "mapLink": "https://www.google.com/maps/place/Westfield+Valley+Fair",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Westfield_Valley_Fair_entrance.jpg/1280px-Westfield_Valley_Fair_entrance.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Original Joe's (Downtown San Jose)",
              "description": "Experience a San Jose institution, serving classic Italian-American comfort food in a lively, retro setting since 1956.",
              "placeName": "Original Joe's (Downtown San Jose)",
              "mapLink": "https://www.google.com/maps/place/Original+Joe's+of+San+Jose",
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/2J2Mv6pE356E0bVd4qgO6g/o.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Explore Stanford University Campus",
              "description": "Take a Caltrain ride to Palo Alto and explore the stunning campus of Stanford University, known for its iconic architecture and beautiful grounds.",
              "placeName": "Stanford University",
              "mapLink": "https://www.google.com/maps/place/Stanford+University",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Stanford_University_aerial.jpg/1280px-Stanford_University_aerial.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Visit Hoover Tower & University Avenue, Palo Alto",
              "description": "Ascend Hoover Tower for panoramic views of the campus and surrounding Silicon Valley. Afterwards, explore the charming shops and cafes along University Avenue in downtown Palo Alto.",
              "placeName": "Hoover Tower",
              "mapLink": "https://www.google.com/maps/place/Hoover+Tower",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Hoover_Tower_at_Stanford_University.jpg/1280px-Hoover_Tower_at_Stanford_University.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Zareen's (Palo Alto)",
              "description": "Enjoy highly-rated Pakistani and Indian cuisine at Zareen's, a popular local spot known for its flavorful dishes and casual atmosphere.",
              "placeName": "Zareen's (Palo Alto)",
              "mapLink": "https://www.google.com/maps/place/Zareen's",
              "imageUrl": "https://s3-media0.fl.yelpcdn.com/bphoto/2J2Mv6pE356E0bVd4qgO6g/o.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Explore the Rosicrucian Egyptian Museum",
              "description": "Discover ancient Egypt in San Jose with one of the most comprehensive collections of Egyptian artifacts in the Western United States, including mummies and tomb replicas.",
              "placeName": "Rosicrucian Egyptian Museum",
              "mapLink": "https://www.google.com/maps/place/Rosicrucian+Egyptian+Museum",
              "ticketLink": "https://egyptianmuseum.org/visit",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Rosicrucian_Egyptian_Museum_2011.jpg/1280px-Rosicrucian_Egyptian_Museum_2011.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch and Souvenir Shopping at San Pedro Square Market",
              "description": "Grab a diverse lunch from various food vendors and find last-minute souvenirs at this lively indoor/outdoor market in downtown San Jose.",
              "placeName": "San Pedro Square Market",
              "mapLink": "https://www.google.com/maps/place/San+Pedro+Square+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/San_Pedro_Square_Market.jpg/1280px-San_Pedro_Square_Market.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure from San Jose",
              "description": "Head back to San Jose Mineta International Airport (SJC) or San Francisco International Airport (SFO) for your departure, taking with you unforgettable FIFA World Cup memories.",
              "placeName": "San Jose Mineta International Airport (SJC)",
              "mapLink": "https://www.google.com/maps/place/San+Jose+Mineta+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/San_Jose_Mineta_International_Airport_Terminal_B.jpg/1280px-San_Jose_Mineta_International_Airport_Terminal_B.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Birk's Restaurant (Santa Clara) - Classic American Steakhouse",
        "Left Bank Brasserie (Santana Row, San Jose) - French Brasserie",
        "Din Tai Fung (Westfield Valley Fair, San Jose) - Taiwanese Dumplings",
        "Original Joe's (Downtown San Jose) - Italian-American Comfort Food",
        "Zareen's (Palo Alto) - Pakistani and Indian Cuisine",
        "San Pedro Square Market (Downtown San Jose) - Diverse Food Hall"
      ],
      "football_experiences": [
        "Levi's Stadium Tour (Santa Clara)",
        "FIFA Fan Festival Santa Clara (Official Fan Zone)",
        "FIFA World Cup Match at Levi's Stadium",
        "Britannia Arms Pub (San Jose) - Local sports bar atmosphere"
      ],
      "travel_tips": [
        "**Getting to Levi's Stadium (Santa Clara):** Levi's Stadium is well-served by public transport. The most direct way is via VTA (Valley Transportation Authority) Light Rail to the 'Great America' station, which is right next to the stadium. VTA also operates bus services. For those coming from further afield, Caltrain provides commuter rail service along the Peninsula, with connections to VTA Light Rail at the Mountain View or San Jose Diridon stations. Dedicated FIFA shuttles from key transit hubs are also expected on match days. Plan to arrive early on match day due to increased security and crowds.",
        "**Where to Stay:** Consider accommodations in Santa Clara, San Jose, Sunnyvale, or Mountain View. These areas offer a good balance of hotel options (medium budget) and excellent public transportation access (VTA, Caltrain) to Levi's Stadium and other attractions. Staying in San Francisco is possible but will involve a longer commute (1-1.5 hours each way by Caltrain/BART) to Santa Clara.",
        "**Public Transportation in the Bay Area:** The Bay Area has an integrated public transport system. The **Clipper Card** is highly recommended—it's a reusable fare card that works on almost all transit agencies, including:",
        "- **VTA (Valley Transportation Authority):** Operates light rail and bus services throughout Santa Clara County, connecting Santa Clara, San Jose, Sunnyvale, Mountain View, and more. Essential for reaching Levi's Stadium.",
        "- **Caltrain:** A commuter rail line running from San Francisco down the Peninsula to San Jose. Useful for connecting to Palo Alto and for connecting to VTA for stadium access.",
        "- **BART (Bay Area Rapid Transit):** A heavy rail system connecting San Francisco, Oakland, Berkeley, and extends into San Jose (via Milpitas and Berryessa/North San Jose stations, where you can transfer to VTA).",
        "Purchase a Clipper Card (physical card or via mobile app) upon arrival and load it with cash value or a multi-day pass. This will be the most convenient way to travel."
      ]
    }
  },
  "miami": {
    "3": {
      "plannerCity": "Miami",
      "matchDay": 2,
      "city": "Miami",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Art Deco Historic District & South Beach",
              "description": "Explore the iconic pastel-colored buildings and vibrant atmosphere of the Art Deco Historic District, followed by a relaxing stroll along the famous South Beach.",
              "placeName": "Art Deco Historic District, Miami Beach",
              "mapLink": "https://www.google.com/maps/place/Art+Deco+Historic+District",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Ocean_Drive_Miami_Beach_Art_Deco.jpg/1280px-Ocean_Drive_Miami_Beach_Art_Deco.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Breakfast/Lunch at Puerto Sagua",
              "description": "Enjoy a classic Cuban breakfast or a hearty Cuban sandwich at Puerto Sagua, a long-standing, no-frills diner on South Beach known for its authentic flavors.",
              "placeName": "Puerto Sagua",
              "mapLink": "https://www.google.com/maps/place/Puerto+Sagua",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Puerto_Sagua_Restaurant.jpg/1280px-Puerto_Sagua_Restaurant.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pérez Art Museum Miami (PAMM)",
              "description": "Immerse yourself in modern and contemporary international art at PAMM, featuring stunning architecture and waterfront views in Downtown Miami.",
              "placeName": "Pérez Art Museum Miami (PAMM)",
              "mapLink": "https://www.google.com/maps/place/Pérez+Art+Museum+Miami",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Perez_Art_Museum_Miami_exterior.jpg/1280px-Perez_Art_Museum_Miami_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at La Mar by Gastón Acurio",
              "description": "Experience exquisite Peruvian cuisine with stunning views of the Miami skyline and Biscayne Bay at the Mandarin Oriental, Brickell Key.",
              "placeName": "La Mar by Gastón Acurio",
              "mapLink": "https://www.google.com/maps/place/La+Mar+by+Gastón+Acurio",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Mandarin_Oriental%2C_Miami_-_La_Mar_by_Gast%C3%B3n_Acurio.jpg/1280px-Mandarin_Oriental%2C_Miami_-_La_Mar_by_Gast%C3%B3n_Acurio.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            },
            {
              "name": "Evening Stroll in Brickell City Centre",
              "description": "Enjoy the vibrant atmosphere, high-end shops, and dining options at the open-air Brickell City Centre, a modern urban oasis.",
              "placeName": "Brickell City Centre",
              "mapLink": "https://www.google.com/maps/place/Brickell+City+Centre",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Brickell_City_Centre_%282020%29.jpg/1280px-Brickell_City+Centre_%282020%29.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Breakfast at Bayside Marketplace",
              "description": "Start your match day with breakfast and enjoy the scenic views of Biscayne Bay at Bayside Marketplace, a lively outdoor mall in Downtown Miami.",
              "placeName": "Bayside Marketplace",
              "mapLink": "https://www.google.com/maps/place/Bayside+Marketplace",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Bayside_Marketplace_Miami_03-12-2015.jpg/1280px-Bayside_Marketplace_Miami_03-12-2015.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival (Pre-Match Celebration)",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and interact with fellow fans. (Location TBD, but often in a central area like Bayfront Park or near the stadium).",
              "placeName": "Bayfront Park (potential FIFA Fan Festival location)",
              "mapLink": "https://www.google.com/maps/place/Bayfront+Park",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Bayfront_Park_Miami.jpg/1280px-Bayfront_Park_Miami.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:00"
            },
            {
              "name": "Travel to Hard Rock Stadium & Pre-Match Tailgate",
              "description": "Head to Hard Rock Stadium early to soak in the pre-match excitement. Enjoy the fan zones, food trucks, and tailgate parties around the stadium before the game.",
              "placeName": "Hard Rock Stadium, Miami Gardens",
              "mapLink": "https://www.google.com/maps/place/Hard+Rock+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Hard_Rock_Stadium_during_Super_Bowl_LIV.jpg/1280px-Hard_Rock_Stadium_during_Super_Bowl_LIV.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Hard Rock Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at Hard Rock Stadium, home to world-class soccer events. Be prepared for an electrifying atmosphere!",
              "placeName": "Hard Rock Stadium, Miami Gardens",
              "mapLink": "https://www.google.com/maps/place/Hard+Rock+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Hard_Rock_Stadium_during_Super_Bowl_LIV.jpg/1280px-Hard_Rock_Stadium_during_Super_Bowl_LIV.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Explore Little Havana & Calle Ocho",
              "description": "Discover the vibrant Cuban culture in Little Havana. Stroll along Calle Ocho, watch cigar rolling, listen to live music, and immerse yourself in the lively neighborhood.",
              "placeName": "Calle Ocho, Little Havana",
              "mapLink": "https://www.google.com/maps/place/Calle+Ocho",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Calle_Ocho_Street_in_Little_Havana%2C_Miami.jpg/1280px-Calle_Ocho_Street_in_Little_Havana%2C_Miami.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Cuban Coffee Break at Versailles Restaurant Bakery",
              "description": "Enjoy a traditional Cuban coffee (cafecito) and a pastelito (pastry) at the iconic Versailles Restaurant Bakery, a Miami institution in the heart of Little Havana.",
              "placeName": "Versailles Restaurant Bakery",
              "mapLink": "https://www.google.com/maps/place/Versailles+Restaurant+Bakery",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Versailles_Restaurant_Miami.jpg/1280px-Versailles_Restaurant_Miami.jpg",
              "best_time": "morning",
              "suggested_time": "11:00"
            },
            {
              "name": "Cuban Sandwich at Sanguich de Miami",
              "description": "Savor an authentic Cuban sandwich at Sanguich de Miami, known for its traditional recipes and quality ingredients, often hailed as one of the best in the city.",
              "placeName": "Sanguich de Miami",
              "mapLink": "https://www.google.com/maps/place/Sanguich+De+Miami",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cuban_sandwich_at_Sanguich_de_Miami.jpg/1280px-Cuban_sandwich_at_Sanguich_de_Miami.jpg",
              "best_time": "morning",
              "suggested_time": "12:30"
            }
          ],
          "afternoon": [
            {
              "name": "Vizcaya Museum & Gardens",
              "description": "Step back in time at this stunning European-inspired estate, featuring magnificent architecture, lush gardens, and historical art collections overlooking Biscayne Bay.",
              "placeName": "Vizcaya Museum & Gardens",
              "mapLink": "https://www.google.com/maps/place/Vizcaya+Museum+%26+Gardens",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Vizcaya_Museum_and_Gardens_-_Main_House_and_Fountain.jpg/1280px-Vizcaya_Museum_and_Gardens_-_Main_House_and_Fountain.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Mandolin Aegean Bistro",
              "description": "Enjoy a delightful Mediterranean dining experience in a charming outdoor setting in the trendy Wynwood Arts District, known for its fresh, authentic dishes.",
              "placeName": "Mandolin Aegean Bistro",
              "mapLink": "https://www.google.com/maps/place/Mandolin+Aegean+Bistro",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Mandolin_Aegean_Bistro%2C_Miami.jpg/1280px-Mandolin_Aegean_Bistro%2C_Miami.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Cuban Sandwich at Sanguich de Miami: A classic, must-try Miami staple known for its authentic taste and quality ingredients in Little Havana.",
        "Peruvian Ceviche at La Mar by Gastón Acurio: Fresh seafood with a creative twist and stunning bay views, offering an upscale dining experience.",
        "Cuban Breakfast/Lunch at Puerto Sagua: A no-frills, iconic diner on South Beach serving traditional Cuban fare.",
        "Stone Crab at Joe's Stone Crab (seasonal): A Miami institution, though often pricey and seasonal, it's an iconic local delicacy for seafood lovers.",
        "Espresso and Pastelitos at Versailles Restaurant Bakery: Experience Miami's Cuban coffee culture with traditional pastries in Little Havana."
      ],
      "football_experiences": [
        "FIFA Fan Festival: The official fan zone offering live broadcasts, entertainment, food, and a vibrant atmosphere for all fans (location TBD by FIFA).",
        "Pre-Match Tailgate at Hard Rock Stadium: Join fellow fans for food, drinks, and festivities in the designated tailgate areas around the stadium before the game.",
        "FIFA World Cup Match at Hard Rock Stadium: The ultimate experience of watching a live World Cup game, feeling the energy of thousands of fans.",
        "Local Sports Bars: Catch other matches and soak in the football fervor at popular Miami sports bars like Batch Gastropub or Black Market Miami, known for their lively ambiance."
      ],
      "travel_tips": [
        "**Stadium Access (Hard Rock Stadium, Miami Gardens):** For match day, utilize the Metrorail. Take the Metrorail to the Golden Glades Station. From there, dedicated shuttle services are typically provided for major events like the World Cup to transport fans directly to Hard Rock Stadium. Alternatively, rideshare services (Uber/Lyft) are available but expect surge pricing and significant traffic on match days. Plan to arrive early to account for travel and security.",
        "**Where to Stay:** Consider accommodations in Brickell, Downtown Miami, or Wynwood. These areas offer excellent access to Metrorail and Metromover, making it easier to reach both tourist attractions and connect to the Metrorail line for stadium access. They also provide a wide range of dining, nightlife, and entertainment options. Coral Gables is another option, offering a quieter, more upscale atmosphere with Metrorail access.",
        "**Public Transportation:** Miami's public transport system includes the **Metrorail** (an elevated heavy rail system connecting northern Miami-Dade County to downtown and southern areas), **Metromover** (a free elevated people mover system serving Downtown Miami, Brickell, and Omni neighborhoods), and **Metrobus** (an extensive bus network covering the entire county). To use Metrorail and Metrobus, purchase an **EASY Card** or an **EASY Ticket** at Metrorail stations or select retailers. The EASY Card is a rechargeable fare card that offers discounted fares compared to single-use tickets. Google Maps is a reliable tool for planning routes and checking real-time schedules. During the World Cup, expect increased service and potential dedicated routes/shuttles for major event areas and the stadium."
      ]
    },
    "5": {
      "plannerCity": "Miami",
      "matchDay": 3,
      "city": "Miami",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Art Deco Historic District Walking Tour",
              "description": "Explore the iconic pastel-colored buildings and unique architecture of Miami Beach's Art Deco Historic District.",
              "placeName": "Art Deco Historic District",
              "mapLink": "https://www.google.com/maps/place/Art+Deco+Historic+District/@25.783063,-80.130768,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b4898129e719:0x895690b201a357f!8m2!3d25.783063!4d-80.128193!16s%2Fg%2F12270919",
              "ticketLink": "https://www.viator.com/Miami-tours/Cultural-and-Theme-Tours/d662-g25",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Art_Deco_Historic_District%2C_Miami_Beach%2C_Florida%2C_USA.jpg/1280px-Art_Deco_Historic_District%2C_Miami_Beach%2C_Florida%2C_USA.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Relax at Lummus Park & South Beach",
              "description": "Enjoy the sun and sand at the famous South Beach, stroll along Ocean Drive, and see the lifeguard stands. Lunch at a casual spot.",
              "placeName": "Lummus Park",
              "mapLink": "https://www.google.com/maps/place/Lummus+Park/@25.783063,-80.130768,17z/data=!4m6!3m5!1s0x88d9b48b61c94fc5:0x524b0c266943a41b!8m2!3d25.783063!4d-80.128193!16s%2Fg%2F11b6_c882p",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e0/Lummus_Park%2C_Miami_Beach.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at La Sandwicherie",
              "description": "Grab a fresh, gourmet sandwich or salad at this popular, no-frills South Beach institution.",
              "placeName": "La Sandwicherie",
              "mapLink": "https://www.google.com/maps/place/La+Sandwicherie/@25.7891285,-80.1345688,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b4886f44d95b:0x54867c4d16805d23!8m2!3d25.7891285!4d-80.1319939!16s%2Fg%2F1tdw76_0",
              "ticketLink": "",
              "imageUrl": "https://cdn.miamiandbeaches.com/images/articles/4840/la-sandwicherie-miami-beach-hero.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Stroll on Española Way",
              "description": "Enjoy a charming evening on Española Way, a historic pedestrian street with Spanish-inspired architecture, restaurants, and live music.",
              "placeName": "Española Way",
              "mapLink": "https://www.google.com/maps/place/Espa%C3%B1ola+Way/@25.791533,-80.133246,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b48873092047:0x5e2b027c44e995e8!8m2!3d25.791533!4d-80.1306711!16s%2Fg%2F1tdw4l0b",
              "ticketLink": "",
              "imageUrl": "https://media.cntraveler.com/photos/5a7a72d3e1850117079d8f37/master/w_1600%2Cc_limit/Espanola-Way-Miami-Beach_2018_Espa%C3%B1ola-Way-Credit-Greater-Miami-CVB-5.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Tapas and Drinks at Tapas y Tintos",
              "description": "Savor authentic Spanish tapas and sangria in a lively atmosphere with flamenco shows on Española Way.",
              "placeName": "Tapas y Tintos",
              "mapLink": "https://www.google.com/maps/place/Tapas+y+Tintos/@25.7914833,-80.1317112,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b48873092047:0x70c1d295e865f973!8m2!3d25.7914833!4d-80.1306711!16s%2Fg%2F1tdw86qj",
              "ticketLink": "",
              "imageUrl": "https://tapasytintos.com/wp-content/uploads/2021/04/Gallery-8.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Explore Wynwood Walls & Art District",
              "description": "Immerse yourself in the vibrant street art and murals of Wynwood Walls and the surrounding art district.",
              "placeName": "Wynwood Walls",
              "mapLink": "https://www.google.com/maps/place/Wynwood+Walls/@25.79901,-80.198943,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b481971752b5:0x524b0c266943a41b!8m2!3d25.79901!4d-80.1963681!16s%2Fg%2F11b6_c882p",
              "ticketLink": "https://thewynwoodwalls.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Wynwood_Walls%2C_Miami.jpg/1280px-Wynwood_Walls%2C_Miami.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch in Wynwood",
              "description": "Enjoy a modern American or Asian-inspired meal in the trendy Wynwood neighborhood.",
              "placeName": "KYU Miami",
              "mapLink": "https://www.google.com/maps/place/KYU+Miami/@25.8010833,-80.1990463,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b40742f10b7f:0x524b0c266943a41b!8m2!3d25.8010833!4d-80.1964714!16s%2Fg%2F11b6_c882p",
              "ticketLink": "",
              "imageUrl": "https://media.timeout.com/images/105822369/750/562/image.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Discover Little Havana & Calle Ocho",
              "description": "Immerse yourself in Cuban culture, visit Domino Park, and explore the vibrant shops and galleries of Calle Ocho.",
              "placeName": "Calle Ocho",
              "mapLink": "https://www.google.com/maps/place/Calle+Ocho/@25.775833,-80.228889,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b6264d998799:0x524b0c266943a41b!8m2!3d25.775833!4d-80.226314!16s%2Fg%2F11b6_c882p",
              "ticketLink": "https://www.viator.com/Miami-tours/Little-Havana-Tours/d662-t12095",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Calle_Ocho%2C_Little_Havana%2C_Miami%2C_Florida.jpg/1280px-Calle_Ocho%2C_Little_Havana%2C_Miami%2C_Florida.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Versailles Restaurant",
              "description": "Dine at Miami's most famous Cuban restaurant, serving classic Cuban dishes in a grand, mirrored dining room.",
              "placeName": "Versailles Restaurant",
              "mapLink": "https://www.google.com/maps/place/Versailles+Restaurant/@25.776667,-80.228611,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b6264d998799:0x524b0c266943a41b!8m2!3d25.776667!4d-80.2260361!16s%2Fg%2F1tdw70p3",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Versailles_Restaurant_in_Little_Havana.jpg/1280px-Versailles_Restaurant_in_Little_Havana.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Live Music and Drinks at Ball & Chain",
              "description": "Experience live Cuban jazz and enjoy cocktails in a historic Little Havana bar with a vibrant atmosphere.",
              "placeName": "Ball & Chain",
              "mapLink": "https://www.google.com/maps/place/Ball+%26+Chain/@25.775953,-80.227201,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b6264d998799:0x524b0c266943a41b!8m2!3d25.775953!4d-80.2246261!16s%2Fg%2F1tdw70p3",
              "ticketLink": "",
              "imageUrl": "https://ballandchainmiami.com/wp-content/uploads/2019/04/Ball-and-Chain-Gallery-10.jpg",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Fest Experience",
              "description": "Join fellow fans at the official FIFA Fan Fest for live music, food, games, and a vibrant pre-match atmosphere. (Location TBD by FIFA, Bayfront Park is a common large event venue).",
              "placeName": "Bayfront Park",
              "mapLink": "https://www.google.com/maps/place/Bayfront+Park/@25.776667,-80.198333,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b42d54e0c1f5:0x524b0c266943a41b!8m2!3d25.776667!4d-80.1957581!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Bayfront_Park_Miami_FL_USA.jpg/1280px-Bayfront_Park_Miami_FL_USA.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to Hard Rock Stadium & Pre-Match Tailgate",
              "description": "Head to Hard Rock Stadium in Miami Gardens. Experience the vibrant pre-match atmosphere, tailgate parties, and fan activities around the stadium.",
              "placeName": "Hard Rock Stadium",
              "mapLink": "https://www.google.com/maps/place/Hard+Rock+Stadium/@25.957947,-80.23933,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9afc9e6d0a7a3:0x524b0c266943a41b!8m2!3d25.957947!4d-80.2367551!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Hard_Rock_Stadium.jpg/1280px-Hard_Rock_Stadium.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Hard Rock Stadium",
              "description": "Witness the excitement of a FIFA World Cup match live at Hard Rock Stadium, cheering on your favorite team.",
              "placeName": "Hard Rock Stadium",
              "mapLink": "https://www.google.com/maps/place/Hard+Rock+Stadium/@25.957947,-80.23933,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9afc9e6d0a7a3:0x524b0c266943a41b!8m2!3d25.957947!4d-80.2367551!16s%2Fg%2F1tdw76p3",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/54e7d488-8121-419b-a7e8-b2a605f15d2a/Miami-Stadium-2026-Render-1?width=1920",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Pérez Art Museum Miami (PAMM)",
              "description": "Explore contemporary and modern international art with a focus on 20th and 21st-century works, housed in an architecturally stunning building overlooking Biscayne Bay.",
              "placeName": "Pérez Art Museum Miami (PAMM)",
              "mapLink": "https://www.google.com/maps/place/P%C3%A9rez+Art+Museum+Miami/@25.782012,-80.191147,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b68e980302b1:0x524b0c266943a41b!8m2!3d25.782012!4d-80.1885721!16s%2Fg%2F1tdw76p3",
              "ticketLink": "https://www.pamm.org/visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/P%C3%A9rez_Art_Museum_Miami_aerial.jpg/1280px-P%C3%A9rez_Art_Museum_Miami_aerial.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Bayside Marketplace & Bay Cruise",
              "description": "Enjoy shopping, dining, and live entertainment at this open-air festival marketplace. Consider taking a scenic boat tour of Biscayne Bay to see Millionaire's Row and the Miami skyline.",
              "placeName": "Bayside Marketplace",
              "mapLink": "https://www.google.com/maps/place/Bayside+Marketplace/@25.779722,-80.189444,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b68e980302b1:0x524b0c266943a41b!8m2!3d25.779722!4d-80.1868691!16s%2Fg%2F1tdw76p3",
              "ticketLink": "https://www.viator.com/Miami-tours/Boat-Tours/d662-g4",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Bayside_Marketplace_02.JPG/1280px-Bayside_Marketplace_02.JPG",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at Bubba Gump Shrimp Co.",
              "description": "Dine on seafood and American cuisine in a fun, Forrest Gump-themed restaurant with bay views at Bayside Marketplace.",
              "placeName": "Bubba Gump Shrimp Co.",
              "mapLink": "https://www.google.com/maps/place/Bubba+Gump+Shrimp+Co./@25.779831,-80.189155,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b68e980302b1:0x524b0c266943a41b!8m2!3d25.779831!4d-80.1865801!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://www.bubbagump.com/wp-content/uploads/2019/07/BubbaGumpShrimp_Logo.png",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner & Shopping at Brickell City Centre",
              "description": "Explore this upscale, open-air shopping and dining complex in the heart of Miami's Brickell financial district.",
              "placeName": "Brickell City Centre",
              "mapLink": "https://www.google.com/maps/place/Brickell+City+Centre/@25.766389,-80.193333,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b691060966f9:0x524b0c266943a41b!8m2!3d25.766389!4d-80.1907581!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Brickell_City_Centre_Miami.jpg/1280px-Brickell_City_Centre_Miami.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Dinner at Komodo",
              "description": "Experience upscale Southeast Asian cuisine in a chic, multi-level dining space in the Brickell neighborhood.",
              "placeName": "Komodo",
              "mapLink": "https://www.google.com/maps/place/Komodo/@25.766579,-80.190678,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b691060966f9:0x524b0c266943a41b!8m2!3d25.766579!4d-80.1881031!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://komodomiami.com/wp-content/uploads/2021/04/Komodo-Miami-Exterior-Dining.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Vizcaya Museum & Gardens",
              "description": "Step back in time at this stunning Gilded Age estate, featuring European-inspired architecture, lush gardens, and exquisite art collections along Biscayne Bay.",
              "placeName": "Vizcaya Museum & Gardens",
              "mapLink": "https://www.google.com/maps/place/Vizcaya+Museum+%26+Gardens/@25.744167,-80.211111,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b60e6f6631b1:0x524b0c266943a41b!8m2!3d25.744167!4d-80.2085361!16s%2Fg%2F1tdw76p3",
              "ticketLink": "https://vizcaya.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Vizcaya_Museum_and_Gardens.jpg/1280px-Vizcaya_Museum_and_Gardens.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Coconut Grove & Lunch",
              "description": "Wander through Miami's oldest neighborhood, known for its bohemian charm, independent boutiques, and bayfront parks. Enjoy lunch at a local cafe.",
              "placeName": "Coconut Grove",
              "mapLink": "https://www.google.com/maps/place/Coconut+Grove/@25.7225,-80.256111,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b6348821415d:0x524b0c266943a41b!8m2!3d25.7225!4d-80.2535361!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Coconut_Grove%2C_Miami.jpg/1280px-Coconut_Grove%2C_Miami.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at GreenStreet Cafe",
              "description": "Enjoy a casual outdoor lunch at this iconic Coconut Grove spot, known for its people-watching and diverse menu.",
              "placeName": "GreenStreet Cafe",
              "mapLink": "https://www.google.com/maps/place/GreenStreet+Cafe/@25.725969,-80.255959,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b63510e1371b:0x524b0c266943a41b!8m2!3d25.725969!4d-80.2533841!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://greenstreetcafe.net/wp-content/uploads/2021/08/GreenstreetCafe_Gallery_05.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Coconut Grove",
              "description": "Enjoy a final dinner in the charming Coconut Grove before preparing for departure.",
              "placeName": "Bellini Restaurant and Bar",
              "mapLink": "https://www.google.com/maps/place/Bellini+Restaurant+and+Bar/@25.725969,-80.255959,17z/data=!3m1!4b1!4m6!3m5!1s0x88d9b63510e1371b:0x524b0c266943a41b!8m2!3d25.725969!4d-80.2533841!16s%2Fg%2F1tdw76p3",
              "ticketLink": "",
              "imageUrl": "https://www.bellinirestaurant.com/wp-content/uploads/2021/04/Bellini-Miami-Gallery-01-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Cuban Sandwich at Versailles Restaurant",
        "Stone Crab (seasonal) at Joe's Stone Crab",
        "Gourmet Sandwiches at La Sandwicherie",
        "Tapas and Sangria at Tapas y Tintos",
        "Modern Asian BBQ at KYU Miami",
        "Fresh Seafood at Casablanca on the Bay",
        "Key Lime Pie (various locations)"
      ],
      "football_experiences": [
        "FIFA Fan Fest at Bayfront Park (anticipated location)",
        "FIFA World Cup Match at Hard Rock Stadium",
        "Pre-match tailgate and fan zones around Hard Rock Stadium",
        "Watching matches at local sports bars (e.g., Black Market Miami, Mike's at Venetia)"
      ],
      "travel_tips": [
        "Stadium Access (Hard Rock Stadium, Miami Gardens): Hard Rock Stadium is located north of downtown Miami. On match days, FIFA will likely provide dedicated shuttle services from central locations like Downtown Miami, South Beach, and potentially from the Brightline Aventura station. Public transport via Metrorail to a northern station (e.g., Golden Glades) then a bus or rideshare is an option but can be less convenient. Always check official FIFA transport guides closer to the event for the most up-to-date information.",
        "Where to Stay: Consider staying in South Beach (vibrant, close to beaches/nightlife), Downtown Miami/Brickell (central, modern, good public transport connections), Wynwood (artsy, trendy), or Coconut Grove (historic, relaxed, bayfront). All are generally within a 60-minute drive or public transport + shuttle combination from Hard Rock Stadium.",
        "Public Transportation (Miami-Dade Transit): Miami-Dade Transit operates Metrorail, Metromover, and Metrobus. The Metromover is a FREE elevated rail system connecting Downtown Miami, Brickell, and Omni neighborhoods – excellent for exploring these areas. The Metrorail is an elevated heavy-rail system connecting Miami International Airport (MIA), Downtown, Dadeland, and northern areas. Metrobus provides an extensive bus network across the county. For payment, purchase an 'EASY Card' (reloadable smart card) or use 'EASY Pay' (mobile app) for Metrorail and Metrobus. These can be bought at Metrorail stations or online. A 7-day pass is also available and recommended for visitors.",
        "Brightline: This intercity rail service has a station in Aventura, which is relatively close to Hard Rock Stadium. On match days, there might be special services or shuttles connecting Aventura station to the stadium. Check Brightline schedules and FIFA transport info for specific event-day options.",
        "Ride-sharing: Uber and Lyft are widely available throughout Miami, but prices can surge during peak events and match days. Factor this into your budget and time planning."
      ]
    },
    "7": {
      "plannerCity": "Miami",
      "matchDay": 4,
      "city": "Miami",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Miami International Airport (MIA), transfer to your hotel, and check in. Consider staying in the Aventura or Hollywood areas for better proximity to Hard Rock Stadium.",
              "placeName": "Miami International Airport",
              "mapLink": "https://www.google.com/maps/search/Miami+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Miami_International_Airport_sign.jpg/1280px-Miami_International_Airport_sign.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Aventura Mall",
              "description": "Visit one of the largest and most luxurious shopping malls in the U.S. for shopping, dining, and people-watching. It's a landmark in itself and relatively close to Hard Rock Stadium.",
              "placeName": "Aventura Mall, Aventura, FL",
              "mapLink": "https://www.google.com/maps/search/Aventura+Mall,+Aventura,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Aventura_Mall_2019.jpg/1280px-Aventura_Mall_2019.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at The Cheesecake Factory",
              "description": "Enjoy a casual dinner at The Cheesecake Factory, known for its extensive menu and delicious cheesecakes, located within Aventura Mall.",
              "placeName": "The Cheesecake Factory, Aventura Mall, Aventura, FL",
              "mapLink": "https://www.google.com/maps/search/The+Cheesecake+Factory,+Aventura+Mall,+Aventura,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/The_Cheesecake_Factory_Aventura.jpg/1280px-The_Cheesecake_Factory_Aventura.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Hollywood Beach Broadwalk",
              "description": "Start your day with a walk or bike ride along the scenic Hollywood Beach Broadwalk, a 2.5-mile promenade alongside the Atlantic Ocean, popular for its vibrant atmosphere and ocean views.",
              "placeName": "Hollywood Beach Broadwalk, Hollywood, FL",
              "mapLink": "https://www.google.com/maps/search/Hollywood+Beach+Broadwalk,+Hollywood,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Hollywood_Beach_Broadwalk_2017.jpg/1280px-Hollywood_Beach_Broadwalk_2017.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Margaritaville Hollywood Beach Resort",
              "description": "Enjoy a casual beachfront lunch at one of the restaurants within the Margaritaville Hollywood Beach Resort, offering great views and a relaxed atmosphere.",
              "placeName": "Margaritaville Hollywood Beach Resort, Hollywood, FL",
              "mapLink": "https://www.google.com/maps/search/Margaritaville+Hollywood+Beach+Resort,+Hollywood,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Margaritaville_Hollywood_Beach_Resort.jpg/1280px-Margaritaville_Hollywood_Beach_Resort.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Le Tub Saloon",
              "description": "Experience a unique dining atmosphere at Le Tub Saloon, a rustic waterfront restaurant famous for its award-winning burgers and quirky decor.",
              "placeName": "Le Tub Saloon, Hollywood, FL",
              "mapLink": "https://www.google.com/maps/search/Le+Tub+Saloon,+Hollywood,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Le_Tub_Saloon_Hollywood_FL.jpg/1280px-Le_Tub_Saloon_Hollywood_FL.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Stroll along Las Olas Boulevard",
              "description": "Explore Las Olas Boulevard in Fort Lauderdale, known for its upscale boutiques, art galleries, restaurants, and charming Mediterranean-style architecture.",
              "placeName": "Las Olas Boulevard, Fort Lauderdale, FL",
              "mapLink": "https://www.google.com/maps/search/Las+Olas+Boulevard,+Fort+Lauderdale,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Las_Olas_Boulevard_Fort_Lauderdale_Florida.jpg/1280px-Las_Olas_Boulevard_Fort_Lauderdale_Florida.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Fort Lauderdale Water Taxi Tour",
              "description": "Discover Fort Lauderdale's scenic canals and 'Venice of America' charm with a relaxing Water Taxi ride, hopping on and off at various points of interest.",
              "placeName": "Fort Lauderdale Water Taxi, Fort Lauderdale, FL",
              "mapLink": "https://www.google.com/maps/search/Fort+Lauderdale+Water+Taxi,+Fort+Lauderdale,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Fort_Lauderdale_Water_Taxi.jpg/1280px-Fort_Lauderdale_Water_Taxi.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Louie Bossi's Ristorante Bar Pizzeria",
              "description": "Savor authentic Italian cuisine in a lively atmosphere at Louie Bossi's, a popular spot on Las Olas Boulevard known for its delicious pizzas and homemade pasta.",
              "placeName": "Louie Bossi's Ristorante Bar Pizzeria, Fort Lauderdale, FL",
              "mapLink": "https://www.google.com/maps/search/Louie+Bossi%27s+Ristorante+Bar+Pizzeria,+Fort+Lauderdale,+FL",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0e/ff/45/62/louie-bossi-s-ristorante.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Official FIFA Fan Festival",
              "description": "Immerse yourself in the World Cup atmosphere at the Official FIFA Fan Festival. The location is TBD but often in a central city park like Bayfront Park in Downtown Miami. (Longer excursion from Hard Rock Stadium area)",
              "placeName": "Bayfront Park, Miami, FL (Hypothetical FIFA Fan Festival location)",
              "mapLink": "https://www.google.com/maps/search/Bayfront+Park,+Miami,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Bayfront_Park_and_Biscayne_Bay%2C_Miami%2C_Florida.jpg/1280px-Bayfront_Park_and_Biscayne_Bay%2C_Miami%2C_Florida.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Hard Rock Stadium Fan Zone",
              "description": "Travel to Hard Rock Stadium in Miami Gardens. Enjoy the vibrant pre-match festivities, engage in fan zone activities, and soak in the excitement with fellow supporters.",
              "placeName": "Hard Rock Stadium, Miami Gardens, FL",
              "mapLink": "https://www.google.com/maps/search/Hard+Rock+Stadium,+Miami+Gardens,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Hard_Rock_Stadium_-_South_end_zone.jpg/1280px-Hard_Rock_Stadium_-_South_end_zone.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a live FIFA World Cup match at Hard Rock Stadium. Enjoy the game, cheer for your team, and witness football history.",
              "placeName": "Hard Rock Stadium, Miami Gardens, FL",
              "mapLink": "https://www.google.com/maps/search/Hard+Rock+Stadium,+Miami+Gardens,+FL",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Hard_Rock_Stadium_-_2021_Orange_Bowl_-_Pre-Game_Flyover.jpg/1280px-Hard_Rock_Stadium_-_2021_Orange_Bowl_-_Pre-Game_Flyover.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Explore Wynwood Walls",
              "description": "Visit the iconic Wynwood Walls, an outdoor street art museum featuring colorful murals and graffiti by renowned artists. (Longer excursion from Hard Rock Stadium area)",
              "placeName": "Wynwood Walls, Miami, FL",
              "mapLink": "https://www.google.com/maps/search/Wynwood+Walls,+Miami,+FL",
              "ticketLink": "https://thewynwoodwalls.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Wynwood_Walls_Street_Art_Miami_2016.jpg/1280px-Wynwood_Walls_Street_Art_Miami_2016.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Zak the Baker & Design District",
              "description": "Enjoy artisanal bread and pastries for lunch at Zak the Baker in Wynwood, then head to the nearby Design District to explore its unique architecture, public art installations, and luxury boutiques.",
              "placeName": "Zak the Baker, Miami, FL",
              "mapLink": "https://www.google.com/maps/search/Zak+the+Baker,+Miami,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Zak_the_Baker_flagship_store.jpg/1280px-Zak_the_Baker_flagship_store.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at KYU Miami",
              "description": "Indulge in Asian-inspired, wood-fired cuisine at KYU Miami, a highly-rated restaurant in the heart of Wynwood known for its innovative dishes and vibrant ambiance.",
              "placeName": "KYU Miami, Miami, FL",
              "mapLink": "https://www.google.com/maps/search/KYU+Miami,+Miami,+FL",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0d/18/88/5d/kyu-miami.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Art Deco Historic District & Ocean Drive",
              "description": "Take a walking tour of the iconic Art Deco Historic District in South Beach, admiring the pastel-colored buildings, then stroll along the famous Ocean Drive. (Longer excursion from Hard Rock Stadium area)",
              "placeName": "Art Deco Historic District, Miami Beach, FL",
              "mapLink": "https://www.google.com/maps/search/Art+Deco+Historic+District,+Miami+Beach,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Art_Deco_buildings%2C_Ocean_Drive%2C_Miami_Beach.jpg/1280px-Art_Deco_buildings%2C_Ocean_Drive%2C_Miami_Beach.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "South Beach Relaxation & Lincoln Road Mall",
              "description": "Relax on the sandy shores of South Beach or explore Lincoln Road Mall, an open-air pedestrian mall offering shopping, dining, and street performances.",
              "placeName": "South Beach, Miami Beach, FL",
              "mapLink": "https://www.google.com/maps/search/South+Beach,+Miami+Beach,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/South_Beach_Miami_2016.jpg/1280px-South_Beach_Miami_2016.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Havana 1957 on Española Way",
              "description": "Enjoy an authentic Cuban dinner at Havana 1957, located on the charming pedestrian street of Española Way, known for its lively atmosphere and traditional Cuban dishes.",
              "placeName": "Havana 1957, Española Way, Miami Beach, FL",
              "mapLink": "https://www.google.com/maps/search/Havana+1957,+Espa%C3%B1ola+Way,+Miami+Beach,+FL",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0d/18/88/5d/havana-1957.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Little Havana - Calle Ocho & Domino Park",
              "description": "Immerse yourself in Cuban culture in Little Havana. Walk along Calle Ocho, visit the iconic Domino Park, and enjoy a strong Cuban coffee. (Longer excursion from Hard Rock Stadium area)",
              "placeName": "Calle Ocho, Miami, FL",
              "mapLink": "https://www.google.com/maps/search/Calle+Ocho,+Miami,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Calle_Ocho_Street_Scene_in_Little_Havana%2C_Miami%2C_Florida.jpg/1280px-Calle_Ocho_Street_Scene_in_Little_Havana%2C_Miami%2C_Florida.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Versailles Restaurant & Departure",
              "description": "Have a classic Cuban lunch at Versailles Restaurant, Miami's most famous Cuban restaurant. Afterward, do some last-minute souvenir shopping before heading to Miami International Airport (MIA) for your departure.",
              "placeName": "Versailles Restaurant, Miami, FL",
              "mapLink": "https://www.google.com/maps/search/Versailles+Restaurant,+Miami,+FL",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Versailles_Restaurant_Miami.jpg/1280px-Versailles_Restaurant_Miami.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Cuban Sandwich at Versailles Restaurant",
        "Stone Crab Claws (seasonal) at Joe's Stone Crab (South Beach, premium)",
        "Arepas from a local food truck",
        "Key Lime Pie (various bakeries)",
        "Artisanal bread and pastries at Zak the Baker",
        "Fish tacos at a beachside cafe"
      ],
      "football_experiences": [
        "Attending a FIFA World Cup Match at Hard Rock Stadium",
        "Visiting the Official FIFA Fan Festival (location TBD)",
        "Soaking in the pre-match atmosphere at Hard Rock Stadium fan zones",
        "Exploring local sports bars for match viewing on non-game days"
      ],
      "travel_tips": [
        "**Getting to Hard Rock Stadium (Miami Gardens):** The stadium is in Miami Gardens. Public transport options include Brightline (to Aventura Station) or Tri-Rail (to Golden Glades Station), both of which typically offer shuttle services or ride-share connections to the stadium on event days. Check official FIFA/stadium transport guides closer to 2026. Ride-share services (Uber/Lyft) are available but expect surge pricing and traffic.",
        "**Where to Stay:** For proximity to Hard Rock Stadium and a good balance of amenities, consider hotels in **Aventura**, **Sunny Isles Beach**, or **Hollywood**. These areas are generally within a 20-30 minute drive of the stadium. Downtown Miami, Brickell, or South Beach offer more nightlife and central attractions but involve longer commutes (45-60+ minutes) to the stadium.",
        "**Public Transportation in Miami-Dade County:** The main public transport systems are **Metrorail** (elevated rail), **Metrobus** (bus network), and **Brightline** (inter-city high-speed rail).",
        "**Payment for Public Transport:** For Metrorail and Metrobus, use an **EASY Card** or **EASY Ticket**. These can be purchased and reloaded at Metrorail stations or online. Brightline and Tri-Rail have their own separate ticketing systems. Free local trolleys operate in specific neighborhoods like Miami Beach, Downtown Miami, and Wynwood.",
        "**Getting Around:** While public transport can connect major hubs, Miami is very spread out. For convenience, especially to areas not well-served by rail, ride-sharing (Uber/Lyft) or taxis are common. Traffic can be heavy, especially during peak hours.",
        "**Weather:** Miami is hot and humid, especially in summer. Stay hydrated and use sunscreen. Afternoon thunderstorms are common.",
        "**Language:** English and Spanish are widely spoken."
      ]
    }
  },
  "houston": {
    "3": {
      "plannerCity": "Houston",
      "matchDay": 2,
      "city": "Houston",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore Houston Museum of Natural Science",
              "description": "Discover diverse exhibits from dinosaur skeletons to space exploration and dazzling gems. Located in the Museum District.",
              "placeName": "Houston Museum of Natural Science",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Houston+Museum+of+Natural+Science",
              "ticketLink": "https://www.hmns.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Houston_Museum_of_Natural_Science_-_Exterior.jpg/1024px-Houston_Museum_of_Natural_Science_-_Exterior.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Stroll through Hermann Park & Visit Houston Zoo",
              "description": "Enjoy the green spaces, reflection pool, and diverse animal exhibits, conveniently located next to the museum.",
              "placeName": "Hermann Park",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Hermann+Park",
              "ticketLink": "https://www.houstonzoo.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Hermann_Park_Reflecting_Pool.jpg/1024px-Hermann_Park_Reflecting_Pool.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Authentic Tex-Mex at Ninfa's on Navigation",
              "description": "Savor the original Tex-Mex flavors at this iconic Houston restaurant, famous for its fajitas. Easily accessible from Downtown.",
              "placeName": "The Original Ninfa's on Navigation",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Original+Ninfa%27s+on+Navigation",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/The_Original_Ninfa%27s_on_Navigation%2C_Houston%2C_TX.jpg/1024px-The_Original_Ninfa%27s_on_Navigation%2C_Houston%2C_TX.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            },
            {
              "name": "Evening Stroll at Discovery Green",
              "description": "Enjoy the vibrant downtown park with art installations, water features, and city views.",
              "placeName": "Discovery Green",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Discovery+Green",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Discovery_Green_Park%2C_Houston_TX.jpg/1024px-Discovery_Green_Park%2C_Houston_TX.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Immerse in FIFA Fan Festival",
              "description": "Experience the vibrant atmosphere of the official FIFA Fan Festival with live music, food vendors, cultural performances, and fan activities. Likely located in or near Discovery Green.",
              "placeName": "Discovery Green",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Discovery+Green",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg/1024px-FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Excitement at NRG Stadium",
              "description": "Travel to NRG Stadium via METRORail and soak in the pre-match atmosphere at the stadium's official fan zone. Grab food and drinks before kickoff.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=NRG+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/NRG_Stadium_2017.jpg/1024px-NRG_Stadium_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Attend FIFA World Cup Match",
              "description": "Witness the excitement of a live FIFA World Cup match at NRG Stadium, Houston's premier sports venue.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=NRG+Stadium",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/NRG_Stadium_2017.jpg/1024px-NRG_Stadium_2017.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Late Night Bites at Hubcap Grill",
              "description": "Enjoy a classic Houston burger experience after the match. Check for the closest open location.",
              "placeName": "Hubcap Grill (Downtown location)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Hubcap+Grill+Downtown+Houston",
              "imageUrl": "https://cdn.houstoniamag.com/images/2021/04/06/hubcap-grill-burger-houston-eater.jpg",
              "best_time": "evening",
              "suggested_time": "09:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Explore Buffalo Bayou Park and The Cistern",
              "description": "Enjoy scenic views of the city skyline, walking trails, and explore the historic Cistern, a repurposed underground reservoir with unique acoustics and art installations.",
              "placeName": "Buffalo Bayou Park",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Buffalo+Bayou+Park",
              "ticketLink": "https://buffalobayou.org/visit/destination/the-cistern/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Buffalo_Bayou_Park_Houston.jpg/1024px-Buffalo_Bayou_Park_Houston.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Shopping & Sightseeing at The Galleria",
              "description": "Visit Texas's largest shopping mall, featuring high-end brands, department stores, and an ice rink. A notable Houston landmark.",
              "placeName": "The Galleria",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The+Galleria+Houston",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/The_Galleria_Houston%2C_Texas.jpg/1024px-The_Galleria_Houston%2C_Texas.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at Goode Company Seafood",
              "description": "Indulge in fresh Gulf Coast seafood in a casual, vibrant setting. A Houston institution known for its delicious offerings.",
              "placeName": "Goode Company Seafood (Westpark location)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Goode+Company+Seafood+Westpark",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Goode_Company_Seafood%2C_Houston%2C_TX.jpg/1024px-Goode_Company_Seafood%2C_Houston%2C_TX.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "The Original Ninfa's on Navigation (Authentic Tex-Mex)",
        "Hubcap Grill (Classic Houston Burgers)",
        "Goode Company Seafood (Fresh Gulf Coast Seafood)",
        "The Pit Room (Award-winning Texas BBQ)",
        "Xochi (Oaxacan cuisine by Chef Hugo Ortega)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Official fan event with live entertainment and food)",
        "NRG Stadium Match Day Experience (Pre-match atmosphere, fan zones, and live game)",
        "Official FIFA Fan Zone at NRG Stadium (Activities and entertainment inside the stadium perimeter)"
      ],
      "travel_tips": [
        "Reaching NRG Stadium: The most efficient way to reach NRG Stadium on match days is via the METRORail Red Line. The 'NRG Park' station is directly connected to the stadium complex. Plan to arrive early to account for crowds and security.",
        "Where to Stay: Consider accommodations in areas like Downtown, Midtown, the Museum District, or the Galleria area. These neighborhoods offer good access to public transportation and are generally within a 30-60 minute METRORail or bus ride to NRG Stadium. They also provide a variety of dining and entertainment options.",
        "Public Transportation in Houston: Houston's public transit system is managed by METRO.\n*   METRORail: Consists of three lines (Red, Purple, Green). The Red Line is essential for reaching NRG Stadium and connects key areas like Downtown, Midtown, and the Museum District.\n*   METRO Bus: An extensive bus network covers areas not served by the rail.\n*   Fares & Passes: For easy tap-and-go access, purchase a reloadable METRO Q Fare Card. These cards can be bought at METRORail stations, select retailers, or online. Single rides are affordable, and day passes are available. Cash is accepted on buses (exact change required). Alternatively, you can use the METRO Q Mobile Ticket app for convenience.\n*   Getting Around: While public transport is available, Houston is a sprawling city. For some destinations or late-night travel, ride-sharing services (Uber/Lyft) or taxis might be more convenient."
      ]
    },
    "5": {
      "plannerCity": "Houston",
      "matchDay": 3,
      "city": "Houston",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Discovery Green Park",
              "description": "Arrive in Houston, check into your accommodation. Start your exploration at Discovery Green, a vibrant urban park in the heart of downtown, offering public art, lush landscaping, and a lively atmosphere.",
              "placeName": "Discovery Green",
              "mapLink": "https://www.google.com/maps/place/Discovery+Green/@29.7554,-95.3627,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be22f77918a5:0x2213715d3122c608!8m2!3d29.7554!4d-95.360188!16s%2Fg%2F1tdn548h?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e1/Discovery_Green_Park_in_Houston.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Coffee & Pastries at Tout Suite",
              "description": "Enjoy a delicious coffee and fresh pastries at Tout Suite, a popular cafe and bakeshop known for its bright atmosphere and extensive menu.",
              "placeName": "Tout Suite",
              "mapLink": "https://www.google.com/maps/place/Tout+Suite/@29.7561,-95.3533,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be2019777271:0x41f486411516e881!8m2!3d29.7561!4d-95.350775!16s%2Fg%2F1tf70s22?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://fastly.4sqi.net/img/general/600x600/3932822_31e-4hX_0n0Lg3FjC_xN_4m59-4vO6l_2P-98j2R_80.jpg",
              "best_time": "morning",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Downtown Aquarium",
              "description": "Explore the Downtown Aquarium, a unique complex combining a public aquarium, restaurant, and amusement rides. Perfect for families and marine life enthusiasts.",
              "placeName": "Downtown Aquarium",
              "mapLink": "https://www.google.com/maps/place/Downtown+Aquarium/@29.7616,-95.3678,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be2b2b16d003:0x498e82a17088d8b1!8m2!3d29.7616!4d-95.365293!16s%2Fg%2F1tgd384x?entry=ttu",
              "ticketLink": "https://www.aquariumrestaurants.com/downtownaquariumhouston/tickets.asp",
              "imageUrl": "https://www.aquariumrestaurants.com/downtownaquariumhouston/assets/img/galleries/aquarium/aq-gallery-thumb-01.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Xochi",
              "description": "Indulge in authentic Oaxacan cuisine at Xochi, chef Hugo Ortega's acclaimed restaurant, known for its moles, masa dishes, and chocolate.",
              "placeName": "Xochi",
              "mapLink": "https://www.google.com/maps/place/Xochi/@29.7568,-95.3642,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be221448b1d9:0x8979313b194d257a!8m2!3d29.7568!4d-95.361664!16s%2Fg%2F11b6gj93z6?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://assets.houstoniamag.com/photo-gallery/Xochi-Houston-Hugo-Ortega.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Houston Museum of Natural Science",
              "description": "Spend your morning at the Houston Museum of Natural Science, home to a massive dinosaur hall, planetarium, and various exhibits on natural history and science.",
              "placeName": "Houston Museum of Natural Science",
              "mapLink": "https://www.google.com/maps/place/Houston+Museum+of+Natural+Science/@29.7220,-95.3908,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c06a38618683:0x1b4142f36d40026e!8m2!3d29.7220!4d-95.388277!16s%2Fg%2F1tdw2s78?entry=ttu",
              "ticketLink": "https://www.hmns.org/tickets/",
              "imageUrl": "https://www.hmns.org/wp-content/uploads/2023/10/HMNS_building_web.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Hermann Park",
              "description": "Enjoy the afternoon at Hermann Park, a sprawling urban park adjacent to the museum district. Visit the Japanese Garden, pedal boat on the lake, or simply relax.",
              "placeName": "Hermann Park",
              "mapLink": "https://www.google.com/maps/place/Hermann+Park/@29.7203,-95.3891,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c06a3f124623:0x203534b41a7c36a4!8m2!3d29.7203!4d-95.38661!16s%2Fg%2F1th28r53?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.hermannpark.org/media/filer_public_thumbnails/filer_public/77/8a/778a3c89-66c9-467d-933e-515c0e0b3c66/hp_mc_hero_1.jpg__1920x1080_q85_crop_subsampling-2_upscale.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Pondicheri (Indian Cuisine)",
              "description": "Experience modern Indian cuisine with a Houston twist at Pondicheri, a highly-rated restaurant known for its unique flavors and vibrant atmosphere in the Upper Kirby area.",
              "placeName": "Pondicheri",
              "mapLink": "https://www.google.com/maps/place/Pondicheri/@29.7423,-95.4206,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c1f516447847:0x5e2b020c90472e39!8m2!3d29.7423!4d-95.418042!16s%2Fg%2F1tf70d7r?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://static.wixstatic.com/media/76a454_992497b7b137452d9a9b9a67e411b423~mv2.jpg/v1/fill/w_640,h_480,fp_0.50_0.50,q_80,s_1/76a454_992497b7b137452d9a9b9a67e411b423~mv2.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Relaxed Morning & Coffee",
              "description": "Enjoy a relaxed start to your match day. Grab a quick breakfast and coffee at a local cafe near your accommodation, preparing for the excitement ahead.",
              "placeName": "Local Coffee Shop",
              "ticketLink": null,
              "imageUrl": null,
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival & Pre-Match Atmosphere",
              "description": "Immerse yourself in the World Cup spirit at the official FIFA Fan Festival (likely located at Discovery Green or a similar large public space). Enjoy live music, food vendors, merchandise, and interact with fellow fans before heading to the stadium.",
              "placeName": "FIFA Fan Festival (e.g., Discovery Green)",
              "mapLink": "https://www.google.com/maps/place/Discovery+Green/@29.7554,-95.3627,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be22f77918a5:0x2213715d3122c608!8m2!3d29.7554!4d-95.360188!16s%2Fg%2F1tdn548h?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://digitalhub.fifa.com/transform/4b17f516-7d19-482a-9e79-880094e963b2/FIFA-Fan-Festival-Doha-Qatar",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Travel to NRG Stadium",
              "description": "Head to NRG Stadium for the FIFA World Cup match. Utilize the METRORail Red Line for convenient and efficient travel directly to the stadium grounds.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/place/NRG+Stadium/@29.6847,-95.4093,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c04f981453ef:0x26685511b228965f!8m2!3d29.6847!4d-95.406775!16s%2Fg%2F11b6m28g2m?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/NRG_Stadium_2017.jpg/1200px-NRG_Stadium_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": "04:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at NRG Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at NRG Stadium, one of the premier sports venues in the United States.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/place/NRG+Stadium/@29.6847,-95.4093,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c04f981453ef:0x26685511b228965f!8m2!3d29.6847!4d-95.406775!16s%2Fg%2F11b6m28g2m?entry=ttu",
              "ticketLink": "Check official FIFA World Cup ticketing website",
              "imageUrl": "https://content.api.news/v3/images/bin/257f8641a27f620c32ac739669527963",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Space Center Houston (Longer Excursion)",
              "description": "Embark on an unforgettable journey to Space Center Houston, the official visitor center of NASA Johnson Space Center. Explore interactive exhibits, historic spacecraft, and experience the wonders of space exploration. (Note: This is a longer excursion, approximately 45-60 minutes travel from downtown).",
              "placeName": "Space Center Houston",
              "mapLink": "https://www.google.com/maps/place/Space+Center+Houston/@29.5501,-95.0970,17z/data=!3m1!4b1!4m6!3m5!1s0x863f60f64c62c2f5:0x5181a4a6e87f169f!8m2!3d29.5501!4d-95.094503!16s%2Fg%2F1tgd35w8?entry=ttu",
              "ticketLink": "https://spacecenter.org/tickets/",
              "imageUrl": "https://spacecenter.org/wp-content/uploads/2021/08/SC-Houston-Exterior.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Continue Space Center Houston Exploration",
              "description": "Spend the afternoon fully exploring the Space Center, including the tram tour to the historic Mission Control Center and the Rocket Park.",
              "placeName": "Space Center Houston",
              "mapLink": "https://www.google.com/maps/place/Space+Center+Houston/@29.5501,-95.0970,17z/data=!3m1!4b1!4m6!3m5!1s0x863f60f64c62c2f5:0x5181a4a6e87f169f!8m2!3d29.5501!4d-95.094503!16s%2Fg%2F1tgd35w8?entry=ttu",
              "ticketLink": "https://spacecenter.org/tickets/",
              "imageUrl": "https://spacecenter.org/wp-content/uploads/2021/08/SC-Houston-Interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner & Brewery Visit at Saint Arnold Brewing Company",
              "description": "After returning to Houston, enjoy dinner and a tasting at Saint Arnold Brewing Company, Texas's oldest craft brewery. They offer a diverse menu and a lively taproom.",
              "placeName": "Saint Arnold Brewing Company",
              "mapLink": "https://www.google.com/maps/place/Saint+Arnold+Brewing+Company/@29.7788,-95.3524,17z/data=!3m1!4b1!4m6!3m5!1s0x8640be4430e39669:0xb260f252656360c7!8m2!3d29.7788!4d-95.349909!16s%2Fg%2F1tf701f2?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.saintarnold.com/wp-content/uploads/2021/09/SA_Brewery_2019_01-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "The Menil Collection",
              "description": "Visit The Menil Collection, a renowned art museum showcasing a diverse array of art from antiquity to the present, housed in a tranquil setting. Admission is free.",
              "placeName": "The Menil Collection",
              "mapLink": "https://www.google.com/maps/place/The+Menil+Collection/@29.7360,-95.3995,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c06497746537:0x2287c897a9f94f9e!8m2!3d29.7360!4d-95.397036!16s%2Fg%2F1tdw20c0?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://www.menil.org/sites/default/files/styles/1_1_3_2_hero_narrow/public/2020-04/Exterior-East-Facade.jpg?itok=5_K-B3Mv",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Truth BBQ & The Galleria",
              "description": "Savor authentic Texas barbecue for lunch at Truth BBQ, famous for its brisket and ribs. Afterward, explore The Galleria, Houston's premier shopping destination, offering high-end stores and diverse dining options.",
              "placeName": "Truth BBQ & The Galleria",
              "mapLink": "https://www.google.com/maps/place/Truth+BBQ/@29.7915,-95.3900,17z/data=!3m1!4b1!4m6!3m5!1s0x8640c7490082f8a1:0x4d07b4d1b82fb3ec!8m2!3d29.7915!4d-95.387494!16s%2Fg%2F11f07z4d3r?entry=ttu",
              "ticketLink": null,
              "imageUrl": "https://truthbbq.com/wp-content/uploads/2021/08/truth-bbq-houston-exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure",
              "description": "Enjoy a final Houston meal or last-minute souvenir shopping before heading to the airport for your departure.",
              "placeName": "Houston",
              "ticketLink": null,
              "imageUrl": null,
              "best_time": "evening",
              "suggested_time": "05:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Tout Suite (Coffee & Pastries)",
        "Xochi (Oaxacan Cuisine)",
        "Pondicheri (Modern Indian Cuisine)",
        "Saint Arnold Brewing Company (Brewery Food)",
        "Truth BBQ (Texas Barbecue)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (likely at Discovery Green)",
        "FIFA World Cup Match at NRG Stadium",
        "Pre-match atmosphere and fan interactions around NRG Park"
      ],
      "travel_tips": [
        "**Stadium Access (NRG Stadium):** The most efficient way to reach NRG Stadium is via the METRORail Red Line. Take the Red Line to the 'NRG Park' station, which is directly adjacent to the stadium grounds. Plan to arrive early on match day to account for security checks and crowds.",
        "**Where to Stay:** Consider staying in Downtown Houston, the Museum District, or the Galleria area. Downtown and the Museum District offer excellent access to the METRORail Red Line, making travel to NRG Stadium and other attractions straightforward. The Galleria area provides upscale shopping and dining, with bus connections to the METRORail.",
        "**Public Transportation:** Houston's public transportation system is managed by METRO. The primary forms of transport are: \n- **METRORail:** A light rail system with three lines (Red, Green, Purple). The Red Line is crucial for accessing Downtown, the Museum District, and NRG Stadium. \n- **METRO Buses:** An extensive network covering areas not served by the rail. \n- **Fare Card:** Purchase a reloadable **METRO Q-Card** for easy tap-and-go access on all METRO services. You can buy and reload Q-Cards at METRORail stations, participating retailers, or the METRO RideStore. Single rides are also available for purchase on buses and at rail station kiosks. \n- **Using Public Transport:** While Houston is a sprawling city, the METRORail connects key tourist areas. For destinations like Space Center Houston, while public bus options exist (e.g., METRO Bus 247 from Downtown), they can be time-consuming (1.5-2 hours one way). For this specific longer excursion, a ride-share service (Uber/Lyft) or a dedicated shuttle might be a more convenient option if time is a concern. For most other itinerary items, METRORail and local buses should suffice.",
        "**Budgeting:** Houston offers a range of dining options from affordable to high-end. For a medium budget, consider a mix of casual eateries, food trucks, and a few nicer sit-down restaurants. Public transport passes will help save on travel costs compared to taxis/ride-shares for daily commuting."
      ]
    },
    "7": {
      "plannerCity": "Houston",
      "matchDay": 4,
      "city": "Houston",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Houston, check into your accommodation. Consider hotels in Downtown, Midtown, or the Museum District for excellent public transport access.",
              "placeName": "Downtown Houston",
              "mapLink": "https://www.google.com/maps/place/Downtown+Houston,+Houston,+TX",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Houston_Downtown_Skyline.jpg/1024px-Houston_Downtown_Skyline.jpg",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Explore Discovery Green Park",
              "description": "Stroll through this vibrant 12-acre urban park in the heart of downtown, featuring public art, water features, and green spaces. This location might also host FIFA Fan Festival events.",
              "placeName": "Discovery Green",
              "mapLink": "https://www.google.com/maps/place/Discovery+Green/@29.755495,-95.361955,17z",
              "imageUrl": "https://www.discoverygreen.com/wp-content/uploads/2023/07/DDG_2023_04_27_0008-scaled.jpg",
              "suggested_time": null
            },
            {
              "name": "Lunch at Frank's Pizza",
              "description": "Enjoy a casual, classic New York-style pizza experience, a local favorite in Downtown Houston.",
              "placeName": "Frank's Pizza",
              "mapLink": "https://www.google.com/maps/place/Frank's+Pizza/@29.756778,-95.363717,17z",
              "imageUrl": "https://irp.cdn-website.com/39352e00/dms3rep/multi/pizza-franks-pizza-houston.jpg",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Xochi",
              "description": "Savor award-winning Oaxacan cuisine by Chef Hugo Ortega, known for its authentic flavors and unique ingredients.",
              "placeName": "Xochi",
              "mapLink": "https://www.google.com/maps/place/Xochi/@29.757041,-95.364332,17z",
              "imageUrl": "https://static.wixstatic.com/media/5811c0_7a59e990c793444991c49c7162d04a60~mv2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/5811c0_7a59e990c793444991c49c7162d04a60~mv2.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Visit the Houston Museum of Natural Science",
              "description": "Explore diverse exhibits including dinosaurs, a planetarium, and a butterfly center. Located in the Museum District, easily accessible by METRORail.",
              "placeName": "Houston Museum of Natural Science",
              "mapLink": "https://www.google.com/maps/place/Houston+Museum+of+Natural+Science/@29.722513,-95.390509,17z",
              "ticketLink": "https://www.hmns.org/tickets/",
              "imageUrl": "https://www.hmns.org/wp-content/uploads/2023/08/HMNS-Exterior-Day-1920x1080-1.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Stroll through Hermann Park",
              "description": "Relax in this expansive urban park adjacent to the Museum District, home to the Japanese Garden, Reflection Pool, and Houston Zoo.",
              "placeName": "Hermann Park",
              "mapLink": "https://www.google.com/maps/place/Hermann+Park/@29.71694,-95.388889,17z",
              "imageUrl": "https://www.hermannpark.org/media/hermann-park-conservancy_park_reflection-pool_01_1920x1080.jpg",
              "suggested_time": null
            },
            {
              "name": "Lunch at Lucille's",
              "description": "Enjoy Southern comfort food with a modern twist at this popular restaurant in the Museum District.",
              "placeName": "Lucille's",
              "mapLink": "https://www.google.com/maps/place/Lucille's/@29.72506,-95.39121,17z",
              "imageUrl": "https://lucilleshouston.com/wp-content/uploads/2023/07/Lucilles-Houston-exterior-2.jpg",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner in Montrose",
              "description": "Explore the diverse culinary scene of Montrose, known for its eclectic restaurants and vibrant nightlife. Consider 'Uchi' for upscale Japanese.",
              "placeName": "Montrose, Houston",
              "mapLink": "https://www.google.com/maps/place/Montrose,+Houston,+TX",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Montrose_Blvd_at_Westheimer%2C_Houston.jpg/1024px-Montrose_Blvd_at_Westheimer%2C_Houston.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Day Trip to Space Center Houston",
              "description": "Embark on an inspiring journey to the official visitor center of NASA Johnson Space Center. This is a longer excursion (approx. 45-60 min drive from downtown). Allow ample time.",
              "placeName": "Space Center Houston",
              "mapLink": "https://www.google.com/maps/place/Space+Center+Houston/@29.54924,-95.09355,17z",
              "ticketLink": "https://spacecenter.org/tickets/",
              "imageUrl": "https://spacecenter.org/wp-content/uploads/2023/02/DSC00174-1920x1080.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Continue exploring Space Center Houston",
              "description": "Engage with interactive exhibits, see real spacecraft, and touch a moon rock. Don't miss the tram tour to historic Mission Control and Rocket Park.",
              "placeName": "Space Center Houston",
              "mapLink": "https://www.google.com/maps/place/Space+Center+Houston/@29.54924,-95.09355,17z",
              "imageUrl": "https://spacecenter.org/wp-content/uploads/2023/02/TramTour_Building30_DSC00139-1920x1080.jpg",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Truth BBQ",
              "description": "Return to Houston and indulge in some of Texas's finest craft barbecue. Be prepared for a line, but it's worth the wait!",
              "placeName": "Truth BBQ",
              "mapLink": "https://www.google.com/maps/place/Truth+BBQ/@29.74313,-95.38555,17z",
              "imageUrl": "https://truthbbq.com/wp-content/uploads/2020/02/TruthBBQ_Houston-36-scaled.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch parties. (Location likely Discovery Green or similar large venue).",
              "placeName": "Discovery Green (Potential FIFA Fan Festival Site)",
              "mapLink": "https://www.google.com/maps/place/Discovery+Green/@29.755495,-95.361955,17z",
              "imageUrl": "https://cdn.houstontx.gov/fifa-world-cup-2026/images/houston-fan-fest.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to NRG Stadium & Pre-Match Festivities",
              "description": "Head to NRG Stadium via METRORail Red Line to Stadium Park/Astrodome Station. Soak in the match-day excitement, visit team merchandise stalls, and join pre-game tailgating or official fan events outside the stadium.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/place/NRG+Stadium/@29.684722,-95.409167,17z",
              "imageUrl": "https://www.houstontexans.com/assets/images/stadium/stadium-exterior-2018.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at NRG Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at NRG Stadium! Enjoy world-class football in this state-of-the-art venue.",
              "placeName": "NRG Stadium",
              "mapLink": "https://www.google.com/maps/place/NRG+Stadium/@29.684722,-95.409167,17z",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://www.houstontexans.com/assets/images/stadium/nrg-stadium-interior-2018.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Explore Buffalo Bayou Park",
              "description": "Enjoy a morning walk or bike ride along Buffalo Bayou, offering stunning skyline views, public art, and the unique Buffalo Bayou Park Cistern (check for tour availability).",
              "placeName": "Buffalo Bayou Park",
              "mapLink": "https://www.google.com/maps/place/Buffalo+Bayou+Park/@29.76451,-95.38575,17z",
              "imageUrl": "https://buffalobayou.org/wp-content/uploads/2020/09/Park-Image.jpg",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Discover The Heights Neighborhood",
              "description": "Wander through the historic Houston Heights, known for its Victorian architecture, charming boutiques, art galleries, and antique shops.",
              "placeName": "The Heights, Houston",
              "mapLink": "https://www.google.com/maps/place/The+Heights,+Houston,+TX",
              "imageUrl": "https://assets.simpleviewinc.com/simpleview/image/upload/c_fill,h_670,q_75,w_1000/v1/clients/houston/Heights_mural_by_Mural_by_local_artist_Daniel_Anguilu_on_the_side_of_Boomtown_Coffee_courtesy_of_Houston_First_d27d750c-0352-4467-96a9-ce222dd81c00.jpg",
              "suggested_time": null
            },
            {
              "name": "Lunch at Field & Tides",
              "description": "Enjoy a delicious Southern-inspired meal with a focus on fresh, seasonal ingredients in a relaxed Heights setting.",
              "placeName": "Field & Tides",
              "mapLink": "https://www.google.com/maps/place/Field+%26+Tides/@29.79093,-95.39572,17z",
              "imageUrl": "https://static.wixstatic.com/media/ef8f69_148386a3479a4055b4870fbf155259cf~mv2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ef8f69_148386a3479a4055b4870fbf155259cf~mv2.jpg",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Evening Entertainment in The Heights",
              "description": "Enjoy dinner and drinks at one of The Heights' many acclaimed restaurants and bars. Consider 'Eight Row Flint' for cocktails and tacos.",
              "placeName": "Eight Row Flint",
              "mapLink": "https://www.google.com/maps/place/Eight+Row+Flint/@29.79051,-95.39413,17z",
              "imageUrl": "https://static.wixstatic.com/media/ef8f69_2548842661d94b0d87a414e0473e35a9~mv2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ef8f69_2548842661d94b0d87a414e0473e35a9~mv2.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Shopping at The Galleria",
              "description": "Experience Houston's premier shopping destination, featuring luxury brands, department stores, and an indoor ice rink.",
              "placeName": "The Galleria",
              "mapLink": "https://www.google.com/maps/place/The+Galleria/@29.7275,-95.462778,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/The_Galleria_Houston_interior.jpg/1024px-The_Galleria_Houston_interior.jpg",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Lunch and stroll in Uptown Park",
              "description": "Enjoy lunch and explore the upscale boutiques and cafes in Uptown Park, just a short distance from The Galleria.",
              "placeName": "Uptown Park",
              "mapLink": "https://www.google.com/maps/place/Uptown+Park/@29.7745,-95.4655,17z",
              "imageUrl": "https://uptownparkhouston.com/wp-content/uploads/2020/04/Uptown-Park-Houston-TX-02-1.jpg",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Caracol",
              "description": "Indulge in exquisite coastal Mexican cuisine, specializing in seafood, by renowned Chef Hugo Ortega.",
              "placeName": "Caracol Restaurant",
              "mapLink": "https://www.google.com/maps/place/Caracol+Restaurant/@29.74233,-95.46545,17z",
              "imageUrl": "https://caracol.net/wp-content/uploads/2021/04/Caracol-web-1.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Breakfast at Common Bond Bistro & Bakery",
              "description": "Enjoy a delightful breakfast or brunch with artisanal pastries, coffee, and a full menu at this popular Houston spot.",
              "placeName": "Common Bond Bistro & Bakery - Montrose",
              "mapLink": "https://www.google.com/maps/place/Common+Bond+Bistro+%26+Bakery/@29.74415,-95.39763,17z",
              "imageUrl": "https://static.wixstatic.com/media/5811c0_29d71c4c11b14a27a81093126f5d8122~mv2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/5811c0_29d71c4c11b14a27a81093126f5d8122~mv2.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Last-minute souvenir shopping and Departure",
              "description": "Grab some last-minute souvenirs or relax before heading to George Bush Intercontinental Airport (IAH) or William P. Hobby Airport (HOU) for departure.",
              "placeName": "Houston",
              "mapLink": "https://www.google.com/maps/place/Houston,+TX",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Texas_Souvenirs.jpg/1024px-Texas_Souvenirs.jpg",
              "suggested_time": null
            }
          ],
          "afternoon": [],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Tex-Mex (e.g., The Original Ninfa's on Navigation)",
        "Texas BBQ (e.g., Truth BBQ, Pinkerton's BBQ)",
        "Oaxacan Cuisine (Xochi)",
        "Coastal Mexican Seafood (Caracol)",
        "Southern Comfort Food (Lucille's)",
        "Vietnamese (Bellaire Blvd 'Asiatown')",
        "Craft Breweries (Saint Arnold Brewing Company)"
      ],
      "football_experiences": [
        "FIFA World Cup Match at NRG Stadium",
        "FIFA Fan Festival (location TBD, likely Discovery Green or similar large park)",
        "Pre-match tailgating and fan events around NRG Stadium",
        "Visiting local sports bars to catch other matches (e.g., Pitch 25, Richmond Arms Pub)"
      ],
      "travel_tips": [
        "**How to Reach NRG Stadium:** NRG Stadium (8400 Kirby Dr, Houston, TX 77054) is best accessed via the METRORail Red Line. Take the Red Line to the 'Stadium Park/Astrodome' station. Expect significant crowds on match days; arrive early. Consider using METRO's Park & Ride facilities and then taking the METRORail.",
        "**Where to Stay:** For convenient access to NRG Stadium and other attractions via public transport, consider staying in hotels located in Downtown, Midtown, the Museum District, or Montrose. These areas are along or close to the METRORail Red Line and offer a variety of accommodation options for different budgets.",
        "**Public Transportation in Houston:** Houston's public transportation is managed by METRO. The system includes METRORail (light rail with Red, Green, and Purple Lines) and an extensive METRO Bus network. The most efficient way to pay for fares is with a Q Card, a rechargeable smart card available at METRORail stations, METRO customer service centers, and select retailers. You can also purchase paper tickets for single rides or day passes at METRORail stations. Plan your routes using the METRO Trip Planner or Google Maps. Ride-sharing services like Uber and Lyft are also widely available."
      ]
    }
  },
  "philadelphia": {
    "3": {
      "plannerCity": "Philadelphia",
      "matchDay": 2,
      "city": "Philadelphia",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Independence Hall & Liberty Bell",
              "description": "Explore the birthplace of American democracy where the Declaration of Independence and U.S. Constitution were signed. Visit the iconic Liberty Bell nearby.",
              "placeName": "Independence Hall",
              "mapLink": "https://www.google.com/maps/place/Independence+Hall",
              "ticketLink": "https://www.nps.gov/inde/planyourvisit/independencehalltickets.htm",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Independence_Hall%2C_Philadelphia_PA%2C_USA_-_Diliff.jpg/1920px-Independence_Hall%2C_Philadelphia_PA%2C_USA_-_Diliff.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Breakfast & Lunch at Reading Terminal Market",
              "description": "Indulge in a diverse culinary experience at one of America's oldest and largest public markets. Try a roast pork sandwich from DiNic's or a pastry from Beiler's Doughnuts.",
              "placeName": "Reading Terminal Market",
              "mapLink": "https://www.google.com/maps/place/Reading+Terminal+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Reading_Terminal_Market_Interior.jpg/1920px-Reading_Terminal_Market_Interior.jpg",
              "best_time": "morning",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Betsy Ross House",
              "description": "Visit the historic home where Betsy Ross is said to have sewn the first American flag. A key piece of Old City history.",
              "placeName": "Betsy Ross House",
              "mapLink": "https://www.google.com/maps/place/Betsy+Ross+House",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Betsy_Ross_House_2008.jpg/1920px-Betsy_Ross_House_2008.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Explore Elfreth's Alley",
              "description": "Wander through Elfreth's Alley, the oldest continuously inhabited residential street in the United States, offering a glimpse into 18th-century life.",
              "placeName": "Elfreth's Alley",
              "mapLink": "https://www.google.com/maps/place/Elfreth's+Alley",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/ElfrethsAlley.jpg/1920px-ElfrethsAlley.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            },
            {
              "name": "Authentic Philly Cheesesteak",
              "description": "Experience the classic Philadelphia cheesesteak. Choose between Pat's King of Steaks or Geno's Steaks for an iconic rivalry experience.",
              "placeName": "Pat's King of Steaks",
              "mapLink": "https://www.google.com/maps/place/Pat's+King+of+Steaks",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Pat%27s_King_of_Steaks_-_Cheesesteak.jpg/1920px-Pat%27s_King_of_Steaks_-_Cheesesteak.jpg",
              "best_time": "afternoon",
              "suggested_time": "04:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner & Stroll through Italian Market",
              "description": "Explore the vibrant South 9th Street Italian Market, America's oldest outdoor market. Enjoy dinner at a local Italian restaurant like Ralph's Italian Restaurant.",
              "placeName": "Italian Market",
              "mapLink": "https://www.google.com/maps/place/Italian+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Italian_Market_Philadelphia_2011.jpg/1920px-Italian_Market_Philadelphia_2011.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch matches on giant screens.",
              "placeName": "FIFA Fan Festival (TBD - likely Center City)",
              "mapLink": "https://www.google.com/maps/search/Philadelphia+convention+center",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg/1920px-FIFA_Fan_Fest_2014_in_Rio_de_Janeiro_01.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Brunch at Green Eggs Cafe",
              "description": "Enjoy a hearty brunch at Green Eggs Cafe, known for its creative and delicious breakfast and lunch offerings, with several locations across the city.",
              "placeName": "Green Eggs Cafe (South Philadelphia)",
              "mapLink": "https://www.google.com/maps/place/Green+Eggs+Cafe+-+South+Philadelphia",
              "imageUrl": "https://www.greeneggscafe.com/wp-content/uploads/2019/07/SouthPhilly-1.jpg",
              "best_time": "morning",
              "suggested_time": "12:00 PM"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to Lincoln Financial Field & Pre-Match Atmosphere",
              "description": "Head to Lincoln Financial Field via the Broad Street Line. Soak in the pre-match excitement, explore the stadium surroundings, and enjoy the tailgate-like atmosphere.",
              "placeName": "Lincoln Financial Field",
              "mapLink": "https://www.google.com/maps/place/Lincoln+Financial+Field",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Lincoln_Financial_Field_2019.jpg/1920px-Lincoln_Financial_Field_2019.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a live FIFA World Cup match at Lincoln Financial Field. Cheer for your favorite team amidst thousands of passionate fans.",
              "placeName": "Lincoln Financial Field",
              "mapLink": "https://www.google.com/maps/place/Lincoln+Financial+Field",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/FIFA_World_Cup_2014_-_Germany_vs_Brazil_-_8_July_2014.jpg/1920px-FIFA_World_Cup_2014_-_Germany_vs_Brazil_-_8_July_2014.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Post-Match Celebration at Xfinity Live!",
              "description": "Continue the celebration (or commiseration) at Xfinity Live!, a massive entertainment complex adjacent to the stadium, featuring multiple bars and restaurants.",
              "placeName": "Xfinity Live!",
              "mapLink": "https://www.google.com/maps/place/Xfinity+Live!",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Xfinity_Live%21_at_the_South_Philadelphia_Sports_Complex.jpg/1920px-Xfinity_Live%21_at_the_South_Philadelphia_Sports_Complex.jpg",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Philadelphia Museum of Art & Rocky Steps",
              "description": "Visit the iconic Philadelphia Museum of Art, famous for its vast collection and the 'Rocky Steps' leading to its entrance, offering panoramic city views.",
              "placeName": "Philadelphia Museum of Art",
              "mapLink": "https://www.google.com/maps/place/Philadelphia+Museum+of+Art",
              "ticketLink": "https://philamuseum.org/visit",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Philadelphia_Museum_of_Art_at_dusk.jpg/1920px-Philadelphia_Museum_of_Art_at_dusk.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Breakfast at Sabrina's Cafe (Art Museum)",
              "description": "Enjoy a delicious breakfast or brunch at Sabrina's Cafe, a popular spot known for its generous portions and creative menu, conveniently located near the Art Museum.",
              "placeName": "Sabrina's Cafe (Art Museum)",
              "mapLink": "https://www.google.com/maps/place/Sabrina's+Cafe+-+Art+Museum",
              "imageUrl": "https://sabrinascafe.com/wp-content/uploads/2021/04/Art-Museum-scaled.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Eastern State Penitentiary",
              "description": "Explore the historic and imposing Eastern State Penitentiary, a former prison known for its wagon-wheel design and as the world's first true penitentiary.",
              "placeName": "Eastern State Penitentiary",
              "mapLink": "https://www.google.com/maps/place/Eastern+State+Penitentiary",
              "ticketLink": "https://www.easternstate.org/plan-your-visit/buy-tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Eastern_State_Penitentiary_1.jpg/1920px-Eastern_State_Penitentiary_1.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at Parc Brasserie",
              "description": "Savor a delightful farewell dinner at Parc Brasserie, a classic French bistro overlooking Rittenhouse Square, offering excellent food and a vibrant atmosphere.",
              "placeName": "Parc Brasserie",
              "mapLink": "https://www.google.com/maps/place/Parc+Brasserie",
              "imageUrl": "https://parcrestaurant.com/wp-content/uploads/2022/10/Parc-Rittenhouse-Square-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "DiNic's Roast Pork Sandwich at Reading Terminal Market",
        "Cheesesteak from Pat's King of Steaks or Geno's Steaks",
        "Cannoli or pastries from Termini Bros Bakery in the Italian Market",
        "Brunch at Green Eggs Cafe or Sabrina's Cafe",
        "French bistro experience at Parc Brasserie"
      ],
      "football_experiences": [
        "FIFA Fan Festival (location TBD, likely in Center City)",
        "FIFA World Cup Match at Lincoln Financial Field",
        "Pre-match atmosphere and activities around Lincoln Financial Field",
        "Post-match celebration/gathering at Xfinity Live!"
      ],
      "travel_tips": [
        "Stadium Access: Lincoln Financial Field is located in the South Philadelphia Sports Complex. The easiest way to reach it is via SEPTA's Broad Street Line (Orange Line). Take the subway southbound to NRG Station (the last stop). Special express trains often run on game days.",
        "Where to Stay: Consider staying in Center City neighborhoods like Rittenhouse Square, Old City, or Washington Square West. These areas offer excellent access to public transportation, dining, and attractions, and are within 60 minutes of Lincoln Financial Field via SEPTA.",
        "Public Transportation: Philadelphia's public transit is managed by SEPTA (Southeastern Pennsylvania Transportation Authority). It includes a comprehensive network of subway (Broad Street Line and Market-Frankford Line), regional rail, trolleys, and buses.",
        "SEPTA Key Card: Purchase a reusable SEPTA Key Card for easy travel. You can load funds ('Travel Wallet') for individual rides or buy weekly/monthly passes. It's tap-to-pay and more convenient than cash. Cards can be purchased at station kiosks and various retailers."
      ]
    },
    "5": {
      "plannerCity": "Philadelphia",
      "matchDay": 3,
      "city": "Philadelphia",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive in Philadelphia, check into your hotel. Recommended areas: Center City, Old City, or Society Hill for easy access to public transport and attractions.",
              "placeName": "Center City, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Center+City,+Philadelphia,+PA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Comcast_Technology_Center_and_Liberty_Place_from_Dilworth_Park_cropped.jpg/1280px-Comcast_Technology_Center_and_Liberty_Place_from_Dilworth_Park_cropped.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Independence Hall & Liberty Bell",
              "description": "Immerse yourself in American history at two of the nation's most iconic landmarks. Book tickets in advance for Independence Hall.",
              "placeName": "Independence Hall",
              "mapLink": "https://www.google.com/maps/place/Independence+Hall/@39.948749,-75.149959,17z",
              "ticketLink": "https://www.nps.gov/inde/planyourvisit/independencehalltickets.htm",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Independence_Hall_at_dusk.jpg/1920px-Independence_Hall_at_dusk.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at Reading Terminal Market",
              "description": "Experience one of America's oldest and largest public markets, offering a vast array of cuisines from local delicacies to international foods.",
              "placeName": "Reading Terminal Market",
              "mapLink": "https://www.google.com/maps/place/Reading+Terminal+Market/@39.953796,-75.159239,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Reading_Terminal_Market_Interior.jpg/1920px-Reading_Terminal_Market_Interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Old City & Elfreth's Alley",
              "description": "Enjoy dinner in the historic Old City district, followed by a stroll through Elfreth's Alley, the oldest residential street in the U.S.",
              "placeName": "City Tavern Restaurant",
              "mapLink": "https://www.google.com/maps/place/City+Tavern+Restaurant/@39.947231,-75.145028,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/City_Tavern%2C_Philadelphia.jpg/1280px-City_Tavern%2C_Philadelphia.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Evening Stroll through Elfreth's Alley",
              "description": "Discover the charm of the nation's oldest continuously inhabited residential street, perfect for an evening walk.",
              "placeName": "Elfreth's Alley",
              "mapLink": "https://www.google.com/maps/place/Elfreth's+Alley/@39.952026,-75.141699,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Elfreth%27s_Alley_in_Philadelphia.jpg/1920px-Elfreth%27s_Alley_in_Philadelphia.jpg",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Philadelphia Museum of Art & Rocky Steps",
              "description": "Visit one of the largest art museums in the United States and recreate the iconic 'Rocky Run' up its famous steps.",
              "placeName": "Philadelphia Museum of Art",
              "mapLink": "https://www.google.com/maps/place/Philadelphia+Museum+of+Art/@39.979313,-75.180479,17z",
              "ticketLink": "https://philamuseum.org/visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Philadelphia_Museum_of_Art_Main_Building_01.jpg/1920px-Philadelphia_Museum_of_Art_Main_Building_01.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Eastern State Penitentiary Tour",
              "description": "Explore the historic, vaulted cellblocks of this former prison, once the most famous and expensive in the world. A short walk from the Art Museum.",
              "placeName": "Eastern State Penitentiary",
              "mapLink": "https://www.google.com/maps/place/Eastern+State+Penitentiary/@39.968434,-75.172559,17z",
              "ticketLink": "https://www.easternstate.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eastern_State_Penitentiary_Main_Entrance.jpg/1920px-Eastern_State_Penitentiary_Main_Entrance.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at Sabrina's Cafe (Art Museum Area)",
              "description": "Enjoy a delicious and popular brunch/lunch spot known for its creative American comfort food.",
              "placeName": "Sabrina's Cafe - Fairmount",
              "mapLink": "https://www.google.com/maps/place/Sabrina's+Cafe+Fairmount/@39.967812,-75.176464,17z",
              "imageUrl": "https://sabrinascafe.com/wp-content/uploads/2021/04/Sabrinas-Cafe-Fairmount-Exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Explore South Street & Dinner",
              "description": "Wander through the eclectic shops, galleries, and vibrant nightlife of South Street. Enjoy a classic Philadelphia cheesesteak.",
              "placeName": "Jim's Steaks South Street",
              "mapLink": "https://www.google.com/maps/place/Jim's+Steaks+South+Street/@39.943141,-75.150495,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Jim%27s_Steaks_on_South_Street.jpg/1920px-Jim%27s_Steaks_on_South_Street.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Relaxed Morning & Breakfast",
              "description": "Enjoy a leisurely morning and breakfast to prepare for an exciting match day.",
              "placeName": "Your Hotel/Local Cafe",
              "mapLink": "https://www.google.com/maps",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Head to the official FIFA Fan Festival to soak in the pre-match atmosphere, enjoy live music, food, and interactive football experiences.",
              "placeName": "FIFA Fan Festival Philadelphia (Location TBD)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Philadelphia+2026",
              "imageUrl": "https://assets.fifacdn.net/image/upload/v1667575307/FIFA+Fan+Festival/doha-qatar-2022-fifa-fan-festival-2022-doha-qatar-fifa-world-cup-qatar-2022-photos-of-the-fifa-fan-festival.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Travel to Lincoln Financial Field",
              "description": "Take the SEPTA Broad Street Line (Orange Line) south to NRG Station. Lincoln Financial Field is a short walk from the station.",
              "placeName": "NRG Station",
              "mapLink": "https://www.google.com/maps/place/NRG+Station/@39.901053,-75.172406,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/NRG_Station_%28SEPTA%29.jpg/1280px-NRG_Station_%28SEPTA%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "04:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Lincoln Financial Field",
              "description": "Experience the thrill of a live World Cup match in the iconic Lincoln Financial Field, home of the Philadelphia Eagles.",
              "placeName": "Lincoln Financial Field",
              "mapLink": "https://www.google.com/maps/place/Lincoln+Financial+Field/@39.90076,-75.167448,17z",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Lincoln_Financial_Field_-_Philadelphia.jpg/1920px-Lincoln_Financial_Field_-_Philadelphia.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Explore the Italian Market",
              "description": "Wander through America's oldest outdoor market, offering fresh produce, meats, cheeses, and unique shops. Enjoy a local pastry or coffee.",
              "placeName": "Italian Market",
              "mapLink": "https://www.google.com/maps/place/Italian+Market/@39.933393,-75.162791,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Italian_Market_Philadelphia.jpg/1920px-Italian_Market_Philadelphia.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Breakfast/Brunch at Anthony's Italian Coffee House",
              "description": "Enjoy a classic Italian breakfast or coffee in the heart of the Italian Market.",
              "placeName": "Anthony's Italian Coffee House",
              "mapLink": "https://www.google.com/maps/place/Anthony's+Italian+Coffee+House/@39.932943,-75.162817,17z",
              "imageUrl": "https://anthonysitaliancoffeehouse.com/wp-content/uploads/2019/04/Anthonys-Coffee-House-Exterior.jpg",
              "best_time": "morning",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Cheesesteak Rivalry: Pat's vs. Geno's",
              "description": "Experience the legendary Philadelphia cheesesteak rivalry by trying both Pat's King of Steaks and Geno's Steaks, located across the street from each other.",
              "placeName": "Pat's King of Steaks",
              "mapLink": "https://www.google.com/maps/place/Pat's+King+of+Steaks/@39.932029,-75.162395,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Pat%27s_King_of_Steaks%2C_Philadelphia.jpg/1920px-Pat%27s_King_of_Steaks%2C_Philadelphia.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Geno's Steaks",
              "description": "Taste the competition in the famous cheesesteak rivalry.",
              "placeName": "Geno's Steaks",
              "mapLink": "https://www.google.com/maps/place/Geno's+Steaks/@39.931792,-75.162024,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Geno%27s_Steaks.jpg/1920px-Geno%27s_Steaks.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Sports Bar Experience at Chickie's & Pete's",
              "description": "Enjoy a lively evening at a popular Philadelphia sports bar, known for its Crabfries and extensive sports coverage, perfect for discussing the World Cup.",
              "placeName": "Chickie's & Pete's - South Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Chickie's+and+Pete's/@39.905662,-75.16453,17z",
              "imageUrl": "https://www.chickiesandpetes.com/wp-content/uploads/2021/04/South-Philly-1.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "National Constitution Center",
              "description": "Delve deeper into American democracy and the U.S. Constitution with interactive exhibits and historical artifacts.",
              "placeName": "National Constitution Center",
              "mapLink": "https://www.google.com/maps/place/National+Constitution+Center/@39.952674,-75.150036,17z",
              "ticketLink": "https://constitutioncenter.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/National_Constitution_Center_Front.JPG/1920px-National_Constitution_Center_Front.JPG",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Last-minute Souvenir Shopping & Lunch",
              "description": "Grab some last-minute souvenirs and enjoy a final meal at the diverse Reading Terminal Market before heading to the airport.",
              "placeName": "Reading Terminal Market",
              "mapLink": "https://www.google.com/maps/place/Reading+Terminal+Market/@39.953796,-75.159239,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Reading_Terminal_Market_Interior.jpg/1920px-Reading_Terminal_Market_Interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure from Philadelphia",
              "description": "Head to Philadelphia International Airport (PHL) via SEPTA Regional Rail (Airport Line) from Center City.",
              "placeName": "Philadelphia International Airport (PHL)",
              "mapLink": "https://www.google.com/maps/place/Philadelphia+International+Airport/@39.874457,-75.244302,17z",
              "best_time": "evening",
              "suggested_time": "05:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        {
          "name": "Reading Terminal Market",
          "description": "A historic market with diverse food vendors, from cheesesteaks to international cuisine."
        },
        {
          "name": "Jim's Steaks South Street",
          "description": "A classic spot on South Street for an authentic Philadelphia cheesesteak."
        },
        {
          "name": "Pat's King of Steaks & Geno's Steaks",
          "description": "Iconic rival cheesesteak establishments in South Philadelphia, a must-try experience."
        },
        {
          "name": "Anthony's Italian Coffee House",
          "description": "A beloved spot in the Italian Market for coffee, pastries, and Italian deli fare."
        },
        {
          "name": "Sabrina's Cafe",
          "description": "Popular for creative American comfort food, especially brunch."
        },
        {
          "name": "City Tavern Restaurant",
          "description": "Experience colonial dining in a reconstructed historic tavern."
        }
      ],
      "football_experiences": [
        {
          "name": "FIFA Fan Festival Philadelphia",
          "description": "Official fan zone with live match screenings, entertainment, food, and activities."
        },
        {
          "name": "Lincoln Financial Field",
          "description": "Host stadium for the FIFA World Cup matches, home of the Philadelphia Eagles."
        },
        {
          "name": "Chickie's & Pete's",
          "description": "A popular local sports bar chain, famous for Crabfries, great for game-day atmosphere."
        }
      ],
      "travel_tips": [
        {
          "title": "How to Reach Lincoln Financial Field (Stadium)",
          "details": "The most efficient way to reach Lincoln Financial Field, located in the South Philadelphia Sports Complex, is via SEPTA's Broad Street Line (Orange Line). Take any southbound train to the last stop, NRG Station (formerly Pattison Station). The stadium is a short walk from the station. Travel time from Center City is approximately 15-20 minutes."
        },
        {
          "title": "Where to Stay",
          "details": "For optimal access to both tourist attractions and the stadium, consider staying in Center City, Old City, or Society Hill. These areas offer a wide range of accommodation options, excellent dining, and direct public transport connections (especially the Broad Street Line) to the sports complex. They are generally within a 30-45 minute commute to Lincoln Financial Field."
        },
        {
          "title": "Public Transportation in Philadelphia (SEPTA)",
          "details": "The Southeastern Pennsylvania Transportation Authority (SEPTA) operates Philadelphia's comprehensive public transit system. \n- **SEPTA Key Card:** Purchase a reusable SEPTA Key Card for easy tap-to-ride access on subways, buses, trolleys, and regional rail. You can load funds (Travel Wallet) or various passes (e.g., One Day Pass, Weekly Pass) onto it. Cards can be purchased at station kiosks or transit centers. \n- **Broad Street Line (BSL - Orange Line):** Essential for reaching the sports complex. Runs north-south through Center City and South Philadelphia. \n- **Market-Frankford Line (MFL - Blue Line):** Runs east-west, connecting West Philadelphia, Center City, and Northeast Philadelphia. \n- **Regional Rail:** Connects Center City to the suburbs and Philadelphia International Airport (PHL). The Airport Line offers direct service between Center City stations and PHL. \n- **Buses & Trolleys:** Extensive network covering areas not reached by subway. \n- **Fares:** Single rides are $2.50 with a SEPTA Key Card. Day Passes (e.g., One Day Independence Pass) might be cost-effective if you plan extensive travel."
        }
      ]
    },
    "7": {
      "plannerCity": "Philadelphia",
      "matchDay": 4,
      "city": "Philadelphia",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Philadelphia, check into your accommodation, and settle in. Recommended areas for accommodation include Center City, Old City, or Rittenhouse Square for easy access to public transport and attractions.",
              "placeName": "Center City, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Center+City,+Philadelphia,+PA",
              "imageUrl": "https://example.com/philadelphia_skyline.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Independence Hall & Liberty Bell",
              "description": "Explore the birthplace of American democracy. See the iconic Liberty Bell and take a tour of Independence Hall, where the Declaration of Independence and U.S. Constitution were signed.",
              "placeName": "Independence National Historical Park",
              "mapLink": "https://www.google.com/maps/place/Independence+National+Historical+Park",
              "ticketLink": "https://www.nps.gov/inde/planyourvisit/reservations.htm",
              "imageUrl": "https://example.com/independence_hall.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Old City",
              "description": "Enjoy dinner at a historic restaurant in Old City. Try City Tavern, known for its 18th-century ambiance and colonial-inspired menu.",
              "placeName": "City Tavern",
              "mapLink": "https://www.google.com/maps/place/City+Tavern",
              "imageUrl": "https://example.com/city_tavern.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Philadelphia Museum of Art & Rocky Steps",
              "description": "Visit the Philadelphia Museum of Art, known for its extensive collection, and run up the famous 'Rocky Steps' for an iconic photo opportunity and city views.",
              "placeName": "Philadelphia Museum of Art",
              "mapLink": "https://www.google.com/maps/place/Philadelphia+Museum+of+Art",
              "ticketLink": "https://philamuseum.org/visit/tickets",
              "imageUrl": "https://example.com/rocky_steps.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Reading Terminal Market",
              "description": "Immerse yourself in one of America's oldest and largest public markets. Enjoy lunch from a vast selection of local vendors. Don't miss DiNic's Roast Pork for a classic Philly sandwich or Beiler's Doughnuts.",
              "placeName": "Reading Terminal Market",
              "mapLink": "https://www.google.com/maps/place/Reading+Terminal+Market",
              "imageUrl": "https://example.com/reading_terminal_market.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Stroll in Rittenhouse Square",
              "description": "Experience the vibrant Rittenhouse Square neighborhood. Enjoy dinner at a restaurant like Parc Brasserie for French cuisine or explore other options in the area, followed by a leisurely stroll around the park.",
              "placeName": "Rittenhouse Square",
              "mapLink": "https://www.google.com/maps/place/Rittenhouse+Square",
              "imageUrl": "https://example.com/rittenhouse_square.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Elfreth's Alley & Betsy Ross House",
              "description": "Walk down Elfreth's Alley, the oldest continuously inhabited residential street in the U.S., and visit the Betsy Ross House, home of the legendary flag maker.",
              "placeName": "Elfreth's Alley",
              "mapLink": "https://www.google.com/maps/place/Elfreth's+Alley",
              "ticketLink": "https://historicphiladelphia.org/betsy-ross-house/what-to-see/",
              "imageUrl": "https://example.com/elfreths_alley.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Penn's Landing & Delaware River Waterfront",
              "description": "Enjoy the revitalized waterfront at Penn's Landing. Take a walk along the Delaware River, relax in the parks, and enjoy the views.",
              "placeName": "Penn's Landing",
              "mapLink": "https://www.google.com/maps/place/Penn's+Landing",
              "imageUrl": "https://example.com/penns_landing.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner on South Street",
              "description": "Explore the eclectic shops and vibrant atmosphere of South Street. Have dinner at a local eatery, enjoying the diverse culinary scene.",
              "placeName": "South Street, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/South+Street,+Philadelphia,+PA",
              "imageUrl": "https://example.com/south_street.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and interact with fellow fans. Check official FIFA announcements for the exact location closer to the event (likely in Center City or near the stadium).",
              "placeName": "Philadelphia FIFA Fan Festival (TBD)",
              "mapLink": "https://www.google.com/maps/search/Philadelphia+FIFA+Fan+Festival",
              "imageUrl": "https://example.com/fifa_fan_festival.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Travel to Stadium",
              "description": "Continue enjoying the fan festivities, grab some lunch, and then make your way to Lincoln Financial Field. Allow ample time for travel and security checks. The Broad Street Line is the recommended public transport.",
              "placeName": "Lincoln Financial Field",
              "mapLink": "https://www.google.com/maps/place/Lincoln+Financial+Field",
              "imageUrl": "https://example.com/lff_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Lincoln Financial Field",
              "description": "Experience the thrill of a live FIFA World Cup match at Lincoln Financial Field. Cheer for your favorite team and soak in the electric atmosphere of international football.",
              "placeName": "Lincoln Financial Field",
              "mapLink": "https://www.google.com/maps/place/Lincoln+Financial+Field",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://example.com/lff_match.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Italian Market Exploration",
              "description": "Wander through the historic Italian Market, one of the oldest outdoor markets in the country. Sample fresh produce, cheeses, and local specialties. Grab a coffee and a pastry.",
              "placeName": "Italian Market, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Italian+Market,+Philadelphia,+PA",
              "imageUrl": "https://example.com/italian_market.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Philadelphia's Magic Gardens",
              "description": "Discover Isaiah Zagar's whimsical mosaic art environment, a unique and immersive outdoor art space in South Philadelphia.",
              "placeName": "Philadelphia's Magic Gardens",
              "mapLink": "https://www.google.com/maps/place/Philadelphia's+Magic+Gardens",
              "ticketLink": "https://www.phillymagicgardens.org/visit/plan-your-visit/",
              "imageUrl": "https://example.com/magic_gardens.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Authentic Cheesesteak Dinner",
              "description": "Indulge in an iconic Philadelphia cheesesteak. Head to John's Roast Pork, a local favorite known for its award-winning cheesesteaks and roast pork sandwiches, offering a more authentic experience than the tourist traps.",
              "placeName": "John's Roast Pork",
              "mapLink": "https://www.google.com/maps/place/John's+Roast+Pork",
              "imageUrl": "https://example.com/johns_roast_pork.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "The Franklin Institute",
              "description": "Spend the morning at The Franklin Institute, an interactive science museum perfect for all ages. Walk through a giant heart, explore electricity, and engage with hands-on exhibits.",
              "placeName": "The Franklin Institute",
              "mapLink": "https://www.google.com/maps/place/The+Franklin+Institute",
              "ticketLink": "https://www.fi.edu/tickets",
              "imageUrl": "https://example.com/franklin_institute.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Shopping on Rittenhouse Row",
              "description": "Enjoy some retail therapy along Rittenhouse Row, particularly on Walnut Street and Chestnut Street, offering a mix of high-end boutiques and popular brand stores.",
              "placeName": "Walnut Street, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Walnut+Street,+Philadelphia,+PA",
              "imageUrl": "https://example.com/rittenhouse_row_shopping.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Center City",
              "description": "Enjoy a farewell dinner in Center City. Consider a restaurant in the Midtown Village area for a lively atmosphere and diverse dining options.",
              "placeName": "Midtown Village, Philadelphia",
              "mapLink": "https://www.google.com/maps/place/Midtown+Village,+Philadelphia,+PA",
              "imageUrl": "https://example.com/midtown_village.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Eastern State Penitentiary",
              "description": "Visit the historic Eastern State Penitentiary, a former prison known for its wagon-wheel design and as the first true penitentiary. It's a fascinating, eerie historical site.",
              "placeName": "Eastern State Penitentiary",
              "mapLink": "https://www.google.com/maps/place/Eastern+State+Penitentiary",
              "ticketLink": "https://www.easternstate.org/visit/tickets",
              "imageUrl": "https://example.com/eastern_state_penitentiary.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Last-minute Souvenirs & Philly Soft Pretzel",
              "description": "Grab any last-minute souvenirs and enjoy a classic Philadelphia soft pretzel from a street vendor or a local shop like Philly Pretzel Factory before heading to the airport.",
              "placeName": "Philly Pretzel Factory (various locations)",
              "mapLink": "https://www.google.com/maps/search/Philly+Pretzel+Factory",
              "imageUrl": "https://example.com/philly_pretzel.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure",
              "description": "Head to Philadelphia International Airport (PHL) for your departure, using SEPTA Regional Rail (Airport Line) or a ride-share service.",
              "placeName": "Philadelphia International Airport (PHL)",
              "mapLink": "https://www.google.com/maps/place/Philadelphia+International+Airport",
              "imageUrl": "https://example.com/phl_airport.jpg",
              "best_time": "evening",
              "suggested_time": "04:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Cheesesteak (try John's Roast Pork)",
        "Roast Pork Sandwich (DiNic's at Reading Terminal Market)",
        "Philly Soft Pretzel",
        "Water Ice (Italian ice)",
        "Hoagies (sub sandwiches)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (official fan zone)",
        "Attending a FIFA World Cup Match at Lincoln Financial Field",
        "Visiting local sports bars in Center City or South Philly on non-match days to watch other games"
      ],
      "travel_tips": [
        "**Getting to Lincoln Financial Field:** The easiest way to reach Lincoln Financial Field (located in the South Philadelphia Sports Complex) is via SEPTA's Broad Street Line (subway). Take the southbound train to the Pattison Station (NRG Station). The stadium is a short walk from there. Allow extra time on match days.",
        "**Where to Stay:** For convenient access to attractions and public transport, consider staying in Center City (including Rittenhouse Square and Washington Square West), Old City, or University City. South Philadelphia also offers options and closer proximity to the stadium, but may have fewer tourist amenities. Aim for accommodation within a 60-minute commute to Lincoln Financial Field.",
        "**Public Transportation (SEPTA):** Philadelphia's public transit system is managed by SEPTA (Southeastern Pennsylvania Transportation Authority). It includes subways (Broad Street Line and Market-Frankford Line), trolleys, buses, and Regional Rail. For visitors, the subway lines are most useful for navigating the city center and reaching the stadium.",
        "**SEPTA Key Card:** Purchase a reusable SEPTA Key Card for easy tap-and-go travel on all SEPTA modes. You can load funds ('Travel Wallet') or multi-day passes onto it. Cards can be purchased and reloaded at subway stations and select retailers. A 'One Day Pass' or 'Three Day Pass' might be cost-effective depending on your travel frequency."
      ]
    }
  },
  "boston": {
    "3": {
      "plannerCity": "Foxborough",
      "matchDay": 2,
      "city": "Foxborough",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore the Freedom Trail",
              "description": "Walk a portion of Boston's historic Freedom Trail, starting from Boston Common and visiting iconic sites like the Massachusetts State House, Park Street Church, Granary Burying Ground, and Faneuil Hall. This walk offers a deep dive into American Revolutionary history.",
              "placeName": "Boston Common",
              "mapLink": "https://www.google.com/maps/place/Boston+Common/@42.355208,-71.066491,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Boston_Common_Park_Street_Church.jpg/1280px-Boston_Common_Park_Street_Church.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Quincy Market & Faneuil Hall Marketplace",
              "description": "Enjoy a wide array of food options at the historic Quincy Market, from local seafood to international cuisine. Afterward, explore the shops and street performers at Faneuil Hall Marketplace.",
              "placeName": "Quincy Market",
              "mapLink": "https://www.google.com/maps/place/Quincy+Market/@42.360155,-71.056073,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Quincy_Market_exterior_July_2011.jpg/1280px-Quincy_Market_exterior_July_2011.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            },
            {
              "name": "Visit the New England Aquarium",
              "description": "Discover thousands of aquatic animals in a four-story ocean tank, featuring sharks, turtles, and various fish. Enjoy daily presentations and marine mammal shows.",
              "placeName": "New England Aquarium",
              "mapLink": "https://www.google.com/maps/place/New+England+Aquarium/@42.359265,-71.051939,17z",
              "ticketLink": "https://www.neaq.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/New_England_Aquarium_2017.jpg/1280px-New_England_Aquarium_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in the North End",
              "description": "Experience Boston's historic Italian neighborhood with an authentic dinner. Try traditional pasta or seafood dishes.",
              "placeName": "Giacomo's Ristorante",
              "mapLink": "https://www.google.com/maps/place/Giacomo's+Ristorante/@42.364426,-71.054366,17z",
              "ticketLink": null,
              "imageUrl": "https://fastly.4sqi.net/img/general/width960/1557007_c-rU53ZtM-M-VfR6X6F03h0K5Wk8aB7J8w3z_g_Y7kY.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            },
            {
              "name": "Enjoy a Cannoli at Mike's Pastry",
              "description": "Cap off your North End experience with a famous cannoli or other Italian pastry from this iconic bakery.",
              "placeName": "Mike's Pastry",
              "mapLink": "https://www.google.com/maps/place/Mike's+Pastry/@42.363943,-71.053867,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Mike%27s_Pastry%2C_Boston.jpg/1280px-Mike%27s_Pastry%2C_Boston.jpg",
              "best_time": "evening",
              "suggested_time": "20:30"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Travel to Foxborough & Explore Patriot Place Fan Zone",
              "description": "Take the special MBTA Commuter Rail service from Boston to Foxborough. Upon arrival, immerse yourself in the World Cup atmosphere at the official Fan Zone located at Patriot Place, adjacent to Gillette Stadium. Enjoy interactive games, live music, and sponsor activations.",
              "placeName": "Patriot Place",
              "mapLink": "https://www.google.com/maps/place/Patriot+Place/@42.062089,-71.267866,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Patriot_Place_Gillette_Stadium_Foxboro_MA.JPG/1280px-Patriot_Place_Gillette_Stadium_Foxboro_MA.JPG",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Visit The Hall at Patriot Place presented by Raytheon",
              "description": "Delve into the history of the New England Patriots and local sports. This award-winning museum offers interactive exhibits and showcases the team's Super Bowl trophies.",
              "placeName": "The Hall at Patriot Place presented by Raytheon",
              "mapLink": "https://www.google.com/maps/place/The+Hall+at+Patriot+Place+presented+by+Raytheon/@42.062089,-71.267866,17z",
              "ticketLink": "https://www.thehallatpatriotplace.com/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Hall_at_Patriot_Place.jpg/1280px-Hall_at_Patriot_Place.jpg",
              "best_time": "morning",
              "suggested_time": "11:30"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Lunch",
              "description": "Continue enjoying the vibrant atmosphere at Patriot Place. Grab lunch at one of the many casual dining options like Five Guys or Davio's Northern Italian Steakhouse for a more upscale option, before heading into the stadium.",
              "placeName": "Patriot Place Restaurants",
              "mapLink": "https://www.google.com/maps/place/Patriot+Place/@42.062089,-71.267866,17z",
              "ticketLink": null,
              "imageUrl": "https://patriot-place.com/wp-content/uploads/2021/06/PatriotPlace_Restaurants_WebHeader.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Enter Gillette Stadium",
              "description": "Head into Gillette Stadium for the highly anticipated FIFA World Cup match. Find your seats, soak in the electric atmosphere, and prepare for world-class football.",
              "placeName": "Gillette Stadium",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium/@42.062089,-71.267866,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Gillette_Stadium_from_east_stand.jpg/1280px-Gillette_Stadium_from_east_stand.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Attend FIFA World Cup Match",
              "description": "Witness a thrilling FIFA World Cup match live at Gillette Stadium, experiencing the pinnacle of international football.",
              "placeName": "Gillette Stadium",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium/@42.062089,-71.267866,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Gillette_Stadium_from_east_stand.jpg/1280px-Gillette_Stadium_from_east_stand.jpg",
              "best_time": "evening",
              "suggested_time": "17:00"
            },
            {
              "name": "Post-Match Journey Back to Boston",
              "description": "After the match, make your way back to the special MBTA Commuter Rail service for your return journey to Boston.",
              "placeName": "Gillette Stadium MBTA Station",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium/@42.062089,-71.267866,17z",
              "ticketLink": null,
              "imageUrl": null,
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Explore Harvard University",
              "description": "Take the Red Line to Harvard Square and explore the historic campus of Harvard University. Walk through Harvard Yard, see the John Harvard Statue, and visit the Harvard Book Store.",
              "placeName": "Harvard University",
              "mapLink": "https://www.google.com/maps/place/Harvard+University/@42.377002,-71.116666,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Harvard_University_Campus_2019.jpg/1280px-Harvard_University_Campus_2019.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Harvard Square",
              "description": "Enjoy a casual lunch in the vibrant Harvard Square. There are many options, from quick bites to sit-down restaurants.",
              "placeName": "Felipe's Taqueria",
              "mapLink": "https://www.google.com/maps/place/Felipe's+Taqueria/@42.373574,-71.121516,17z",
              "ticketLink": null,
              "imageUrl": "https://fastly.4sqi.net/img/general/600x600/1531649_K15_3fE1u81_166b_5wL8j9s82r7s7902S1Lq4YkG3U.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            },
            {
              "name": "Visit the Museum of Fine Arts, Boston",
              "description": "Immerse yourself in art and culture at one of the largest museums in the United States, featuring extensive collections from around the world.",
              "placeName": "Museum of Fine Arts, Boston",
              "mapLink": "https://www.google.com/maps/place/Museum+of+Fine+Arts,+Boston/@42.339243,-71.094056,17z",
              "ticketLink": "https://www.mfa.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/MFA_Boston_West_Wing.jpg/1280px-MFA_Boston_West_Wing.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Back Bay",
              "description": "Dine in the elegant Back Bay neighborhood, known for its beautiful architecture and diverse culinary scene.",
              "placeName": "Legal Sea Foods (Copley Place)",
              "mapLink": "https://www.google.com/maps/place/Legal+Sea+Foods/@42.348633,-71.077678,17z",
              "ticketLink": null,
              "imageUrl": "https://www.legalseafoods.com/wp-content/uploads/2019/12/Copley-Place-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            },
            {
              "name": "Stroll down Newbury Street",
              "description": "Enjoy an evening stroll along Newbury Street, famous for its boutiques, galleries, and historic brownstones.",
              "placeName": "Newbury Street",
              "mapLink": "https://www.google.com/maps/place/Newbury+Street/@42.350328,-71.079213,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Newbury_Street_Boston.jpg/1280px-Newbury_Street_Boston.jpg",
              "best_time": "evening",
              "suggested_time": "20:30"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "New England Clam Chowder (try at Quincy Market or Legal Sea Foods)",
        "Lobster Roll (seasonal, try at James Hook & Co. or Legal Sea Foods)",
        "Cannoli from Mike's Pastry or Modern Pastry in the North End",
        "Boston Cream Pie (local dessert)",
        "Italian cuisine in the North End (Giacomo's Ristorante, Regina Pizzeria)",
        "Craft Beer from local breweries (e.g., Samuel Adams Brewery Tour)"
      ],
      "football_experiences": [
        "FIFA World Cup Match at Gillette Stadium",
        "Official FIFA Fan Zone at Patriot Place",
        "The Hall at Patriot Place presented by Raytheon (New England Patriots history, adjacent to Gillette Stadium)",
        "Experiencing the local football (soccer) culture in Boston pubs on match days (e.g., Banshee Pub in Dorchester)"
      ],
      "travel_tips": [
        "**Stadium Access (Gillette Stadium, Foxborough):** Gillette Stadium is located in Foxborough, about 30 miles southwest of Boston. On FIFA World Cup match days, the MBTA (Massachusetts Bay Transportation Authority) Commuter Rail typically operates special event trains from South Station and Back Bay Station in Boston directly to Gillette Stadium. Check the MBTA website for schedules and ticket information closer to the event. Alternatively, private shuttle services or ride-sharing options will be available, but traffic can be heavy. The journey can take 1 hour or more.",
        "**Where to Stay:** It is highly recommended to stay in Boston proper or Cambridge. Good areas include Downtown Boston, Back Bay, Seaport District, and areas near major MBTA subway lines. These locations offer excellent access to public transportation, dining, and attractions, and provide easier access to the special commuter rail services on match day. Accommodation directly in Foxborough is limited and fills up quickly.",
        "**Public Transportation (Boston/Cambridge):** The primary public transportation system is the MBTA, also known as 'The T'. It includes subway lines (Red, Green, Blue, Orange, Silver), Commuter Rail, and buses. Purchase a 'CharlieCard' for contactless tap-and-go travel on subways and buses, or a 'CharlieTicket' for paper tickets. You can load value or multi-day passes onto these cards at stations. For travel to Cambridge (e.g., Harvard University), use the Red Line. Plan your routes using Google Maps or the MBTA's official app. Public transport does not run 24/7; check operating hours, especially for late-night returns from Foxborough."
      ]
    },
    "5": {
      "plannerCity": "Foxborough",
      "matchDay": 3,
      "city": "Foxborough",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive in the Foxborough area and check into your accommodation. Settle in before starting your World Cup adventure.",
              "placeName": "Foxborough, MA",
              "mapLink": "https://www.google.com/maps/place/Foxborough,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Foxborough_Town_Hall.jpg/1920px-Foxborough_Town_Hall.jpg",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Explore Patriot Place & The Hall",
              "description": "Visit Patriot Place, an open-air shopping, dining, and entertainment center adjacent to Gillette Stadium. Dive into the history of the New England Patriots and Revolution at The Hall.",
              "placeName": "The Hall at Patriot Place presented by Kraft",
              "mapLink": "https://www.google.com/maps/place/The+Hall+at+Patriot+Place+presented+by+Kraft/@42.062085,-71.264771,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4726c04f5e135:0x8797f1e7807d8984!8m2!3d42.062081!4d-71.262196!16s%2Fg%2F1tdw93_l",
              "ticketLink": "https://www.thehallatpatriotplace.com/tickets/",
              "imageUrl": "https://www.thehallatpatriotplace.com/wp-content/uploads/2019/07/The-Hall-Exterior-300x200.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Davio's Northern Italian Steakhouse",
              "description": "Enjoy a sophisticated dinner at Davio's, known for its Northern Italian cuisine and prime steaks, located conveniently at Patriot Place.",
              "placeName": "Davio's Northern Italian Steakhouse",
              "mapLink": "https://www.google.com/maps/place/Davio's+Northern+Italian+Steakhouse/@42.064563,-71.264259,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4726c07572793:0x1b72a6b22591605f!8m2!3d42.064559!4d-71.261684!16s%2Fg%2F12239m50",
              "imageUrl": "https://davios.com/wp-content/uploads/2021/04/PatriotPlace_Hero_2020.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Freedom Trail Walking Tour (Part 1)",
              "description": "Embark on a journey through American history. Walk the iconic Freedom Trail, starting from Boston Common and visiting sites like the Massachusetts State House, Park Street Church, and Granary Burying Ground. (Travel time to Boston via commuter rail: ~45-60 min)",
              "placeName": "Boston Common",
              "mapLink": "https://www.google.com/maps/place/Boston+Common/@42.355209,-71.066497,17z/data=!3m1!4b1!4m6!3m5!1s0x89e37a7605d3b66d:0x2287f466b44a7f0!8m2!3d42.355205!4d-71.063922!16s%2Fm%2F017_0v",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Boston_Common_Park_Street_Church_and_State_House_2008.jpg/1920px-Boston_Common_Park_Street_Church_and_State_House_2008.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Quincy Market & Freedom Trail (Part 2)",
              "description": "Enjoy a casual lunch with diverse food options at Quincy Market in Faneuil Hall Marketplace. Continue your Freedom Trail journey to Faneuil Hall, Old State House, and the Old North Church.",
              "placeName": "Quincy Market",
              "mapLink": "https://www.google.com/maps/place/Quincy+Market/@42.360064,-71.056088,17z/data=!3m1!4b1!4m6!3m5!1s0x89e37084a441e17b:0x5113941400e93278!8m2!3d42.36006!4d-71.053513!16s%2Fm%2F0110j8f",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Quincy_Market_2017.jpg/1920px-Quincy_Market_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner in Boston's North End",
              "description": "Experience Boston's historic Italian neighborhood. Enjoy authentic Italian cuisine at Regina Pizzeria, one of America's oldest pizzerias, or explore other fantastic options.",
              "placeName": "Regina Pizzeria (North End)",
              "mapLink": "https://www.google.com/maps/place/Regina+Pizzeria/@42.364426,-71.057754,17z/data=!3m1!4b1!4m6!3m5!1s0x89e3708170c0c53d:0xb842a27546e30062!8m2!3d42.364422!4d-71.055179!16s%2Fg%2F1tdwcl2w",
              "imageUrl": "https://static.spotapps.co/spots/9c/614610486c11e5a55c2d3856b3e70d/attachments/original/1444778393_Regina_Pizzeria_North_End_Exterior_Night_1.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Fest Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Fest. Enjoy live music, entertainment, food, and activities with fellow fans at Patriot Place.",
              "placeName": "Patriot Place (FIFA Fan Fest Location)",
              "mapLink": "https://www.google.com/maps/place/Patriot+Place/@42.063462,-71.264771,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4726c04f5e135:0x5223363402773b0!8m2!3d42.063458!4d-71.262196!16s%2Fg%2F11b7x4n75y",
              "imageUrl": "https://media.foxboroughtownnews.com/img/photos/2022/11/04/Patriot_Place_Fan_Zone_1.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Stadium Entry",
              "description": "Continue soaking up the pre-match excitement around Gillette Stadium. Grab some stadium food or drinks and head into the stadium well before kickoff to find your seats and enjoy the build-up.",
              "placeName": "Gillette Stadium",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium/@42.066497,-71.264771,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4726c03932e67:0x5e236319859f5f6b!8m2!3d42.066493!4d-71.262196!16s%2Fm%2F025b6g",
              "imageUrl": "https://www.gillettestadium.com/wp-content/uploads/sites/4/2023/06/Gillette-Stadium-Aerial-Summer.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Gillette Stadium",
              "description": "Experience the thrill of a FIFA World Cup match live at Gillette Stadium. Cheer on your favorite team and be part of history!",
              "placeName": "Gillette Stadium",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium/@42.066497,-71.264771,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4726c03932e67:0x5e236319859f5f6b!8m2!3d42.066493!4d-71.262196!16s%2Fm%2F025b6g",
              "ticketLink": "https://www.fifa.com/tickets/world-cup-2026",
              "imageUrl": "https://www.gillettestadium.com/wp-content/uploads/sites/4/2023/06/Gillette-Stadium-Aerial-Summer.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "New England Aquarium",
              "description": "Discover fascinating marine life at the New England Aquarium, home to thousands of aquatic animals and a giant ocean tank. A great experience for all ages. (Travel time to Boston via commuter rail: ~45-60 min)",
              "placeName": "New England Aquarium",
              "mapLink": "https://www.google.com/maps/place/New+England+Aquarium/@42.359858,-71.05206,17z/data=!3m1!4b1!4m6!3m5!1s0x89e370823c932a3f:0xd08204b6b66e5114!8m2!3d42.359854!4d-71.049485!16s%2Fm%2F01772m",
              "ticketLink": "https://www.neaq.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/New_England_Aquarium_exterior.jpg/1920px-New_England_Aquarium_exterior.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Boston Tea Party Ships & Museum",
              "description": "Step back in time to 1773 and relive the historic Boston Tea Party. Interact with historical reenactors and explore reconstructed 18th-century sailing vessels.",
              "placeName": "Boston Tea Party Ships & Museum",
              "mapLink": "https://www.google.com/maps/place/Boston+Tea+Party+Ships+%26+Museum/@42.351296,-71.052673,17z/data=!3m1!4b1!4m6!3m5!1s0x89e3708304910b55:0x1b79d20c32608442!8m2!3d42.351292!4d-71.05010!16s%2Fm%2F0g_2z60",
              "ticketLink": "https://www.bostonteapartyship.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Boston_Tea_Party_Ships_%26_Museum.jpg/1920px-Boston_Tea_Party_Ships_%26_Museum.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Seafood Dinner at Legal Sea Foods (Seaport)",
              "description": "Indulge in fresh New England seafood at Legal Sea Foods, a Boston institution. Enjoy classic dishes with waterfront views in the vibrant Seaport District.",
              "placeName": "Legal Harborside",
              "mapLink": "https://www.google.com/maps/place/Legal+Harborside/@42.350325,-71.043657,17z/data=!3m1!4b1!4m6!3m5!1s0x89e37a77e5d2639d:0x2287f466b44ab59f!8m2!3d42.350321!4d-71.041082!16s%2Fm%2F0h19qgn",
              "imageUrl": "https://www.legalseafoods.com/wp-content/uploads/2021/08/LSF_Harborside-Hero.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Brunch at Lafayette House",
              "description": "Enjoy a delightful brunch at Lafayette House in Foxborough, offering a charming atmosphere and classic American fare before heading out.",
              "placeName": "Lafayette House",
              "mapLink": "https://www.google.com/maps/place/Lafayette+House/@42.062035,-71.218525,17z/data=!3m1!4b1!4m6!3m5!1s0x89e4722883395c55:0x5e236319859f5f6b!8m2!3d42.062031!4d-71.21595!16s%2Fg%2F1tdw93_l",
              "imageUrl": "https://www.lafayettehouse.com/wp-content/uploads/2019/04/Lafayette-House-Exterior-1.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure",
              "description": "Enjoy any last-minute souvenir shopping or a final coffee before heading to the airport or your next destination.",
              "placeName": "Foxborough, MA",
              "mapLink": "https://www.google.com/maps/place/Foxborough,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Foxborough_Town_Hall.jpg/1920px-Foxborough_Town_Hall.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "New England Clam Chowder (try at Legal Sea Foods)",
        "Lobster Roll (various seafood restaurants)",
        "Boston Cream Pie (especially at Omni Parker House, though not on this itinerary)",
        "Cannoli from Mike's Pastry or Modern Pastry (North End)",
        "Pizza (Regina Pizzeria)"
      ],
      "football_experiences": [
        "The Hall at Patriot Place presented by Kraft (New England Patriots & Revolution history)",
        "FIFA Fan Fest at Patriot Place (Match Day 3)",
        "FIFA World Cup Match at Gillette Stadium (Match Day 3)",
        "Exploring Patriot Place for sports-themed shops and atmosphere"
      ],
      "travel_tips": [
        "How to reach Gillette Stadium (Foxborough): On World Cup match days, special MBTA Commuter Rail trains are expected to run from South Station (Boston) and Providence (RI) directly to Foxboro Station at Patriot Place. Check the MBTA website for schedules and ticket purchasing closer to the event. Alternatively, ride-sharing services are available, but expect surge pricing and traffic. Pre-booked parking passes are essential if driving.",
        "Where to stay: Consider hotels in Foxborough, Mansfield, Norwood, or Dedham for closer proximity to Gillette Stadium. For more options and easier access to Boston's attractions (with longer travel to the stadium), look for accommodations in downtown Boston, Back Bay, or Seaport neighborhoods. Aim for areas within 60 minutes of Gillette Stadium via car or commuter rail.",
        "Public Transportation in Boston/Massachusetts: The Massachusetts Bay Transportation Authority (MBTA) operates the subway ('T'), buses, and Commuter Rail. For travel within Boston, purchase a CharlieCard (rechargeable) or CharlieTicket (single-use paper ticket) for subway and bus services. For Commuter Rail, especially to Foxborough for games, special event tickets will likely be required and should be purchased in advance via the mTicket app or station kiosks. Plan your routes using the MBTA website or Google Maps. Note that regular Commuter Rail service to Foxborough is limited outside of special events."
      ]
    },
    "7": {
      "plannerCity": "Foxborough",
      "matchDay": 4,
      "city": "Foxborough",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive at Boston Logan International Airport (BOS), transfer to your hotel in Boston, and settle in. Boston offers better public transport access and more attractions.",
              "placeName": "Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Boston,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Boston_Logan_International_Airport_%28BOS%29_Terminal_A.jpg/1024px-Boston_Logan_International_Airport_%28BOS%29_Terminal_A.jpg",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore the Freedom Trail",
              "description": "Walk Boston's historic Freedom Trail, a 2.5-mile route through downtown Boston that passes 16 historically significant sites. Visit landmarks like the Massachusetts State House, Old North Church, and Paul Revere House.",
              "placeName": "Freedom Trail, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Freedom+Trail",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Old_State_House_Boston_Freedom_Trail.jpg/1024px-Old_State_House_Boston_Freedom_Trail.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Boston's North End",
              "description": "Enjoy authentic Italian cuisine in Boston's historic North End. Consider Monica's Trattoria for a classic experience or Giacomo's Ristorante for fresh seafood pasta.",
              "placeName": "North End, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/North+End,+Boston,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/North_End_Boston_street.jpg/1024px-North_End_Boston_street.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Visit Faneuil Hall Marketplace & Quincy Market",
              "description": "Explore Faneuil Hall, a historic meeting place, and the bustling Quincy Market, known for its diverse food stalls, shops, and street performers.",
              "placeName": "Faneuil Hall Marketplace, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Faneuil+Hall+Marketplace",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Quincy_Market_in_Boston%2C_Massachusetts.jpg/1024px-Quincy_Market_in_Boston%2C_Massachusetts.jpg",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Boston Tea Party Ships & Museum",
              "description": "Experience a dramatic reenactment of the Boston Tea Party, explore the museum, and throw tea chests overboard.",
              "placeName": "Boston Tea Party Ships & Museum, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Boston+Tea+Party+Ships+%26+Museum",
              "ticketLink": "https://www.bostonteapartyship.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Boston_Tea_Party_Ships_and_Museum.jpg/1024px-Boston_Tea_Party_Ships_and_Museum.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Seaport District",
              "description": "Dine in Boston's modern and vibrant Seaport District. Consider Row 34 for exceptional oysters and seafood, or Legal Sea Foods Harborside for classic New England fare with water views.",
              "placeName": "Seaport District, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Seaport+District,+Boston,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Boston_Seaport_District_Skyline.jpg/1024px-Boston_Seaport_District_Skyline.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Harvard University Campus Tour",
              "description": "Take a student-led tour of the historic Harvard University campus in Cambridge, exploring iconic spots like Harvard Yard, Widener Library, and the John Harvard Statue.",
              "placeName": "Harvard University, Cambridge, MA",
              "mapLink": "https://www.google.com/maps/place/Harvard+University",
              "ticketLink": "https://www.harvard.edu/on-campus/visit-harvard/tours",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Harvard_University%2C_Cambridge%2C_MA_-_IMG_4260.jpg/1024px-Harvard_University%2C_Cambridge%2C_MA_-_IMG_4260.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Harvard Museum of Natural History",
              "description": "Discover diverse collections at the Harvard Museum of Natural History, including the renowned Blaschka Glass Flowers, dinosaur skeletons, and extensive mineral exhibits.",
              "placeName": "Harvard Museum of Natural History, Cambridge, MA",
              "mapLink": "https://www.google.com/maps/place/Harvard+Museum+of+Natural+History",
              "ticketLink": "https://hmnh.harvard.edu/plan-your-visit",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/HMNH_Glass_Flowers_2018.jpg/1024px-HMNH_Glass_Flowers_2018.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Harvard Square",
              "description": "Enjoy a meal in the vibrant Harvard Square area, known for its eclectic mix of restaurants. Consider Alden & Harlow for modern American dishes or The Hourly Oyster House for fresh seafood.",
              "placeName": "Harvard Square, Cambridge, MA",
              "mapLink": "https://www.google.com/maps/place/Harvard+Square",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Harvard_Square_at_night.jpg/1024px-Harvard_Square_at_night.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival (Boston Common)",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Festival in Boston Common. Enjoy live music, cultural performances, food vendors, and interactive football activities.",
              "placeName": "Boston Common, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Boston+Common",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Boston_Common_Park_Street_Station.jpg/1024px-Boston_Common_Park_Street_Station.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to Gillette Stadium & Pre-Match Festivities",
              "description": "Take the MBTA Commuter Rail special service from South Station directly to Gillette Stadium in Foxborough. Arrive early to soak in the vibrant atmosphere, explore the stadium's Fan Zones, and enjoy food and drinks from local vendors.",
              "placeName": "Gillette Stadium, Foxborough, MA",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Gillette_Stadium_-_aerial_view.jpg/1024px-Gillette_Stadium_-_aerial_view.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match!",
              "description": "Experience the thrill of a live FIFA World Cup match at Gillette Stadium. Cheer for your favorite team, witness world-class football, and be part of the global celebration.",
              "placeName": "Gillette Stadium, Foxborough, MA",
              "mapLink": "https://www.google.com/maps/place/Gillette+Stadium",
              "ticketLink": "https://www.fifa.com/worldcup/2026/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Gillette_Stadium_interior.jpg/1024px-Gillette_Stadium_interior.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Fenway Park Tour",
              "description": "Take a guided tour of America's Most Beloved Ballpark, Fenway Park, home of the Boston Red Sox. Learn about its rich history, iconic features like the Green Monster, and legendary players.",
              "placeName": "Fenway Park, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Fenway+Park",
              "ticketLink": "https://www.mlb.com/redsox/ballpark/tours",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Fenway_Park_2021.jpg/1024px-Fenway_Park_2021.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Samuel Adams Boston Brewery Tour",
              "description": "Visit the Samuel Adams Boston Brewery for a tour that delves into the brewing process, the history of the brand, and includes a tasting of their craft beers.",
              "placeName": "Samuel Adams Boston Brewery, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Samuel+Adams+Boston+Brewery",
              "ticketLink": "https://www.samueladams.com/breweries/boston",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Samuel_Adams_Brewery_Boston.jpg/1024px-Samuel_Adams_Brewery_Boston.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in the South End",
              "description": "Explore the charming South End neighborhood, known for its Victorian brownstones and diverse culinary scene. Try The Butcher Shop for charcuterie and Italian-inspired dishes or Toro for authentic Spanish tapas.",
              "placeName": "South End, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/South+End,+Boston,+MA",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/South_End_Boston_Street.jpg/1024px-South_End_Boston_Street.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Salem Witch Museum",
              "description": "Take a day trip to Salem, the historic 'Witch City'. Begin with the Salem Witch Museum to learn about the infamous 1692 witch trials through immersive presentations.",
              "placeName": "Salem Witch Museum, Salem, MA",
              "mapLink": "https://www.google.com/maps/place/Salem+Witch+Museum",
              "ticketLink": "https://salemwitchmuseum.com/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Salem_Witch_Museum.jpg/1024px-Salem_Witch_Museum.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Peabody Essex Museum",
              "description": "Visit the Peabody Essex Museum, one of the oldest and most dynamic art museums in the U.S., featuring global art, culture, and architecture.",
              "placeName": "Peabody Essex Museum, Salem, MA",
              "mapLink": "https://www.google.com/maps/place/Peabody+Essex+Museum",
              "ticketLink": "https://www.pem.org/visit",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Peabody_Essex_Museum_exterior.jpg/1024px-Peabody_Essex_Museum_exterior.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Turner's Seafood at Lyceum Hall",
              "description": "Enjoy fresh, locally sourced seafood in a historic setting at Turner's Seafood in Salem. Known for its raw bar and classic New England seafood dishes.",
              "placeName": "Turner's Seafood at Lyceum Hall, Salem, MA",
              "mapLink": "https://www.google.com/maps/place/Turner%27s+Seafood+at+Lyceum+Hall",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Salem_MA_street_scene.jpg/1024px-Salem_MA_street_scene.jpg",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Brunch at Mike's Pastry & Souvenir Shopping",
              "description": "Savor a classic Boston cannoli or other Italian pastries at Mike's Pastry in the North End, then pick up some last-minute souvenirs in the area.",
              "placeName": "Mike's Pastry, Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Mike%27s+Pastry",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Mikes_Pastry.jpg/1024px-Mikes_Pastry.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Boston Logan International Airport (BOS)",
              "description": "Head to Boston Logan International Airport (BOS) for your departure, taking public transport (MBTA Silver Line) or a taxi/rideshare.",
              "placeName": "Boston Logan International Airport (BOS), Boston, MA",
              "mapLink": "https://www.google.com/maps/place/Logan+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Boston_Logan_International_Airport_%28BOS%29_Terminal_A.jpg/1024px-Boston_Logan_International_Airport_%28BOS%29_Terminal_A.jpg",
              "suggested_time": "14:00"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "New England Clam Chowder",
        "Lobster Roll (hot with butter or cold with mayo)",
        "Cannoli from Mike's Pastry or Modern Pastry in the North End",
        "Boston Cream Pie",
        "Fresh Oysters and Seafood",
        "Craft Beer from local breweries like Samuel Adams"
      ],
      "football_experiences": [
        "Attend a FIFA World Cup Match at Gillette Stadium, Foxborough",
        "Experience the FIFA Fan Festival in Boston Common (official host city fan zone)",
        "Explore the pre-match Fan Zones and atmosphere around Gillette Stadium on match day",
        "Visit local sports bars in Boston (e.g., Cask 'n Flagon near Fenway Park) to soak in the football culture"
      ],
      "travel_tips": [
        "How to reach Gillette Stadium (Foxborough): On match days, the MBTA Commuter Rail operates special train services directly from South Station (Boston) and Providence (Rhode Island) to Gillette Stadium. Check the MBTA website for schedules closer to the event. Otherwise, rideshare services or driving are the primary options.",
        "Where to stay: For convenience and access to public transport and attractions, it is highly recommended to stay in Boston proper (e.g., Downtown, Back Bay, Seaport, Cambridge). These areas are within 30-60 minutes travel time to Gillette Stadium on match days via special train services or longer via rideshare/car on non-match days. Accommodation options in Foxborough itself are limited.",
        "Public Transportation in Boston: The Massachusetts Bay Transportation Authority (MBTA), known as 'the T', is Boston's public transit system. It includes Subway (Red, Green, Blue, Orange Lines), Commuter Rail, Buses, and Ferry services. Purchase a CharlieCard or CharlieTicket at subway stations for fares. A 7-day pass is often cost-effective for visitors planning extensive use of public transport.",
        "Booking: Book your flights, accommodations, and match tickets well in advance, as demand will be extremely high for the World Cup.",
        "Weather: June/July in Boston generally offers pleasant summer weather, but be prepared for occasional humidity or rain. Pack layers and comfortable walking shoes.",
        "Safety: Boston is generally a safe city, but always be aware of your surroundings, especially in crowded areas and when using public transport at night."
      ]
    }
  },
  "kansas-city": {
    "3": {
      "plannerCity": "Kansas City",
      "matchDay": 2,
      "city": "Kansas City",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Union Station Exploration",
              "description": "Arrive in Kansas City, check into your accommodation, then begin your exploration at the historic Union Station. Admire its grand architecture, visit the various exhibits, and learn about the city's past.",
              "placeName": "Union Station Kansas City",
              "mapLink": "https://www.google.com/maps/place/Union+Station+Kansas+City/@39.080005,-94.584344,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f0d2c3809623:0xf953331b672a912e!8m2!3d39.080001!4d-94.5817693!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Kansas_City%2C_MO_Union_Station_01.jpg/1280px-Kansas_City%2C_MO_Union_Station_01.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "National WWI Museum and Memorial",
              "description": "Visit America's official museum dedicated to World War I. Explore the interactive exhibits and ascend the Liberty Memorial Tower for panoramic views of Kansas City. It's a short walk from Union Station.",
              "placeName": "National WWI Museum and Memorial",
              "mapLink": "https://www.google.com/maps/place/National+WWI+Museum+and+Memorial/@39.079223,-94.589885,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f0d2358826d9:0x8979313b16952e46!8m2!3d39.079219!4d-94.5873103!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/National_WWI_Museum_and_Memorial_Kansas_City.jpg/1280px-National_WWI_Museum_and_Memorial_Kansas_City.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Country Club Plaza",
              "description": "Enjoy an evening in the beautiful Country Club Plaza, known for its Spanish-inspired architecture, fountains, sculptures, and upscale shopping. Have dinner at a local favorite.",
              "placeName": "Country Club Plaza",
              "mapLink": "https://www.google.com/maps/place/Country+Club+Plaza/@39.039609,-94.591244,15z/data=!3m1!4b1!4m6!3m5!1s0x87c0ef95f0000001:0x39534f31c818817a!8m2!3d39.0396092!4d-94.5912437!16s%2Fg%2F11b619g_h7",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Country_Club_Plaza.jpg/1280px-Country_Club_Plaza.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            },
            {
              "name": "Dinner at Q39 Midtown",
              "description": "Savor authentic Kansas City barbecue at Q39, known for its competition-style 'cue and modern atmosphere. Try their burnt ends or a smoked brisket sandwich.",
              "placeName": "Q39 Midtown",
              "mapLink": "https://www.google.com/maps/place/Q39+Midtown/@39.071755,-94.591968,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f003668e2289:0x8788448f8691515!8m2!3d39.071751!4d-94.5893933!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://q39kc.com/wp-content/uploads/2022/01/Q39_Midtown_Exterior_2020-scaled.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food vendors, interactive games, and watch other matches on giant screens.",
              "placeName": "Power & Light District (anticipated Fan Festival location)",
              "mapLink": "https://www.google.com/maps/place/Kansas+City+Power+%26+Light+District/@39.100918,-94.584344,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f0581c70e30d:0x38415715f16e37e9!8m2!3d39.100914!4d-94.5817693!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://www.powerandlightdistrict.com/assets/images/power-light-district-overview.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Brunch at Grünauer",
              "description": "Enjoy a delicious brunch at Grünauer, an Austrian and Central European restaurant known for its authentic dishes and cozy ambiance, located near the Power & Light District.",
              "placeName": "Grünauer",
              "mapLink": "https://www.google.com/maps/place/Grünauer/@39.098492,-94.584105,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f0580c85c2c1:0x4d538600c4364c6!8m2!3d39.098488!4d-94.5815303!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://grunauerkc.com/wp-content/uploads/2019/08/grunauer-restaurant-kc-header.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Journey to Arrowhead Stadium & Tailgating",
              "description": "Head to Arrowhead Stadium early to soak in the pre-match atmosphere. Experience the famous Kansas City tailgating culture, enjoy local food and drinks, and mingle with fellow fans.",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048995,-94.484218,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0fa3706041071:0x6d75605d3c7d6727!8m2!3d39.048991!4d-94.4816433!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Arrowhead_Stadium_2022.jpg/1280px-Arrowhead_Stadium_2022.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Arrowhead Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at Arrowhead Stadium, one of the most iconic sports venues in the world. Witness football history unfold.",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048995,-94.484218,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0fa3706041071:0x6d75605d3c7d6727!8m2!3d39.048991!4d-94.4816433!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Arrowhead_Stadium_2022.jpg/1280px-Arrowhead_Stadium_2022.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Nelson-Atkins Museum of Art",
              "description": "Visit the renowned Nelson-Atkins Museum of Art, famous for its extensive collection ranging from ancient to contemporary art, and its iconic 'Shuttlecocks' on the lawn.",
              "placeName": "The Nelson-Atkins Museum of Art",
              "mapLink": "https://www.google.com/maps/place/The+Nelson-Atkins+Museum+of+Art/@39.045063,-94.584344,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0ef9e8b746813:0x1b1d7d0a790f9e9d!8m2!3d39.045059!4d-94.5817693!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Nelson-Atkins_Museum_of_Art_East_Entrance_and_Shuttlecocks.jpg/1280px-Nelson-Atkins_Museum_of_Art_East_Entrance_and_Shuttlecocks.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Westport & Lunch at Joe's KC BBQ",
              "description": "Discover Westport, one of Kansas City's oldest neighborhoods, known for its historic buildings, vibrant nightlife, and unique boutiques. Have lunch at the iconic original gas station location of Joe's Kansas City Bar-B-Que.",
              "placeName": "Westport, Kansas City & Joe's Kansas City Bar-B-Que (Original Gas Station)",
              "mapLink": "https://www.google.com/maps/place/Joe's+Kansas+City+Bar-B-Que/@39.047806,-94.629393,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0ee6e06b75823:0x2213568c0762df27!8m2!3d39.047802!4d-94.6268183!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Joe%27s_Kansas_City_Bar-B-Que_original_location.jpg/1280px-Joe%27s_Kansas_City_Bar-B-Que_original_location.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Crossroads Arts District",
              "description": "Enjoy a final dinner in the Crossroads Arts District, a dynamic neighborhood filled with art galleries, boutiques, and diverse restaurants. It's a great spot for a relaxed evening.",
              "placeName": "Crossroads Arts District",
              "mapLink": "https://www.google.com/maps/place/Crossroads+Arts+District/@39.091011,-94.589885,16z/data=!3m1!4b1!4m6!3m5!1s0x87c0f050b18f029b:0xf857a264a04d3393!8m2!3d39.091011!4d-94.589885!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Crossroads_Art_District.jpg/1280px-Crossroads_Art_District.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at Extra Virgin",
              "description": "Savor Mediterranean small plates and cocktails at Extra Virgin, a popular spot in the Crossroads Arts District known for its lively atmosphere and delicious food.",
              "placeName": "Extra Virgin",
              "mapLink": "https://www.google.com/maps/place/Extra+Virgin/@39.091763,-94.585507,17z/data=!3m1!4b1!4m6!3m5!1s0x87c0f051515e0241:0x28f747804dfef258!8m2!3d39.091759!4d-94.5829323!16s%2Fg%2F1td0k61l",
              "imageUrl": "https://extravirginkc.com/wp-content/uploads/2019/07/extra-virgin-kc-interior.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Joe's Kansas City Bar-B-Que (Z-Man Sandwich)",
        "Q39 (Burnt Ends)",
        "Arthur Bryant's Barbeque (Ribs)",
        "Gates Bar-B-Q (Beef on Bun)",
        "Jack Stack Barbecue (Crown Prime Beef Ribs)",
        "Grünauer (Austrian/Central European cuisine)",
        "Extra Virgin (Mediterranean small plates)"
      ],
      "football_experiences": [
        "FIFA Fan Festival at Power & Light District",
        "Tailgating experience at Arrowhead Stadium on match day",
        "Attending a FIFA World Cup Match at Arrowhead Stadium",
        "Exploring the vibrant sports culture of Kansas City"
      ],
      "travel_tips": [
        "How to reach Arrowhead Stadium: On match days, dedicated shuttle services from downtown Kansas City (e.g., from Union Station or the Power & Light District) are usually available. The RideKC bus system also serves the stadium area, but direct routes might be limited on game days; check specific schedules closer to 2026. Rideshares (Uber/Lyft) are also an option, but expect surge pricing and traffic. Driving yourself is possible, but parking needs to be pre-booked and can be expensive.",
        "Where to stay: Consider staying in downtown Kansas City, the Power & Light District, Westport, or Country Club Plaza. These areas offer a variety of accommodations, dining, and entertainment options, and are generally within a 30-60 minute drive or public transport ride to Arrowhead Stadium (depending on traffic and specific route).",
        "Public Transportation in Kansas City: Kansas City primarily relies on the RideKC bus system for wider metro access. The KC Streetcar offers free service through the downtown core, connecting Union Station, the Power & Light District, and River Market. For RideKC buses, you can pay with cash (exact change required) or use the RideKC app for tickets. There is no specific all-encompassing transit card like ORCA or TAP in Kansas City, but the KC Streetcar is free to ride. For match day, always check official FIFA World Cup and RideKC announcements for special services or extended hours."
      ]
    },
    "5": {
      "plannerCity": "Kansas City",
      "matchDay": 3,
      "city": "Kansas City",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Kansas City, check into your accommodation. Consider staying in downtown, Crossroads, or Country Club Plaza for easy access to attractions.",
              "placeName": "Downtown Kansas City",
              "mapLink": "https://www.google.com/maps/place/Downtown+Kansas+City,+Kansas+City,+MO",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "National WWI Museum and Memorial",
              "description": "Explore America's official museum dedicated to World War I, offering powerful exhibits and panoramic views of the city from the Liberty Memorial Tower.",
              "placeName": "National WWI Museum and Memorial",
              "mapLink": "https://www.google.com/maps/place/National+WWI+Museum+and+Memorial/@39.0792376,-94.5878438,17z",
              "ticketLink": "https://www.theworldwar.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e9/WWI_Museum_Liberty_Memorial.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Jack Stack Barbecue (Freight House)",
              "description": "Savor authentic Kansas City barbecue at one of the city's most beloved institutions. The Freight House location offers a classic KC dining experience.",
              "placeName": "Jack Stack Barbecue - Freight House",
              "mapLink": "https://www.google.com/maps/place/Jack+Stack+Barbecue+-+Freight+House/@39.0880572,-94.5804595,17z",
              "imageUrl": "https://www.jackstackbbq.com/media/2021/08/FH-exterior-night-1920x1080.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Explore Power & Light District",
              "description": "Experience Kansas City's premier entertainment district, featuring restaurants, bars, and live music venues.",
              "placeName": "Kansas City Power & Light District",
              "mapLink": "https://www.google.com/maps/place/Kansas+City+Power+%26+Light+District/@39.0970679,-94.5835948,17z",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Nelson-Atkins Museum of Art",
              "description": "Wander through one of the nation's top art museums, known for its extensive collection and iconic shuttlecock sculptures on the lawn.",
              "placeName": "Nelson-Atkins Museum of Art",
              "mapLink": "https://www.google.com/maps/place/The+Nelson-Atkins+Museum+of+Art/@39.0437438,-94.5824558,17z",
              "ticketLink": "https://www.nelson-atkins.org/visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fb/Nelson-Atkins_Museum_of_Art.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Country Club Plaza Exploration",
              "description": "Stroll through the beautiful Spanish-inspired architecture of the Country Club Plaza, offering upscale shopping, fountains, and sculptures.",
              "placeName": "Country Club Plaza",
              "mapLink": "https://www.google.com/maps/place/Country+Club+Plaza/@39.0371307,-94.5907409,16z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/f/fb/Country_Club_Plaza_at_night.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Gram & Dun",
              "description": "Enjoy a sophisticated meal on the Country Club Plaza at Gram & Dun, known for its American comfort food and extensive patio.",
              "placeName": "Gram & Dun",
              "mapLink": "https://www.google.com/maps/place/Gram+%26+Dun/@39.034336,-94.591322,17z",
              "imageUrl": "https://gramanddun.com/wp-content/uploads/2021/01/Gram-Dun-Exterior.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Catch a drink at The Monarch Bar",
              "description": "Indulge in craft cocktails at this elegant and chic bar located near the Plaza.",
              "placeName": "The Monarch Bar",
              "mapLink": "https://www.google.com/maps/place/The+Monarch+Bar/@39.039601,-94.584347,17z",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch other matches on giant screens. Specific location TBD, but expect a vibrant downtown area.",
              "placeName": "Kansas City FIFA Fan Festival (Anticipated Downtown Location)",
              "mapLink": "https://www.google.com/maps/search/Kansas+City+Downtown+Park",
              "imageUrl": "https://digitalhub.fifa.com/transform/4b17f573-0ce8-48b6-b51f-6113b52b2f67/FIFA-Fan-Festival-Doha",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Travel to Arrowhead Stadium",
              "description": "Continue enjoying the fan atmosphere, then make your way to Arrowhead Stadium. Allow ample time for travel, security, and finding your seats. Consider official shuttles or ride-sharing.",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048999,-94.4840428,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e5/Arrowhead_Stadium_in_Kansas_City%2C_Missouri.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Arrowhead Stadium",
              "description": "Experience the thrill of a live FIFA World Cup match at the iconic Arrowhead Stadium, home of the Kansas City Chiefs. Cheer on your favorite team!",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048999,-94.4840428,17z",
              "ticketLink": "https://www.fifa.com/tournaments/mens/worldcup/2026/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e5/Arrowhead_Stadium_in_Kansas_City%2C_Missouri.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Negro Leagues Baseball Museum & American Jazz Museum",
              "description": "Delve into rich American history and culture at these two adjacent museums in the historic 18th & Vine Jazz District.",
              "placeName": "Negro Leagues Baseball Museum",
              "mapLink": "https://www.google.com/maps/place/Negro+Leagues+Baseball+Museum/@39.097034,-94.568478,17z",
              "ticketLink": "https://nlbm.com/visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a2/Negro_Leagues_Baseball_Museum_front.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "American Jazz Museum",
              "description": "Explore the history of jazz music, particularly Kansas City's significant role, with exhibits and a working jazz club.",
              "placeName": "American Jazz Museum",
              "mapLink": "https://www.google.com/maps/place/American+Jazz+Museum/@39.096894,-94.568579,17z",
              "ticketLink": "https://americanjazzmuseum.org/visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/9/91/American_Jazz_Museum.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "City Market (River Market)",
              "description": "Discover Kansas City's historic City Market, home to a vibrant farmers market, unique shops, and diverse international eateries. Grab lunch from one of the many vendors.",
              "placeName": "City Market",
              "mapLink": "https://www.google.com/maps/place/City+Market/@39.112102,-94.582845,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/a/a3/City_Market_Kansas_City.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Galleries in Crossroads Arts District",
              "description": "Enjoy dinner in the trendy Crossroads Arts District, known for its art galleries, boutiques, and diverse culinary scene. Consider visiting during 'First Fridays' if it aligns with your visit for an enhanced experience.",
              "placeName": "Crossroads Arts District",
              "mapLink": "https://www.google.com/maps/place/Crossroads+Arts+District/@39.092762,-94.588825,16z",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            },
            {
              "name": "Dinner at Grünauer",
              "description": "Savor authentic Austrian and Central European cuisine in the heart of the Crossroads, a local favorite.",
              "placeName": "Grünauer",
              "mapLink": "https://www.google.com/maps/place/Grünauer/@39.090623,-94.588725,17z",
              "imageUrl": "https://grunauerkc.com/wp-content/uploads/2019/07/Grunauer-KC-Restaurant-Exterior.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Boulevard Brewing Company Tour & Tasting",
              "description": "Take a tour of one of the largest craft brewers in the Midwest, learn about their brewing process, and enjoy a tasting of their acclaimed beers.",
              "placeName": "Boulevard Brewing Company",
              "mapLink": "https://www.google.com/maps/place/Boulevard+Brewing+Company/@39.083758,-94.595449,17z",
              "ticketLink": "https://www.boulevard.com/brewery/tours/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/d/d7/Boulevard_Brewing_Company_1.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Q39 Midtown",
              "description": "Enjoy a final taste of Kansas City barbecue at Q39, known for its competition-style, wood-fired barbecue.",
              "placeName": "Q39 Midtown",
              "mapLink": "https://www.google.com/maps/place/Q39+Midtown/@39.06828,-94.59388,17z",
              "imageUrl": "https://q39kc.com/wp-content/uploads/2021/04/Q39-Midtown-Exterior-scaled.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Departure",
              "description": "Enjoy any last-minute souvenir shopping or revisit a favorite spot before heading to the airport for your departure.",
              "placeName": "Kansas City International Airport (MCI)",
              "mapLink": "https://www.google.com/maps/place/Kansas+City+International+Airport/@39.297619,-94.713917,11z",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Joe's Kansas City Bar-B-Que (Original Gas Station or Leawood)",
        "Arthur Bryant's Barbeque",
        "Gates Bar-B-Q",
        "Jack Stack Barbecue (multiple locations)",
        "Q39 (Midtown or South)",
        "Town Topic (classic diner experience)",
        "Grünauer (Austrian/Central European)",
        "Extra Virgin (Mediterranean tapas)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (anticipated downtown location)",
        "FIFA World Cup Match at Arrowhead Stadium",
        "Local sports bars (e.g., Johnny's Tavern, The Blue Line) for watching other matches",
        "Explore team stores for official merchandise"
      ],
      "travel_tips": [
        "**Stadium Access (Arrowhead Stadium):** Arrowhead Stadium is located in the Truman Sports Complex, east of downtown Kansas City, Missouri. On match days, dedicated shuttle services from downtown hubs (like Union Station or Power & Light District) are highly recommended. Ride-sharing services (Uber/Lyft) will also be available but expect surge pricing and potential traffic delays. Public KCATA buses have limited direct routes to the complex; check for special event routes closer to the tournament.",
        "**Where to Stay:** For convenient access to attractions and potential stadium shuttles, consider staying in hotels within: \n- **Downtown Kansas City:** Offers easy access to the Streetcar and many restaurants/bars.\n- **Crossroads Arts District:** Trendy area with galleries, eateries, and good public transport links.\n- **Country Club Plaza:** Upscale area with shopping, dining, and beautiful architecture, accessible by bus from downtown.\n- All these areas are within a 30-60 minute drive/ride to Arrowhead Stadium depending on traffic.",
        "**Public Transportation (Kansas City, MO):**\n- **KC Streetcar:** A FREE, 2.2-mile streetcar line that runs north-south through the core of downtown, connecting River Market, Power & Light District, and Crossroads Arts District. It's a great way to navigate central attractions.\n- **KCATA (Kansas City Area Transportation Authority) Buses:** The primary bus system serving the wider metropolitan area. Fares can be paid with cash (exact change required) or via the 'RideKC' app. Check routes and schedules on the RideKC website or app.\n- **RideKC App:** This app provides real-time bus tracking, trip planning, and mobile fare payment for KCATA buses.\n- **No dedicated visitor transit card like ORCA/TAP:** For KCATA buses, use cash or the RideKC app. The Streetcar is free.\n- **Walkability:** Downtown, Crossroads, and the Plaza are generally walkable within their respective districts."
      ]
    },
    "7": {
      "plannerCity": "Kansas City",
      "matchDay": 4,
      "city": "Kansas City",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive in Kansas City and check into your accommodation, preferably in the Downtown or Power & Light District for central access.",
              "placeName": "Downtown Kansas City",
              "mapLink": "https://www.google.com/maps/place/Downtown+Kansas+City,+Kansas+City,+MO",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Kansas_City_Missouri_skyline_2017.jpg/1280px-Kansas_City_Missouri_skyline_2017.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore City Market & Lunch",
              "description": "Wander through the historic City Market, browse local vendors, and enjoy lunch from one of the diverse food stalls or restaurants.",
              "placeName": "City Market",
              "mapLink": "https://www.google.com/maps/place/City+Market/@39.1118671,-94.5843475,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/City_Market_Kansas_City_Missouri.jpg/1280px-City_Market_Kansas_City_Missouri.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner & Entertainment at Power & Light District",
              "description": "Experience the vibrant nightlife of the Power & Light District. Enjoy dinner at a lively restaurant and explore the entertainment options.",
              "placeName": "Kansas City Power & Light District",
              "mapLink": "https://www.google.com/maps/place/Kansas+City+Power+%26+Light+District/@39.0984922,-94.5828456,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Power_%26_Light_District.jpg/1280px-Power_%26_Light_District.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "National WWI Museum and Memorial",
              "description": "Visit America's official World War I museum, offering a poignant and comprehensive look at the Great War. Don't miss the panoramic view from the Liberty Memorial tower.",
              "placeName": "National WWI Museum and Memorial",
              "mapLink": "https://www.google.com/maps/place/National+WWI+Museum+and+Memorial/@39.0830495,-94.5855018,17z",
              "ticketLink": "https://www.theworldwar.org/visit/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/National_WWI_Museum_and_Memorial_with_Kansas_City_Skyline.jpg/1280px-National_WWI_Museum_and_Memorial_with_Kansas_City_Skyline.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Union Station",
              "description": "Discover the beautifully restored Union Station, a grand architectural landmark. Explore its historic halls and consider visiting Science City or other exhibits within.",
              "placeName": "Union Station Kansas City",
              "mapLink": "https://www.google.com/maps/place/Union+Station+Kansas+City/@39.0811802,-94.5833446,17z",
              "ticketLink": "https://unionstation.org/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Union_Station_Kansas_City_MO.jpg/1280px-Union_Station_Kansas_City_MO.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Crossroads Arts District",
              "description": "Stroll through the vibrant Crossroads Arts District, known for its galleries and unique restaurants. Enjoy dinner at a local favorite like Grünauer, offering Austrian and Central European cuisine.",
              "placeName": "Crossroads Arts District",
              "mapLink": "https://www.google.com/maps/place/Crossroads+Arts+District,+Kansas+City,+MO",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Crossroads_Art_District.jpg/1280px-Crossroads_Art_District.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Nelson-Atkins Museum of Art",
              "description": "Spend your morning at the renowned Nelson-Atkins Museum of Art, featuring a vast collection from around the world. Admission is free.",
              "placeName": "The Nelson-Atkins Museum of Art",
              "mapLink": "https://www.google.com/maps/place/The+Nelson-Atkins+Museum+of+Art/@39.0435165,-94.5828456,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Nelson-Atkins_Museum_of_Art_-_Kansas_City%2C_MO.jpg/1280px-Nelson-Atkins_Museum_of_Art_-_Kansas_City%2C_MO.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Country Club Plaza Exploration & Lunch",
              "description": "Wander through the beautiful Country Club Plaza, known for its Spanish-inspired architecture, fountains, sculptures, and upscale shops. Enjoy lunch at a restaurant like Gram & Dun.",
              "placeName": "Country Club Plaza",
              "mapLink": "https://www.google.com/maps/place/Country+Club+Plaza/@39.0384752,-94.5936773,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Country_Club_Plaza_at_night.jpg/1280px-Country_Club_Plaza_at_night.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Iconic Kansas City BBQ at Joe's Kansas City Bar-B-Que",
              "description": "Indulge in a true Kansas City culinary experience with dinner at Joe's Kansas City Bar-B-Que, famous for its Z-Man sandwich and ribs. Consider the original gas station location for the full experience, or the Leawood location for a slightly less crowded option.",
              "placeName": "Joe's Kansas City Bar-B-Que (Gas Station)",
              "mapLink": "https://www.google.com/maps/place/Joe's+Kansas+City+Bar-B-Que/@39.0560706,-94.6366088,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Joe%27s_Kansas_City_Bar-B-Que%2C_Kansas_City%2C_Kansas.jpg/1280px-Joe%27s_Kansas_City_Bar-B-Que%2C_Kansas_City%2C_Kansas.jpg",
              "best_time": "evening",
              "suggested_time": "06:30 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Festival. Enjoy live music, food, games, and interact with fellow fans. (Location to be announced by FIFA, likely downtown Kansas City).",
              "placeName": "FIFA Fan Festival (Kansas City)",
              "mapLink": "https://www.google.com/maps/search/Downtown+Kansas+City+fan+zone",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/FIFA_Fan_Fest_Rio_de_Janeiro.jpg/1280px-FIFA_Fan_Fest_Rio_de_Janeiro.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Travel to Arrowhead Stadium",
              "description": "Join the pre-match buzz, grab a quick bite, and then make your way to Arrowhead Stadium. Utilize official World Cup shuttles from designated pick-up points (e.g., Union Station, downtown hotels) for efficient travel to the stadium.",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048995,-94.4842187,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Arrowhead_Stadium_2023.jpg/1280px-Arrowhead_Stadium_2023.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Arrowhead Stadium",
              "description": "Witness the thrill of a live FIFA World Cup match at the iconic Arrowhead Stadium, home of the Kansas City Chiefs. Experience the electric atmosphere of international football.",
              "placeName": "Arrowhead Stadium",
              "mapLink": "https://www.google.com/maps/place/Arrowhead+Stadium/@39.048995,-94.4842187,17z",
              "ticketLink": "[Your FIFA Match Ticket Link Here]",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Arrowhead_Stadium_2023.jpg/1280px-Arrowhead_Stadium_2023.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Explore 18th & Vine Jazz District",
              "description": "Delve into the rich history of Kansas City jazz. Explore the district, visit the American Jazz Museum, and learn about legendary musicians.",
              "placeName": "18th & Vine Jazz District",
              "mapLink": "https://www.google.com/maps/place/18th+%26+Vine+Jazz+District/@39.0911786,-94.5649419,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/American_Jazz_Museum_in_Kansas_City%2C_Missouri.jpg/1280px-American_Jazz_Museum_in_Kansas_City%2C_Missouri.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Negro Leagues Baseball Museum",
              "description": "Discover the inspiring history of African American baseball at the Negro Leagues Baseball Museum, located within the 18th & Vine district.",
              "placeName": "Negro Leagues Baseball Museum",
              "mapLink": "https://www.google.com/maps/place/Negro+Leagues+Baseball+Museum/@39.0914104,-94.5638525,17z",
              "ticketLink": "https://nlbm.com/visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Negro_Leagues_Baseball_Museum_Kansas_City_Missouri.jpg/1280px-Negro_Leagues_Baseball_Museum_Kansas_City_Missouri.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Live Jazz at The Blue Room",
              "description": "Enjoy an authentic Kansas City experience with live jazz music at The Blue Room, a historic club located in the American Jazz Museum.",
              "placeName": "The Blue Room",
              "mapLink": "https://www.google.com/maps/place/The+Blue+Room/@39.0914104,-94.5638525,17z",
              "ticketLink": "https://americanjazzmuseum.org/the-blue-room/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/The_Blue_Room_jazz_club_in_Kansas_City%2C_Missouri.jpg/1280px-The_Blue_Room_jazz_club_in_Kansas_City%2C_Missouri.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "The Roasterie Factory Tour",
              "description": "Start your day with a guided tour of The Roasterie's coffee factory, learn about the coffee-making process, and enjoy a fresh brew.",
              "placeName": "The Roasterie Factory Cafe",
              "mapLink": "https://www.google.com/maps/place/The+Roasterie+Factory+Cafe/@39.079203,-94.5936458,17z",
              "ticketLink": "https://theroasterie.com/pages/tours",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/The_Roasterie_Kansas_City.jpg/1280px-The_Roasterie_Kansas_City.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Boulevard Brewing Company Tour & Tasting",
              "description": "Take a tour of Boulevard Brewing Company, one of the largest craft brewers in the Midwest, and enjoy a tasting of their popular beers.",
              "placeName": "Boulevard Brewing Company",
              "mapLink": "https://www.google.com/maps/place/Boulevard+Brewing+Company/@39.0838848,-94.594719,17z",
              "ticketLink": "https://www.boulevard.com/brewery-tours/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Boulevard_Brewing_Company_01.jpg/1280px-Boulevard_Brewing_Company_01.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Upscale BBQ Dinner at Jack Stack Barbecue",
              "description": "Enjoy a more refined Kansas City BBQ experience at Jack Stack Barbecue, known for its extensive menu and comfortable dining atmosphere. Try the burnt ends!",
              "placeName": "Jack Stack Barbecue - Freight House",
              "mapLink": "https://www.google.com/maps/place/Jack+Stack+Barbecue+-+Freight+House/@39.0881944,-94.582873,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Jack_Stack_BBQ_%28Freight_House%29.jpg/1280px-Jack_Stack_BBQ_%28Freight_House%29.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Last Kansas City Breakfast & Souvenir Shopping",
              "description": "Enjoy a final Kansas City breakfast, perhaps a hearty meal at Arthur Bryant's Barbeque, and pick up any last-minute souvenirs.",
              "placeName": "Arthur Bryant's Barbeque",
              "mapLink": "https://www.google.com/maps/place/Arthur+Bryant's+Barbeque/@39.0898555,-94.567087,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Arthur_Bryant%27s_Barbecue.jpg/1280px-Arthur_Bryant%27s_Barbecue.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Kansas City",
              "description": "Head to the airport or your next destination, carrying fond memories of the FIFA World Cup and Kansas City.",
              "placeName": "Kansas City International Airport (MCI)",
              "mapLink": "https://www.google.com/maps/place/Kansas+City+International+Airport/@39.2976722,-94.7139049,17z",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Kansas_City_International_Airport_Terminal_A.jpg/1280px-Kansas_City_International_Airport_Terminal_A.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Joe's Kansas City Bar-B-Que (Original Gas Station or Leawood) for the iconic Z-Man sandwich and ribs.",
        "Arthur Bryant's Barbeque for classic, smoky Kansas City BBQ.",
        "Jack Stack Barbecue (Freight House or Plaza) for a more upscale BBQ experience, especially the burnt ends.",
        "Q39 for a modern take on Kansas City BBQ with a popular wood-fired grill.",
        "Grünauer for authentic Austrian and Central European cuisine in the Crossroads Arts District.",
        "City Market vendors for diverse international and local food options.",
        "Gram & Dun on Country Club Plaza for American cuisine with a great patio atmosphere."
      ],
      "football_experiences": [
        "FIFA World Cup Match at Arrowhead Stadium.",
        "FIFA Fan Festival (location to be confirmed by FIFA, likely downtown Kansas City).",
        "Pre-match tailgate atmosphere around Arrowhead Stadium.",
        "Visiting local sports bars in the Power & Light District or Westport to watch other matches."
      ],
      "travel_tips": [
        "How to reach Arrowhead Stadium:",
        "-   Match Day Shuttles: FIFA and KCATA will likely operate dedicated shuttle services from key downtown locations (e.g., Union Station, Power & Light District) directly to Arrowhead Stadium on match days. This is the most recommended and efficient method. Check official World Cup transport guides closer to the event.",
        "-   Public Bus: KCATA offers bus routes, but direct routes to Arrowhead are limited and may require transfers. It's generally not the most convenient option for game days due to potential crowds and indirect routes.",
        "-   Ride-share/Taxi: Available but expect significant surge pricing and heavy traffic congestion on match days. Book well in advance or be prepared for delays.",
        "-   Driving: Parking is available but must be pre-purchased, and traffic will be extremely heavy. Arrive very early if driving.",
        "Where to stay:",
        "-   Downtown Kansas City: Central, walkable, good access to the KC Streetcar, Power & Light District, City Market, and Union Station. Ideal for accessing match-day shuttles.",
        "-   Country Club Plaza: Upscale, scenic, good dining and shopping options, slightly further from downtown but well-connected by bus.",
        "-   Crossroads Arts District: Trendy, art galleries, unique restaurants, close to downtown and Streetcar access.",
        "-   Westport: Lively nightlife, independent shops, diverse dining, good bus connections. All these areas are generally within a 30-45 minute public transport ride to downtown hubs.",
        "Public Transportation in Kansas City:",
        "-   KC Streetcar: Free to ride, runs along a 2.2-mile route connecting River Market, Power & Light District, Crossroads, and Union Station. Excellent for exploring downtown areas.",
        "-   KCATA (Kansas City Area Transportation Authority) Buses: An extensive bus network covers the wider metro area. Fares are typically $1.50 per ride, or a day pass for $3. Buses are useful for reaching areas beyond the Streetcar line, like the Country Club Plaza or Westport.",
        "-   Payment: Cash (exact change required for buses) or use the RideKC App for convenient mobile ticketing. There isn't a specific 'card' like ORCA or TAP for KCATA, but the app is the most convenient option.",
        "-   Planning: Use Google Maps or the RideKC app for real-time bus tracking and route planning.",
        "-   RideKC Bike & Scooter: Bike and scooter share programs are available in central areas for short distances."
      ]
    }
  },
  "vancouver": {
    "3": {
      "plannerCity": "Vancouver",
      "matchDay": 2,
      "city": "Vancouver",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore Gastown and Steam Clock",
              "description": "Wander through Vancouver's historic Gastown, known for its Victorian architecture, cobbled streets, and the iconic Steam Clock. Enjoy boutique shops and art galleries.",
              "placeName": "Gastown, Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Gastown%2C%20Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Gastown_Steam_Clock_2016.jpg/1024px-Gastown_Steam_Clock_2016.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Breakfast at Nelson the Seagull",
              "description": "Enjoy artisanal bread, coffee, and breakfast fare in a rustic setting.",
              "placeName": "Nelson the Seagull, Gastown",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Nelson%20the%20Seagull%2C%20Gastown",
              "imageUrl": "https://d3emaq2doa6vk.cloudfront.net/labels/nelson-the-seagull-vancouver-menu.jpeg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Visit Canada Place",
              "description": "Walk along the iconic Canada Place, known for its distinctive 'sails' architecture. Enjoy waterfront views, seaplane activity, and perhaps the FlyOver Canada experience.",
              "placeName": "Canada Place, Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Canada%20Place%2C%20Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Canada_Place_and_Vancouver_skyline_2017.jpg/1280px-Canada_Place_and_Vancouver_skyline_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Lunch at Miku Vancouver",
              "description": "Experience Aburi (flame-seared) sushi and other Japanese delights with stunning waterfront views.",
              "placeName": "Miku Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Miku%20Vancouver",
              "imageUrl": "https://www.miku.com/wp-content/uploads/2021/03/Miku-Vancouver-Restaurant-Interior-min.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Explore Robson Street & Yaletown",
              "description": "Stroll down Robson Street for shopping and then head to Yaletown, a trendy warehouse district, for dinner and drinks. Experience the vibrant nightlife.",
              "placeName": "Yaletown, Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Yaletown%2C%20Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Yaletown_Night_Vancouver_BC_Canada.jpg/1280px-Yaletown_Night_Vancouver_BC_Canada.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            },
            {
              "name": "Dinner at Blue Water Cafe + Raw Bar",
              "description": "Indulge in an exquisite seafood dining experience, renowned for its fresh, sustainable seafood and raw bar.",
              "placeName": "Blue Water Cafe + Raw Bar",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Blue%20Water%20Cafe%20%2B%20Raw%20Bar",
              "imageUrl": "https://www.bluewatercafe.net/wp-content/uploads/2020/09/Blue-Water-Cafe-Interior-1024x683.jpg",
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match atmosphere at the official FIFA Fan Festival. Enjoy live music, food stalls, interactive games, and screenings of other matches.",
              "placeName": "FIFA Fan Festival (approx. location Jack Poole Plaza)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Jack%20Poole%20Plaza%2C%20Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/FIFA_Fan_Fest%2C_Berlin_2006.jpg/1024px-FIFA_Fan_Fest%2C_Berlin_2006.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Pre-Match Meal: Japadog",
              "description": "Grab a quick and iconic Vancouver street food experience with a unique Japanese-inspired hot dog. Perfect before heading to the stadium.",
              "placeName": "Japadog, various locations (e.g., Burrard St. Cart)",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Japadog%2C%20Burrard%20St%20Cart",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Japadog_Kurobuta_Terimayo_Vancouver.jpg/1280px-Japadog_Kurobuta_Terimayo_Vancouver.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30"
            }
          ],
          "afternoon": [
            {
              "name": "Match Day at BC Place",
              "description": "Head to BC Place for the FIFA World Cup match. Soak in the electric atmosphere, cheer for your team, and witness world-class football.",
              "placeName": "BC Place, Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=BC%20Place%2C%20Vancouver",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/BC_Place_Stadium_at_night.jpg/1280px-BC_Place_Stadium_at_night.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Post-Match Celebration Dinner",
              "description": "Celebrate or commiserate after the match with dinner and drinks at a lively sports bar or restaurant near BC Place. Yaletown offers many options.",
              "placeName": "The Flying Pig Yaletown",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The%20Flying%20Pig%20Yaletown",
              "imageUrl": "https://theflyingpigvan.com/wp-content/uploads/2021/04/flying-pig-yaletown-patio.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Explore Stanley Park",
              "description": "Rent a bike or walk a portion of the Seawall in Stanley Park, Vancouver's largest urban park. Visit the iconic Totem Poles and enjoy stunning views of the city and North Shore mountains.",
              "placeName": "Stanley Park, Vancouver",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Stanley%20Park%2C%20Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Stanley_Park_Seawall_-_Vancouver%2C_BC_-_DSC07718.jpg/1280px-Stanley_Park_Seawall_-_Vancouver%2C_BC_-_DSC07718.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Brunch at The Teahouse in Stanley Park",
              "description": "Enjoy a delicious brunch with scenic views of the ocean and gardens in a historic setting within Stanley Park.",
              "placeName": "The Teahouse in Stanley Park",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=The%20Teahouse%20in%20Stanley%20Park",
              "imageUrl": "https://www.vancouverdine.com/wp-content/uploads/2019/08/Teahouse-Stanley-Park-restaurant-patio-1.jpg",
              "best_time": "morning",
              "suggested_time": "11:30"
            }
          ],
          "afternoon": [
            {
              "name": "Discover Granville Island Market",
              "description": "Take a False Creek Ferry to Granville Island. Explore the Public Market for local produce, artisanal foods, and unique crafts. Enjoy street performers and local art.",
              "placeName": "Granville Island Public Market",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Granville%20Island%20Public%20Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Granville_Island_Public_Market_interior.jpg/1280px-Granville_Island_Public_Market_interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch/Snack at Lee's Donuts",
              "description": "Indulge in a classic Vancouver treat at Lee's Donuts, famous for its freshly made, old-fashioned donuts.",
              "placeName": "Lee's Donuts, Granville Island",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=Lee%27s%20Donuts%2C%20Granville%20Island",
              "imageUrl": "https://www.leesdonuts.ca/wp-content/uploads/2021/04/leesdonuts-menu-hero.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Kitsilano",
              "description": "Enjoy a final dinner in the vibrant Kitsilano neighborhood, known for its relaxed beach vibe and diverse dining options. Catch a sunset view if time permits.",
              "placeName": "AnnaLena, Kitsilano",
              "mapLink": "https://www.google.com/maps/search/?api=1&query=AnnaLena%2C%20Kitsilano",
              "imageUrl": "https://www.annalena.ca/wp-content/uploads/2022/07/annalena-interior-1.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Japadog: A unique Japanese-inspired hot dog street food experience.",
        "Poutine: A Canadian classic of fries, cheese curds, and gravy (e.g., Belgium Fries on Robson St).",
        "Fresh West Coast Seafood: Enjoy salmon, halibut, and oysters at restaurants like Blue Water Cafe or Fanny Bay Oyster Bar.",
        "Dim Sum: Vancouver boasts excellent Chinese cuisine, especially dim sum in areas like Chinatown or Richmond.",
        "Craft Beer: Explore Vancouver's thriving craft brewery scene, particularly in areas like Brewery Creek."
      ],
      "football_experiences": [
        "FIFA Fan Festival: The official hub for all fans, offering entertainment, food, and live match screenings.",
        "BC Place Stadium: Attend a live FIFA World Cup match and experience the electric atmosphere.",
        "Local Pubs & Sports Bars: Catch other matches and soak in the football culture at places like The Sportsbar LIVE! at Rogers Arena or Mahony's Tavern (various locations).",
        "Vancouver Whitecaps FC Store: Visit the official store for local football merchandise."
      ],
      "travel_tips": [
        "**Getting to BC Place**: BC Place (Vancouver, BC) is centrally located and easily accessible by public transport. The Stadium-Chinatown SkyTrain Station (Expo Line and Millennium Line) is directly adjacent to the stadium. Several bus routes also serve the area. Plan to arrive early on match day.",
        "**Where to Stay**: Consider staying in Downtown, Yaletown, Gastown, Coal Harbour, or the West End. These areas are well-connected by public transit and offer a range of accommodation options, all within 30-60 minutes of BC Place.",
        "**Public Transportation**: Vancouver's public transport system, TransLink, includes SkyTrain (subway/elevated rail), SeaBus (passenger ferry), and buses. It is efficient and covers most major attractions. Purchase a Compass Card (rechargeable fare card) for seamless travel. You can load stored value or a DayPass onto the card. Tap your Compass Card when entering and exiting SkyTrain/SeaBus stations and when boarding buses. Fares are zone-based for SkyTrain/SeaBus.",
        "**Currency**: Canadian Dollar (CAD). Credit cards are widely accepted.",
        "**Tipping**: Standard practice for good service in restaurants (15-20%), bars, and for taxi drivers."
      ]
    },
    "5": {
      "plannerCity": "Vancouver",
      "matchDay": 3,
      "city": "Vancouver",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive in Vancouver, transfer to your accommodation, and check in. Settle in before starting your exploration.",
              "placeName": "Downtown Vancouver",
              "mapLink": "https://www.google.com/maps/place/Downtown+Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Downtown_Vancouver_skyline_from_Stanley_Park.jpg/1280px-Downtown_Vancouver_skyline_from_Stanley_Park.jpg",
              "suggested_time": "09:00"
            },
            {
              "name": "Explore Gastown & Steam Clock",
              "description": "Wander through the historic Gastown district, famous for its Victorian architecture, cobblestone streets, and the iconic Gastown Steam Clock.",
              "placeName": "Gastown Steam Clock",
              "mapLink": "https://www.google.com/maps/place/Gastown+Steam+Clock",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Gastown_Steam_Clock_2019.jpg/1280px-Gastown_Steam_Clock_2019.jpg",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Granville Island Public Market",
              "description": "Take a False Creek Ferry to Granville Island and enjoy a diverse range of local and international foods from various vendors at the bustling Public Market.",
              "placeName": "Granville Island Public Market",
              "mapLink": "https://www.google.com/maps/place/Granville+Island+Public+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Granville_Island_Public_Market.jpg/1280px-Granville_Island_Public_Market.jpg",
              "suggested_time": "13:00"
            },
            {
              "name": "Visit Canada Place & Olympic Cauldron",
              "description": "Walk along the waterfront at Canada Place, admire the iconic sails, and see the Olympic Cauldron from the 2010 Winter Olympics.",
              "placeName": "Canada Place",
              "mapLink": "https://www.google.com/maps/place/Canada+Place",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Canada_Place_Vancouver_2019.jpg/1280px-Canada_Place_Vancouver_2019.jpg",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Yaletown",
              "description": "Enjoy an evening meal in the trendy Yaletown district, known for its converted warehouse restaurants and vibrant nightlife. Try 'Blue Water Cafe' for seafood.",
              "placeName": "Blue Water Cafe",
              "mapLink": "https://www.google.com/maps/place/Blue+Water+Cafe",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Blue_Water_Cafe.jpg/1280px-Blue_Water_Cafe.jpg",
              "suggested_time": "19:00"
            },
            {
              "name": "Evening Stroll along False Creek",
              "description": "Take a leisurely walk along the False Creek seawall, enjoying the city lights and views of Granville Island.",
              "placeName": "False Creek Seawall",
              "mapLink": "https://www.google.com/maps/place/False+Creek+Seawall",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/False_Creek_from_Granville_Island.jpg/1280px-False_Creek_from_Granville_Island.jpg",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Explore Stanley Park",
              "description": "Rent a bike or walk a portion of the Seawall in Stanley Park, visit the Totem Poles, and enjoy the natural beauty of this urban oasis.",
              "placeName": "Stanley Park",
              "mapLink": "https://www.google.com/maps/place/Stanley+Park",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Stanley_Park_Seawall_in_Vancouver.jpg/1280px-Stanley_Park_Seawall_in_Vancouver.jpg",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Japadog",
              "description": "Experience Vancouver's unique street food culture with a gourmet Japanese-style hot dog from Japadog.",
              "placeName": "Japadog Stand (Burrard St)",
              "mapLink": "https://www.google.com/maps/place/Japadog/@49.284242,-123.123512,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717f90919245:0x8542b6a94f31c2a!8m2!3d49.284242!4d-123.1213233!16s%2Fg%2F1tc64v6j?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Japadog_in_Vancouver.jpg/1280px-Japadog_in_Vancouver.jpg",
              "suggested_time": "13:00"
            },
            {
              "name": "Vancouver Art Gallery",
              "description": "Immerse yourself in art and culture at the Vancouver Art Gallery, housed in a magnificent neoclassical building.",
              "placeName": "Vancouver Art Gallery",
              "mapLink": "https://www.google.com/maps/place/Vancouver+Art+Gallery",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Vancouver_Art_Gallery_2010.jpg/1280px-Vancouver_Art_Gallery_2010.jpg",
              "ticketLink": "https://www.vanartgallery.bc.ca/visit/tickets",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner on Robson Street",
              "description": "Explore the diverse culinary scene on Robson Street, offering a wide array of international restaurants. Consider 'Miku Waterfront' for upscale Aburi sushi.",
              "placeName": "Miku Waterfront",
              "mapLink": "https://www.google.com/maps/place/Miku+Waterfront",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Miku_Waterfront_Vancouver.jpg/1280px-Miku_Waterfront_Vancouver.jpg",
              "suggested_time": "19:00"
            },
            {
              "name": "Evening Entertainment in Downtown",
              "description": "Catch a show, visit a lively bar, or enjoy a casual drink in one of downtown Vancouver's entertainment venues.",
              "placeName": "Downtown Vancouver",
              "mapLink": "https://www.google.com/maps/place/Downtown+Vancouver",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Robson_Street_at_night%2C_Vancouver.jpg/1280px-Robson_Street_at_night%2C_Vancouver.jpg",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and watch other matches on big screens.",
              "placeName": "FIFA Fan Festival (likely Live Nation Plaza or designated downtown area)",
              "mapLink": "https://www.google.com/maps/place/Live+Nation+Canada+Plaza",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/FIFA_Fan_Festival_Doha_2022.jpg/1280px-FIFA_Fan_Festival_Doha_2022.jpg",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Lunch near Stadium",
              "description": "Head towards BC Place, soaking in the pre-match excitement. Grab a quick and easy lunch at a pub or restaurant near the stadium, such as 'Devil's Elbow Ale & Smoke House'.",
              "placeName": "Devil's Elbow Ale & Smoke House",
              "mapLink": "https://www.google.com/maps/place/Devil's+Elbow+Ale+%26+Smoke+House",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/BC_Place_with_Stadium-Chinatown_station_in_foreground.jpg/1280px-BC_Place_with_Stadium-Chinatown_station_in_foreground.jpg",
              "suggested_time": "14:00"
            },
            {
              "name": "Arrive at BC Place",
              "description": "Make your way to BC Place, allowing ample time for security checks and finding your seats. Enjoy the pre-match ceremonies and build-up.",
              "placeName": "BC Place",
              "mapLink": "https://www.google.com/maps/place/BC+Place",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/BC_Place_Stadium%2C_Vancouver.jpg/1280px-BC_Place_Stadium%2C_Vancouver.jpg",
              "suggested_time": "16:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match!",
              "description": "Experience the thrill of a live FIFA World Cup match at BC Place, cheering on your favourite team.",
              "placeName": "BC Place",
              "mapLink": "https://www.google.com/maps/place/BC+Place",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/BC_Place_stadium_%282011%29.jpg/1280px-BC_Place_stadium_%282011%29.jpg",
              "suggested_time": "18:00"
            },
            {
              "name": "Post-Match Celebration/Drinks",
              "description": "Join fellow fans for post-match discussions and celebrations at a nearby pub or sports bar, such as 'The Sportsbar LIVE! at Rogers Arena'.",
              "placeName": "The Sportsbar LIVE! at Rogers Arena",
              "mapLink": "https://www.google.com/maps/place/The+Sportsbar+LIVE!+at+Rogers+Arena",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Rogers_Arena_exterior_in_Vancouver.jpg/1280px-Rogers_Arena_exterior_in_Vancouver.jpg",
              "suggested_time": "20:30"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Explore Vancouver's Chinatown",
              "description": "Discover the vibrant culture of Vancouver's historic Chinatown, one of the oldest and largest in North America. Visit the Millennium Gate.",
              "placeName": "Vancouver Chinatown Millennium Gate",
              "mapLink": "https://www.google.com/maps/place/Vancouver+Chinatown+Millennium+Gate",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Chinatown_Millennium_Gate%2C_Vancouver.jpg/1280px-Chinatown_Millennium_Gate%2C_Vancouver.jpg",
              "suggested_time": "09:30"
            },
            {
              "name": "Dr. Sun Yat-Sen Classical Chinese Garden",
              "description": "Find tranquility in the Dr. Sun Yat-Sen Classical Chinese Garden, an authentic Ming Dynasty-style garden and a peaceful oasis in the city.",
              "placeName": "Dr. Sun Yat-Sen Classical Chinese Garden",
              "mapLink": "https://www.google.com/maps/place/Dr.+Sun+Yat-Sen+Classical+Chinese+Garden",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Dr._Sun_Yat-Sen_Classical_Chinese_Garden%2C_Vancouver.jpg/1280px-Dr._Sun_Yat-Sen_Classical_Chinese_Garden%2C_Vancouver.jpg",
              "ticketLink": "https://vancouverchinesegarden.com/visit/hours-admission/",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch in Chinatown",
              "description": "Savour authentic Chinese cuisine in Chinatown. Try 'New Town Bakery & Restaurant' for delicious dim sum and baked goods.",
              "placeName": "New Town Bakery & Restaurant",
              "mapLink": "https://www.google.com/maps/place/New+Town+Bakery+%26+Restaurant",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Dim_Sum_at_New_Town_Bakery.jpg/1280px-Dim_Sum_at_New_Town_Bakery.jpg",
              "suggested_time": "13:00"
            },
            {
              "name": "Capilano Suspension Bridge Park",
              "description": "Embark on an intentional longer excursion to the stunning Capilano Suspension Bridge Park. Walk across the famous bridge, explore the Cliffwalk, and Treetops Adventure. (Accessible via free shuttle from Canada Place or public transit).",
              "placeName": "Capilano Suspension Bridge Park",
              "mapLink": "https://www.google.com/maps/place/Capilano+Suspension+Bridge+Park",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Capilano_Suspension_Bridge_in_Vancouver.jpg/1280px-Capilano_Suspension_Bridge_in_Vancouver.jpg",
              "ticketLink": "https://www.capbridge.com/visit/tickets/",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in North Vancouver or Gastown",
              "description": "After returning from Capilano, enjoy dinner in North Vancouver near the SeaBus terminal (e.g., Lonsdale Quay Market) or head back to Gastown for more dining options.",
              "placeName": "Lonsdale Quay Market",
              "mapLink": "https://www.google.com/maps/place/Lonsdale+Quay+Market",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Lonsdale_Quay_Market_in_North_Vancouver.jpg/1280px-Lonsdale_Quay_Market_in_North_Vancouver.jpg",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Museum of Anthropology at UBC",
              "description": "Visit the world-renowned Museum of Anthropology at the University of British Columbia (UBC), showcasing global art and cultural heritage, especially from First Nations of the Pacific Northwest.",
              "placeName": "Museum of Anthropology at UBC",
              "mapLink": "https://www.google.com/maps/place/Museum+of+Anthropology+at+UBC",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Museum_of_Anthropology_at_UBC_exterior.jpg/1280px-Museum_of_Anthropology_at_UBC_exterior.jpg",
              "ticketLink": "https://moa.ubc.ca/visit/admission/",
              "suggested_time": "09:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch & Relax at Kitsilano Beach",
              "description": "Enjoy a casual lunch in the Kitsilano neighbourhood. Grab some fish and chips from 'The Galley Patio & Grill' and relax at Kitsilano Beach, enjoying views of the city and mountains.",
              "placeName": "The Galley Patio & Grill",
              "mapLink": "https://www.google.com/maps/place/The+Galley+Patio+%26+Grill",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Kitsilano_Beach%2C_Vancouver.jpg/1280px-Kitsilano_Beach%2C_Vancouver.jpg",
              "suggested_time": "13:00"
            },
            {
              "name": "Last-Minute Souvenir Shopping",
              "description": "Do some last-minute souvenir shopping in Kitsilano or back in downtown Vancouver.",
              "placeName": "Robson Street",
              "mapLink": "https://www.google.com/maps/place/Robson+Street",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Robson_Street_at_night%2C_Vancouver.jpg/1280px-Robson_Street_at_night%2C_Vancouver.jpg",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Departure from Vancouver",
              "description": "Head to Vancouver International Airport (YVR) for your departure, reflecting on your World Cup and Vancouver experience.",
              "placeName": "Vancouver International Airport (YVR)",
              "mapLink": "https://www.google.com/maps/place/Vancouver+International+Airport",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Vancouver_International_Airport_Terminal.jpg/1280px-Vancouver_International_Airport_Terminal.jpg",
              "suggested_time": "18:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Japadog (Street Food)",
        "Granville Island Public Market (Variety of Stalls)",
        "Miku Waterfront (Aburi Sushi)",
        "New Town Bakery & Restaurant (Dim Sum & Baked Goods)",
        "Blue Water Cafe (Seafood)",
        "Hawksworth Restaurant (Fine Dining - Hotel Georgia)",
        "Poutine (Canadian Classic, try 'La Belle Patate')",
        "Nanaimo Bars (Dessert)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Live Nation Plaza or designated area)",
        "FIFA World Cup Match at BC Place",
        "Post-match celebrations at 'The Sportsbar LIVE! at Rogers Arena'",
        "Visiting official team merchandise stores",
        "Watching other matches at local sports bars (e.g., 'Library Square Public House')"
      ],
      "travel_tips": [
        "**How to reach BC Place:** BC Place is centrally located in downtown Vancouver at 777 Pacific Blvd. It is directly accessible via the Stadium-Chinatown SkyTrain station on both the Expo Line and Millennium Line. Buses also serve the area. Walking from most downtown hotels is also a viable option.",
        "**Where to stay:** For convenient access to BC Place and major attractions, consider staying in downtown Vancouver, Yaletown, Gastown, West End, or False Creek. These areas offer a range of accommodation options and are all within a 15-30 minute public transport ride to the stadium.",
        "**Public Transportation in Vancouver:** The public transportation system is managed by TransLink and includes the SkyTrain (automated metro), SeaBus (passenger ferry), and bus services. It's highly efficient for getting around the city and surrounding municipalities.",
        "**Recommended Public Transport Pass:** Purchase a **Compass Card** for seamless travel across all TransLink services. You can load stored value onto it or buy DayPasses (for unlimited travel within a day). Compass Cards can be purchased at SkyTrain stations, SeaBus terminals, London Drugs stores, and other retail outlets. Tap your Compass Card when entering and exiting SkyTrain/SeaBus stations, and when boarding a bus (only tap once when boarding a bus). Fares are zone-based for SkyTrain and SeaBus, but bus fares are single-zone regardless of distance.",
        "**Accessibility:** Vancouver's public transport system is generally accessible. BC Place is also fully accessible, with ramps, elevators, and accessible seating."
      ]
    },
    "7": {
      "plannerCity": "Vancouver",
      "matchDay": 4,
      "city": "Vancouver",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Vancouver International Airport (YVR), take the Canada Line SkyTrain to downtown, and check into your accommodation.",
              "placeName": "Vancouver International Airport (YVR)",
              "mapLink": "https://www.google.com/maps/place/Vancouver+International+Airport/@49.1939257,-123.1818274,15z/data=!4m6!3m5!1s0x54860b005128362b:0x393c593630f78550!8m2!3d49.1939257!4d-123.1818274!16s%2Fg%2F122_s1b9?entry=ttu",
              "imageUrl": "https://example.com/yvr_airport.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Gastown & Steam Clock",
              "description": "Wander through the historic Gastown district, admire the Victorian architecture, and witness the iconic Gastown Steam Clock.",
              "placeName": "Gastown Steam Clock",
              "mapLink": "https://www.google.com/maps/place/Gastown+Steam+Clock/@49.284249,-123.107089,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717f9d1469a3:0x1b79f83a8b417e3!8m2!3d49.284249!4d-123.107089!16s%2Fg%2F1210w4y6?entry=ttu",
              "imageUrl": "https://example.com/gastown_steamclock.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Steamworks Brewpub",
              "description": "Enjoy locally brewed craft beers and classic pub fare in a historic building overlooking the waterfront.",
              "placeName": "Steamworks Brewpub",
              "mapLink": "https://www.google.com/maps/place/Steamworks+Brewpub/@49.286202,-123.108608,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717f9e83161b:0x51c4a01c801c4021!8m2!3d49.286202!4d-123.108608!16s%2Fg%2F1tf7_z8s?entry=ttu",
              "imageUrl": "https://example.com/steamworks_brewpub.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Stanley Park Seawall & Totem Poles",
              "description": "Rent a bike or walk along a portion of the scenic Stanley Park Seawall, visiting the famous Totem Poles at Brockton Point.",
              "placeName": "Stanley Park Totem Poles",
              "mapLink": "https://www.google.com/maps/place/Stanley+Park+Totem+Poles/@49.300585,-123.111812,17z/data=!3m1!4b1!4m6!3m5!1s0x548671746f338d77:0x54477c772c6cf39e!8m2!3d49.300585!4d-123.111812!16s%2Fg%2F1thz7v_p?entry=ttu",
              "imageUrl": "https://example.com/stanley_park_totems.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Granville Island Public Market",
              "description": "Take an Aquabus or ferry to Granville Island, explore the vibrant public market, artisan shops, and grab lunch from one of the many food stalls.",
              "placeName": "Granville Island Public Market",
              "mapLink": "https://www.google.com/maps/place/Granville+Island+Public+Market/@49.271161,-123.137021,17z/data=!3m1!4b1!4m6!3m5!1s0x548673d32152778f:0x79493f0b2f0592b!8m2!3d49.271161!4d-123.137021!16s%2Fg%2F1tg96y5v?entry=ttu",
              "imageUrl": "https://example.com/granville_market.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Rodney's Oyster House",
              "description": "Savor fresh, local seafood and oysters in a lively atmosphere in Yaletown, a short walk or Aquabus ride from Granville Island.",
              "placeName": "Rodney's Oyster House Yaletown",
              "mapLink": "https://www.google.com/maps/place/Rodney's+Oyster+House+Yaletown/@49.274191,-123.120531,17z/data=!3m1!4b1!4m6!3m5!1s0x548673c2419c8f0f:0x1b1103c200508d5!8m2!3d49.274191!4d-123.120531!16s%2Fg%2F1td0k9n_?entry=ttu",
              "imageUrl": "https://example.com/rodneys_oyster_house.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Vancouver Art Gallery",
              "description": "Explore the impressive collections at the Vancouver Art Gallery, housed in a beautiful historic courthouse building.",
              "placeName": "Vancouver Art Gallery",
              "mapLink": "https://www.google.com/maps/place/Vancouver+Art+Gallery/@49.283151,-123.121516,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717ea960134f:0x1b1e9565538e11a2!8m2!3d49.283151!4d-123.121516!16s%2Fg%2F1tn7b47n?entry=ttu",
              "ticketLink": "https://www.vanartgallery.bc.ca/visit/tickets",
              "imageUrl": "https://example.com/vancouver_art_gallery.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Robson Street Shopping & Stroll",
              "description": "Enjoy an afternoon of browsing shops, people-watching, and grabbing a coffee on Vancouver's famous Robson Street.",
              "placeName": "Robson Street",
              "mapLink": "https://www.google.com/maps/place/Robson+St,+Vancouver,+BC/@49.284242,-123.128791,17z/data=!3m1!4b1!4m6!3m5!1s0x548673c004c27447:0x524458f4a13295e!8m2!3d49.284242!4d-123.128791!16s%2Fg%2F1tf7t38k?entry=ttu",
              "imageUrl": "https://example.com/robson_street.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Miku Vancouver (Aburi Sushi)",
              "description": "Experience Vancouver's renowned Aburi (flame-seared) sushi at the upscale Miku restaurant, offering stunning waterfront views.",
              "placeName": "Miku Vancouver",
              "mapLink": "https://www.google.com/maps/place/Miku+Vancouver/@49.287233,-123.114704,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717e30752531:0x3953587b64bf25c8!8m2!3d49.287233!4d-123.114704!16s%2Fg%2F1th3l_1m?entry=ttu",
              "imageUrl": "https://example.com/miku_vancouver.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival, with live music, food, and giant screens showing matches.",
              "placeName": "Concord Pacific Place (Potential Fan Festival Location)",
              "mapLink": "https://www.google.com/maps/place/Concord+Pacific+Place/@49.277864,-123.109151,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717ee261e4d1:0x14032d80d1964f43!8m2!3d49.277864!4d-123.109151!16s%2Fg%2F11b6x_740c?entry=ttu",
              "imageUrl": "https://example.com/fan_festival.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Walk to BC Place",
              "description": "Soak in the electric pre-match atmosphere around BC Place. Enjoy street performers, food vendors, and the excitement of fellow fans as you make your way to the stadium.",
              "placeName": "BC Place Stadium",
              "mapLink": "https://www.google.com/maps/place/BC+Place/@49.276667,-123.112693,17z/data=!3m1!4b1!4m6!3m5!1s0x548673c246f481c9:0x8479e001c36b132e!8m2!3d49.276667!4d-123.112693!16s%2Fg%2F1tf7_68h?entry=ttu",
              "imageUrl": "https://example.com/bc_place_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at BC Place",
              "description": "Experience the thrill of a live FIFA World Cup match at BC Place, the heart of Vancouver's football action.",
              "placeName": "BC Place Stadium",
              "mapLink": "https://www.google.com/maps/place/BC+Place/@49.276667,-123.112693,17z/data=!3m1!4b1!4m6!3m5!1s0x548673c246f481c9:0x8479e001c36b132e!8m2!3d49.276667!4d-123.112693!16s%2Fg%2F1tf7_68h?entry=ttu",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://example.com/bc_place_match.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "TELUS World of Science (Science World)",
              "description": "Visit the iconic geodesic dome of Science World, offering interactive exhibits for all ages, located at the end of False Creek.",
              "placeName": "TELUS World of Science",
              "mapLink": "https://www.google.com/maps/place/TELUS+World+of+Science/@49.273062,-123.109848,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717ee0302569:0x5b3310023447990b!8m2!3d49.273062!4d-123.109848!16s%2Fg%2F1tdw085c?entry=ttu",
              "ticketLink": "https://www.scienceworld.ca/tickets/",
              "imageUrl": "https://example.com/science_world.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Olympic Village & False Creek Seawall",
              "description": "Stroll through the modern Olympic Village, enjoy public art, and walk along the False Creek Seawall with scenic city and mountain views.",
              "placeName": "Olympic Village",
              "mapLink": "https://www.google.com/maps/place/Olympic+Village,+Vancouver,+BC/@49.271501,-123.107002,16z/data=!3m1!4b1!4m6!3m5!1s0x548673d3170e7e0f:0x65611110037a503a!8m2!3d49.271501!4d-123.107002!16s%2Fg%2F1td0g7h_?entry=ttu",
              "imageUrl": "https://example.com/olympic_village.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Craft Beer Market Olympic Village",
              "description": "Dine at the Craft Beer Market, offering a massive selection of local and international beers, along with elevated pub food, in the vibrant Olympic Village.",
              "placeName": "Craft Beer Market - Vancouver",
              "mapLink": "https://www.google.com/maps/place/CRAFT+Beer+Market+-+Vancouver/@49.270914,-123.107142,17z/data=!3m1!4b1!4m6!3m5!1s0x5486717e3350280f:0x5e089222622956c3!8m2!3d49.270914!4d-123.107142!16s%2Fg%2F1th3j39h?entry=ttu",
              "imageUrl": "https://example.com/craft_beer_market.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Day Trip to Capilano Suspension Bridge Park",
              "description": "Venture north for a thrilling experience at Capilano Suspension Bridge Park, featuring the iconic bridge, Treetops Adventure, and Cliffwalk. (Approx. 30-45 min drive from downtown, free shuttle available).",
              "placeName": "Capilano Suspension Bridge Park",
              "mapLink": "https://www.google.com/maps/place/Capilano+Suspension+Bridge+Park/@49.344405,-123.114757,17z/data=!3m1!4b1!4m6!3m5!1s0x548671c668352b2f:0x2289c02506b3a322!8m2!3d49.344405!4d-123.114757!16s%2Fg%2F1td09n69?entry=ttu",
              "ticketLink": "https://www.capbridge.com/visit/tickets/",
              "imageUrl": "https://example.com/capilano_bridge.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch and Exploration at Capilano",
              "description": "Enjoy lunch at one of the cafes within Capilano Suspension Bridge Park and continue exploring its various attractions.",
              "placeName": "Capilano Suspension Bridge Park",
              "mapLink": "https://www.google.com/maps/place/Capilano+Suspension+Bridge+Park/@49.344405,-123.114757,17z/data=!3m1!4b1!4m6!3m5!1s0x548671c668352b2f:0x2289c02506b3a322!8m2!3d49.344405!4d-123.114757!16s%2Fg%2F1td09n69?entry=ttu",
              "imageUrl": "https://example.com/capilano_park.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Kitsilano",
              "description": "Return to the city and head to the Kitsilano neighborhood for a relaxed dinner. Consider 'Nook Restaurant' for delicious Italian food.",
              "placeName": "Nook Restaurant Kitsilano",
              "mapLink": "https://www.google.com/maps/place/Nook/@49.266299,-123.167884,17z/data=!3m1!4b1!4m6!3m5!1s0x5486738981f42111:0x4d3b6f2e82510255!8m2!3d49.266299!4d-123.167884!16s%2Fg%2F1td01j4k?entry=ttu",
              "imageUrl": "https://example.com/nook_kitsilano.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Breakfast at Cafe Medina & Souvenir Shopping",
              "description": "Enjoy a famous Belgian waffle breakfast at 'Cafe Medina' before heading out for some last-minute souvenir shopping in downtown Vancouver.",
              "placeName": "Cafe Medina",
              "mapLink": "https://www.google.com/maps/place/Cafe+Medina/@49.278912,-123.111867,17z/data=!3m1!4b1!4m6!3m5!1s0x548673c2419c8f0f:0x7e3c3b0e1b6f6580!8m2!3d49.278912!4d-123.111867!16s%2Fg%2F1td0k9n_?entry=ttu",
              "imageUrl": "https://example.com/cafe_medina.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Vancouver",
              "description": "Head back to Vancouver International Airport (YVR) via the Canada Line SkyTrain for your departure.",
              "placeName": "Vancouver International Airport (YVR)",
              "mapLink": "https://www.google.com/maps/place/Vancouver+International+Airport/@49.1939257,-123.1818274,15z/data=!4m6!3m5!1s0x54860b005128362b:0x393c593630f78550!8m2!3d49.1939257!4d-123.1818274!16s%2Fg%2F122_s1b9?entry=ttu",
              "imageUrl": "https://example.com/yvr_departure.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Japadog (Japanese-style hot dogs from street vendors)",
        "Poutine (Canadian classic, try a local twist)",
        "Fresh Seafood (especially Pacific Salmon and Oysters)",
        "Aburi Sushi (flame-seared sushi, a Vancouver specialty)",
        "Craft Beer (explore Vancouver's vibrant brewery scene)",
        "Nanaimo Bars (classic Canadian no-bake dessert)",
        "Dim Sum (Richmond, a short SkyTrain ride, offers world-class dim sum)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (official fan zones with live broadcasts, entertainment, and food)",
        "FIFA World Cup Match at BC Place (the ultimate match day experience)",
        "Pre-match gatherings and celebrations around BC Place",
        "Watching other matches at local sports pubs (e.g., Yaletown Brewing Company, The Pint Public House)"
      ],
      "travel_tips": [
        "How to reach BC Place: The stadium is centrally located and easily accessible via TransLink's SkyTrain. Take the Expo Line or Millennium Line to 'Stadium-Chinatown' Station, which is directly adjacent to BC Place.",
        "Where to stay: Consider staying in downtown Vancouver neighborhoods such as Yaletown, Gastown, Coal Harbour, or West End. These areas offer excellent access to public transportation, are within walking distance or a short ride to BC Place, and provide a wide range of dining and entertainment options. Olympic Village is also a great choice with good transit links.",
        "Public Transportation: Vancouver's public transit system is operated by TransLink and includes SkyTrain (light rapid transit), SeaBus (passenger ferry), and buses. Purchase a 'Compass Card' (available at SkyTrain stations, London Drugs, and 7-Eleven stores) for convenient tap-on/tap-off travel across all modes. You can load Stored Value or DayPasses onto the card. The system is efficient and covers most major attractions and neighborhoods.",
        "Weather: Vancouver can be rainy, especially outside of summer. Pack layers and waterproof outerwear, even in June/July, as weather can be unpredictable.",
        "Connectivity: Free public Wi-Fi is available in many cafes, restaurants, and public spaces. Consider a local SIM card or eSIM for consistent data access."
      ]
    }
  },
  "toronto": {
    "3": {
      "plannerCity": "Toronto",
      "matchDay": 2,
      "city": "Toronto",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Visit the CN Tower",
              "description": "Ascend to the top of Toronto's iconic CN Tower for breathtaking panoramic views of the city and Lake Ontario. A symbol of Toronto, offering an unparalleled perspective.",
              "placeName": "CN Tower",
              "mapLink": "https://www.google.com/maps/place/CN+Tower",
              "ticketLink": "https://www.cntower.ca/tickets",
              "imageUrl": "https://example.com/cntower.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Breakfast at Fran's Restaurant",
              "description": "Enjoy a classic Canadian breakfast at a beloved Toronto institution. Famous for its all-day breakfast and comfort food.",
              "placeName": "Fran's Restaurant (Victoria St)",
              "mapLink": "https://www.google.com/maps/place/Fran's+Restaurant+and+Bar",
              "imageUrl": "https://example.com/frans_restaurant.jpg",
              "best_time": "morning",
              "suggested_time": "08:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Ripley's Aquarium of Canada",
              "description": "Discover a mesmerizing underwater world with diverse marine life, interactive exhibits, and the thrilling Dangerous Lagoon tunnel.",
              "placeName": "Ripley's Aquarium of Canada",
              "mapLink": "https://www.google.com/maps/place/Ripley's+Aquarium+of+Canada",
              "ticketLink": "https://www.ripleyaquariums.com/canada/tickets/",
              "imageUrl": "https://example.com/ripleys_aquarium.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at Amsterdam Brewhouse on the Lake",
              "description": "Savor delicious pub fare and craft beers with stunning views of Lake Ontario and the city skyline from this waterfront brewery.",
              "placeName": "Amsterdam Brewhouse on the Lake",
              "mapLink": "https://www.google.com/maps/place/Amsterdam+Brewhouse+on+the+Lake",
              "imageUrl": "https://example.com/amsterdam_brewhouse.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Stroll through the Historic Distillery District",
              "description": "Wander through the charming cobblestone streets of the Distillery District, a pedestrian-only village filled with Victorian-era industrial architecture, boutiques, galleries, and cafes.",
              "placeName": "Distillery District",
              "mapLink": "https://www.google.com/maps/place/The+Distillery+District",
              "imageUrl": "https://example.com/distillery_district.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at El Catrin Destileria",
              "description": "Indulge in authentic Mexican cuisine and creative cocktails in a vibrant and beautifully decorated setting within the Distillery District.",
              "placeName": "El Catrin Destileria",
              "mapLink": "https://www.google.com/maps/place/El+Catrin+Destileria",
              "imageUrl": "https://example.com/el_catrin.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, cultural performances, food stalls, and interactive football activities.",
              "placeName": "FIFA Fan Festival (Exhibition Place)",
              "mapLink": "https://www.google.com/maps/place/Exhibition+Place",
              "imageUrl": "https://example.com/fifa_fanfest.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Brunch at Liberty Commons at Big Rock Brewery",
              "description": "Enjoy a hearty brunch with craft beer options in Liberty Village, just a short walk from Exhibition Place, perfect for fueling up before the match.",
              "placeName": "Liberty Commons at Big Rock Brewery",
              "mapLink": "https://www.google.com/maps/place/Liberty+Commons+at+Big+Rock+Brewery",
              "imageUrl": "https://example.com/liberty_commons.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities & Fan Walk to BMO Field",
              "description": "Join fellow fans in the vibrant pre-match celebrations around Exhibition Place. Experience the excitement building up as you make your way to BMO Field.",
              "placeName": "BMO Field (Exhibition Place)",
              "mapLink": "https://www.google.com/maps/place/BMO+Field",
              "imageUrl": "https://example.com/bmo_prematch.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at BMO Field",
              "description": "Experience the thrill of a live FIFA World Cup match at BMO Field, home of Toronto FC. Witness world-class football in an electric stadium atmosphere.",
              "placeName": "BMO Field",
              "mapLink": "https://www.google.com/maps/place/BMO+Field",
              "ticketLink": "https://www.fifa.com/worldcup/2026/tickets",
              "imageUrl": "https://example.com/bmo_field_match.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Post-Match Dinner at Real Sports Bar & Grill",
              "description": "Continue the football excitement at one of North America's premier sports bars. Enjoy a lively atmosphere, massive screens, and classic pub fare after the match.",
              "placeName": "Real Sports Bar & Grill",
              "mapLink": "https://www.google.com/maps/place/Real+Sports+Bar+%26+Grill",
              "imageUrl": "https://example.com/real_sports_bar.jpg",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Discover the Royal Ontario Museum (ROM)",
              "description": "Explore Canada's largest museum, featuring a diverse collection spanning art, culture, and natural history from around the world and across the ages.",
              "placeName": "Royal Ontario Museum (ROM)",
              "mapLink": "https://www.google.com/maps/place/Royal+Ontario+Museum",
              "ticketLink": "https://www.rom.on.ca/en/visit/plan-your-visit/tickets",
              "imageUrl": "https://example.com/rom_museum.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Brunch at Flo's Diner",
              "description": "Step back in time at this retro-themed diner in Yorkville, offering classic breakfast and brunch dishes in a cozy, nostalgic setting.",
              "placeName": "Flo's Diner",
              "mapLink": "https://www.google.com/maps/place/Flo's+Diner",
              "imageUrl": "https://example.com/flos_diner.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Kensington Market",
              "description": "Wander through the eclectic and bohemian streets of Kensington Market, a vibrant neighborhood known for its vintage shops, independent boutiques, street art, and diverse food vendors.",
              "placeName": "Kensington Market",
              "mapLink": "https://www.google.com/maps/place/Kensington+Market",
              "imageUrl": "https://example.com/kensington_market.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at Seven Lives Tacos y Mariscos",
              "description": "Experience some of Toronto's most celebrated tacos at this popular Kensington Market spot, known for its fresh ingredients and authentic flavors.",
              "placeName": "Seven Lives Tacos y Mariscos",
              "mapLink": "https://www.google.com/maps/place/Seven+Lives+Tacos+y+Mariscos",
              "imageUrl": "https://example.com/seven_lives_tacos.jpg",
              "best_time": "afternoon",
              "suggested_time": "12:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner on Queen Street West",
              "description": "Enjoy a final dinner in the trendy Queen Street West area, known for its fashion, art, and diverse culinary scene.",
              "placeName": "Terroni (Queen Street West)",
              "mapLink": "https://www.google.com/maps/place/Terroni+-+Queen",
              "imageUrl": "https://example.com/terroni_queen.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Poutine (classic Canadian dish of fries, cheese curds, and gravy)",
        "Peameal Bacon Sandwich (a Toronto specialty, especially from St. Lawrence Market)",
        "Tim Hortons (iconic Canadian coffee and donut chain)",
        "Diverse international cuisine (e.g., tacos in Kensington Market, Italian on College St, dim sum in Chinatown)",
        "Craft Beer from local breweries (e.g., Amsterdam Brewery, Steam Whistle)"
      ],
      "football_experiences": [
        "FIFA Fan Festival at Exhibition Place (official fan zone with live screenings, entertainment, and food)",
        "FIFA World Cup Match at BMO Field (experiencing a live World Cup game)",
        "Real Sports Bar & Grill (one of North America's largest sports bars for a vibrant match-watching atmosphere)",
        "Walking through Exhibition Place on match day (soaking in the pre-match energy and fan activities)"
      ],
      "travel_tips": [
        {
          "name": "How to Reach BMO Field",
          "description": "BMO Field is located at Exhibition Place. It is easily accessible via public transit. Take the 509 Harbourfront streetcar or 511 Bathurst streetcar directly to Exhibition Place. Alternatively, take the GO Train Lakeshore West line to Exhibition GO Station from Union Station. Walking from the Exhibition GO Station to BMO Field is approximately 10-15 minutes.",
          "imageUrl": "https://example.com/ttc_streetcar.jpg"
        },
        {
          "name": "Where to Stay",
          "description": "Recommended areas for accommodation within 60 minutes of BMO Field (via public transport) include: Downtown Toronto (Financial District, Entertainment District), Harbourfront, Liberty Village (closest to BMO Field, trendy), Queen West, and King West. These areas offer a range of hotels and are well-connected by the TTC.",
          "imageUrl": "https://example.com/toronto_skyline.jpg"
        },
        {
          "name": "Public Transportation in Toronto",
          "description": "Toronto's public transit is operated by the Toronto Transit Commission (TTC), which includes subways, streetcars, and buses. The most convenient way to pay for fares is with a PRESTO card, a rechargeable smart card that can be purchased and loaded with funds at subway stations, Shoppers Drug Mart stores, or online. Single-use PRESTO tickets are also available. Google Maps or the official TTC app are excellent resources for planning routes. GO Transit provides regional commuter rail and bus services, useful for connections like Union Station to Exhibition Place.",
          "imageUrl": "https://example.com/presto_card.jpg"
        }
      ]
    },
    "5": {
      "plannerCity": "Toronto",
      "matchDay": 3,
      "city": "Toronto",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Check-in",
              "description": "Arrive in Toronto, check into your accommodation. Head to Union Station, a major transportation hub and architectural marvel.",
              "placeName": "Union Station",
              "mapLink": "https://www.google.com/maps/place/Union+Station/@43.6456,-79.3807,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Union_Station_Toronto_2016.jpg/1920px-Union_Station_Toronto_2016.jpg",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Breakfast at St. Lawrence Market",
              "description": "Grab a classic Toronto peameal bacon sandwich from Carousel Bakery or explore other vendors at this historic market.",
              "placeName": "St. Lawrence Market",
              "mapLink": "https://www.google.com/maps/place/St.+Lawrence+Market/@43.6482,-79.3725,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/St._Lawrence_Market_South_Building.jpg/1920px-St._Lawrence_Market_South_Building.jpg",
              "suggested_time": "11:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "CN Tower Experience",
              "description": "Ascend to the top of the iconic CN Tower for breathtaking panoramic views of Toronto and Lake Ontario. Consider the EdgeWalk for an extra thrill.",
              "placeName": "CN Tower",
              "mapLink": "https://www.google.com/maps/place/CN+Tower/@43.6426,-79.3871,17z",
              "ticketLink": "https://www.ticketmaster.ca/cn-tower-tickets/artist/806148",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/CN_Tower_from_the_water.jpg/1920px-CN_Tower_from_the_water.jpg",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Explore Ripley's Aquarium of Canada",
              "description": "Dive into an underwater world with various marine species, including sharks, stingrays, and colorful fish, located right next to the CN Tower.",
              "placeName": "Ripley's Aquarium of Canada",
              "mapLink": "https://www.google.com/maps/place/Ripley's+Aquarium+of+Canada/@43.6423,-79.3871,17z",
              "ticketLink": "https://www.ripleyaquariums.com/canada/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Ripley%27s_Aquarium_of_Canada_2017.jpg/1920px-Ripley%27s_Aquarium_of_Canada_2017.jpg",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in the Entertainment District",
              "description": "Enjoy dinner at El Caballito Tequila Bar for Mexican cuisine and a vibrant atmosphere, or explore other restaurants in the bustling Entertainment District.",
              "placeName": "El Caballito Tequila Bar",
              "mapLink": "https://www.google.com/maps/place/El+Caballito/@43.6468,-79.3892,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/17/c3/b3/f5/el-caballito-tequila-bar.jpg",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Evening Stroll along Harbourfront Centre",
              "description": "Take a leisurely walk along the waterfront, enjoying the city lights and lake views.",
              "placeName": "Harbourfront Centre",
              "mapLink": "https://www.google.com/maps/place/Harbourfront+Centre/@43.6393,-79.3846,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Harbourfront_Centre_building.jpg/1920px-Harbourfront_Centre_building.jpg",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Royal Ontario Museum (ROM)",
              "description": "Explore Canada's largest museum with diverse collections covering art, culture, and natural history from around the world and across the ages.",
              "placeName": "Royal Ontario Museum",
              "mapLink": "https://www.google.com/maps/place/Royal+Ontario+Museum/@43.6677,-79.3948,17z",
              "ticketLink": "https://www.rom.on.ca/en/visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/ROM_Crystal_entrance.jpg/1920px-ROM_Crystal_entrance.jpg",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Kensington Market Exploration",
              "description": "Wander through the eclectic and bohemian Kensington Market, known for its vintage shops, street art, unique boutiques, and diverse food scene.",
              "placeName": "Kensington Market",
              "mapLink": "https://www.google.com/maps/place/Kensington+Market/@43.6542,-79.4005,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Kensington_Market_Toronto.jpg/1920px-Kensington_Market_Toronto.jpg",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Lunch at Seven Lives Tacos y Mariscos",
              "description": "Enjoy highly-rated, authentic Baja-style tacos at this popular Kensington Market eatery.",
              "placeName": "Seven Lives Tacos y Mariscos",
              "mapLink": "https://www.google.com/maps/place/Seven+Lives+Tacos+y+Mariscos/@43.6542,-79.4005,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0b/49/b4/0f/seven-lives-tacos-y-mariscos.jpg",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Chinatown",
              "description": "Experience the vibrant atmosphere and delicious cuisine of Toronto's Chinatown. Enjoy traditional dim sum or other Chinese dishes at Rol San Restaurant.",
              "placeName": "Rol San Restaurant",
              "mapLink": "https://www.google.com/maps/place/Rol+San+Restaurant/@43.6547,-79.3989,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0e/75/e2/0a/rol-san-restaurant.jpg",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Explore Queen Street West",
              "description": "Take an evening stroll down Queen Street West, known for its indie boutiques, art galleries, and live music venues.",
              "placeName": "Queen Street West",
              "mapLink": "https://www.google.com/maps/place/Queen+Street+West,+Toronto,+ON/@43.6496,-79.4022,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Queen_Street_West_at_Spadina_Avenue%2C_Toronto.jpg/1920px-Queen_Street_West_at_Spadina_Avenue%2C_Toronto.jpg",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Fest Activation",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Fest. Enjoy live music, food, games, and interact with fellow fans. (Location TBD, typically downtown or near the stadium).",
              "placeName": "FIFA Fan Fest (Downtown Toronto)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Fest+Toronto",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/FIFA_Fan_Fest_at_Berlin_Brandenburg_Gate_in_2006.jpg/1920px-FIFA_Fan_Fest_at_Berlin_Brandenburg_Gate_in_2006.jpg",
              "suggested_time": "10:00 AM"
            },
            {
              "name": "Football-themed Brunch",
              "description": "Enjoy a relaxed brunch at a sports bar or cafe, soaking in the football atmosphere before heading to the stadium.",
              "placeName": "Real Sports Bar & Grill",
              "mapLink": "https://www.google.com/maps/place/Real+Sports/@43.6433,-79.3797,17z",
              "imageUrl": "https://realsports.ca/wp-content/uploads/2023/06/RSBG_Exterior_1920x1080.jpg",
              "suggested_time": "12:00 PM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities at Exhibition Place",
              "description": "Arrive early at Exhibition Place, home of BMO Field. Enjoy the vibrant atmosphere, explore vendor stalls, and participate in pre-match activities around the stadium grounds.",
              "placeName": "Exhibition Place",
              "mapLink": "https://www.google.com/maps/place/Exhibition+Place/@43.6338,-79.4184,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Princes%27_Gates_at_Exhibition_Place%2C_Toronto.jpg/1920px-Princes%27_Gates_at_Exhibition_Place%2C_Toronto.jpg",
              "suggested_time": "03:00 PM"
            },
            {
              "name": "Dinner at Local Public Eatery (Liberty Village)",
              "description": "Grab a casual pre-match meal or drinks at this popular spot in Liberty Village, just a short walk from BMO Field, known for its lively pub atmosphere.",
              "placeName": "Local Public Eatery Liberty Village",
              "mapLink": "https://www.google.com/maps/place/LOCAL+Liberty+Village/@43.6373,-79.4124,17z",
              "imageUrl": "https://static.wixstatic.com/media/89311d_24523d46a6f140689b7084620f4c0a52~mv2.jpg/v1/fill/w_1000,h_563,al_c,q_85,usm_0.66_1.00_0.01/89311d_24523d46a6f140689b7084620f4c0a52~mv2.jpg",
              "suggested_time": "05:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at BMO Field",
              "description": "Experience the thrill of a live FIFA World Cup match at BMO Field! Soak in the electric atmosphere, cheer for your team, and be part of football history.",
              "placeName": "BMO Field",
              "mapLink": "https://www.google.com/maps/place/BMO+Field/@43.6328,-79.4187,17z",
              "ticketLink": "https://www.fifa.com/worldcup/2026/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/BMO_Field_Toronto.jpg/1920px-BMO_Field_Toronto.jpg",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Toronto Islands Ferry Ride",
              "description": "Take a scenic ferry ride from Jack Layton Ferry Terminal to the Toronto Islands, enjoying stunning views of the city skyline.",
              "placeName": "Jack Layton Ferry Terminal",
              "mapLink": "https://www.google.com/maps/place/Jack+Layton+Ferry+Terminal/@43.6391,-79.3776,17z",
              "ticketLink": "https://www.toronto.ca/explore-enjoy/parks-gardens-beaches/toronto-island-park/ferry-schedule-fares/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Toronto_Island_Ferry.jpg/1920px-Toronto_Island_Ferry.jpg",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Centre Island",
              "description": "Rent a bike, relax on the beach, visit the petting zoo, or simply enjoy the car-free tranquility and panoramic city views from Centre Island.",
              "placeName": "Centre Island",
              "mapLink": "https://www.google.com/maps/place/Centre+Island/@43.6214,-79.3789,15z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Toronto_skyline_from_Centre_Island.jpg/1920px-Toronto_skyline_from_Centre_Island.jpg",
              "suggested_time": "12:00 PM"
            },
            {
              "name": "Lunch at Rectory Cafe (Centre Island)",
              "description": "Enjoy a casual meal with beautiful views at Rectory Cafe, one of the popular dining options on Centre Island.",
              "placeName": "Rectory Cafe",
              "mapLink": "https://www.google.com/maps/place/The+Rectory+Cafe/@43.6214,-79.3789,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0f/22/07/74/photo0jpg.jpg",
              "suggested_time": "01:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Distillery District Exploration",
              "description": "Step back in time in the historic Distillery District, a pedestrian-only village filled with Victorian-era buildings, unique shops, art galleries, and renowned restaurants.",
              "placeName": "Distillery District",
              "mapLink": "https://www.google.com/maps/place/The+Distillery+District/@43.6504,-79.3584,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Distillery_District_street_in_Toronto.jpg/1920px-Distillery_District_street_in_Toronto.jpg",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner at Cluny Bistro & Boulangerie",
              "description": "Indulge in French-inspired cuisine in the elegant and charming setting of Cluny Bistro, a highlight of the Distillery District's culinary scene.",
              "placeName": "Cluny Bistro & Boulangerie",
              "mapLink": "https://www.google.com/maps/place/Cluny+Bistro+%26+Boulangerie/@43.6504,-79.3584,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/06/f0/a2/28/cluny-bistro.jpg",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Art Gallery of Ontario (AGO)",
              "description": "Visit one of North America's largest art museums, featuring an impressive collection of Canadian, Indigenous, European, and contemporary art.",
              "placeName": "Art Gallery of Ontario",
              "mapLink": "https://www.google.com/maps/place/Art+Gallery+of+Ontario/@43.6536,-79.3927,17z",
              "ticketLink": "https://ago.ca/plan-your-visit/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Art_Gallery_of_Ontario_2016.jpg/1920px-Art_Gallery_of_Ontario_2016.jpg",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Shopping at Toronto Eaton Centre",
              "description": "Enjoy some last-minute shopping at the Toronto Eaton Centre, a large, bright, and airy multi-level shopping mall in the heart of downtown.",
              "placeName": "Toronto Eaton Centre",
              "mapLink": "https://www.google.com/maps/place/CF+Toronto+Eaton+Centre/@43.6544,-79.3807,17z",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Toronto_Eaton_Centre.jpg/1920px-Toronto_Eaton_Centre.jpg",
              "suggested_time": "01:30 PM"
            },
            {
              "name": "Lunch at Kinton Ramen (Queen West)",
              "description": "Savor a delicious and authentic bowl of ramen at Kinton Ramen on Queen Street West, a popular spot for Japanese comfort food.",
              "placeName": "Kinton Ramen (Queen West)",
              "mapLink": "https://www.google.com/maps/place/Kinton+Ramen/@43.6496,-79.3986,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0d/95/92/83/kinton-ramen.jpg",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at Richmond Station",
              "description": "Enjoy a sophisticated farewell dinner at Richmond Station, a chef-owned and operated restaurant focusing on seasonal Canadian ingredients.",
              "placeName": "Richmond Station",
              "mapLink": "https://www.google.com/maps/place/Richmond+Station/@43.6517,-79.3812,17z",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0d/17/23/e8/richmond-station.jpg",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Departure Preparations",
              "description": "Head back to your accommodation to collect luggage and prepare for departure from Toronto.",
              "placeName": "Toronto Pearson International Airport (YYZ)",
              "mapLink": "https://www.google.com/maps/place/Toronto+Pearson+International+Airport/@43.6817,-79.6120,17z",
              "suggested_time": "09:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Peameal Bacon Sandwich at St. Lawrence Market",
        "Poutine (various locations, e.g., Poutini's House of Poutine)",
        "Baja-style Tacos at Seven Lives Tacos y Mariscos (Kensington Market)",
        "Dim Sum in Chinatown (e.g., Rol San Restaurant)",
        "Ramen at Kinton Ramen",
        "Upscale Canadian cuisine at Richmond Station"
      ],
      "football_experiences": [
        "FIFA Fan Fest (location TBD, likely downtown)",
        "Pre-match festivities and fan activities at Exhibition Place around BMO Field",
        "Attending a live FIFA World Cup match at BMO Field",
        "Visiting sports bars in the Entertainment District or Liberty Village on match days"
      ],
      "travel_tips": [
        "How to reach BMO Field: BMO Field is located at Exhibition Place. The easiest ways to get there are by TTC streetcar (509 Harbourfront or 511 Bathurst lines) to Exhibition Loop, or by GO Transit train (Lakeshore West line) to Exhibition Station. Both options drop you directly at Exhibition Place, a short walk from the stadium.",
        "Where to stay: Consider areas like Downtown Toronto, the Entertainment District, Harbourfront, and Liberty Village. These areas are centrally located, offer a wide range of accommodation options, and are well-connected by public transit, ensuring you can reach BMO Field and other attractions within 60 minutes or less.",
        "Public Transportation: Toronto's public transit system is operated by the Toronto Transit Commission (TTC), which includes subways, streetcars, and buses. For regional travel, GO Transit offers commuter trains and buses. We highly recommend purchasing a PRESTO card, a reloadable fare card that allows for tap-and-go payments on all TTC and GO Transit services. You can load money or passes onto the card. Single fares are also available but a PRESTO card offers convenience and often better value for multiple trips. Day passes or weekly passes might be cost-effective depending on your usage."
      ]
    },
    "7": {
      "plannerCity": "Toronto",
      "matchDay": 4,
      "city": "Toronto",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Toronto Pearson International Airport (YYZ), take the UP Express train to Union Station, and check into your hotel in a central area like Downtown, Entertainment District, or Harbourfront.",
              "placeName": "Toronto Pearson International Airport (YYZ)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "CN Tower Visit",
              "description": "Ascend to the top of Toronto's most iconic landmark for breathtaking panoramic views of the city and Lake Ontario. Don't miss the Glass Floor!",
              "placeName": "CN Tower",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at PAI Northern Thai Kitchen (Downtown)",
              "description": "Enjoy authentic Northern Thai cuisine, famous for its flavourful curries and noodles, in a vibrant atmosphere.",
              "placeName": "PAI Northern Thai Kitchen (Downtown)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Explore the Distillery District",
              "description": "Wander through the charming pedestrian-only streets of the historic Distillery District, home to Victorian-era industrial buildings, unique boutiques, art galleries, and cafes.",
              "placeName": "Distillery District",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "18:00"
            },
            {
              "name": "Dinner at El Catrin Destileria",
              "description": "Savour modern Mexican cuisine and creative cocktails in the beautiful, lively setting of El Catrin Destileria in the Distillery District.",
              "placeName": "El Catrin Destileria",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Royal Ontario Museum (ROM)",
              "description": "Discover art, culture, and natural history from around the world at Canada's largest museum. Explore dinosaur exhibits, ancient civilizations, and Canadian art.",
              "placeName": "Royal Ontario Museum (ROM)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Kensington Market Exploration",
              "description": "Immerse yourself in the bohemian atmosphere of Kensington Market, known for its eclectic shops, vintage stores, street art, and diverse food vendors.",
              "placeName": "Kensington Market",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Lunch at Rasta Pasta (Kensington Market)",
              "description": "Experience delicious Jamaican-Italian fusion cuisine with a casual vibe in the heart of Kensington Market.",
              "placeName": "Rasta Pasta",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Drinks in Queen West",
              "description": "Enjoy an evening in the trendy Queen West neighbourhood, known for its live music venues, art galleries, and diverse dining options.",
              "placeName": "Queen West",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Ferry to Toronto Islands",
              "description": "Take a scenic ferry ride across Lake Ontario to the Toronto Islands, offering stunning views of the city skyline and a peaceful escape.",
              "placeName": "Jack Layton Ferry Terminal",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Toronto Islands and Lunch",
              "description": "Rent a bike, stroll along the beaches, visit Centreville Amusement Park (seasonal), or simply relax and enjoy the serene environment. Grab a casual lunch at a cafe on the island.",
              "placeName": "Toronto Islands",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "12:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Harbourfront Centre",
              "description": "Enjoy dinner at one of the many restaurants along the bustling Harbourfront Centre, with views of the lake and city lights.",
              "placeName": "Harbourfront Centre",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Festival. Enjoy live music, cultural performances, food, and interactive football activities.",
              "placeName": "Nathan Phillips Square (or designated Fan Festival location)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere & Travel to BMO Field",
              "description": "Soak in the vibrant atmosphere, grab some fan merchandise, and make your way to BMO Field via TTC streetcar (509 Harbourfront or 511 Bathurst) to Exhibition Place.",
              "placeName": "Exhibition Place / BMO Field",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            },
            {
              "name": "Pre-match Meal near BMO Field",
              "description": "Grab a quick and casual meal or snack at one of the vendors or restaurants within Exhibition Place before heading into the stadium.",
              "placeName": "Exhibition Place",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "17:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at BMO Field",
              "description": "Experience the thrill of a live FIFA World Cup match at BMO Field. Enjoy the game, the roaring crowd, and the unforgettable atmosphere.",
              "placeName": "BMO Field",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "St. Lawrence Market Exploration",
              "description": "Visit the historic St. Lawrence Market, a foodie paradise. Explore the South Market for fresh produce, baked goods, and prepared foods.",
              "placeName": "St. Lawrence Market",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Peameal Bacon Sandwich at Carousel Bakery",
              "description": "Indulge in Toronto's iconic Peameal Bacon Sandwich, a local favourite, from Carousel Bakery inside St. Lawrence Market.",
              "placeName": "Carousel Bakery (St. Lawrence Market)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Hockey Hall of Fame",
              "description": "Even if you're a football fan, explore Canada's other national passion at the Hockey Hall of Fame, home to the Stanley Cup and countless hockey artifacts.",
              "placeName": "Hockey Hall of Fame",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in the Entertainment District",
              "description": "Enjoy dinner at one of the many restaurants in Toronto's bustling Entertainment District, followed by a show or drinks.",
              "placeName": "Entertainment District",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Graffiti Alley and Queen West Breakfast",
              "description": "Wander through Graffiti Alley (Rush Lane) to admire vibrant street art, then enjoy breakfast at a cafe in the trendy Queen West neighbourhood.",
              "placeName": "Graffiti Alley (Rush Lane)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Art Gallery of Ontario (AGO)",
              "description": "Visit one of the largest art museums in North America, featuring a diverse collection ranging from Canadian and Indigenous art to European masterpieces and contemporary works.",
              "placeName": "Art Gallery of Ontario (AGO)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Little Italy",
              "description": "Experience the vibrant atmosphere and delicious Italian cuisine of Toronto's Little Italy. Enjoy classic dishes and a lively street scene.",
              "placeName": "Little Italy (College Street)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Last-Minute Souvenir Shopping",
              "description": "Grab any last-minute gifts or souvenirs at places like the Eaton Centre or unique shops downtown.",
              "placeName": "CF Toronto Eaton Centre",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Brunch at Mildred's Temple Kitchen",
              "description": "Enjoy a famous brunch experience at Mildred's Temple Kitchen in Liberty Village, known for its delicious pancakes and creative dishes.",
              "placeName": "Mildred's Temple Kitchen",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "morning",
              "suggested_time": "11:00"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Toronto Pearson International Airport (YYZ)",
              "description": "Head back to Toronto Pearson International Airport (YYZ) via the UP Express for your departure.",
              "placeName": "Toronto Pearson International Airport (YYZ)",
              "ticketLink": "N/A",
              "imageUrl": "N/A",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Peameal Bacon Sandwich from Carousel Bakery at St. Lawrence Market",
        "Northern Thai cuisine from PAI Northern Thai Kitchen",
        "Modern Mexican at El Catrin Destileria in the Distillery District",
        "Jamaican-Italian fusion at Rasta Pasta in Kensington Market",
        "Brunch at Mildred's Temple Kitchen"
      ],
      "football_experiences": [
        "FIFA Fan Festival (likely Nathan Phillips Square or Exhibition Place)",
        "FIFA World Cup Match at BMO Field",
        "Pre-match atmosphere and fan zones around BMO Field"
      ],
      "travel_tips": [
        "Public Transportation: Toronto's public transit system is operated by the TTC (Toronto Transit Commission), which includes subways, streetcars, and buses. It is efficient for navigating the city.",
        "PRESTO Card: Purchase a PRESTO card at subway stations, Shoppers Drug Mart, or online. Load it with funds or a weekly pass for convenient travel. You can also pay with contactless credit/debit on TTC.",
        "To BMO Field: BMO Field is located at Exhibition Place. From downtown, take the 509 Harbourfront or 511 Bathurst streetcar west to Exhibition Loop. These streetcars can be accessed from Union Station (509) or Bathurst Station (511). Travel time is typically 15-25 minutes from downtown.",
        "Accommodation: Stay in central areas like Downtown, Entertainment District, Harbourfront, or Queen West. These areas offer excellent access to public transport, tourist attractions, and are within 30-45 minutes of BMO Field via TTC.",
        "Walking: Toronto is a walkable city, especially in its downtown core and various neighbourhoods. Don't hesitate to explore on foot.",
        "Accessibility: The TTC system has accessible routes and stations, but it's advisable to check the TTC website for real-time elevator/escalator status."
      ]
    }
  },
  "mexico-city": {
    "3": {
      "plannerCity": "Mexico City",
      "matchDay": 2,
      "city": "Mexico City",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore the Zócalo and Metropolitan Cathedral",
              "description": "Begin your day at the historic heart of Mexico City, the Plaza de la Constitución, known as the Zócalo. Visit the stunning Metropolitan Cathedral, a masterpiece of colonial architecture.",
              "placeName": "Zócalo, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Zócalo",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Mexico_City_Zocalo_Aerial_View.jpg/1280px-Mexico_City_Zocalo_Aerial_View.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Visit Templo Mayor Museum",
              "description": "Discover the archaeological site and museum of Templo Mayor, the main temple of the Aztec capital Tenochtitlan, located just behind the Cathedral.",
              "placeName": "Templo Mayor Museum",
              "mapLink": "https://www.google.com/maps/place/Templo+Mayor+Museum",
              "ticketLink": "https://www.viator.com/Mexico-City-attractions/Templo-Mayor-Museum/d628-a2893",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Templo_Mayor_%28Mexico_City%29.jpg/1280px-Templo_Mayor_%28Mexico_City%29.jpg",
              "best_time": "morning",
              "suggested_time": "10:30 AM"
            },
            {
              "name": "Traditional Mexican Breakfast at El Cardenal",
              "description": "Enjoy a classic Mexican breakfast at one of the city's most beloved restaurants, famous for its traditional dishes and conchas.",
              "placeName": "El Cardenal, Centro Histórico",
              "mapLink": "https://www.google.com/maps/place/El+Cardenal+Centro+Histórico",
              "imageUrl": "https://www.elcardenal.com.mx/wp-content/uploads/2019/07/cardenal-centro-historico.jpg",
              "best_time": "morning",
              "suggested_time": "08:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Admire Palacio de Bellas Artes",
              "description": "Visit the stunning Palacio de Bellas Artes, an architectural marvel housing murals by famous Mexican artists and often hosting cultural events.",
              "placeName": "Palacio de Bellas Artes",
              "mapLink": "https://www.google.com/maps/place/Palacio+de+Bellas+Artes",
              "ticketLink": "https://www.viator.com/Mexico-City-attractions/Palacio-de-Bellas-Artes/d628-a2894",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Palacio_de_Bellas_Artes_M%C3%A9xico_2016.jpg/1280px-Palacio_de_Bellas_Artes_M%C3%A9xico_2016.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Lunch at Azul Histórico",
              "description": "Savor gourmet Mexican cuisine in a beautiful courtyard setting. Azul Histórico is renowned for its regional dishes and seasonal specials.",
              "placeName": "Azul Histórico",
              "mapLink": "https://www.google.com/maps/place/Azul+Histórico",
              "imageUrl": "https://azul.com.mx/wp-content/uploads/2021/04/Azul-Historico-CDMX-1024x683.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Taquería Orinoco",
              "description": "Experience the vibrant taco culture of Mexico City at Taquería Orinoco, famous for its delicious trompo (al pastor) tacos.",
              "placeName": "Taquería Orinoco Roma Norte",
              "mapLink": "https://www.google.com/maps/place/Taquería+Orinoco+Roma+Norte",
              "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP_Fj_x1B_0t9n4t0w_b_y_8p_q_w_z_7l_l_h_w=s1360-w1360-h1020",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            },
            {
              "name": "Stroll through Roma Norte",
              "description": "Enjoy an evening walk through the charming, tree-lined streets of Roma Norte, known for its art deco architecture, boutiques, and lively atmosphere.",
              "placeName": "Roma Norte, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Roma+Norte,+Mexico+City",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Roma_Norte_calle_Tabasco.jpg/1280px-Roma_Norte_calle_Tabasco.jpg",
              "best_time": "evening",
              "suggested_time": "09:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Official FIFA Fan Zone Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the Official FIFA Fan Zone. Enjoy live music, interactive games, official merchandise, and watch matches on giant screens.",
              "placeName": "Official FIFA Fan Zone (near Estadio Azteca or designated central location)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Zone+Mexico+City",
              "imageUrl": "https://digitalhub.fifa.com/transform/554868f7-7892-4d2c-905e-f00e93ed26c0/FIFA-Fan-Festival-Doha-Qatar-2022-GettyImages-1442111162?io=transform:fill,width:1920,height:1080",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Festivities and Lunch near Estadio Azteca",
              "description": "Soak in the electric atmosphere around Estadio Azteca. Enjoy street food from local vendors or a casual lunch at a nearby eatery before heading into the stadium.",
              "placeName": "Estadio Azteca surroundings",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Estadio_Azteca_pre-match.jpg/1280px-Estadio_Azteca_pre-match.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Enter Estadio Azteca for FIFA World Cup Match",
              "description": "Head into the iconic Estadio Azteca, one of the world's most legendary football stadiums, to experience a FIFA World Cup match live.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/c6081467-3331-4171-893c-2384a6c4b285/Estadio-Azteca-Mexico-City-World-Cup-2026?io=transform:fill,width:1920,height:1080",
              "best_time": "afternoon",
              "suggested_time": "04:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Witness the excitement of a FIFA World Cup game in one of football's most historic venues. Cheer on your favorite team and experience the global passion for the sport.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/f3c9e3a6-5c68-4665-9836-8e50b925b413/FIFA_World_Cup_Qatar_2022_Final_Argentina_v_France?io=transform:fill,width:1920,height:1080",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Post-Match Celebration",
              "description": "Celebrate the match with fellow fans at a local bar or restaurant near Estadio Azteca or in a lively district like Coyoacán, easily accessible from the stadium.",
              "placeName": "Coyoacán or nearby establishments",
              "mapLink": "https://www.google.com/maps/place/Coyoacán",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Bar_in_Coyoacan.jpg/1280px-Bar_in_Coyoacan.jpg",
              "best_time": "evening",
              "suggested_time": "09:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Visit Casa Azul (Frida Kahlo Museum)",
              "description": "Explore the former home of iconic artist Frida Kahlo, now a museum showcasing her life, art, and personal belongings. Book tickets well in advance!",
              "placeName": "Museo Frida Kahlo",
              "mapLink": "https://www.google.com/maps/place/Museo+Frida+Kahlo",
              "ticketLink": "https://www.museofridakahlo.org.mx/en/the-blue-house/your-visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Casa_Azul_Coyoacan_1.jpg/1280px-Casa_Azul_Coyoacan_1.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Breakfast at Café El Jarocho Coyoacán",
              "description": "Enjoy a traditional Mexican coffee and pastry at this beloved local institution in Coyoacán, famous for its rich coffee since 1953.",
              "placeName": "Café El Jarocho Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Caf%C3%A9+El+Jarocho+Coyoac%C3%A1n",
              "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP_tY7c_z_z_z_z_z_z_z_z_z_z_z_z_z_z_z_z=s1360-w1360-h1020",
              "best_time": "morning",
              "suggested_time": "08:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Coyoacán's Main Squares and Market",
              "description": "Wander through Jardín Centenario and Plaza Hidalgo, soaking in the bohemian atmosphere. Then, visit Mercado de Coyoacán for local crafts, souvenirs, and street food.",
              "placeName": "Jardín Centenario, Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Jardín+Centenario",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Jard%C3%ADn_Centenario%2C_Coyoac%C3%A1n.jpg/1280px-Jard%C3%ADn_Centenario%2C_Coyoac%C3%A1n.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at Mercado de Coyoacán",
              "description": "Indulge in authentic Mexican street food like tostadas, quesadillas, and esquites from the various food stalls within the vibrant Mercado de Coyoacán.",
              "placeName": "Mercado de Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Mercado+de+Coyoac%C3%A1n",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Mercado_de_Coyoacán.jpg/1280px-Mercado_de_Coyoacán.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner at San Angel Inn",
              "description": "Enjoy an elegant farewell dinner at the historic San Angel Inn, a former hacienda offering exquisite Mexican and international cuisine in a beautiful setting.",
              "placeName": "San Angel Inn",
              "mapLink": "https://www.google.com/maps/place/San+Angel+Inn",
              "imageUrl": "https://www.sanangelinn.com.mx/wp-content/uploads/2021/08/fachada-1024x683.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Tacos al Pastor (Taquería Orinoco, El Califa)",
        "Conchas (El Cardenal)",
        "Mole (Azul Histórico, Los Danzantes)",
        "Tostadas (Mercado de Coyoacán)",
        "Churros (El Moro)",
        "Esquites / Elotes (street vendors)"
      ],
      "football_experiences": [
        "Attending a FIFA World Cup Match at Estadio Azteca",
        "Visiting the Official FIFA Fan Zone for interactive experiences and broadcasts",
        "Experiencing the vibrant pre-match atmosphere around Estadio Azteca",
        "Exploring local football culture and fan gatherings in the city"
      ],
      "travel_tips": [
        "Public Transportation: Mexico City has an extensive and affordable public transport system. The main components are the Metro (subway), Metrobus (Bus Rapid Transit), and Tren Ligero (light rail).",
        "Getting to Estadio Azteca: On match day, the most efficient way to reach Estadio Azteca is via the Tren Ligero (Light Rail). Take Metro Line 2 (Blue Line) to Tasqueña station, then transfer to the Tren Ligero and ride to the 'Estadio Azteca' station. Allow ample time due to crowds.",
        "MI Card: Purchase a Tarjeta de Movilidad Integrada (MI Card) at any Metro or Metrobus station. This rechargeable card can be used for all major public transport systems (Metro, Metrobus, Tren Ligero, Cablebús) and is essential for easy travel.",
        "Accommodation: Consider staying in areas like Coyoacán (charming, historic, close to Estadio Azteca), Roma Norte or Condesa (trendy, great dining, well-connected, but a bit further from Azteca), or San Ángel (upscale, historic, near Coyoacán) for a good balance of access and local experience. Aim for accommodation within 60 minutes of Estadio Azteca by public transport.",
        "Booking Tickets: For popular attractions like the Frida Kahlo Museum (Casa Azul), it is crucial to book your tickets online several weeks or even months in advance, especially during peak World Cup season, as they sell out quickly.",
        "Safety: Like any large city, be aware of your surroundings, especially in crowded areas and on public transport. Use licensed taxis or ride-sharing apps (Uber, Didi) for late-night travel."
      ]
    },
    "5": {
      "plannerCity": "Mexico City",
      "matchDay": 3,
      "city": "Mexico City",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Zócalo and Metropolitan Cathedral",
              "description": "Begin your exploration at the heart of Mexico City, the Zócalo, one of the largest city squares in the world. Visit the impressive Metropolitan Cathedral, a masterpiece of colonial architecture.",
              "placeName": "Zócalo, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Zócalo,+Centro+Histórico+de+la+Cdad.+de+México,+Centro,+Ciudad+de+México,+CDMX,+México",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Catedral_Metropolitana_de_la_Ciudad_de_México_noche.jpg/1920px-Catedral_Metropolitana_de_la_Ciudad_de_México_noche.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Palacio Nacional",
              "description": "Admire the murals by Diego Rivera depicting Mexico's history inside the Palacio Nacional (requires ID for entry, access subject to government activities).",
              "placeName": "Palacio Nacional",
              "mapLink": "https://www.google.com/maps/place/Palacio+Nacional/@19.432549,-99.132801,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f93309a4736f:0x39a03f837330225!8m2!3d19.432549!4d-99.132801!16z1s0x85d1f93309a4736f:0x39a03f837330225",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Palacio_Nacional_Mexico_City_2013.jpg/1920px-Palacio_Nacional_Mexico_City_2013.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Templo Mayor Museum",
              "description": "Explore the ruins of the ancient Aztec city of Tenochtitlan and its associated museum, located right next to the Zócalo.",
              "placeName": "Museo del Templo Mayor",
              "mapLink": "https://www.google.com/maps/place/Museo+del+Templo+Mayor/@19.434057,-99.132817,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f933010b42f3:0x192d192135c3c12f!8m2!3d19.434057!4d-99.132817!16z1s0x85d1f933010b42f3:0x192d192135c3c12f",
              "ticketLink": "https://www.inah.gob.mx/zonas/234-zona-arqueologica-y-museo-del-templo-mayor",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Templo_Mayor_1.jpg/1920px-Templo_Mayor_1.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Palacio de Bellas Artes",
              "description": "Visit the stunning Palacio de Bellas Artes, an architectural gem housing murals by famous Mexican artists and serving as a cultural center.",
              "placeName": "Palacio de Bellas Artes",
              "mapLink": "https://www.google.com/maps/place/Palacio+de+Bellas+Artes/@19.435061,-99.14115,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f92c222e519b:0x701726a27e7482a!8m2!3d19.435061!4d-99.14115!16z1s0x85d1f92c222e519b:0x701726a27e7482a",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Palacio_de_Bellas_Artes_Mexico_City.jpg/1920px-Palacio_de_Bellas_Artes_Mexico_City.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Azul Histórico",
              "description": "Enjoy upscale Mexican cuisine in a beautiful colonial courtyard setting. Reservations highly recommended.",
              "placeName": "Azul Histórico",
              "mapLink": "https://www.google.com/maps/place/Azul+Histórico/@19.431694,-99.134015,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f932f17088b9:0x89e1b212f451f28e!8m2!3d19.431694!4d-99.134015!16s1s0x85d1f932f17088b9:0x89e1b212f451f28e",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0e/01/f9/ce/azul-historico.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Frida Kahlo Museum (Casa Azul)",
              "description": "Visit the iconic 'Blue House' where Frida Kahlo was born, lived, and died. It offers an intimate look into her life and art. Book tickets well in advance.",
              "placeName": "Museo Frida Kahlo",
              "mapLink": "https://www.google.com/maps/place/Museo+Frida+Kahlo/@19.35445,-99.162235,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ffc93540e53f:0xa19f96996d96a5f!8m2!3d19.35445!4d-99.162235!16s1s0x85d1ffc93540e53f:0xa19f96996d96a5f",
              "ticketLink": "https://www.museofridakahlo.org.mx/en/the-blue-house/plan-your-visit/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Museo_Frida_Kahlo.jpg/1920px-Museo_Frida_Kahlo.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Coyoacán Neighborhood",
              "description": "Wander through the charming cobblestone streets of Coyoacán, known for its bohemian atmosphere, colorful colonial houses, and lively squares.",
              "placeName": "Coyoacán, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Coyoacán,+Ciudad+de+México,+CDMX,+México",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Plaza_Hidalgo%2C_Coyoac%C3%A1n.jpg/1920px-Plaza_Hidalgo%2C_Coyoac%C3%A1n.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Mercado de Coyoacán",
              "description": "Immerse yourself in local life at Mercado de Coyoacán. Try traditional street food like tostadas, quesadillas, and fresh fruit juices.",
              "placeName": "Mercado de Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Mercado+de+Coyoacán/@19.35122,-99.162795,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ffc907ee7b29:0x851722881b212f20!8m2!3d19.35122!4d-99.162795!16s1s0x85d1ffc907ee7b29:0x851722881b212f20",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Mercado_de_Coyoac%C3%A1n_04.jpg/1920px-Mercado_de_Coyoac%C3%A1n_04.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Churros at El Moro",
              "description": "Indulge in freshly made churros and hot chocolate at the famous Churreria El Moro. There's a branch in Coyoacán or you can visit the original in the Historic Center.",
              "placeName": "Churreria El Moro Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Churreria+El+Moro+Coyoacán/@19.351421,-99.162817,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ffc91b58535b:0x5140f0236a9926d1!8m2!3d19.351421!4d-99.162817!16s1s0x85d1ffc91b58535b:0x5140f0236a9926d1",
              "imageUrl": "https://www.churreriaelmoro.com.mx/static/media/Sucursal-Coyoacan.c87bf764.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival",
              "description": "Experience the excitement of the FIFA World Cup at the official Fan Festival. Enjoy live music, food, games, and watch matches on giant screens. (Location to be announced, often in central parks like Zócalo or Chapultepec).",
              "placeName": "FIFA Fan Festival (TBD, likely central CDMX)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Mexico+City",
              "imageUrl": "https://digitalhub.fifa.com/transform/c470129a-25c2-479c-9c9c-2374e2b027d1/GettyImages-1245041926?io=transform:fill,height:480,width:720&quality=75",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to Estadio Azteca & Pre-Match Atmosphere",
              "description": "Head to Estadio Azteca early to soak in the pre-match atmosphere. Enjoy local food vendors, merchandise stalls, and the vibrant energy of fans.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca/@19.30292,-99.15065,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f97a55282559:0x2213a69315000000!8m2!3d19.30292!4d-99.15065!16s1s0x85d1f97a55282559:0x2213a69315000000",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Estadio_Azteca_Panor%C3%A1mica.jpg/1920px-Estadio_Azteca_Panor%C3%A1mica.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "FIFA World Cup Match",
              "description": "Experience the thrill of a FIFA World Cup match live at the legendary Estadio Azteca, an iconic venue in football history.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca/@19.30292,-99.15065,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f97a55282559:0x2213a69315000000!8m2!3d19.30292!4d-99.15065!16s1s0x85d1f97a55282559:0x2213a69315000000",
              "imageUrl": "https://digitalhub.fifa.com/transform/4b17936a-2f47-49e5-946f-c1f09c2a61f2/GettyImages-1422774917?io=transform:fill,height:480,width:720&quality=75",
              "best_time": "afternoon",
              "suggested_time": "17:00"
            }
          ],
          "evening": [
            {
              "name": "Post-Match Dinner near Coyoacán",
              "description": "After the match, head back towards Coyoacán for dinner. It's a convenient location from Estadio Azteca and offers a variety of dining options. Try authentic tacos al pastor at a local taqueria.",
              "placeName": "El Jarocho (Coyoacán)",
              "mapLink": "https://www.google.com/maps/place/El+Jarocho/@19.35122,-99.162795,17z/data=!4m6!3m5!1s0x85d1ffc91b58535b:0x5140f0236a9926d1!8m2!3d19.351421!4d-99.162817!16s1s0x85d1ffc91b58535b:0x5140f0236a9926d1",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0f/0e/e6/57/tacos-al-pastor.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Chapultepec Park",
              "description": "Start your day exploring Bosque de Chapultepec, one of the largest city parks in the world. It's home to museums, a castle, a zoo, and beautiful green spaces.",
              "placeName": "Bosque de Chapultepec",
              "mapLink": "https://www.google.com/maps/place/Bosque+de+Chapultepec/@19.420658,-99.191599,15z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff230835f111:0x5075c3f91c95e1e0!8m2!3d19.420658!4d-99.191599!16z1s0x85d1ff230835f111:0x5075c3f91c95e1e0",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Chapultepec_Castle_01.jpg/1920px-Chapultepec_Castle_01.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "National Museum of Anthropology",
              "description": "Visit one of the finest museums in the world, showcasing Mexico's pre-Hispanic heritage and indigenous cultures. Allow several hours to explore.",
              "placeName": "Museo Nacional de Antropología",
              "mapLink": "https://www.google.com/maps/place/Museo+Nacional+de+Antropología/@19.426217,-99.18671,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff2317134449:0x2c6426477e92b157!8m2!3d19.426217!4d-99.18671!16z1s0x85d1ff2317134449:0x2c6426477e92b157",
              "ticketLink": "https://mna.inah.gob.mx/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Museo_Nacional_de_Antropolog%C3%ADa_-_Fachada.jpg/1920px-Museo_Nacional_de_Antropolog%C3%ADa_-_Fachada.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Chapultepec Castle (National Museum of History)",
              "description": "Perched atop Chapultepec Hill, this majestic castle offers stunning views of the city and houses the National Museum of History.",
              "placeName": "Castillo de Chapultepec",
              "mapLink": "https://www.google.com/maps/place/Castillo+de+Chapultepec/@19.420658,-99.191599,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff2317134449:0x2c6426477e92b157!8m2!3d19.426217!4d-99.18671!16z1s0x85d1ff2317134449:0x2c6426477e92b157",
              "ticketLink": "https://mnh.inah.gob.mx/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Chapultepec_Castle_01.jpg/1920px-Chapultepec_Castle_01.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Roma Norte / Condesa",
              "description": "Explore the trendy neighborhoods of Roma Norte or Condesa, known for their art deco architecture, leafy streets, and diverse culinary scene. Dine at Contramar for exquisite seafood (reservations essential) or a more casual eatery.",
              "placeName": "Contramar",
              "mapLink": "https://www.google.com/maps/place/Contramar/@19.41793,-99.16781,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff4e18379435:0x23f7c4f4b232371b!8m2!3d19.41793!4d-99.16781!16s1s0x85d1ff4e18379435:0x23f7c4f4b232371b",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0c/33/c4/81/contramar.jpg",
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Day Trip to Teotihuacan Pyramids",
              "description": "Embark on an unforgettable day trip to the ancient city of Teotihuacan, home to the magnificent Pyramids of the Sun and Moon. Walk the Avenue of the Dead and marvel at this UNESCO World Heritage site.",
              "placeName": "Zona Arqueológica de Teotihuacán",
              "mapLink": "https://www.google.com/maps/place/Zona+Arqueológica+de+Teotihuacán/@19.692508,-98.84365,15z/data=!3m1!4b1!4m6!3m5!1s0x85d1e8c078041065:0x7095b36440263f3!8m2!3d19.692508!4d-98.84365!16z1s0x85d1e8c078041065:0x7095b36440263f3",
              "ticketLink": "https://www.inah.gob.mx/zonas/127-zona-arqueologica-de-teotihuacan",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Vista_pir%C3%A1mide_del_Sol_y_de_la_Luna%2C_Teotihuacan.jpg/1920px-Vista_pir%C3%A1mide_del_Sol_y_de_la_Luna%2C_Teotihuacan.jpg",
              "best_time": "morning",
              "suggested_time": "08:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch near Teotihuacan",
              "description": "Enjoy a traditional Mexican lunch at a restaurant near the Teotihuacan archaeological site before heading back to Mexico City.",
              "placeName": "La Gruta (Teotihuacan)",
              "mapLink": "https://www.google.com/maps/place/La+Gruta+Restaurante/@19.68656,-98.84501,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1e8c148283a15:0x76707f16ef06f695!8m2!3d19.68656!4d-98.84501!16s1s0x85d1e8c148283a15:0x76707f16ef06f695",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/17/25/08/9b/entrance-to-la-gruta.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in San Ángel",
              "description": "Conclude your trip with a farewell dinner in the picturesque San Ángel neighborhood, known for its colonial mansions and cobblestone streets. Enjoy traditional Mexican cuisine in a refined setting.",
              "placeName": "San Ángel, Mexico City",
              "mapLink": "https://www.google.com/maps/place/San+%C3%81ngel,+Ciudad+de+México,+CDMX,+México",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/San_Angel_Mexico_City.jpg/1920px-San_Angel_Mexico_City.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Tacos al Pastor (street food)",
        "Churros and hot chocolate from El Moro",
        "Tostadas and quesadillas at Mercado de Coyoacán",
        "Mole Poblano (at a traditional restaurant)",
        "Esquites or Elotes (street corn)",
        "Aguas Frescas (fresh fruit drinks)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Day 3)",
        "FIFA World Cup Match at Estadio Azteca (Day 3)",
        "Soaking in the pre-match atmosphere around Estadio Azteca",
        "Exploring local sports bars or 'cantinas' to watch other matches"
      ],
      "travel_tips": [
        "**Getting to Estadio Azteca:** The most direct public transport is via the Tren Ligero (Light Rail). Take Metro Line 2 (Blue Line) to Tasqueña station, then transfer to the Tren Ligero heading south. Get off at the Estadio Azteca station. Allow 45-60 minutes from central areas on match day.",
        "**Where to Stay:** Consider staying in neighborhoods like Roma Norte, Condesa, or Coyoacán for a vibrant atmosphere, good dining, and relatively easy access to public transport. The Historic Center is also an option for budget and historical immersion. For direct access to Estadio Azteca, areas around Tasqueña might be convenient but offer fewer tourist amenities.",
        "**Public Transportation in Mexico City:** The city has an extensive and affordable public transport system. The main components are:",
        "  - **Metro:** Mexico City's subway system, covering most of the city. It can be very crowded during peak hours.",
        "  - **Metrobús:** A bus rapid transit system with dedicated lanes, offering efficient travel on major avenues.",
        "  - **Tren Ligero:** Light rail line connecting Tasqueña (Metro Line 2) to southern neighborhoods, including Estadio Azteca.",
        "  - **M1 (RTP) Buses:** Conventional bus lines that complement the Metro and Metrobús.",
        "  - **Ecobici:** A popular bike-sharing system for short distances, especially in central neighborhoods.",
        "**Integrated Mobility Card (Tarjeta de Movilidad Integrada):** This is essential for using the Metro, Metrobús, and Tren Ligero. Purchase it at any Metro or Metrobús station and load credit onto it. It's the most convenient way to pay fares.",
        "**Safety:** Be aware of your surroundings, especially in crowded areas and on public transport. Use licensed taxis or ride-sharing apps (Uber, Didi, Cabify) for evening travel. Avoid displaying expensive valuables.",
        "**Altitude Sickness:** Mexico City is at a high altitude (over 2,200m or 7,200ft). Drink plenty of water, avoid excessive alcohol on arrival, and take it easy for the first day or two to acclimate."
      ]
    },
    "7": {
      "plannerCity": "Mexico City",
      "matchDay": 4,
      "city": "Mexico City",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore Zócalo and Metropolitan Cathedral",
              "description": "Begin your journey at the historic heart of Mexico City, the Zócalo, one of the world's largest city squares. Visit the impressive Metropolitan Cathedral, a masterpiece of colonial architecture built over centuries.",
              "placeName": "Zócalo, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Z%C3%B3calo,+Centro+Hist%C3%B3rico+de+la+Cdad.+de+M%C3%A9xico,+Centro,+Cuauht%C3%A9moc,+06000+Ciudad+de+M%C3%A9xico,+CDMX,+Mexico",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Zocalo_Mexico_City.jpg/1200px-Zocalo_Mexico_City.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Palacio Nacional and Templo Mayor",
              "description": "Visit the Palacio Nacional to admire Diego Rivera's famous murals depicting Mexican history. Afterwards, explore the archaeological site and museum of Templo Mayor, revealing the ancient Aztec city of Tenochtitlan.",
              "placeName": "Palacio Nacional, Mexico City",
              "mapLink": "https://www.google.com/maps/place/Palacio+Nacional,+Centro+Hist%C3%B3rico+de+la+Cdad.+de+M%C3%A9xico,+Centro,+Cuauht%C3%A9moc,+06060+Ciudad+de+M%C3%A9xico,+CDMX,+Mexico",
              "ticketLink": "https://palacionacional.inah.gob.mx/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Palacio_Nacional_-_Fachada_principal.jpg/1200px-Palacio_Nacional_-_Fachada_principal.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Templo Mayor Museum",
              "description": "Delve deeper into Aztec history at the Templo Mayor Museum, showcasing artifacts found at the archaeological site.",
              "placeName": "Museo del Templo Mayor",
              "mapLink": "https://www.google.com/maps/place/Museo+del+Templo+Mayor,+Seminario+8,+Centro+Hist%C3%B3rico+de+la+Cdad.+de+M%C3%A9xico,+Centro,+Cuauht%C3%A9moc,+06060+Ciudad+de+M%C3%A9xico,+CDMX,+Mexico",
              "ticketLink": "https://www.inah.gob.mx/zonas/125-zona-arqueologica-y-museo-del-templo-mayor",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Templo_Mayor_main_pyramid.jpg/1200px-Templo_Mayor_main_pyramid.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Azul Histórico",
              "description": "Enjoy an upscale traditional Mexican dinner in a beautiful open-air courtyard setting at Azul Histórico, known for its regional specialties.",
              "placeName": "Azul Histórico",
              "mapLink": "https://www.google.com/maps/place/Azul+Hist%C3%B3rico/@19.432658,-99.136009,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f8d07011d13f:0x2287950c44360e2!8m2!3d19.432658!4d-99.136009!16s%2Fg%2F1tdy4q1c?entry=ttu",
              "imageUrl": "https://azulenmexico.com/wp-content/uploads/2023/10/AZUL-HISTORICO-2.webp",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Frida Kahlo Museum (Casa Azul)",
              "description": "Visit the iconic Casa Azul, the former home of artist Frida Kahlo, now a museum showcasing her life, art, and personal belongings. Book tickets well in advance.",
              "placeName": "Museo Frida Kahlo",
              "mapLink": "https://www.google.com/maps/place/Museo+Frida+Kahlo/@19.354477,-99.162391,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377e89e365:0x1b4b711e5828d11d!8m2!3d19.354477!4d-99.162391!16s%2Fg%2F122_974b?entry=ttu",
              "ticketLink": "https://www.museofridakahlo.org.mx/en/the-museum/plan-your-visit/tickets/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Casa_Azul_exterior.jpg/1200px-Casa_Azul_exterior.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Coyoacán Market & Plazas",
              "description": "Wander through the vibrant Mercado de Coyoacán, sampling local street food and browsing artisan crafts. Afterward, relax in the charming Jardín Centenario and Plaza Hidalgo, the main squares of Coyoacán.",
              "placeName": "Mercado de Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Mercado+de+Coyoac%C3%A1n/@19.352467,-99.164501,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff3776a3e143:0x19277d341909a34e!8m2!3d19.352467!4d-99.164501!16s%2Fg%2F1231f8f3?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Mercado_de_Coyoac%C3%A1n.jpg/1200px-Mercado_de_Coyoac%C3%A1n.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Jardín Centenario & Plaza Hidalgo",
              "description": "Relax and people-watch in the beautiful and lively main squares of Coyoacán, surrounded by cafes and colonial buildings.",
              "placeName": "Jardín Centenario & Plaza Hidalgo",
              "mapLink": "https://www.google.com/maps/place/Jard%C3%ADn+Centenario/@19.350811,-99.163836,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377759c9a7:0x51c5f3e9e144a70e!8m2!3d19.350811!4d-99.163836!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Jard%C3%ADn_Centenario%2C_Coyoac%C3%A1n%2C_M%C3%A9xico.jpg/1200px-Jard%C3%ADn_Centenario%2C_Coyoac%C3%A1n%2C_M%C3%A9xico.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Los Danzantes Coyoacán",
              "description": "Enjoy contemporary Mexican cuisine with a focus on Oaxacan flavors, paired with mezcal, in a chic setting overlooking Jardín Centenario.",
              "placeName": "Los Danzantes Coyoacán",
              "mapLink": "https://www.google.com/maps/place/Los+Danzantes+Coyoac%C3%A1n/@19.350711,-99.163901,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377759c9a7:0x2287950c44360e2!8m2!3d19.350711!4d-99.163901!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://losdanzantes.com/cdn/shop/files/danzantes-coyoacan-1.jpg?v=1686940003",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "National Museum of Anthropology",
              "description": "Spend your morning at one of the world's finest museums, showcasing Mexico's pre-Hispanic heritage with vast collections, including the Aztec Sun Stone.",
              "placeName": "National Museum of Anthropology",
              "mapLink": "https://www.google.com/maps/place/National+Museum+of+Anthropology/@19.423985,-99.186985,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff4fb2c26217:0x2287950c44360e2!8m2!3d19.423985!4d-99.186985!16s%2Fg%2F122_974b?entry=ttu",
              "ticketLink": "https://www.inah.gob.mx/museos/38-museo-nacional-de-antropologia",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Museo_Nacional_de_Antropolog%C3%ADa_%28M%C3%A9xico%29_02.jpg/1200px-Museo_Nacional_de_Antropolog%C3%ADa_%28M%C3%A9xico%29_02.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Paseo de la Reforma & Angel of Independence",
              "description": "Stroll down Mexico City's grandest boulevard, Paseo de la Reforma, admiring its monuments and skyscrapers. Conclude your walk at the iconic Angel of Independence.",
              "placeName": "Angel of Independence",
              "mapLink": "https://www.google.com/maps/place/%C3%81ngel+de+la+Independencia/@19.427027,-99.167664,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff3b593630f9:0x2287950c44360e2!8m2!3d19.427027!4d-99.167664!16s%2Fg%2F122_974b?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/%C3%81ngel_de_la_Independencia_CDMX.jpg/1200px-%C3%81ngel_de_la_Independencia_CDMX.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Contramar",
              "description": "Indulge in exquisite seafood at Contramar in Roma Norte, famous for its whole grilled fish (pescado a la talla) and tuna tostadas.",
              "placeName": "Contramar",
              "mapLink": "https://www.google.com/maps/place/Contramar/@19.418469,-99.166164,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff3b683d735f:0x2287950c44360e2!8m2!3d19.418469!4d-99.166164!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://static.mexicoenmicocina.com/wp-content/uploads/2019/08/Contramar-Mexico-City.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the pre-match atmosphere at the official FIFA Fan Festival. Enjoy live music, cultural performances, food stalls, and interactive football experiences. The exact location will be announced by FIFA closer to the tournament, but Zócalo is a popular choice for large public events.",
              "placeName": "Zócalo, Mexico City (Potential Fan Fest Location)",
              "mapLink": "https://www.google.com/maps/place/Z%C3%B3calo,+Centro+Hist%C3%B3rico+de+la+Cdad.+de+M%C3%A9xico,+Centro,+Cuauht%C3%A9moc,+06000+Ciudad+de+M%C3%A9xico,+CDMX,+Mexico",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Zocalo_Mexico_City.jpg/1200px-Zocalo_Mexico_City.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Travel to Estadio Azteca & Pre-Match Atmosphere",
              "description": "Head early to Estadio Azteca to soak in the match day excitement. Explore the stadium surroundings, visit official merchandise stores, and enjoy the vibrant atmosphere with fellow fans. Allow ample travel time.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca/@19.302831,-99.150651,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f9747a8d56b3:0x2287950c44360e2!8m2!3d19.302831!4d-99.150651!16s%2Fg%2F122_974b?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Estadio_Azteca_Panoramica_2023.jpg/1200px-Estadio_Azteca_Panoramica_2023.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Estadio Azteca",
              "description": "Experience the thrill of a live FIFA World Cup match at the iconic Estadio Azteca, the only stadium to host two World Cup finals. Feel the energy of the crowd and witness football history.",
              "placeName": "Estadio Azteca",
              "mapLink": "https://www.google.com/maps/place/Estadio+Azteca/@19.302831,-99.150651,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f9747a8d56b3:0x2287950c44360e2!8m2!3d19.302831!4d-99.150651!16s%2Fg%2F122_974b?entry=ttu",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Estadio_Azteca_Panoramica_2023.jpg/1200px-Estadio_Azteca_Panoramica_2023.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Xochimilco Canals (Trajinera Ride)",
              "description": "Take a colorful 'trajinera' boat ride through the ancient canals of Xochimilco, a UNESCO World Heritage site. Enjoy floating mariachi bands, food vendors, and a unique glimpse into pre-Hispanic life.",
              "placeName": "Embarcadero Nuevo Nativitas Xochimilco",
              "mapLink": "https://www.google.com/maps/place/Embarcadero+Nuevo+Nativitas+Xochimilco/@19.278306,-99.109015,17z/data=!3m1!4b1!4m6!3m5!1s0x85ce006a8636f321:0x2287950c44360e2!8m2!3d19.278306!4d-99.109015!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Xochimilco_trajineras.jpg/1200px-Xochimilco_trajineras.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "UNAM Campus (Ciudad Universitaria)",
              "description": "Explore the UNESCO-listed campus of the National Autonomous University of Mexico, famous for its mid-20th-century architecture and murals by Mexican artists like Diego Rivera and David Alfaro Siqueiros. See the iconic Central Library and Estadio Olímpico Universitario.",
              "placeName": "Ciudad Universitaria (UNAM)",
              "mapLink": "https://www.google.com/maps/place/Ciudad+Universitaria+%28UNAM%29/@19.332353,-99.189569,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377e89e365:0x2287950c44360e2!8m2!3d19.332353!4d-99.189569!16s%2Fg%2F122_974b?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/UNAM_Central_Library.jpg/1200px-UNAM_Central_Library.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at San Angel Inn",
              "description": "Enjoy a sophisticated dinner at the historic San Angel Inn, a beautiful former hacienda offering traditional Mexican cuisine in an elegant setting in the charming San Ángel neighborhood.",
              "placeName": "San Angel Inn",
              "mapLink": "https://www.google.com/maps/place/San+Angel+Inn/@19.349688,-99.191691,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377e89e365:0x2287950c44360e2!8m2!3d19.349688!4d-99.191691!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0r4oG_9k9Hk8oX7bL8j0rP-U9C0cK5S_E5g&s",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Day Trip to Teotihuacan Pyramids",
              "description": "Embark on a day trip to the ancient city of Teotihuacan, a UNESCO World Heritage site. Marvel at the colossal Pyramids of the Sun and Moon, walk the Avenue of the Dead, and imagine life in this powerful pre-Aztec metropolis.",
              "placeName": "Teotihuacan Pyramids",
              "mapLink": "https://www.google.com/maps/place/Zona+Arqueol%C3%B3gica+de+Teotihuac%C3%A1n/@19.692558,-99.117181,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f8552f6d0f8d:0x2287950c44360e2!8m2!3d19.692558!4d-99.117181!16s%2Fg%2F122_974b?entry=ttu",
              "ticketLink": "https://www.inah.gob.mx/zonas/127-zona-arqueologica-de-teotihuacan",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Pyramid_of_the_Sun_and_Avenue_of_the_Dead%2C_Teotihuacan%2C_Mexico_-_2015.jpg/1200px-Pyramid_of_the_Sun_and_Avenue_of_the_Dead%2C_Teotihuacan%2C_Mexico_-_2015.jpg",
              "best_time": "morning",
              "suggested_time": "08:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at La Gruta & Return to Mexico City",
              "description": "Enjoy a unique dining experience inside a natural cave restaurant, La Gruta, located just outside the Teotihuacan archaeological zone. Offers traditional Mexican cuisine before heading back to the city.",
              "placeName": "Restaurante La Gruta Teotihuacán",
              "mapLink": "https://www.google.com/maps/place/Restaurante+La+Gruta+Teotihuac%C3%A1n/@19.691763,-99.115849,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f8552f6d0f8d:0x2287950c44360e2!8m2!3d19.691763!4d-99.115849!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0616/8718/7670/files/la_gruta_teotihuacan_2_1024x1024.jpg?v=1661362704",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Taquería Orinoco",
              "description": "Savor authentic tacos al pastor and other Mexican delights at the popular Taquería Orinoco in Roma Norte, a local favorite.",
              "placeName": "Taquería Orinoco",
              "mapLink": "https://www.google.com/maps/place/Taquer%C3%ADa+Orinoco/@19.419077,-99.167084,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff3b683d735f:0x2287950c44360e2!8m2!3d19.419077!4d-99.167084!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Tacos_al_pastor_from_Taqueria_Orinoco.jpg/1200px-Tacos_al_pastor_from_Taqueria_Orinoco.jpg",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Souvenir Shopping at Mercado de Artesanías La Ciudadela",
              "description": "Browse and purchase traditional Mexican handicrafts, textiles, pottery, and souvenirs at this vibrant market, perfect for finding gifts and mementos.",
              "placeName": "Mercado de Artesanías La Ciudadela",
              "mapLink": "https://www.google.com/maps/place/Mercado+de+Artesan%C3%ADas+La+Ciudadela/@19.431057,-99.148128,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377e89e365:0x2287950c44360e2!8m2!3d19.431057!4d-99.148128!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Mercado_de_Artesan%C3%ADas_La_Ciudadela_1.jpg/1200px-Mercado_de_Artesan%C3%ADas_La_Ciudadela_1.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Churros and coffee at Churrería El Moro",
              "description": "Indulge in freshly made churros with chocolate at the iconic Churrería El Moro, a Mexico City institution since 1935, for a sweet farewell.",
              "placeName": "Churrería El Moro (Eje Central)",
              "mapLink": "https://www.google.com/maps/place/Churrer%C3%ADa+El+Moro/@19.434691,-99.140733,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1ff377e89e365:0x2287950c44360e2!8m2!3d19.434691!4d-99.140733!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Churreria_El_Moro%2C_Mexico_City.jpg/1200px-Churreria_El_Moro%2C_Mexico_City.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Departure from Mexico City",
              "description": "Head to the airport for your departure, taking with you unforgettable memories of Mexico City and the FIFA World Cup.",
              "placeName": "Mexico City International Airport (MEX)",
              "mapLink": "https://www.google.com/maps/place/Mexico+City+International+Airport/@19.436329,-99.07185,17z/data=!3m1!4b1!4m6!3m5!1s0x85d1f99c0847b2c5:0x2287950c44360e2!8m2!3d19.436329!4d-99.07185!16s%2Fg%2F1tdy4yq4?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Mexico_City_International_Airport_Terminal_2.jpg/1200px-Mexico_City_International_Airport_Terminal_2.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Tacos al Pastor (Taquería Orinoco, El Huequito)",
        "Chilaquiles (El Cardenal)",
        "Mole Poblano (Azul Histórico)",
        "Esquites and Elotes (street vendors)",
        "Churros (Churrería El Moro)",
        "Pozole (Los Amantes de la Noche)"
      ],
      "football_experiences": [
        "Attend a FIFA World Cup Match at Estadio Azteca",
        "Visit the FIFA Fan Festival (location to be announced)",
        "Take a guided tour of Estadio Azteca (on non-match days)",
        "Immerse yourself in local football culture at sports bars or public viewing events"
      ],
      "travel_tips": [
        "How to reach Estadio Azteca: The most efficient way is via the Tren Ligero (Light Rail). Take Metro Line 2 (Blue Line) to Tasqueña station, then transfer to the Tren Ligero and ride it to Estadio Azteca station. On match days, expect crowds and potentially extended travel times. Consider arriving well in advance. Taxis/ride-shares are an option but traffic can be severe.",
        "Where to stay: Consider Coyoacán (charming, close to Azteca), Roma Norte/Condesa (trendy, great food/nightlife, further from Azteca), or Juárez/Reforma (central, good transport links, slightly further from Azteca).",
        "Public Transportation: Mexico City has an extensive and affordable public transport system including Metro (subway), Metrobús (Bus Rapid Transit), Tren Ligero (Light Rail), and Cablebús (gondola lift). Purchase a rechargeable Tarjeta de Movilidad Integrada (MI Card) at any Metro or Metrobús station for easy access to all systems.",
        "Safety: Be aware of your surroundings, especially in crowded areas and on public transport. Avoid displaying expensive items. Use official taxis or ride-sharing apps (Uber, Didi, Cabify) which are widely available and generally safe.",
        "Hydration & Altitude: Mexico City is at a high altitude (over 2,200 meters/7,200 feet). Drink plenty of water and take it easy on your first day to acclimatize. Avoid excessive alcohol consumption initially.",
        "Currency: Mexican Peso (MXN). Credit cards are widely accepted, but it's advisable to carry some cash for street food, small vendors, and tips."
      ]
    }
  },
  "guadalajara": {
    "3": {
      "plannerCity": "Guadalajara",
      "matchDay": 2,
      "city": "Guadalajara",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Explore Guadalajara Historic Center",
              "description": "Begin your day by exploring the vibrant heart of Guadalajara, known for its colonial architecture and bustling atmosphere.",
              "placeName": "Guadalajara Historic Center",
              "mapLink": "https://www.google.com/maps/place/Guadalajara+Historic+Center/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Guadalajara_cathedral_and_plaza.jpg/1280px-Guadalajara_cathedral_and_plaza.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            },
            {
              "name": "Visit Guadalajara Cathedral",
              "description": "Admire the iconic twin-towered cathedral, a symbol of the city, and explore its grand interior.",
              "placeName": "Guadalajara Cathedral",
              "mapLink": "https://www.google.com/maps/place/Guadalajara+Cathedral/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Catedral_de_Guadalajara_2020.jpg/1280px-Catedral_de_Guadalajara_2020.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch and shopping at Mercado Libertad - San Juan de Dios",
              "description": "Immerse yourself in Mexico's largest indoor market. Enjoy authentic street food, local delicacies, and shop for souvenirs and crafts.",
              "placeName": "Mercado Libertad - San Juan de Dios",
              "mapLink": "https://www.google.com/maps/place/Mercado+Libertad+-+San+Juan+de+Dios/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Mercado_San_Juan_de_Dios%2C_Guadalajara.jpg/1280px-Mercado_San_Juan_de_Dios%2C_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Explore Instituto Cultural Cabañas",
              "description": "Visit a UNESCO World Heritage site, a magnificent neoclassical building housing stunning murals by José Clemente Orozco.",
              "placeName": "Instituto Cultural Cabañas",
              "mapLink": "https://www.google.com/maps/place/Instituto+Cultural+Cabañas/",
              "ticketLink": "https://www.institutoculturalcabanashc.gob.mx/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Hospicio_Cabañas_Guadalajara.jpg/1280px-Hospicio_Cabañas_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:30"
            }
          ],
          "evening": [
            {
              "name": "Traditional Dinner at La Chata de Guadalajara",
              "description": "Savor authentic Jalisco cuisine in a traditional setting at one of Guadalajara's most beloved restaurants.",
              "placeName": "La Chata de Guadalajara",
              "mapLink": "https://www.google.com/maps/place/La+Chata+de+Guadalajara/",
              "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipN3uJ3K-2pZ3Yw0s2z5_vEa1tFq7wN7K-0x1_Bv=s680-w680-h510",
              "best_time": "evening",
              "suggested_time": "19:30"
            },
            {
              "name": "Mariachi Performance at Plaza de los Mariachis",
              "description": "Experience the vibrant sounds of live mariachi music in the historic square dedicated to this iconic Mexican tradition.",
              "placeName": "Plaza de los Mariachis",
              "mapLink": "https://www.google.com/maps/place/Plaza+de+los+Mariachis/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Plaza_de_los_Mariachis%2C_Guadalajara.jpg/1280px-Plaza_de_los_Mariachis%2C_Guadalajara.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "FIFA Fan Fest Experience",
              "description": "Immerse yourself in the pre-match excitement at the official FIFA Fan Fest. Enjoy live music, food, games, and connect with fans from around the world. Location likely in a central part of Guadalajara or Zapopan.",
              "placeName": "FIFA Fan Fest Guadalajara (TBD location)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Fest+Guadalajara",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/FIFA_Fan_Fest_Rio_de_Janeiro_2014.jpg/1280px-FIFA_Fan_Fest_Rio_de_Janeiro_2014.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            },
            {
              "name": "Travel to Estadio Akron area",
              "description": "Head towards Estadio Akron in Zapopan, allowing ample time for travel and security checks. Utilize dedicated FIFA shuttles or public transport connections.",
              "placeName": "Estadio Akron",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Estadio_Akron_2022.jpg/1280px-Estadio_Akron_2022.jpg",
              "best_time": "morning",
              "suggested_time": "12:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-match atmosphere and food at Estadio Akron",
              "description": "Soak in the electric atmosphere around Estadio Akron. Enjoy local food from vendors or stadium concessions, and experience the build-up to the match.",
              "placeName": "Estadio Akron surroundings",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Estadio_Akron_interior.jpg/1280px-Estadio_Akron_interior.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            },
            {
              "name": "Enter Estadio Akron and explore",
              "description": "Pass through security and enter the magnificent Estadio Akron. Find your seats and take in the architecture of this modern football temple.",
              "placeName": "Estadio Akron",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Estadio_Akron_2022.jpg/1280px-Estadio_Akron_2022.jpg",
              "best_time": "afternoon",
              "suggested_time": "17:00"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match!",
              "description": "Experience the thrill of a live FIFA World Cup match at Estadio Akron, cheering for your favorite team amidst thousands of passionate fans.",
              "placeName": "Estadio Akron",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/",
              "ticketLink": "https://www.fifa.com/tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Football_at_the_2018_FIFA_World_Cup_Final_%282%29.jpg/1280px-Football_at_the_2018_FIFA_World_Cup_Final_%282%29.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Day trip to Tlaquepaque",
              "description": "Discover the charming artisan town of Tlaquepaque, famous for its colorful streets, traditional crafts, and art galleries.",
              "placeName": "San Pedro Tlaquepaque",
              "mapLink": "https://www.google.com/maps/place/San+Pedro+Tlaquepaque,+Jal./",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Tlaquepaque_Jalisco.jpg/1280px-Tlaquepaque_Jalisco.jpg",
              "best_time": "morning",
              "suggested_time": "09:30"
            },
            {
              "name": "Explore Independencia Pedestrian Street",
              "description": "Stroll along the main pedestrian street of Tlaquepaque, browsing artisan shops selling pottery, blown glass, jewelry, and textiles.",
              "placeName": "Andador Independencia, Tlaquepaque",
              "mapLink": "https://www.google.com/maps/place/Andador+Independencia,+Centro,+45500+San+Pedro+Tlaquepaque,+Jal./",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Tlaquepaque_Jalisco_Mexico.jpg/1280px-Tlaquepaque_Jalisco_Mexico.jpg",
              "best_time": "morning",
              "suggested_time": "10:30"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at El Parian in Tlaquepaque",
              "description": "Enjoy a delicious lunch at El Parian, a large, historic gazebo surrounded by restaurants, often featuring live mariachi music.",
              "placeName": "El Parian, Tlaquepaque",
              "mapLink": "https://www.google.com/maps/place/El+Parian,+San+Pedro+Tlaquepaque,+Jal./",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/El_Parian%2C_Tlaquepaque.jpg/1280px-El_Parian%2C_Tlaquepaque.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Visit Regional Ceramics Museum",
              "description": "Learn about the rich history of ceramic art in Jalisco and Mexico at this fascinating museum.",
              "placeName": "Museo Regional de la Cerámica de Tlaquepaque",
              "mapLink": "https://www.google.com/maps/place/Museo+Regional+de+la+Cerámica+de+Tlaquepaque/",
              "ticketLink": "https://museos.cultura.gob.mx/museos/museo-regional-de-la-ceramica-de-tlaquepaque.html",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Museo_Regional_de_la_Cer%C3%A1mica_de_Tlaquepaque.jpg/1280px-Museo_Regional_de_la_Cer%C3%A1mica_de_Tlaquepaque.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner in Colonia Americana",
              "description": "Enjoy a final dinner in the trendy Colonia Americana neighborhood, known for its diverse culinary scene and vibrant nightlife.",
              "placeName": "Colonia Americana, Guadalajara",
              "mapLink": "https://www.google.com/maps/place/Colonia+Americana,+Guadalajara,+Jal./",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Colonia_Americana_Guadalajara.jpg/1280px-Colonia_Americana_Guadalajara.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Torta Ahogada (pork sandwich 'drowned' in spicy sauce)",
        "Birria (goat or beef stew, often served with tortillas)",
        "Jericallas (custard dessert, similar to flan)",
        "Pozole (hearty hominy and meat soup)",
        "Tejuino (fermented corn drink, often with lime and salt)"
      ],
      "football_experiences": [
        "FIFA Fan Fest Guadalajara (specific location TBD by FIFA)",
        "Attending a FIFA World Cup Match at Estadio Akron, Zapopan",
        "Pre-match festivities and fan zones around Estadio Akron",
        "Exploring local sports bars or cantinas to watch other matches"
      ],
      "travel_tips": [
        "**Getting to Estadio Akron (Zapopan):** Estadio Akron is located in Zapopan, west of Guadalajara's city center. On match days, FIFA typically provides dedicated shuttle services from key points in the city. Alternatively, you can use Guadalajara's public transport: take Mi Tren (light rail) Line 1 or 3 and transfer to Mi Macro Periférico (BRT) or a local bus/ride-share for the final leg. Allow ample travel time.",
        "**Public Transportation in Guadalajara:** The city has an efficient public transport system. The main components are: Mi Tren (light rail with 3 lines), Mi Macro Calzada and Mi Macro Periférico (Bus Rapid Transit, BRT), and Mi Transporte (local buses). To pay, purchase and load credit onto a rechargeable **Tarjeta Mi Movilidad** card, available at train stations and OXXO convenience stores.",
        "**Where to Stay:** For good access to both city attractions and reasonable commute to Estadio Akron, consider staying in areas like: **Colonia Americana** (trendy, good restaurants, central), **Chapultepec** (lively, nightlife, good connections), or the **Centro Histórico** (historic charm, many hotels, but slightly further from the stadium). Zapopan Centro is closer to the stadium but might be less central for other tourist activities.",
        "**Currency:** Mexican Peso (MXN). Credit cards are widely accepted in most establishments, but having cash for street vendors and smaller shops is recommended.",
        "**Safety:** Guadalajara is generally safe for tourists, but like any large city, be aware of your surroundings, especially in crowded areas or at night. Use reputable taxis or ride-sharing apps (Uber, Didi)."
      ]
    },
    "5": {
      "plannerCity": "Guadalajara",
      "matchDay": 3,
      "city": "Guadalajara",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Guadalajara, transfer to your accommodation, and check in. Settle in and prepare for your first day of exploration.",
              "placeName": "Guadalajara",
              "mapLink": "https://www.google.com/maps/place/Guadalajara,+Jalisco,+Mexico",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Guadalajara_from_Above_2021.jpg/1280px-Guadalajara_from_Above_2021.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Guadalajara Historic Center",
              "description": "Begin your journey by exploring the heart of Guadalajara. Visit the iconic Guadalajara Cathedral, stroll through Plaza de Armas, and admire the Palacio de Gobierno with its stunning murals by José Clemente Orozco.",
              "placeName": "Guadalajara Cathedral",
              "mapLink": "https://www.google.com/maps/place/Guadalajara+Cathedral/@20.679888,-103.348425,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b1fb42845c25:0x112102e3b2e5414f!8m2!3d20.679888!4d-103.34585!16s%2Fg%2F122_0y86",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Catedral_de_Guadalajara.jpg/1280px-Catedral_de_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:00"
            },
            {
              "name": "Traditional Birria Lunch at Birrieria Las 9 Esquinas",
              "description": "Savor a traditional 'birria' stew, a signature dish of Jalisco, at one of Guadalajara's most famous birrierias, located in a charming historic square.",
              "placeName": "Birrieria Las 9 Esquinas",
              "mapLink": "https://www.google.com/maps/place/Birrieria+Las+9+Esquinas/@20.670868,-103.351634,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b1fd275c9603:0x393c834a3637e6f9!8m2!3d20.670868!4d-103.349059!16s%2Fg%2F1td0k13f",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Birria_de_Chivo_en_Guadalajara.jpg/1280px-Birria_de_Chivo_en_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Evening in Tlaquepaque and Dinner at El Parian",
              "description": "Take a short trip to the magical town of Tlaquepaque, renowned for its artisan crafts, galleries, and vibrant atmosphere. Enjoy dinner and mariachi music at El Parian, a large gazebo surrounded by restaurants.",
              "placeName": "El Parian de Tlaquepaque",
              "mapLink": "https://www.google.com/maps/place/El+Pari%C3%A1n/@20.655848,-103.310682,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b12239494371:0x46429f5820468087!8m2!3d20.655848!4d-103.308107!16s%2Fg%2F1tc0r5y_",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/El_Pari%C3%A1n_de_Tlaquepaque.jpg/1280px-El_Pari%C3%A1n_de_Tlaquepaque.jpg",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Visit Instituto Cultural Cabañas",
              "description": "Explore this UNESCO World Heritage site, a former orphanage turned cultural center, famous for its magnificent murals by José Clemente Orozco. A true masterpiece of Mexican art and architecture.",
              "placeName": "Instituto Cultural Cabañas",
              "mapLink": "https://www.google.com/maps/place/Instituto+Cultural+Caba%C3%B1as/@20.679234,-103.34212,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b1fbd5508a6b:0x501a33742468350b!8m2!3d20.679234!4d-103.339545!16s%2Fm%2F02p_v_0",
              "ticketLink": "https://hospiciocabanas.jalisco.gob.mx/visitas/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Instituto_Cultural_Caba%C3%B1as_%283401569477%29.jpg/1280px-Instituto_Cultural_Caba%C3%B1as_%283401569477%29.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Mercado Libertad - San Juan de Dios",
              "description": "Immerse yourself in the vibrant atmosphere of Latin America's largest indoor market. Discover local crafts, clothing, electronics, and a vast array of food stalls.",
              "placeName": "Mercado Libertad - San Juan de Dios",
              "mapLink": "https://www.google.com/maps/place/Mercado+Libertad+-+San+Juan+de+Dios/@20.674487,-103.34005,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b1fb66f81491:0x41113b2d18471e84!8m2!3d20.674487!4d-103.337475!16s%2Fm%2F02pq4v4",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Mercado_Libertad_%28San_Juan_de_Dios%29_Guadalajara.jpg/1280px-Mercado_Libertad_%28San_Juan_de_Dios%29_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Torta Ahogada at Mercado Libertad",
              "description": "Experience the quintessential Guadalajara street food: the 'torta ahogada' (drowned sandwich), a crusty bread roll filled with pork and submerged in spicy tomato sauce, right inside the market.",
              "placeName": "Mercado Libertad - San Juan de Dios (Food Stalls)",
              "mapLink": "https://www.google.com/maps/place/Mercado+Libertad+-+San+Juan+de+Dios/@20.674487,-103.34005,17z/data=!3m1!4b1!4m6!3m5!1s0x8428b1fb66f81491:0x41113b2d18471e84!8m2!3d20.674487!4d-103.337475!16s%2Fm%2F02pq4v4",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Torta_ahogada.jpg/1280px-Torta_ahogada.jpg",
              "best_time": "afternoon",
              "suggested_time": "14:30"
            }
          ],
          "evening": [
            {
              "name": "Evening Stroll and Dinner on Chapultepec Avenue",
              "description": "Enjoy a lively evening along Avenida Chapultepec, known for its cultural corridor, art markets, and diverse dining options. Choose from various restaurants and bars.",
              "placeName": "Avenida Chapultepec",
              "mapLink": "https://www.google.com/maps/place/Avenida+Chapultepec/@20.672074,-103.372551,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae0e9f697473:0x1b7c3d1839e55106!8m2!3d20.672074!4d-103.369976!16s%2Fg%2F1tcz88q2",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Avenida_Chapultepec%2C_Guadalajara.jpg/1280px-Avenida_Chapultepec%2C_Guadalajara.jpg",
              "best_time": "evening",
              "suggested_time": "19:30"
            },
            {
              "name": "Dinner at Hueso Restaurant",
              "description": "For a unique culinary experience, dine at Hueso, known for its striking all-white interior adorned with bones and a communal dining concept featuring modern Mexican cuisine.",
              "placeName": "Hueso Restaurante",
              "mapLink": "https://www.google.com/maps/place/Hueso+Restaurante/@20.676102,-103.376839,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae101968ed1b:0x5e2079a4e320f77b!8m2!3d20.676102!4d-103.374264!16s%2Fg%2F1tdw1v94",
              "imageUrl": "https://static.wixstatic.com/media/a9d555_ee42416805174092b3226a35a11c056d~mv2.jpg/v1/fill/w_640,h_426,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a9d555_ee42416805174092b3226a35a11c056d~mv2.jpg",
              "best_time": "evening",
              "suggested_time": "21:00"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, interactive games, food, drinks, and watch other matches on giant screens. (Location to be announced, likely central Guadalajara or Zapopan).",
              "placeName": "FIFA Fan Festival (Guadalajara)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Guadalajara",
              "imageUrl": "https://digitalhub.fifa.com/transform/26fb3730-80a5-48b0-8e10-c02058079e0f/Doha-Qatar-18-December-2022-FIFA-World-Cup-Qatar-2022-Fan-Festival-Photo-by-FIFA",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Atmosphere and Travel to Estadio Akron",
              "description": "Soak in the pre-match excitement. Head towards Estadio Akron in Zapopan, allowing ample time for travel, security checks, and enjoying the vibrant atmosphere around the stadium.",
              "placeName": "Estadio Akron",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/@20.627778,-103.483333,17z/data=!3m1!4b1!4m6!3m5!1s0x8428af484d1565a9:0x8524675713c7c25c!8m2!3d20.627778!4d-103.480758!16s%2Fm%2F04j2961",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Estadio_Akron.jpg/1280px-Estadio_Akron.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Attend FIFA World Cup Match at Estadio Akron",
              "description": "Experience the thrill of a live FIFA World Cup match. Cheer for your favorite team and be part of history at Estadio Akron, the home of Club Deportivo Guadalajara (Chivas).",
              "placeName": "Estadio Akron",
              "mapLink": "https://www.google.com/maps/place/Estadio+Akron/@20.627778,-103.483333,17z/data=!3m1!4b1!4m6!3m5!1s0x8428af484d1565a9:0x8524675713c7c25c!8m2!3d20.627778!4d-103.480758!16s%2Fm%2F04j2961",
              "ticketLink": "https://www.fifa.com/fifaplus/en/tickets",
              "imageUrl": "https://digitalhub.fifa.com/transform/1c4115e5-334d-451e-8417-063a8e7e174b/FIFA-World-Cup-Qatar-2022-Match-Day-20-Qatar-v-Netherlands-Photo-by-FIFA",
              "best_time": "evening",
              "suggested_time": "19:00"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Day Trip to Tequila, Jalisco",
              "description": "Embark on an unforgettable day trip to the magical town of Tequila, the birthplace of Mexico's national drink. Explore agave fields, visit a distillery, and learn about the tequila-making process. Consider taking the Jose Cuervo Express train for a unique experience.",
              "placeName": "Tequila, Jalisco",
              "mapLink": "https://www.google.com/maps/place/Tequila,+Jalisco,+Mexico/@20.887258,-103.861783,14z/data=!3m1!4b1!4m6!3m5!1s0x84260a927c3a078f:0x6f1963977c0c1b75!8m2!3d20.887258!4d-103.844274!16s%2Fm%2F025z9s",
              "ticketLink": "https://www.josecuervotren.com/en/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Agave_fields_in_Tequila%2C_Jalisco.jpg/1280px-Agave_fields_in_Tequila%2C_Jalisco.jpg",
              "best_time": "morning",
              "suggested_time": "09:00"
            }
          ],
          "afternoon": [
            {
              "name": "Tequila Distillery Tour and Tasting",
              "description": "Visit a renowned tequila distillery in Tequila, such as La Rojeña (Jose Cuervo) or Sauza, to witness the production process from agave to bottle and enjoy a guided tasting session.",
              "placeName": "La Rojeña (Jose Cuervo Distillery)",
              "mapLink": "https://www.google.com/maps/place/La+Roje%C3%B1a+(Jose+Cuervo+Distillery)/@20.887292,-103.842777,17z/data=!3m1!4b1!4m6!3m5!1s0x84260a927a485749:0x87d60920556f8f17!8m2!3d20.887292!4d-103.840202!16s%2Fg%2F1tdy0m13",
              "ticketLink": "https://mundocuervo.com/tour-rojena/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Mundo_Cuervo%2C_Tequila%2C_Jalisco%2C_M%C3%A9xico.jpg/1280px-Mundo_Cuervo%2C_Tequila%2C_Jalisco%2C_M%C3%A9xico.jpg",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            }
          ],
          "evening": [
            {
              "name": "Return to Guadalajara and Dinner at Karnes Garibaldi",
              "description": "Travel back to Guadalajara after your day in Tequila. For dinner, experience the incredibly fast service and delicious 'carne en su jugo' (meat in its juice) at Karnes Garibaldi, a local institution.",
              "placeName": "Karnes Garibaldi",
              "mapLink": "https://www.google.com/maps/place/Karnes+Garibaldi/@20.677595,-103.376518,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae0f40d04b6d:0x3ae62193e4334335!8m2!3d20.677595!4d-103.373943!16s%2Fm%2F0gx3j3h",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Carne_en_su_jugo_con_salsa_verde.jpg/1280px-Carne_en_su_jugo_con_salsa_verde.jpg",
              "best_time": "evening",
              "suggested_time": "20:00"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Explore Zapopan and Basilica de Zapopan",
              "description": "Discover Zapopan, a vibrant municipality within the Guadalajara metropolitan area. Visit the stunning Basilica de Zapopan, home to the revered Virgin of Zapopan, and explore the charming Plaza de las Américas Juan Pablo II.",
              "placeName": "Basilica de Zapopan",
              "mapLink": "https://www.google.com/maps/place/Basilica+de+Zapopan/@20.72295,-103.399943,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae7c569f4937:0x51c5f3e9c562e873!8m2!3d20.72295!4d-103.397368!16s%2Fm%2F02517s2",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Bas%C3%ADlica_de_Zapopan_2016.jpg/1280px-Bas%C3%ADlica_de_Zapopan_2016.jpg",
              "best_time": "morning",
              "suggested_time": "10:00"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch at Birrieria Chololo (Zapopan)",
              "description": "Enjoy another taste of Jalisco's famous birria at Birrieria Chololo, a highly-rated establishment in Zapopan known for its authentic flavor and lively atmosphere.",
              "placeName": "Birrieria Chololo (Zapopan)",
              "mapLink": "https://www.google.com/maps/place/Birrieria+Chololo/@20.707797,-103.400583,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae7344933939:0x8797f26487e91404!8m2!3d20.707797!4d-103.398008!16s%2Fg%2F1tdr9v0v",
              "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipN32Qh_j9j9i_2S3-a7j71a_5p_b4b9b7b7b7b7=s1600",
              "best_time": "afternoon",
              "suggested_time": "13:00"
            },
            {
              "name": "Last-minute Souvenir Shopping",
              "description": "Grab some last-minute souvenirs or gifts in Zapopan before heading to the airport. Look for local crafts, tequila, or football merchandise.",
              "placeName": "Plaza Andares",
              "mapLink": "https://www.google.com/maps/place/Plaza+Andares/@20.70997,-103.414088,17z/data=!3m1!4b1!4m6!3m5!1s0x8428ae10d3211517:0x5e2079a4e320f77b!8m2!3d20.70997!4d-103.411513!16s%2Fg%2F1tc2672t",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Plaza_Andares_Guadalajara.jpg/1280px-Plaza_Andares_Guadalajara.jpg",
              "best_time": "afternoon",
              "suggested_time": "15:00"
            }
          ],
          "evening": [
            {
              "name": "Departure from Guadalajara",
              "description": "Head to Guadalajara International Airport (GDL) for your departure, taking with you unforgettable memories of the World Cup and Guadalajara.",
              "placeName": "Guadalajara International Airport (GDL)",
              "mapLink": "https://www.google.com/maps/place/Guadalajara+International+Airport/@20.521804,-103.310156,15z/data=!3m1!4b1!4m6!3m5!1s0x842f5349f7e53f1f:0x6b043232822a3b01!8m2!3d20.521804!4d-103.30076!16s%2Fm%2F021f1q",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Aeropuerto_de_Guadalajara_%28GDL%29.jpg/1280px-Aeropuerto_de_Guadalajara_%28GDL%29.jpg",
              "best_time": "evening",
              "suggested_time": "18:00"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Birria (Birrieria Las 9 Esquinas, Birrieria Chololo)",
        "Torta Ahogada (Mercado Libertad - San Juan de Dios)",
        "Carne en su Jugo (Karnes Garibaldi)",
        "Pozole, Enchiladas, Sopes (various local restaurants)"
      ],
      "football_experiences": [
        "FIFA Fan Festival (Guadalajara)",
        "Attending a FIFA World Cup Match at Estadio Akron",
        "Soaking in the pre-match atmosphere around Estadio Akron",
        "Visiting the home stadium of Club Deportivo Guadalajara (Chivas)"
      ],
      "travel_tips": [
        "**How to reach Estadio Akron:** Estadio Akron is located in Zapopan. On match days, special shuttles may be available from key points in the city. Otherwise, use Mi Macro Periférico (BRT line) to the 'Estadio Akron' station, then it's a short walk or taxi ride. Alternatively, take a regular bus or ride-sharing service.",
        "**Where to stay:** Consider staying in areas like Colonia Americana (bohemian, good nightlife, central), Providencia (upscale, good restaurants), or near Avenida Chapultepec for a vibrant atmosphere and good public transport connections. These areas offer a balance of tourist amenities and accessibility. For closer proximity to Estadio Akron, look for accommodation within Zapopan, though it might be less central for general sightseeing.",
        "**Public Transportation in Guadalajara:** The city has an integrated public transport system. Key components include: **Mi Tren** (Light Rail/Metro with 3 lines), **Mi Macro Calzada** (BRT line running north-south), **Mi Macro Periférico** (BRT line encircling the city, highly relevant for Estadio Akron access), and **Mi Transporte** (local buses).",
        "**Recommended Public Transport Pass:** Purchase a **Mi Movilidad card** (available at Mi Tren stations and some Oxxo stores) for seamless travel across all public transport modes. It's rechargeable and more convenient than paying with cash for each ride. Fares are affordable.",
        "**Travel Times:** Be aware that traffic in Guadalajara can be heavy. While activities within a district are close, traveling between the Historic Center and Zapopan (where Estadio Akron is) can take 45-60 minutes by public transport, especially during peak hours. Plan accordingly on match days.",
        "**Safety:** Like any large city, be aware of your surroundings, especially in crowded areas or when using public transport at night. Use reputable ride-sharing services if opting out of public transport. Keep valuables secure."
      ]
    },
    "7": {
      "plannerCity": "Guadalajara",
      "matchDay": 4,
      "city": "Guadalajara",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive at Guadalajara International Airport (GDL), transfer to your accommodation, and check in. Settle in before starting your World Cup adventure.",
              "placeName": "Guadalajara International Airport (GDL)",
              "mapLink": "https://www.google.com/maps?q=Guadalajara+International+Airport",
              "imageUrl": "https://example.com/gdl_airport.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Guadalajara Cathedral & Historic Center",
              "description": "Begin your exploration at the iconic Guadalajara Cathedral, a symbol of the city. Afterwards, wander through Plaza de Armas and visit the Government Palace (Palacio de Gobierno) to admire its murals by José Clemente Orozco.",
              "placeName": "Guadalajara Cathedral",
              "mapLink": "https://www.google.com/maps?q=Guadalajara+Cathedral",
              "imageUrl": "https://example.com/guadalajara_cathedral.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Traditional Birria Dinner at Birriería Las 9 Esquinas",
              "description": "Savor an authentic taste of Jalisco with a traditional birria stew dinner, a must-try local specialty, in a historic setting.",
              "placeName": "Birriería Las 9 Esquinas",
              "mapLink": "https://www.google.com/maps?q=Birrieria+Las+9+Esquinas",
              "imageUrl": "https://example.com/birrieria_9_esquinas.jpg",
              "best_time": "evening",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Hospicio Cabañas (UNESCO World Heritage Site)",
              "description": "Visit the magnificent Hospicio Cabañas, a UNESCO World Heritage site, famous for its neoclassical architecture and stunning murals by José Clemente Orozco, including 'The Man of Fire'.",
              "placeName": "Hospicio Cabañas",
              "mapLink": "https://www.google.com/maps?q=Hospicio+Cabañas",
              "ticketLink": "https://example.com/hospicio_tickets.html",
              "imageUrl": "https://example.com/hospicio_cabanas.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Teatro Degollado & Plaza de la Liberación",
              "description": "Explore the beautiful Teatro Degollado, an iconic opera house, and relax in Plaza de la Liberación, enjoying the historic architecture and vibrant atmosphere of the city center.",
              "placeName": "Teatro Degollado",
              "mapLink": "https://www.google.com/maps?q=Teatro+Degollado",
              "imageUrl": "https://example.com/teatro_degollado.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Tortas Ahogadas Dinner at Las Famosas",
              "description": "Try the iconic Tortas Ahogadas, a 'drowned sandwich' doused in spicy tomato sauce, a Guadalajara staple. Las Famosas is known for its delicious version.",
              "placeName": "Tortas Ahogadas Las Famosas",
              "mapLink": "https://www.google.com/maps?q=Tortas+Ahogadas+Las+Famosas",
              "imageUrl": "https://example.com/tortas_ahogadas.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Day Trip to Tlaquepaque - Artisan Town",
              "description": "Take a short trip to the charming town of Tlaquepaque, renowned for its vibrant artisan culture, galleries, and traditional Mexican crafts. Explore the pedestrian streets and unique shops.",
              "placeName": "San Pedro Tlaquepaque",
              "mapLink": "https://www.google.com/maps?q=Tlaquepaque",
              "imageUrl": "https://example.com/tlaquepaque_streets.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Lunch and Mariachi at El Parián de Tlaquepaque",
              "description": "Enjoy lunch at El Parián, a large central plaza surrounded by restaurants, where you can experience live mariachi music and traditional Mexican dances.",
              "placeName": "El Parián de Tlaquepaque",
              "mapLink": "https://www.google.com/maps?q=El+Parian+de+Tlaquepaque",
              "imageUrl": "https://example.com/el_parian_tlaquepaque.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner in Tlaquepaque or Return to Guadalajara",
              "description": "Enjoy a final dinner in Tlaquepaque at a local restaurant like El Abajeño before heading back to Guadalajara, or return to explore evening options in the city.",
              "placeName": "El Abajeño Tlaquepaque",
              "mapLink": "https://www.google.com/maps?q=El+Abajeño+Tlaquepaque",
              "imageUrl": "https://example.com/el_abajeno_tlaquepaque.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "FIFA Fan Festival / Fan Zone Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, games, and connect with fans from around the globe. Check official FIFA schedules for exact locations and timings.",
              "placeName": "FIFA Fan Festival Guadalajara (TBD)",
              "mapLink": "https://www.google.com/maps?q=Guadalajara+city+center",
              "imageUrl": "https://example.com/fifa_fan_fest.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Pre-Match Excitement at Estadio Akron",
              "description": "Head to Estadio Akron early to soak in the pre-match atmosphere. Enjoy food vendors, merchandise stalls, and fan activities around the stadium perimeter. Ensure ample time for security checks and entry.",
              "placeName": "Estadio Akron, Zapopan",
              "mapLink": "https://www.google.com/maps?q=Estadio+Akron",
              "imageUrl": "https://example.com/estadio_akron_exterior.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Estadio Akron",
              "description": "Experience the thrill of a live FIFA World Cup match at the magnificent Estadio Akron. Cheer on your favorite team and be part of history!",
              "placeName": "Estadio Akron, Zapopan",
              "mapLink": "https://www.google.com/maps?q=Estadio+Akron",
              "ticketLink": "https://www.fifa.com/worldcup/2026/tickets",
              "imageUrl": "https://example.com/estadio_akron_match.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Visit Basilica of Zapopan",
              "description": "Explore the beautiful Basilica of Zapopan, home to the revered Virgin of Zapopan. This grand basilica is a significant religious and architectural landmark in the metropolitan area.",
              "placeName": "Basilica of Zapopan",
              "mapLink": "https://www.google.com/maps?q=Basilica+of+Zapopan",
              "imageUrl": "https://example.com/basilica_zapopan.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Tequila Tasting Experience",
              "description": "Delve into the world of Mexico's national drink with a tequila tasting. Visit a local bar or specialized shop in Zapopan or Guadalajara for an educational and enjoyable experience. Consider places like La Tequila Cocina de México.",
              "placeName": "La Tequila Cocina de México",
              "mapLink": "https://www.google.com/maps?q=La+Tequila+Cocina+de+Mexico+Guadalajara",
              "imageUrl": "https://example.com/tequila_tasting.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at Hueso",
              "description": "Enjoy a unique culinary experience at Hueso, a contemporary Mexican restaurant known for its minimalist design and communal dining, offering inventive dishes.",
              "placeName": "Hueso",
              "mapLink": "https://www.google.com/maps?q=Hueso+Guadalajara",
              "imageUrl": "https://example.com/hueso_restaurant.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Explore Mercado Libertad – San Juan de Dios",
              "description": "Immerse yourself in local life at Mercado Libertad – San Juan de Dios, one of Latin America's largest indoor markets. Browse everything from crafts and clothing to fresh produce and street food.",
              "placeName": "Mercado Libertad – San Juan de Dios",
              "mapLink": "https://www.google.com/maps?q=Mercado+Libertad+San+Juan+de+Dios",
              "imageUrl": "https://example.com/mercado_libertad.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Stroll along Avenida Chapultepec",
              "description": "Discover the lively Avenida Chapultepec, a vibrant cultural corridor. Enjoy its tree-lined promenades, art installations, cafes, and bookstores. A great place for people-watching.",
              "placeName": "Avenida Chapultepec",
              "mapLink": "https://www.google.com/maps?q=Avenida+Chapultepec+Guadalajara",
              "imageUrl": "https://example.com/avenida_chapultepec.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Nightlife on Chapultepec",
              "description": "Enjoy dinner at one of the many trendy restaurants on Avenida Chapultepec, such as La Docena Oyster Bar & Grill, followed by drinks at a bar to experience Guadalajara's vibrant nightlife.",
              "placeName": "La Docena Oyster Bar & Grill Chapultepec",
              "mapLink": "https://www.google.com/maps?q=La+Docena+Oyster+Bar+Chapultepec",
              "imageUrl": "https://example.com/la_docena_chapultepec.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Souvenir Shopping & Brunch",
              "description": "Enjoy a relaxed brunch at a cafe in your preferred neighborhood, like Cafe Palreal, and do some last-minute souvenir shopping for local crafts or tequila.",
              "placeName": "Cafe Palreal",
              "mapLink": "https://www.google.com/maps?q=Cafe+Palreal",
              "imageUrl": "https://example.com/cafe_palreal.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Guadalajara",
              "description": "Check out from your hotel and transfer to Guadalajara International Airport (GDL) for your departure, taking with you unforgettable memories of Guadalajara and the World Cup.",
              "placeName": "Guadalajara International Airport (GDL)",
              "mapLink": "https://www.google.com/maps?q=Guadalajara+International+Airport",
              "imageUrl": "https://example.com/gdl_departure.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Birria (Birriería Las 9 Esquinas)",
        "Tortas Ahogadas (Tortas Ahogadas Las Famosas)",
        "Carne en su Jugo (Karnes Garibaldi)",
        "Pozole",
        "Jericallas (Local dessert)",
        "Tequila (La Tequila Cocina de México)",
        "Paletas (artisanal ice pops)"
      ],
      "football_experiences": [
        "Attending a FIFA World Cup Match at Estadio Akron",
        "Visiting the official FIFA Fan Festival/Fan Zone in Guadalajara",
        "Soaking in the pre-match atmosphere around Estadio Akron",
        "Exploring local sports bars for match viewing on non-stadium days"
      ],
      "travel_tips": [
        "**Stadium Access (Estadio Akron):** Estadio Akron is located in Zapopan, Jalisco, just outside central Guadalajara. On match days, FIFA will likely provide dedicated shuttle services from key points in Guadalajara's metropolitan area to the stadium. Public transport options include a combination of Mi Tren (light rail) and Mi Transporte (buses). From central Guadalajara, take Mi Tren Line 1 or 2 to a connecting point (e.g., Juárez station) and then transfer to a bus that goes towards Zapopan or the stadium area. Allow ample travel time on match days, typically 45-90 minutes depending on traffic and connections. Check official FIFA transport guides closer to the event.",
        "**Where to Stay:** For convenient access to both tourist attractions and potential stadium transport hubs, consider staying in areas like: **Centro Histórico** (historic center, good for sightseeing), **Avenida Chapultepec/Americana** (vibrant, dining, nightlife), or **Zapopan** (closer to Estadio Akron and modern amenities). Aim for accommodation within 60 minutes of Estadio Akron, considering potential event traffic.",
        "**Public Transportation in Guadalajara:** The city's public transport system is called `Mi Movilidad` and includes: **Mi Tren** (Sistema de Tren Eléctrico Urbano - light rail with 3 lines), **Mi Macro Calzada** (Bus Rapid Transit - BRT), **Mi Macro Periférico** (BRT circling the city), and **Mi Transporte** (standard city buses).",
        "**Recommended Public Transport Card:** Purchase a `Mi Movilidad` card (Tarjeta Mi Movilidad) for easy access across all public transport modes. These cards can be bought and recharged at Mi Tren stations and some OXXO convenience stores.",
        "**Getting Around:** For non-match days, public transport is efficient for reaching most major attractions. Taxis and ride-sharing apps (Uber, Didi) are also widely available and reasonably priced. For longer excursions like Tlaquepaque, a short bus ride or taxi is convenient."
      ]
    }
  },
  "monterrey": {
    "3": {
      "plannerCity": "Monterrey",
      "matchDay": 2,
      "city": "Monterrey",
      "total_days": 3,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival and Hotel Check-in",
              "description": "Arrive in Monterrey, check into your accommodation. Settle in before starting your exploration.",
              "placeName": "Monterrey City Center",
              "mapLink": "https://www.google.com/maps/search/Monterrey+City+Center",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Monterrey_skyline.jpg/1280px-Monterrey_skyline.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Explore Macroplaza",
              "description": "Begin your Monterrey journey at the Macroplaza, one of the largest plazas in the world. Admire the Faro del Comercio (Lighthouse of Commerce), Palacio de Gobierno, and the Metropolitan Cathedral.",
              "placeName": "Macroplaza",
              "mapLink": "https://www.google.com/maps/place/Macroplaza/@25.6669,-100.3103",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Faro_del_Comercio%2C_Monterrey%2C_M%C3%A9xico.jpg/1280px-Faro_del_Comercio%2C_Monterrey%2C_M%C3%A9xico.jpg",
              "best_time": "morning",
              "suggested_time": "10:30 AM"
            },
            {
              "name": "Breakfast at Café Flores",
              "description": "Enjoy a traditional Mexican breakfast at a local favorite near Macroplaza.",
              "placeName": "Café Flores",
              "mapLink": "https://www.google.com/maps/search/Caf%C3%A9+Flores+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/cafe_flores_monterrey.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Visit Museo de Historia Mexicana",
              "description": "Delve into Mexico's rich past at the Museum of Mexican History, part of the 'Three Museums' complex, offering comprehensive exhibits from pre-Hispanic times to the present.",
              "placeName": "Museo de Historia Mexicana",
              "mapLink": "https://www.google.com/maps/place/Museo+de+Historia+Mexicana/@25.6708,-100.3069",
              "ticketLink": "https://example.com/museo_historia_mexicana_tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Museo_de_Historia_Mexicana_y_Museo_del_Noreste_en_Monterrey.jpg/1280px-Museo_de_Historia_Mexicana_y_Museo_del_Noreste_en_Monterrey.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Lunch at El Tio",
              "description": "Savor authentic regional cuisine, including Cabrito, in a traditional setting.",
              "placeName": "El Tio Restaurante",
              "mapLink": "https://www.google.com/maps/search/El+Tio+Restaurante+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/el_tio_restaurant.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Paseo Santa Lucía Boat Ride",
              "description": "Take a relaxing boat ride along the artificial canal of Paseo Santa Lucía, connecting Macroplaza to Parque Fundidora, enjoying the illuminated views.",
              "placeName": "Paseo Santa Lucía",
              "mapLink": "https://www.google.com/maps/place/Paseo+Santa+Luc%C3%ADa/@25.6704,-100.297",
              "ticketLink": "https://example.com/paseo_santa_lucia_tickets",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Paseo_Santa_Lucia_Monterrey_N.L._Mexico.jpg/1280px-Paseo_Santa_Lucia_Monterrey_N.L._Mexico.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            },
            {
              "name": "Dinner in Barrio Antiguo",
              "description": "Explore the charming, historic Barrio Antiguo district, known for its colonial architecture, art galleries, and vibrant nightlife. Enjoy dinner at La Nacional, known for its modern Mexican dishes.",
              "placeName": "Barrio Antiguo & La Nacional",
              "mapLink": "https://www.google.com/maps/place/La+Nacional/@25.6644,-100.3047",
              "ticketLink": null,
              "imageUrl": "https://example.com/barrio_antiguo_night.jpg",
              "best_time": "evening",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Traditional Machacado Breakfast",
              "description": "Start your match day with a classic Monterrey breakfast: Machacado con Huevo (dried beef with scrambled eggs).",
              "placeName": "Machacado y Más",
              "mapLink": "https://www.google.com/maps/search/Machacado+y+M%C3%A1s+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/machacado_y_mas.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            },
            {
              "name": "Football Gear Shopping",
              "description": "Visit a local sports store to pick up some fan merchandise or local team jerseys (Tigres or Rayados) to immerse yourself in the local football culture.",
              "placeName": "Innovasport (Galerías Monterrey)",
              "mapLink": "https://www.google.com/maps/search/Innovasport+Galerias+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/innovasport.jpg",
              "best_time": "morning",
              "suggested_time": "10:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Head early to the official FIFA Fan Festival for pre-match excitement. Enjoy live music, interactive games, food vendors, and soak in the global football atmosphere.",
              "placeName": "FIFA Fan Festival Monterrey (Location TBD)",
              "mapLink": "https://www.google.com/maps/search/FIFA+Fan+Festival+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/fifa_fan_fest.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Arrive at Estadio BBVA",
              "description": "Make your way to Estadio BBVA in Guadalupe. Allow ample time for security checks and to find your seats. Enjoy the modern architecture of the 'El Gigante de Acero' (The Steel Giant).",
              "placeName": "Estadio BBVA, Guadalupe",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.6749,-100.244",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Estadio_BBVA_Bancomer_-_Monterrey%2C_M%C3%A9xico.jpg/1280px-Estadio_BBVA_Bancomer_-_Monterrey%2C_M%C3%A9xico.jpg",
              "best_time": "afternoon",
              "suggested_time": "04:30 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match",
              "description": "Witness the thrill of a FIFA World Cup match live at Estadio BBVA. Experience the incredible energy of fans from around the globe.",
              "placeName": "Estadio BBVA, Guadalupe",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.6749,-100.244",
              "ticketLink": "https://example.com/fifa_match_tickets",
              "imageUrl": "https://example.com/fifa_match_action.jpg",
              "best_time": "evening",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Post-Match Dinner at Cabrito La Fama",
              "description": "Celebrate or commiserate after the match with a traditional Monterrey dinner featuring Cabrito (roast goat), a culinary cornerstone of the region.",
              "placeName": "Cabrito La Fama",
              "mapLink": "https://www.google.com/maps/search/Cabrito+La+Fama+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/cabrito_la_fama.jpg",
              "best_time": "evening",
              "suggested_time": "10:00 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Explore Parque Fundidora",
              "description": "Spend the morning at Parque Fundidora, a unique urban park built on the grounds of a former iron and steel foundry. Explore its green spaces, art installations, and the iconic Horno3 museum.",
              "placeName": "Parque Fundidora",
              "mapLink": "https://www.google.com/maps/place/Parque+Fundidora/@25.6766,-100.282",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Parque_Fundidora_1.jpg/1280px-Parque_Fundidora_1.jpg",
              "best_time": "morning",
              "suggested_time": "09:30 AM"
            },
            {
              "name": "Brunch at Pangea",
              "description": "Indulge in a refined brunch experience at Pangea, one of Monterrey's most acclaimed fine dining restaurants, known for its creative Mexican-French fusion cuisine.",
              "placeName": "Pangea Restaurante",
              "mapLink": "https://www.google.com/maps/search/Pangea+Restaurante+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/pangea_restaurant.jpg",
              "best_time": "morning",
              "suggested_time": "11:30 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Panoramic Views from Mirador del Obispado",
              "description": "Visit Mirador del Obispado, a historic site offering breathtaking panoramic views of Monterrey and the iconic Cerro de la Silla mountain.",
              "placeName": "Mirador del Obispado",
              "mapLink": "https://www.google.com/maps/place/Mirador+del+Obispado/@25.6811,-100.334",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Mirador_del_Obispado_%28Monterrey%2C_Nuevo_Le%C3%B3n%29.jpg/1280px-Mirador_del_Obispado_%28Monterrey%2C_Nuevo_Le%C3%B3n%29.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Lunch at Tacos Orinoco",
              "description": "Enjoy a casual, yet iconic, last meal in Monterrey at Tacos Orinoco, famous for its delicious trompo, chicharrón, and arrachera tacos.",
              "placeName": "Tacos Orinoco",
              "mapLink": "https://www.google.com/maps/search/Tacos+Orinoco+Monterrey",
              "ticketLink": null,
              "imageUrl": "https://example.com/tacos_orinoco.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Departure from Monterrey",
              "description": "Head to the airport for your departure, carrying unforgettable memories of the FIFA World Cup and Monterrey.",
              "placeName": "Monterrey International Airport (MTY)",
              "mapLink": "https://www.google.com/maps/place/Monterrey+International+Airport/@25.7788,-100.106",
              "ticketLink": null,
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Aeropuerto_Internacional_de_Monterrey_Terminal_A.jpg/1280px-Aeropuerto_Internacional_de_Monterrey_Terminal_A.jpg",
              "best_time": "evening",
              "suggested_time": "06:00 PM"
            }
          ]
        }
      ],
      "top_food_recommendations": [
        "Cabrito (Roast Goat): A signature dish of Monterrey, slow-roasted to perfection.",
        "Machacado con Huevo: Dried beef scrambled with eggs, a staple breakfast.",
        "Tacos Orinoco: Famous for its simple yet incredibly flavorful trompo, chicharrón, and arrachera tacos.",
        "Arrachera: Skirt steak, often grilled and served with tortillas and guacamole.",
        "Glorias de Linares: A traditional candy made from goat's milk, pecans, and burnt sugar."
      ],
      "football_experiences": [
        "FIFA World Cup Match at Estadio BBVA",
        "FIFA Fan Festival (official fan zone)",
        "Exploring Estadio BBVA's modern architecture and surroundings",
        "Soaking in the local football culture (Rayados and Tigres rivalry)"
      ],
      "travel_tips": [
        "**Accommodation:** For convenience and access to tourist attractions, consider staying in Downtown Monterrey (near Macroplaza) or the upscale San Pedro Garza García area. For closer proximity to Estadio BBVA, look for options in Guadalupe or San Nicolás de los Garza.",
        "**Getting to Estadio BBVA:** The stadium is located in Guadalupe. The most efficient way to reach it on match day is via Metrorrey (Monterrey's light rail system). Take Line 1 to Estación Exposición, which is the closest station to Estadio BBVA. From there, it's a short walk or a designated shuttle service will likely be available. Allow plenty of time due to crowds.",
        "**Public Transportation in Monterrey:** The city's main public transport system is **Metrorrey**, a light rail system with three lines (Line 1, Line 2, Line 3) that connect key areas. There's also an extensive **Metrobus** (bus) network. To use public transport, it is highly recommended to purchase a rechargeable **Tarjeta MIA** card, which can be bought and topped up at Metrorrey stations. Fares are affordable, and it's the most practical way to navigate the city without a car.",
        "**Taxis and Ride-Sharing:** Taxis are widely available. Ride-sharing apps like Uber and Didi are also popular and can be convenient, especially for evening travel or when public transport isn't direct. Confirm the fare or use the app's estimate before starting your journey.",
        "**Safety:** Like any large city, be aware of your surroundings, especially in crowded areas and at night. Use reputable transportation services. Keep valuables out of sight.",
        "**Currency:** The local currency is the Mexican Peso (MXN). ATMs are widely available, and credit cards are accepted in most establishments. It's useful to carry some cash for smaller vendors or tips."
      ]
    },
    "5": {
      "plannerCity": "Monterrey",
      "matchDay": 3,
      "city": "Monterrey",
      "total_days": 5,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive at General Mariano Escobedo International Airport (MTY), transfer to your accommodation, and settle in.",
              "placeName": "General Mariano Escobedo International Airport (MTY)",
              "mapLink": "https://www.google.com/maps/place/Monterrey+International+Airport/@25.7788487,-100.1802936,15z/data=!4m2!3m1!1s0x0:0xbf2625841029c91d?sa=X&ved=1t:2803&hl=en",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Monterrey_International_Airport_Terminal_A.jpg/1920px-Monterrey_International_Airport_Terminal_A.jpg",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Explore Macroplaza",
              "description": "Visit one of the largest plazas in the world, home to many significant monuments and buildings.",
              "placeName": "Macroplaza",
              "mapLink": "https://www.google.com/maps/place/Macroplaza/@25.6698947,-100.3129487,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0xa991e921d701047c!8m2!3d25.6698947!4d-100.3103738!16s%2Fm%2F0407786?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Macroplaza_Monterrey_2011.JPG/1920px-Macroplaza_Monterrey_2011.JPG",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Palacio de Gobierno del Estado de Nuevo León",
              "description": "Admire the impressive neoclassical architecture of the state government palace, located at one end of Macroplaza.",
              "placeName": "Palacio de Gobierno del Estado de Nuevo León",
              "mapLink": "https://www.google.com/maps/place/Palacio+de+Gobierno+del+Estado+de+Nuevo+Le%C3%B3n/@25.667825,-100.3101188,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0x41ff056b4f7389a4!8m2!3d25.667825!4d-100.3075439!16s%2Fm%2F025z9m9?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Palacio_de_Gobierno_de_Nuevo_Le%C3%B3n.jpg/1920px-Palacio_de_Gobierno_de_Nuevo_Le%C3%B3n.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Stroll through Barrio Antiguo",
              "description": "Experience the historic charm of Monterrey's old quarter with its colonial buildings, art galleries, and vibrant nightlife.",
              "placeName": "Barrio Antiguo",
              "mapLink": "https://www.google.com/maps/place/Barrio+Antiguo/@25.665975,-100.3059881,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd8b94873335:0x12d6a5758c0c459b!8m2!3d25.665975!4d-100.3034132!16s%2Fm%2F03m4x99?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Barrio_Antiguo%2C_Monterrey%2C_N.L._(3).jpg/1920px-Barrio_Antiguo%2C_Monterrey%2C_N.L._(3).jpg",
              "best_time": "evening",
              "suggested_time": null
            },
            {
              "name": "Dinner at El Rey del Cabrito",
              "description": "Savor the iconic local dish, Cabrito (roasted goat), at one of Monterrey's most famous restaurants.",
              "placeName": "El Rey del Cabrito (Sucursal Constitución)",
              "mapLink": "https://www.google.com/maps/place/El+Rey+del+Cabrito/@25.670695,-100.3155776,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89542a177b:0x5e2373003058a57e!8m2!3d25.670695!4d-100.3130027!16s%2Fg%2F1tf_2_t_?entry=ttu",
              "imageUrl": "https://elreydelcabrito.com.mx/wp-content/uploads/2020/09/cabrito-el-rey-del-cabrito.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Explore Fundidora Park",
              "description": "Visit a unique urban park built on the grounds of a former iron and steel foundry, featuring museums, green spaces, and a lake.",
              "placeName": "Parque Fundidora",
              "mapLink": "https://www.google.com/maps/place/Parque+Fundidora/@25.679633,-100.2917717,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd93574944d1:0x44619d80d2871758!8m2!3d25.679633!4d-100.2891968!16s%2Fm%2F025z9tq?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Parque_Fundidora.jpg/1920px-Parque_Fundidora.jpg",
              "best_time": "morning",
              "suggested_time": null
            },
            {
              "name": "Boat ride on Paseo Santa Lucía",
              "description": "Enjoy a scenic boat ride along the artificial river connecting Macroplaza to Fundidora Park, admiring the sculptures and fountains.",
              "placeName": "Paseo Santa Lucía",
              "mapLink": "https://www.google.com/maps/place/Paseo+Santa+Luc%C3%ADa/@25.677583,-100.3013892,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd913210439d:0x367fdf8073a4b080!8m2!3d25.677583!4d-100.2988143!16s%2Fm%2F03m4x9b?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Paseo_Santa_Luc%C3%ADa%2C_Monterrey%2C_N.L..jpg/1920px-Paseo_Santa_Luc%C3%ADa%2C_Monterrey%2C_N.L..jpg",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Visit Museo de Historia Mexicana",
              "description": "Explore Mexico's rich history from pre-Hispanic times to the present day through engaging exhibits.",
              "placeName": "Museo de Historia Mexicana",
              "mapLink": "https://www.google.com/maps/place/Museo+de+Historia+Mexicana/@25.670267,-100.306161,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd8a6148301d:0x1b209d7d43232672!8m2!3d25.670267!4d-100.3035861!16s%2Fm%2F0gj339g?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Museo_de_Historia_Mexicana_2011.jpg/1920px-Museo_de_Historia_Mexicana_2011.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Taqueria Orinoco",
              "description": "Indulge in delicious and famous 'tacos de trompo' (spit-grilled pork tacos) at a beloved local spot.",
              "placeName": "Taqueria Orinoco (Centrito Valle)",
              "mapLink": "https://www.google.com/maps/place/Taqueria+Orinoco+Centrito+Valle/@25.6593537,-100.3601552,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd66f443574d:0xc26859346618420e!8m2!3d25.6593537!4d-100.3575803!16s%2Fg%2F1tdy31p3?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/11/4a/c0/86/taqueria-orinoco.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Breakfast & Souvenir Shopping",
              "description": "Enjoy a relaxed breakfast and explore local shops for football merchandise or souvenirs near your hotel in downtown Monterrey.",
              "placeName": "Downtown Monterrey",
              "mapLink": "https://www.google.com/maps/place/Monterrey+Centro/@25.665792,-100.3168233,15z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0x10f76082264c700!8m2!3d25.665792!4d-100.3080685!16s%2Fg%2F11b6m71759?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Monterrey_Centro_de_Noche.jpg/1920px-Monterrey_Centro_de_Noche.jpg",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival, enjoying live music, food, and activities with fellow fans.",
              "placeName": "Parque Fundidora (likely Fan Festival location)",
              "mapLink": "https://www.google.com/maps/place/Parque+Fundidora/@25.679633,-100.2917717,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd93574944d1:0x44619d80d2871758!8m2!3d25.679633!4d-100.2891968!16s%2Fm%2F025z9tq?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/FIFA_Fan_Fest_Rio_de_Janeiro_2014-06-15_1.jpg/1920px-FIFA_Fan_Fest_Rio_de_Janeiro_2014-06-15_1.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Travel to Estadio BBVA",
              "description": "Head to Estadio BBVA in Guadalupe using public transport (Metrorrey Line 1 to Exposición, then walk or shuttle). Allow ample time for security and entry procedures.",
              "placeName": "Estadio BBVA",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.6685806,-100.2312674,17z/data=!3m1!4b1!4m6!3m5!1s0x8662c1613998f483:0x39589d813735166f!8m2!3d25.6685806!4d-100.2286925!16s%2Fm%2F0110j191?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Estadio_BBVA_Bancomer_2017.jpg/1920px-Estadio_BBVA_Bancomer_2017.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Attend FIFA World Cup Match",
              "description": "Experience the thrill of a live FIFA World Cup match at the spectacular Estadio BBVA, home of CF Monterrey.",
              "placeName": "Estadio BBVA",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.6685806,-100.2312674,17z/data=!3m1!4b1!4m6!3m5!1s0x8662c1613998f483:0x39589d813735166f!8m2!3d25.6685806!4d-100.2286925!16s%2Fm%2F0110j191?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Estadio_BBVA_Bancomer_2017.jpg/1920px-Estadio_BBVA_Bancomer_2017.jpg",
              "best_time": "evening",
              "suggested_time": null
            },
            {
              "name": "Post-match Dinner & Celebration",
              "description": "Enjoy post-match dinner and drinks at a local eatery or sports bar near the stadium or back in the city center.",
              "placeName": "Various locations near Estadio BBVA or Downtown Monterrey",
              "mapLink": "https://www.google.com/maps/search/restaurants+near+Estadio+BBVA/@25.6685806,-100.2312674,14z/data=!3m1!4b1",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/17/5c/41/88/photo0-jpg.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Visit Cerro del Obispado & Mirador",
              "description": "Ascend to the historic Obispado Hill for panoramic views of Monterrey and the iconic Cerro de la Silla mountain.",
              "placeName": "Mirador del Obispado",
              "mapLink": "https://www.google.com/maps/place/Mirador+del+Obispado/@25.679166,-100.3340578,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd66f443574d:0x38612f00a5a3a785!8m2!3d25.679166!4d-100.3314829!16s%2Fm%2F03m4x9f?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Mirador_Obispado.jpg/1920px-Mirador_Obispado.jpg",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Explore Mercado Juárez",
              "description": "Immerse yourself in local culture at this bustling traditional market, perfect for souvenirs, crafts, and authentic street food.",
              "placeName": "Mercado Juárez",
              "mapLink": "https://www.google.com/maps/place/Mercado+Ju%C3%A1rez/@25.670356,-100.3129598,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0xb5a0d3b6f2f0c741!8m2!3d25.670356!4d-100.3103849!16s%2Fg%2F1thz7v3r?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Mercado_Ju%C3%A1rez%2C_Monterrey.jpg/1920px-Mercado_Ju%C3%A1rez%2C_Monterrey.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Lunch: Local Street Food at Mercado Juárez",
              "description": "Taste authentic Mexican street food and local delicacies like Gorditas and Tostadas inside Mercado Juárez.",
              "placeName": "Mercado Juárez",
              "mapLink": "https://www.google.com/maps/place/Mercado+Ju%C3%A1rez/@25.670356,-100.3129598,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0xb5a0d3b6f2f0c741!8m2!3d25.670356!4d-100.3103849!16s%2Fg%2F1thz7v3r?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/17/5c/41/88/photo0-jpg.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": [
            {
              "name": "Dinner at Pangea",
              "description": "Experience upscale contemporary Mexican cuisine at one of Monterrey's most acclaimed restaurants in San Pedro Garza García.",
              "placeName": "Pangea Restaurante",
              "mapLink": "https://www.google.com/maps/place/Pangea+Restaurante/@25.666991,-100.3664727,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd715f5c15f5:0x1b79f61b1b36a1c5!8m2!3d25.666991!4d-100.3639018!16s%2Fg%2F1tdy050d?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/12/35/68/73/pangea-restaurante.jpg",
              "best_time": "evening",
              "suggested_time": null
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Visit MARCO (Museo de Arte Contemporáneo)",
              "description": "Explore modern and contemporary art exhibitions in a striking architectural building in the city center.",
              "placeName": "MARCO (Museo de Arte Contemporáneo)",
              "mapLink": "https://www.google.com/maps/place/MARCO+%28Museo+de+Arte+Contempor%C3%A1neo%29/@25.667634,-100.3079637,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd89617d59b3:0x1c8b211d0449520a!8m2!3d25.667634!4d-100.3053888!16s%2Fm%2F025z9tn?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/MARCO_Monterrey_2011.JPG/1920px-MARCO_Monterrey_2011.JPG",
              "best_time": "morning",
              "suggested_time": null
            }
          ],
          "afternoon": [
            {
              "name": "Farewell Lunch at La Nacional",
              "description": "Enjoy a final taste of traditional Mexican cuisine in a charming setting before heading to the airport.",
              "placeName": "La Nacional (Centro)",
              "mapLink": "https://www.google.com/maps/place/La+Nacional+Centro/@25.666358,-100.304561,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bd8c8a77d11f:0xb9f4e2467d0252b4!8m2!3d25.666358!4d-100.3019861!16s%2Fg%2F11b6m71380?entry=ttu",
              "imageUrl": "https://res.cloudinary.com/tf-pf/image/upload/f_auto,q_auto,w_800/restaurant/La_Nacional_Centro_d77f3e09-e85d-4f16-834c-628d0113f898.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            },
            {
              "name": "Depart from Monterrey",
              "description": "Transfer to General Mariano Escobedo International Airport (MTY) for your departure.",
              "placeName": "General Mariano Escobedo International Airport (MTY)",
              "mapLink": "https://www.google.com/maps/place/Monterrey+International+Airport/@25.7788487,-100.1802936,15z/data=!4m2!3m1!1s0x0:0xbf2625841029c91d?sa=X&ved=1t:2803&hl=en",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Monterrey_International_Airport_Terminal_A.jpg/1920px-Monterrey_International_Airport_Terminal_A.jpg",
              "best_time": "afternoon",
              "suggested_time": null
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Cabrito (roasted goat)",
        "Tacos de Trompo (spit-grilled pork tacos, especially from Taqueria Orinoco)",
        "Machacado con Huevo (dried beef with scrambled eggs)",
        "Pan de Elote (sweet corn bread)",
        "Arrachera (grilled skirt steak)",
        "Gorditas and Tostadas (at Mercado Juárez)"
      ],
      "football_experiences": [
        "Attending a FIFA World Cup Match at Estadio BBVA",
        "Immersing in the atmosphere at the FIFA Fan Festival (likely at Parque Fundidora)",
        "Visiting local sports bars or pubs to watch other matches",
        "Shopping for official FIFA and local team merchandise"
      ],
      "travel_tips": [
        "How to reach Estadio BBVA:",
        "Estadio BBVA is located in Guadalupe, Nuevo León. The most efficient way to reach it is via Metrorrey (Monterrey's metro system). Take Line 1 (Línea 1) to the 'Exposición' station. From Exposición, the stadium is approximately a 15-20 minute walk, or you can use dedicated shuttle buses/TransMetro services typically available on match days. Taxis and ride-sharing apps (Uber, Didi) are also options but expect heavy traffic and surge pricing on match days.",
        "Where to Stay:",
        "Consider staying in 'Downtown Monterrey' (Centro) for central access to landmarks, restaurants, and Metrorrey stations, providing good public transport links to the stadium. 'San Pedro Garza García' offers more upscale accommodations and dining, though it's a bit further out. 'Guadalupe' is closest to the stadium but may have fewer amenities for tourists. Aim for accommodations within 60 minutes travel time (public transport) of Estadio BBVA.",
        "Public Transportation in Monterrey:",
        "Metrorrey: Monterrey's light rail/metro system consists of three lines. Line 1 is essential for reaching Estadio BBVA (Exposición station).",
        "TransMetro: A network of feeder buses that connect Metrorrey stations to various neighborhoods, extending the metro's reach.",
        "Regular Bus Routes: An extensive network, though navigating can be challenging for visitors without local knowledge.",
        "Payment: Purchase a rechargeable 'Tarjeta MIA' (MIA Card) at any Metrorrey station. This card is used for Metrorrey and TransMetro. Cash is generally not accepted on Metrorrey but may be on some bus routes.",
        "Ride-sharing: Uber and Didi are widely available and generally affordable outside of peak match day traffic.",
        "General Tips:",
        "Learn basic Spanish phrases to enhance your experience. Stay hydrated, especially in the Monterrey heat. Be mindful of your belongings, particularly in crowded areas. Always use official FIFA channels for match tickets and fan festival information."
      ]
    },
    "7": {
      "plannerCity": "Monterrey",
      "matchDay": 4,
      "city": "Monterrey",
      "total_days": 7,
      "itinerary": [
        {
          "day": 1,
          "morning": [
            {
              "name": "Arrival & Hotel Check-in",
              "description": "Arrive at General Mariano Escobedo International Airport (MTY), transfer to your hotel, and check in. Settle in and prepare for your Monterrey adventure.",
              "placeName": "General Mariano Escobedo International Airport (MTY)",
              "mapLink": "https://www.google.com/maps/place/General+Mariano+Escobedo+International+Airport/@25.778889,-100.106944,17z/data=!3m1!4b1!4m6!3m5!1s0x8662e086786c0c17:0x2287959a4993883a!8m2!3d25.778889!4d-100.106944!16s%2Fg%2F1tf_9r77?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Monterrey_Airport.jpg/1200px-Monterrey_Airport.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Macroplaza & Palacio de Gobierno",
              "description": "Discover Macroplaza, one of the world's largest plazas. Visit the iconic Palacio de Gobierno, a historic building with impressive architecture.",
              "placeName": "Macroplaza",
              "mapLink": "https://www.google.com/maps/place/Macroplaza/@25.666944,-100.310278,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be221447d25f:0x8772a0953a99e74f!8m2!3d25.666944!4d-100.310278!16s%2Fg%2F11b6gj102z?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Macroplaza_Monterrey_N.L._M%C3%A9xico.jpg/1200px-Macroplaza_Monterrey_N.L._M%C3%A9xico.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner and Stroll in Barrio Antiguo",
              "description": "Enjoy traditional Mexican cuisine in the charming, historic Barrio Antiguo. This area comes alive in the evening with restaurants, bars, and live music.",
              "placeName": "Barrio Antiguo",
              "mapLink": "https://www.google.com/maps/place/Barrio+Antiguo/@25.6662,-100.3013,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be226e64259b:0x51c72879f977c77d!8m2!3d25.6662!4d-100.3013!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Barrio_Antiguo%2C_Monterrey.jpg/1200px-Barrio_Antiguo%2C_Monterrey.jpg",
              "suggested_time": "07:00 PM"
            },
            {
              "name": "Taste Tacos al Pastor at Taquería Orinoco",
              "description": "Savor authentic Tacos al Pastor at one of Monterrey's most famous taquerias. A must-try local food experience.",
              "placeName": "Taquería Orinoco",
              "mapLink": "https://www.google.com/maps/place/Taquer%C3%ADa+Orinoco/@25.6690412,-100.3039751,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be224a132049:0x2213797669d6757b!8m2!3d25.6690412!4d-100.3014002!16s%2Fg%2F11g65b53gq?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Taqueria_Orinoco_Tacos.jpg/1024px-Taqueria_Orinoco_Tacos.jpg",
              "suggested_time": "08:30 PM"
            }
          ]
        },
        {
          "day": 2,
          "morning": [
            {
              "name": "Visit MARCO (Museum of Contemporary Art)",
              "description": "Explore contemporary Latin American art at MARCO, known for its stunning architecture and diverse exhibitions.",
              "placeName": "MARCO (Museo de Arte Contemporáneo de Monterrey)",
              "mapLink": "https://www.google.com/maps/place/MARCO+(Museo+de+Arte+Contempor%C3%A1neo+de+Monterrey)/@25.667222,-100.303889,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be221447d25f:0x8772a0953a99e74f!8m2!3d25.667222!4d-100.303889!16s%2Fg%2F11b6gj102z?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Museo_de_Arte_Contempor%C3%A1neo_%28MARCO%29%2C_Monterrey%2C_M%C3%A9xico.jpg/1200px-Museo_de_Arte_Contempor%C3%A1neo_%28MARCO%29%2C_Monterrey%2C_M%C3%A9xico.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Paseo Santa Lucía & Parque Fundidora",
              "description": "Take a boat ride or walk along the artificial river of Paseo Santa Lucía, leading to Parque Fundidora. Explore the park's industrial heritage, museums, and green spaces.",
              "placeName": "Paseo Santa Lucía",
              "mapLink": "https://www.google.com/maps/place/Paseo+Santa+Luc%C3%ADa/@25.670278,-100.291111,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be2281a815a5:0x86c757656e4c760!8m2!3d25.670278!4d-100.291111!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Paseo_Santa_Lucia_Monterrey.jpg/1200px-Paseo_Santa_Lucia_Monterrey.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            },
            {
              "name": "Lunch at Pangea (Fine Dining)",
              "description": "Experience contemporary Mexican cuisine at Pangea, one of Monterrey's most acclaimed restaurants, offering innovative dishes and a sophisticated ambiance.",
              "placeName": "Pangea",
              "mapLink": "https://www.google.com/maps/place/Pangea/@25.656821,-100.364426,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bdc0b11a437f:0x6a053c153723702a!8m2!3d25.656821!4d-100.3618511!16s%2Fg%2F1tdy_f2w?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0d/1e/8a/a5/pangea-restaurant.jpg",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner near Parque Fundidora",
              "description": "Enjoy dinner at one of the many restaurants located around Parque Fundidora, offering various cuisines.",
              "placeName": "Parque Fundidora Area",
              "mapLink": "https://www.google.com/maps/place/Parque+Fundidora/@25.670278,-100.291111,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be2281a815a5:0x86c757656e4c760!8m2!3d25.670278!4d-100.291111!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Paseo_Santa_Lucia_Monterrey.jpg/1200px-Paseo_Santa_Lucia_Monterrey.jpg",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 3,
          "morning": [
            {
              "name": "Panoramic Views from Mirador del Obispado",
              "description": "Ascend to Mirador del Obispado for breathtaking panoramic views of Monterrey, including the iconic Cerro de la Silla.",
              "placeName": "Mirador del Obispado",
              "mapLink": "https://www.google.com/maps/place/Mirador+del+Obispado/@25.6775,-100.342222,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be2281a815a5:0x86c757656e4c760!8m2!3d25.6775!4d-100.342222!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Mirador_del_Obispado%2C_Monterrey.jpg/1200px-Mirador_del_Obispado%2C_Monterrey.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore San Pedro Garza García & Fashion Drive",
              "description": "Visit the upscale municipality of San Pedro Garza García, known for its modern architecture, boutiques, and shopping centers like Fashion Drive.",
              "placeName": "Fashion Drive",
              "mapLink": "https://www.google.com/maps/place/Fashion+Drive/@25.656111,-100.366111,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bde554b42b1f:0x6b1c834e5a9c0f99!8m2!3d25.656111!4d-100.366111!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Fashion_Drive_Monterrey.jpg/1200px-Fashion_Drive_Monterrey.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at El Gran Pastor (Cabrito)",
              "description": "Indulge in the iconic dish of Monterrey, Cabrito (roasted goat), at the renowned El Gran Pastor restaurant in San Pedro Garza García.",
              "placeName": "El Gran Pastor",
              "mapLink": "https://www.google.com/maps/place/El+Gran+Pastor/@25.659167,-100.361667,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bdc0c4a45a1f:0x2c0f2b3e8e1f0e1a!8m2!3d25.659167!4d-100.361667!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/06/66/d4/0b/el-gran-pastor.jpg",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 4,
          "morning": [
            {
              "name": "Pre-Match Breakfast & Relaxation",
              "description": "Enjoy a relaxed breakfast at your hotel or a local cafe. Catch up on World Cup news and build excitement for the match.",
              "placeName": "Local Cafe",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Breakfast_sandwich_and_coffee.jpg/1200px-Breakfast_sandwich_and_coffee.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "FIFA Fan Festival / Fan Zone Experience",
              "description": "Immerse yourself in the World Cup atmosphere at the official FIFA Fan Festival. Enjoy live music, food, sponsor activities, and watch other matches on giant screens.",
              "placeName": "FIFA Fan Festival (likely Parque Fundidora or Macroplaza)",
              "mapLink": "https://www.google.com/maps/place/Parque+Fundidora/@25.670278,-100.291111,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be2281a815a5:0x86c757656e4c760!8m2!3d25.670278!4d-100.291111!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/FIFA_Fan_Fest_Rio_2014.jpg/1200px-FIFA_Fan_Fest_Rio_2014.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            },
            {
              "name": "Travel to Estadio BBVA",
              "description": "Head to Estadio BBVA in Guadalupe. Use public transport (Metro Line 1 to Exposición station, then walk/shuttle) or pre-booked transport. Allow ample time for security checks and entry.",
              "placeName": "Estadio BBVA",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.678768,-100.244795,17z/data=!3m1!4b1!4m6!3m5!1s0x8662c16198889985:0x4106579f6e520d2d!8m2!3d25.678768!4d-100.244795!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Estadio_BBVA.jpg/1200px-Estadio_BBVA.jpg",
              "best_time": "afternoon",
              "suggested_time": "03:00 PM"
            }
          ],
          "evening": [
            {
              "name": "FIFA World Cup Match at Estadio BBVA",
              "description": "Experience the thrill of a live FIFA World Cup match at the magnificent Estadio BBVA. Soak in the atmosphere and cheer for your favorite team!",
              "placeName": "Estadio BBVA",
              "mapLink": "https://www.google.com/maps/place/Estadio+BBVA/@25.678768,-100.244795,17z/data=!3m1!4b1!4m6!3m5!1s0x8662c16198889985:0x4106579f6e520d2d!8m2!3d25.678768!4d-100.244795!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Estadio_BBVA.jpg/1200px-Estadio_BBVA.jpg",
              "best_time": "evening",
              "suggested_time": "05:00 PM"
            },
            {
              "name": "Post-Match Dinner & Celebration",
              "description": "Enjoy a celebratory dinner after the match. Many restaurants near Estadio BBVA or back in central Monterrey will be buzzing with fans.",
              "placeName": "Restaurant near Estadio BBVA or central Monterrey",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Museo_de_Arte_Contempor%C3%A1neo_%28MARCO%29%2C_Monterrey%2C_M%C3%A9xico.jpg/1200px-Museo_de_Arte_Contempor%C3%A1neo_%28MARCO%29%2C_Monterrey%2C_M%C3%A9xico.jpg",
              "suggested_time": "08:00 PM"
            }
          ]
        },
        {
          "day": 5,
          "morning": [
            {
              "name": "Day Trip to Grutas de García (Caves)",
              "description": "Embark on an excursion to Grutas de García, magnificent limestone caves located approximately an hour from Monterrey. Take a cable car to the entrance and explore the impressive formations. This is an intentional longer excursion.",
              "placeName": "Grutas de García",
              "mapLink": "https://www.google.com/maps/place/Grutas+de+Garc%C3%ADa/@25.861111,-100.596944,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bde554b42b1f:0x6b1c834e5a9c0f99!8m2!3d25.861111!4d-100.596944!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "ticketLink": "https://www.getyourguide.com/monterrey-l1288/monterrey-garcia-caves-and-pottery-town-tour-t446698/",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Grutas_de_Garcia%2C_Nuevo_Leon.jpg/1200px-Grutas_de_Garcia%2C_Nuevo_Leon.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Return from Grutas & Late Lunch",
              "description": "Travel back to Monterrey and enjoy a late lunch, perhaps trying some local street food or a casual restaurant.",
              "placeName": "Monterrey City Center",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Monterrey_Airport.jpg/1200px-Monterrey_Airport.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:30 PM"
            }
          ],
          "evening": [
            {
              "name": "Dinner at El Rey del Cabrito (Padre Mier)",
              "description": "Experience another famous spot for Cabrito, El Rey del Cabrito, known for its lively atmosphere and traditional flavors.",
              "placeName": "El Rey del Cabrito (Padre Mier)",
              "mapLink": "https://www.google.com/maps/place/El+Rey+Del+Cabrito/@25.669074,-100.301556,17z/data=!3m1!4b1!4m6!3m5!1s0x8662be21c17243c9:0x8772a0953a99e74f!8m2!3d25.669074!4d-100.2989811!16s%2Fg%2F11b6gj102z?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0e/1e/8a/a5/cabrito-al-pastor.jpg",
              "suggested_time": "07:00 PM"
            }
          ]
        },
        {
          "day": 6,
          "morning": [
            {
              "name": "Football Souvenir Shopping & Coffee",
              "description": "Visit a sports store or market for football-related souvenirs. Enjoy a coffee at a local cafe with a football ambiance.",
              "placeName": "Local Sports Store or Cafe",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Monterrey_Airport.jpg/1200px-Monterrey_Airport.jpg",
              "best_time": "morning",
              "suggested_time": "10:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Explore Mercado Juárez",
              "description": "Wander through Mercado Juárez, a traditional Mexican market offering everything from local crafts and souvenirs to fresh produce and street food.",
              "placeName": "Mercado Juárez",
              "mapLink": "https://www.google.com/maps/place/Mercado+Ju%C3%A1rez/@25.666111,-100.306111,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bde554b42b1f:0x6b1c834e5a9c0f99!8m2!3d25.666111!4d-100.306111!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Mercado_Juarez.jpg/1200px-Mercado_Juarez.jpg",
              "best_time": "afternoon",
              "suggested_time": "02:00 PM"
            }
          ],
          "evening": [
            {
              "name": "Farewell Dinner with Arrachera at La Nacional",
              "description": "Enjoy a farewell dinner featuring Arrachera (skirt steak), a popular cut in Northern Mexico, at the high-quality steakhouse La Nacional.",
              "placeName": "La Nacional (San Pedro)",
              "mapLink": "https://www.google.com/maps/place/La+Nacional+San+Pedro/@25.660144,-100.370597,17z/data=!3m1!4b1!4m6!3m5!1s0x8662bdc1b504620b:0x51c72879f977c77d!8m2!3d25.660144!4d-100.3680221!16s%2Fg%2F11b6j2j6l8?entry=ttu",
              "imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/0f/5e/5c/7e/arrachera-la-nacional.jpg",
              "suggested_time": "07:30 PM"
            }
          ]
        },
        {
          "day": 7,
          "morning": [
            {
              "name": "Last-Minute Souvenirs & Departure Prep",
              "description": "Enjoy a final Mexican breakfast, pick up any last-minute souvenirs, and prepare for your departure from Monterrey.",
              "placeName": "Hotel or local breakfast spot",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Breakfast_sandwich_and_coffee.jpg/1200px-Breakfast_sandwich_and_coffee.jpg",
              "best_time": "morning",
              "suggested_time": "09:00 AM"
            }
          ],
          "afternoon": [
            {
              "name": "Departure from Monterrey",
              "description": "Transfer to General Mariano Escobedo International Airport (MTY) for your onward journey.",
              "placeName": "General Mariano Escobedo International Airport (MTY)",
              "mapLink": "https://www.google.com/maps/place/General+Mariano+Escobedo+International+Airport/@25.778889,-100.106944,17z/data=!3m1!4b1!4m6!3m5!1s0x8662e086786c0c17:0x2287959a4993883a!8m2!3d25.778889!4d-100.106944!16s%2Fg%2F1tf_9r77?entry=ttu",
              "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Monterrey_Airport.jpg/1200px-Monterrey_Airport.jpg",
              "best_time": "afternoon",
              "suggested_time": "01:00 PM"
            }
          ],
          "evening": []
        }
      ],
      "top_food_recommendations": [
        "Cabrito (roasted goat) at El Rey del Cabrito or El Gran Pastor",
        "Arrachera (skirt steak) at La Nacional",
        "Tacos al Pastor at Taquería Orinoco",
        "Machacado con Huevo (dried shredded beef with eggs) for breakfast",
        "Gorditas and other street food from Mercado Juárez"
      ],
      "football_experiences": [
        "FIFA Fan Festival (location TBD, likely Parque Fundidora or Macroplaza)",
        "Attending a FIFA World Cup Match at Estadio BBVA",
        "Soaking in the pre- and post-match atmosphere around Estadio BBVA",
        "Visiting local sports stores for official merchandise and souvenirs"
      ],
      "travel_tips": [
        "**Getting to Estadio BBVA (Guadalupe):** The stadium is located in Guadalupe, a municipality adjacent to Monterrey. The most direct public transport option is to take Metro Line 1 (Línea 1) to the 'Exposición' station. From there, it's a short walk or a designated shuttle service will likely be available on match days. Taxis and ride-sharing services (Uber, Didi) are also widely available.",
        "**Where to Stay:** Consider staying in areas with good Metro access. Popular choices include: 1. **Downtown Monterrey (Centro):** Close to Macroplaza, Barrio Antiguo, and Metro Line 1. 2. **San Pedro Garza García:** An upscale area with modern hotels, shopping, and dining, though slightly further from the stadium (requires taxi/ride-share or a combination of bus/Metro). 3. **Near Parque Fundidora:** Good for tourists, with hotels and easy access to Metro Line 1.",
        "**Public Transportation in Monterrey:** The primary public transportation system is **Metrorrey (Monterrey Metro)**, consisting of three lines (Línea 1, 2, and 3). Línea 1 is crucial as it connects downtown to Guadalupe and near Estadio BBVA. There's also **TransMetro**, a feeder bus system that connects to Metro stations, and a general bus network. To pay for public transport, you can purchase a **Tarjeta MIA** or use single-ride tickets. It's advisable to get a Tarjeta MIA for convenience, which can be topped up at Metro stations. Ride-sharing apps like Uber and Didi are also prevalent and affordable for longer distances or late-night travel."
      ]
    }
  }
};
